(function(){
const $=id=>document.getElementById(id);
const EUR=n=>n.toLocaleString('de-DE',{style:'currency',currency:'EUR'});

// API-Basis-URL GLOBAL definieren
const API_BASE = "https://partner.planet-tree.de";

function ensurePtQrLib(){
  // 1) bereits "eingefroren"
  if (window.PT_QR_LIB && typeof window.PT_QR_LIB.toCanvas === 'function'){
    return Promise.resolve(window.PT_QR_LIB);
  }

  // 2) falls global vorhanden
  if (window.QRCode && typeof window.QRCode.toCanvas === 'function'){
    window.PT_QR_LIB = window.QRCode;
    return Promise.resolve(window.PT_QR_LIB);
  }

  // 3) Script dynamisch nachladen (Race/CSP/Override abfangen)
  return new Promise((resolve)=>{
    // schon in-flight?
    if (window.__ptQrLoading){
      window.__ptQrLoading.then(resolve);
      return;
    }

    window.__ptQrLoading = new Promise((done)=>{
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/qrcode@1.5.1/build/qrcode.min.js';

      s.async = true;
      s.onload = ()=>done(true);
      s.onerror = ()=>done(false);
      document.head.appendChild(s);
    }).then(()=>{
      if (window.QRCode && typeof window.QRCode.toCanvas === 'function'){
        window.PT_QR_LIB = window.QRCode;
        return window.PT_QR_LIB;
      }
      return null;
    });

    window.__ptQrLoading.then(resolve);
  });
}


const wordDE=n=>{
  const m=['EINS','ZWEI','DREI','VIER','FÜNF','SECHS','SIEBEN','ACHT','NEUN','ZEHN','ELF','ZWÖLF'];
  return (n>=1&&n<=12)?m[n-1]:String(n);
};

// Englische Zahlwörter – ab 13 als Zahl
const wordEN=n=>{
  const m=['ONE','TWO','THREE','FOUR','FIVE','SIX','SEVEN','EIGHT','NINE','TEN','ELEVEN','TWELVE'];
  return (n>=1&&n<=12)?m[n-1]:String(n);
};

// Spanisch – ab 13 als Zahl
const wordES = n => {
  const m=['UNO','DOS','TRES','CUATRO','CINCO','SEIS','SIETE','OCHO','NUEVE','DIEZ','ONCE','DOCE'];
  return (n>=1&&n<=12)?m[n-1]:String(n);
};

// Französisch – ab 13 als Zahl
const wordFR = n => {
  const m=['UN','DEUX','TROIS','QUATRE','CINQ','SIX','SEPT','HUIT','NEUF','DIX','ONZE','DOUZE'];
  return (n>=1&&n<=12)?m[n-1]:String(n);
};

// Türkisch – ab 13 als Zahl
const wordTR = n => {
  const m=['BİR','İKİ','ÜÇ','DÖRT','BEŞ','ALTI','YEDİ','SEKİZ','DOKUZ','ON','ON BİR','ON İKİ'];
  return (n>=1&&n<=12)?m[n-1]:String(n);
};



    // Kleiner Helfer: verhindert zu viele Aufrufe bei Resize
  function debounce(fn, delay){
    let t;
    return function(){
      const ctx = this;
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(function(){
        fn.apply(ctx, args);
      }, delay);
    };
  }

  /* Gift-Gimmicks: Metadaten (Titel, Bild etc.) */
  const GIMMICKS = {
    '01':{
      id:'44655453667593',
      price:10.00,
      title:'Zweiter Ofenhandschuh',
      image:'https://cdn.shopify.com/s/files/1/0505/0685/8683/files/DSC_6057_51d759da-4485-44ae-a0b6-5ef859431537.jpg?v=1763490133'
    }
  };

  /* Basis-Varianten (Zertifikat & Extras) – IDs bleiben fix */
const VARIANTS = {
  certBase: '55870787649801', // deine neue 9,90 €-Variante
  extraTree:      '56450695266569',
  printWhite:     '43720846409993',
  printGrass:     '43720846803209',
  giftPaperGrass: '43724459737353',
  giftWrap:       '37399158685883',
// NEU: Grund-Baumpflanzung (10 €) als eigener Zusatzartikel
  treeAddonBase:  '56654228324617',
  gimmicks: {},

  // NEU: Deko-Extras
  extraHeart:       '40026997948603',
  extraJustMarried: '44521505947913',
  bookmarkEule:     '44505450709257',
  bookmarkLibelle:  '44505456017673',
  bookmarkGinkgo:   '44505454903561',

  // Grußkarte: bezahlt & kostenlos
  greetingCardPaid: '37413678743739',   // +3,50 €
  greetingCardFree: '56624788734217',   // 0,00 € (nur cert + digital)

  // B2B Portal / B2B Wizard
  b2bTreeMV: '54947671572745',
  b2bTreeBY: '54947654336777',
  b2bTreeRP: '54947651453193',
  b2bPersonalization: '40840517976251',
  b2bPrint: '43683646210313',
  b2bGrass: '44786929107209',
  b2bDhl: '44786901713161'
};

  /* Preise in EUR – Fallbacks (werden, wenn möglich, aus Shopify geladen) */
  const PRICES = {
    certBase:        9.90, // Zertifikat (1 Baum)
    extraTree:      10.00, // weiterer Baum

    treeAddonBase:  10.00,

    printWhite:     3.00,
    printGrass:     4.00,

    giftPaperGrass: 1.00,
    giftWrap:       3.50,

    gimmicks: {},

        // NEU: Deko-Extras
    extraHeart:       3.50,
    extraJustMarried: 3.50,
    bookmarkEule:     9.00,
    bookmarkLibelle:  9.00,
    bookmarkGinkgo:   9.00,

    greetingCard:   3.50,

    b2bTreeMV: 6.00,
    b2bTreeBY: 6.00,
    b2bTreeRP: 6.00,
    b2bPersonalization: 2.00,
    b2bPrint: 3.00,
    b2bGrass: 0.50,
    b2bDhl: 5.00
  };

  // Varianten-IDs + Defaultpreise aus GIMMICKS übernehmen
  Object.keys(GIMMICKS).forEach(code=>{
    VARIANTS.gimmicks[code] = GIMMICKS[code].id;
    PRICES.gimmicks[code]   = GIMMICKS[code].price;
  });

  function getB2BTreeVariantIdForForest(forestCode){
    const code = String(forestCode || '').trim().toLowerCase();
    if(code === 'by') return VARIANTS.b2bTreeBY || '';
    if(code === 'rp') return VARIANTS.b2bTreeRP || '';
    return VARIANTS.b2bTreeMV || '';
  }

  let b2bAccountTreePriceOverride = null;

  function applyB2BAccountTreePriceOverride(account){
    const cents = parseInt((account && account.tree_price_net_cents) || 0, 10) || 0;
    const eurosFromCents = cents > 0 ? (cents / 100) : NaN;
    const eurosRaw = parseFloat(String((account && account.tree_price_net) != null ? account.tree_price_net : '').replace(',', '.'));
    if (Number.isFinite(eurosFromCents) && eurosFromCents > 0){
      b2bAccountTreePriceOverride = eurosFromCents;
      return;
    }
    if (Number.isFinite(eurosRaw) && eurosRaw > 0){
      b2bAccountTreePriceOverride = eurosRaw;
      return;
    }
    b2bAccountTreePriceOverride = null;
  }

  function getB2BTreePriceForForest(forestCode){
    if (Number.isFinite(b2bAccountTreePriceOverride) && b2bAccountTreePriceOverride > 0){
      return b2bAccountTreePriceOverride;
    }
    const code = String(forestCode || '').trim().toLowerCase();
    if(code === 'by') return Number(PRICES.b2bTreeBY || 0) || 0;
    if(code === 'rp') return Number(PRICES.b2bTreeRP || 0) || 0;
    return Number(PRICES.b2bTreeMV || 0) || 0;
  }

  function isB2BPersonalizedPricingFlow(){
    return !!(isB2B && state && state.mode === 'cert' && isB2BPersonalizedPortalFlow());
  }

  function getB2BPersonalizedCertNetTotal(trees, delivery, paperType, forestCode){
    const count = Math.max(1, parseInt(trees, 10) || 1);
    let total = getB2BTreePriceForForest(forestCode) * count;
    total += Number(PRICES.b2bPersonalization || 0) || 0;
    if(String(delivery || '').toLowerCase() === 'print'){
      total += Number(PRICES.b2bPrint || 0) || 0;
      if(String(paperType || '').toLowerCase() === 'grass'){
        total += Number(PRICES.b2bGrass || 0) || 0;
      }
    }
    return total;
  }

  function getB2BPersonalizedProjectNetTotal(){
    let total = 0;
    let anyPrint = false;

    if(state.seriesEnabled && hasSeriesRows()){
      const count = Array.isArray(state.seriesRows) ? state.seriesRows.length : 0;
      for(let i = 0; i < count; i++){
        const treesThis = Math.max(1, parseInt(getTreesForIndex(i), 10) || 1);
        const deliveryThis = getDeliveryForIndex(i) || state.delivery || 'digital';
        const paperThis = getPaperTypeForIndex(i) || state.paperType || 'white';
        const forestThis = getForestForIndex(i) || state.forest || 'mv';
        total += getB2BPersonalizedCertNetTotal(treesThis, deliveryThis, paperThis, forestThis);
        if(String(deliveryThis).toLowerCase() === 'print') anyPrint = true;
      }
    } else {
      total = getB2BPersonalizedCertNetTotal(
        state.trees || 1,
        state.delivery || 'digital',
        state.paperType || 'white',
        state.forest || 'mv'
      );
      anyPrint = String(state.delivery || '').toLowerCase() === 'print';
    }

    if(anyPrint){
      total += Number(PRICES.b2bDhl || 0) || 0;
    }
    return total;
  }

  function b2bPersonalizedHasShipping(){
    if(state.seriesEnabled && hasSeriesRows()){
      const count = Array.isArray(state.seriesRows) ? state.seriesRows.length : 0;
      for(let i = 0; i < count; i++){
        if(String(getDeliveryForIndex(i) || '').toLowerCase() === 'print'){
          return true;
        }
      }
      return false;
    }
    return String(state.delivery || '').toLowerCase() === 'print';
  }

  const FRAME_COLOR_DEFAULT = '#337451';

  // Hilfsfunktionen für Preis-Handling
function parsePriceParam(p){
  if(!p) return null;
  const s = String(p).replace(',', '.').trim();
  if(!s) return null;
  const num = Number(s);
  if(!isFinite(num) || num <= 0) return null;

  // Wenn ganzzahlig und >= 100, als Cent interpretieren
  if(Number.isInteger(num) && num >= 100){
    return num / 100;
  }
  // Ansonsten direkt als Euro-Betrag interpretieren (z.B. 9.9 oder 9,9)
  return num;
}

  async function fetchVariantPrice(variantId){
    if(!variantId) return null;
    try{
      const res = await fetch('/variants/' + encodeURIComponent(variantId) + '.js', {
        headers:{ 'Accept':'application/json' }
      });
      if(!res.ok) throw new Error('HTTP ' + res.status);
      const json = await res.json();
      if(!json || typeof json.price !== 'number') return null;
      return json.price / 100;
    }catch(e){
      console.warn('fetchVariantPrice failed for', variantId, e);
      return null;
    }
  }

  let editBundleId = null;
  let giftUiInited = false; // Gift-UI (Eventhandler) schon initialisiert?
    // NEU: Original-Container für die Extras in Step 9 merken
  let step9ExtrasGrid = null;

const FORESTS = {
  mv:{
    code:'mv',
    name:'Forstamt Schlemmin, Landesforst Mecklenburg-Vorpommern',

    // Forstamt/Office weglassen, aber MV ausschreiben:
    name_en:'Schlemmin, State Forest Mecklenburg-Vorpommern',
    name_es:'Schlemmin, Bosques estatales Mecklenburg-Vorpommern',
    name_fr:'Schlemmin, Forêts domaniales Mecklenburg-Vorpommern',
    name_tr:'Schlemmin, Mecklenburg-Vorpommern Eyalet Ormanları'
  },
  by:{
    code:'by',
    name:'Kommunaler Wald Stadt Alzenau, Bayern',
    name_en:'Municipal Forest of the City of Alzenau, Bavaria',
    name_es:'Bosque municipal de la ciudad de Alzenau, Baviera',
    name_fr:'Forêt communale de la ville d’Alzenau, Bavière',
    name_tr:'Alzenau Şehri Belediye Ormanı, Bavyera'
  },
  rp:{
    code:'rp',
    name:'Forstrevier Stadtkyll, Eifel, Rheinland-Pfalz',
    name_en:'Stadtkyll Forest district, Eifel, Rhineland-Palatinate',
    name_es:'Distrito forestal de Stadtkyll, Eifel, Renania-Palatinado',
    name_fr:'District forestier de Stadtkyll, Eifel, Rhénanie-Palatinat',
    name_tr:'Stadtkyll Orman Bölgesi, Eifel, Rheinland-Pfalz'
  }
};

const LANG_TEXT = {
  forest_placeholder: {
    de: 'Hier erscheint der Pflanzort.',
    en: 'The planting location will appear here.',
    es: 'El lugar de plantación aparecerá aquí.',
    fr: 'Le lieu de plantation apparaîtra ici.',
    tr: 'Dikim yeri burada görünecek.'
  },
  coords_placeholder: {
    de: 'GPS-Koordinaten werden nach dem Kauf ergänzt.',
    en: 'GPS coordinates will be added after purchase.',
    es: 'Las coordenadas GPS se añadirán después de la compra.',
    fr: 'Les coordonnées GPS seront ajoutées après l’achat.',
    tr: 'GPS koordinatları satın alma işleminden sonra eklenecektir.'
  },
  id_placeholder: {
    de: 'Zertifikats-ID wird nach dem Kauf ergänzt.',
    en: 'Certificate ID will be added after purchase.',
    es: 'El ID del certificado se añadirá después de la compra.',
    fr: 'L’identifiant du certificat sera ajouté après l’achat.',
    tr: 'Sertifika kimliği satın alma işleminden sonra eklenecektir.'
  },
  url_text: {
    de: 'www.planet-tree.de/baumgeschenk',
    en: 'www.planet-tree.de/tree-gift',
    es: 'www.planet-tree.de/tree-gift',
    fr: 'www.planet-tree.de/tree-gift',
    tr: 'www.planet-tree.de/tree-gift'
  },
  monthly_subline: {
    de: 'in deutschen Wäldern gepflanzt',
    en: 'planted in German forests',
    es: 'plantado en bosques alemanes',
    fr: 'planté dans des forêts allemandes',
    tr: 'Alman ormanlarında dikildi'
  }
};


  /* URL-Parameter lesen (Modus + Gift-Infos) */
  const params    = new URLSearchParams(window.location.search || '');
  const modeParam = (params.get('mode') || '').toLowerCase();
  const isGiftMode  = modeParam === 'gift';
  const isLabelMode = modeParam === 'label';

  // B2B-Erkennung:
  // 1) sauberer ?b2b=1
  const isB2BParam = (params.get('b2b') || '').toLowerCase() === '1';

  // 2) Fallback über die URL der Seite
  const pathName   = (window.location.pathname || '').toLowerCase();
  const isB2BPath  = pathName.indexOf('b2b-zertifikat-personalisieren') !== -1;

  // 3) Finale B2B-Flag
  const isB2B = isB2BParam || isB2BPath;

  // B2B-Portal-Parameter
  const portalCustomerRef = String(params.get('customer_ref') || '').trim();
  const portalToken       = String(params.get('portal_token') || '').trim();
  const portalOrderType   = String(params.get('order_type') || '').trim().toLowerCase();
  const portalBillingMode = String(params.get('billing_mode') || '').trim().toLowerCase();
  const portalB2BMode     = String(params.get('b2b_mode') || '').trim().toLowerCase();
  const portalMonthlyMode = String(params.get('monthly_mode') || '').trim().toLowerCase();
  const portalMonthlyKey  = String(params.get('monthly_month') || params.get('target_month') || '').trim();
  const portalSubscriptionId = String(params.get('subscription_id') || '').trim();
  const portalSubscriptionFixedTrees = Math.max(0, parseInt(params.get('subscription_fixed_trees') || '0', 10) || 0);
  const portalSubscriptionCountMode = String(params.get('subscription_count_mode') || '').trim().toLowerCase();
  const portalSubscriptionForestCode = String(params.get('subscription_forest_code') || '').trim().toLowerCase();
  const portalSubscriptionStartDate = String(params.get('subscription_start_date') || '').trim();
  const portalPartnerName = String(params.get('portal_partner_name') || '').trim();
  const portalAdminOpen   = String(params.get('portal_admin_open') || '').trim().toLowerCase() === '1';
  const portalTreePriceNetCents = parseInt(params.get('tree_price_net_cents') || '0', 10) || 0;
  const portalTreePriceNet = parseFloat(String(params.get('tree_price_net') || '').replace(',', '.')) || 0;
  const portalReturnUrl   = String(params.get('portal_return') || '/pages/b2b-portal').trim() || '/pages/b2b-portal';

  if (isB2B && (portalTreePriceNetCents > 0 || portalTreePriceNet > 0)){
    applyB2BAccountTreePriceOverride({
      tree_price_net_cents: portalTreePriceNetCents,
      tree_price_net: portalTreePriceNet
    });
  }

  function isB2BPortalFlow(){
    return !!(isB2B && portalCustomerRef && (portalOrderType || portalB2BMode || portalToken));
  }
  function isB2BSummaryOnlyPortalFlow(){
    return !!(
      isB2BPortalFlow() &&
      (
        portalOrderType === 'summary_only' ||
        portalB2BMode === 'summary_only'
      )
    );
  }
  function isB2BQuickMonthlyPortalFlow(){
    return !!(isB2BSummaryOnlyPortalFlow() && portalMonthlyMode === 'quick_issue');
  }
  function isB2BSubscriptionPortalFlow(){
    return !!(isB2BSummaryOnlyPortalFlow() && portalMonthlyMode === 'subscription');
  }
  function currentB2BSubscriptionId(){
    return String(
      (state && state.b2bPortal && state.b2bPortal.subscriptionId)
      || portalSubscriptionId
      || ''
    ).trim();
  }
  function isEditingB2BSubscription(){
    return !!(isB2BSubscriptionPortalFlow() && currentB2BSubscriptionId());
  }
  function isB2BEventPortalFlow(){
    return !!(
      isB2BPortalFlow() &&
      (
        portalOrderType === 'event_with_summary' ||
        portalB2BMode === 'event'
      )
    );
  }
  function isB2BEventCertificatePhase(){
    return !!(
      isB2BEventPortalFlow() &&
      state &&
      state.b2bPortal &&
      (state.b2bPortal.eventPhase || 'event') !== 'monthly'
    );
  }
  function isB2BEventSummaryPhase(){
    return !!(
      isB2BEventPortalFlow() &&
      state &&
      state.b2bPortal &&
      state.b2bPortal.eventPhase === 'monthly' &&
      state.mode === 'cert' &&
      state.step !== totalSteps()
    );
  }
  function isB2BEventFinalOverviewPhase(){
    return !!(
      isB2BEventPortalFlow() &&
      state &&
      state.b2bPortal &&
      state.b2bPortal.eventPhase === 'monthly' &&
      state.mode === 'cert' &&
      state.step === totalSteps()
    );
  }
  function isB2BPersonalizedPortalFlow(){
    return !!(isB2BPortalFlow() && (portalOrderType === 'personalized_with_summary' || portalB2BMode === 'personalized'));
  }
  function usesLockedMonthlyProjectDeltaFlow(){
    return !!(isB2BPersonalizedPortalFlow() || isB2BEventSummaryPhase() || isB2BQuickMonthlyPortalFlow());
  }
  function usesDedicatedMonthlySenderEditor(){
    return !!(isB2BPersonalizedPortalFlow() || isB2BEventSummaryPhase());
  }
  function shouldSkipDraftRestore(){
    return false;
  }
  function redirectBackToPortal(extraParams){
    if(!isB2BPortalFlow()) return;
    try{
      const url = new URL(portalReturnUrl, window.location.origin);
      if (portalToken){
        url.searchParams.set('token', portalToken);
      }
      if (portalCustomerRef){
        url.searchParams.set('customer_ref', portalCustomerRef);
      }
      if (portalAdminOpen){
        url.searchParams.set('admin_open', '1');
      }
      const obj = extraParams && typeof extraParams === 'object' ? extraParams : {};
      Object.keys(obj).forEach(function(key){
        const val = obj[key];
        if(val !== undefined && val !== null && String(val).trim() !== ''){
          url.searchParams.set(key, String(val));
        }
      });
      window.location.href = url.toString();
    }catch(_){
      window.location.href = portalReturnUrl;
    }
  }
  async function triggerPortalPdfDownload(url, preferredName){
    const raw = String(url || '').trim();
    if(!raw) return false;
    const fallbackName = String(preferredName || '').trim() || ((raw.split('/').pop() || 'Monatszertifikat.pdf').split('?')[0] || 'Monatszertifikat.pdf');
    try{
      const res = await fetch(raw, { credentials:'omit' });
      if(!res.ok) throw new Error('download_http_' + res.status);
      const blob = await res.blob();
      const objUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objUrl;
      a.download = fallbackName;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      setTimeout(function(){
        try{ URL.revokeObjectURL(objUrl); }catch(_){}
        try{ a.remove(); }catch(_){}
      }, 1500);
      return true;
    }catch(_){
      try{
        const a = document.createElement('a');
        a.href = raw;
        a.download = fallbackName;
        a.target = '_blank';
        a.rel = 'noopener';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        setTimeout(function(){ try{ a.remove(); }catch(__){} }, 400);
      }catch(__){}
      return false;
    }
  }

  // Externe Aufrufe (Meta/TikTok etc.) erkennen – per ?wizard_origin=ad|meta|tiktok
const wizardOrigin     = (params.get('wizard_origin') || '').toLowerCase();
const isExternalWizard =
  wizardOrigin === 'ad' ||
  wizardOrigin === 'meta' ||
  wizardOrigin === 'tiktok';

  const adminOrderId    = params.get('order_id');
  const adminLineItemId = params.get('line_item_id');

  const isAdminEdit     = params.get('admin_edit') === '1'
                          && adminOrderId && adminLineItemId;

  const isCustomerEdit  = params.get('customer_edit') === '1'
                          && adminOrderId && adminLineItemId;

  const socialCode = (params.get('code') || '').trim().toUpperCase();
  const socialExp  = parseInt((params.get('exp') || '0').trim(), 10) || 0;
  const socialSig  = (params.get('sig') || '').trim();
  const isSocialEdit = (params.get('social_edit') === '1' && socialCode && socialExp > 0 && socialSig);
  const isLockedEdit = (isCustomerEdit || isSocialEdit);

  const loadingTitleEl = document.querySelector('.wiz-loading-title');
const loadingTextEl  = document.querySelector('.wiz-loading-text');

if ((isLockedEdit || isAdminEdit) && loadingTextEl){
  loadingTextEl.textContent = 'Dein Zertifikat wird im Hintergrund aktualisiert.';
}

  const giftwrapParam  = params.get('giftwrap');
  const gimmickParam   = params.get('gimmick');
  const giftTitleParam = params.get('gift_title') || '';
  const giftImgParam   = params.get('gift_img') || '';

  // Gift-/Label-Basisprodukt (Variante + Preis) aus der Produktseite
  const giftVariantParam     = params.get('gift_variant_id') || params.get('variant_id') || '';
  // Gift-Varianten, bei denen es KEINE "ohne Baum"-Option geben soll
const GIFT_ALWAYS_TREE_VARIANTS = [
  '41825519599803','41825844134075','40264928886971','39488260767931'
  // später einfach weitere IDs ergänzen
  // '12345678901234',
];

// Variante aus der URL (Gift-Modus)
const giftVariantForTreeMode = giftVariantParam || '';
const isGiftAlwaysTree = isGiftMode && GIFT_ALWAYS_TREE_VARIANTS.includes(giftVariantForTreeMode);
  const giftPriceParam       = params.get('gift_price');
  const giftBasePriceParam   = parsePriceParam(giftPriceParam);
  // Zertifikat-Basisprodukt (Variante + Preis) aus der Produktseite (cert)
  const certVariantParam   = params.get('cert_variant_id') || '';
  const certPriceParam     = params.get('cert_price');
  const certBasePriceParam = parsePriceParam(certPriceParam);

  // Draft-Logik: nur verwenden, wenn wir NICHT via edit_bundle/clone_bundle kommen
  const hasEditOrClone = params.has('edit_bundle') || params.has('clone_bundle');

  function getOrCreateDraftId(modeStr, variantId){
    if (!variantId) return null;
    const lsKey = `ptw:draft:${modeStr}:${variantId}`;
    try{
      const existing = window.localStorage.getItem(lsKey);
      if (existing) return existing;
      const rand = Math.random().toString(36).slice(2, 8);
      const now  = Date.now().toString(36);
      const newId = `WD-${modeStr}-${variantId}-${now}-${rand}`;
      window.localStorage.setItem(lsKey, newId);
      return newId;
    }catch(e){
      console.warn('draft id localStorage failed, using ephemeral id', e);
      const rand = Math.random().toString(36).slice(2, 8);
      const now  = Date.now().toString(36);
      return `WD-${modeStr}-${variantId}-${now}-${rand}`;
    }
  }

  const DRAFT_KEY = (function(){
    if (hasEditOrClone) return null;
    if (isB2BSummaryOnlyPortalFlow() && portalCustomerRef){
      const draftKind = isB2BSubscriptionPortalFlow() ? 'subscription' : 'summary';
      const draftVariant = draftKind + (isB2BSubscriptionPortalFlow() ? (':' + (portalSubscriptionId || 'new')) : '');
      return getOrCreateDraftId('b2b-summary', 'portal:' + portalCustomerRef + ':' + draftVariant);
    }
    if (isB2BEventPortalFlow() && portalCustomerRef){
      return getOrCreateDraftId('b2b-event', 'portal:' + portalCustomerRef + ':event');
    }
    if (isB2BPersonalizedPortalFlow() && portalCustomerRef){
      return getOrCreateDraftId('b2b-cert', 'portal:' + portalCustomerRef + ':personalized');
    }
    const modeStr = isLabelMode ? 'label' : (isGiftMode ? 'gift' : 'cert');
    const vId = (isGiftMode || isLabelMode)
      ? (giftVariantParam || '')
      : (certVariantParam || giftVariantParam || '');
    if (!vId) return null;
    return getOrCreateDraftId(modeStr, vId);
  })();

  const initialMode = isB2B
    ? 'cert'
    : (isLabelMode ? 'label' : (isGiftMode ? 'gift' : 'cert'));

  const state={
    mode: initialMode,
    step:0,
    verb:'HAT',
    trees:1,
    lang: 'de',
    seriesLang: [],
photo1State:{scale:1,offX:0,offY:0,w:0,h:0,rotation:0,prevText:undefined,mode:'contain',file:null,dataUrl:null, combine:false},
personalizedMonthlyPhoto1State:{scale:1,offX:0,offY:0,w:0,h:0,rotation:0,prevText:undefined,mode:'contain',file:null,dataUrl:null, combine:false},
photo4State:{scale:1,offX:0,offY:0,w:0,h:0,rotation:0,prevText:undefined,mode:'contain',file:null,dataUrl:null},
photo6State:{scale:1,offX:0,offY:0,w:0,h:0,rotation:0,prevText:undefined,mode:'contain',file:null,dataUrl:null},
// NEU: Grußkarten-Fotos (oben / Mitte / unten)
greetPhoto1State:{scale:1,offX:0,offY:0,w:0,h:0,rotation:0,prevText:undefined,mode:'contain',file:null,dataUrl:null},
greetPhoto2State:{scale:1,offX:0,offY:0,w:0,h:0,rotation:0,prevText:undefined,mode:'contain',file:null,dataUrl:null},
greetPhoto3State:{scale:1,offX:0,offY:0,w:0,h:0,rotation:0,prevText:undefined,mode:'contain',file:null,dataUrl:null},
    decoBalloon:false,
    decoHat:false,
    forest:null,
    frameColor:FRAME_COLOR_DEFAULT,
    delivery: (isGiftMode || isLabelMode) ? 'print' : 'digital',
    paperType:'white',

        // NEU: Serienfunktion (nur für Zertifikate)
    seriesEnabled: false,   // true = Serienmodus aktiv
    seriesBlankMode: false, // true = Serienmodus mit bewusst leerem Empfängerfeld
    seriesBlankCount: 10,
    seriesRows: [],         // [{ line1, line2, blank_recipient? }, ...]
    seriesTrees: [],        // Baumanzahl pro Zertifikat
    seriesSender: [],       // Schenkende:r pro Zertifikat (Step 1)
    seriesIndex: 0,         // aktuell im Wizard ausgewähltes Serien-Zertifikat
    seriesOccasion: [],     // Anlass/Datum/Message pro Zertifikat (Step 4)
    seriesVerb: [],         // Grammatik (HAT/HABEN) pro Zertifikat
    // NEU: Deko pro Zertifikat (Step 6)
    seriesDecoBalloon: [],  // true/false pro Zertifikat
    seriesDecoHat: [],      // true/false pro Zertifikat
    // NEU: Pflanzort pro Zertifikat (Step 7)
    seriesForest: [],       // 'mv' | 'by' | 'rp' pro Zertifikat
    // NEU: Rahmenfarbe pro Zertifikat (Step 8)
    seriesFrameColor: [],   // Hex (#337451, #FF0000, ...) pro Zertifikat
    // NEU: Versandart pro Zertifikat (nur cert-Serie)
    seriesDelivery: [],     // 'digital' | 'print' pro Zertifikat
    // NEU: Papier pro Zertifikat (nur cert-Serie)
    seriesPaperType: [],    // 'white' | 'grass' pro Zertifikat

        // NEU: Monatszertifikat-Koordinaten
    monthlyCoordsLoaded: false,
    monthlyCoordsCacheKey: '',
    monthlyCoords: {
      mv: null,
      by: null,
      rp: null
    },
    // NEU: Monatszertifikat rudimentär steuerbar
monthlyTrees: 0,
monthlyLang: 'de',
monthlyMonth: null,                 // "YYYY-MM"
monthlyForests: [],
monthlyForestTrees: { mv:0, by:0, rp:0 },
monthlyQrUrl: 'https://planet-tree.de',
monthlyId: null,
monthlyPlaceText: '',     // NEU: "Hanau, 14.12.2025" (oder 2 Zeilen)
monthlyServerBaseTrees: 0,
monthlyServerLoadedMonth: '',
monthlyServerBaseForestTrees: { mv:0, by:0, rp:0 },
monthlyProjectForestTrees: { mv:0, by:0, rp:0 },
monthlyUserEdited: false,
subscriptionActive: true,
subscriptionFrequency: 'monthly',
subscriptionCountMode: 'fixed',
subscriptionFixedTrees: 1,
subscriptionForestCode: 'mv',
subscriptionStartDate: '',


    giftTitle: giftTitleParam,
    giftImg:   giftImgParam,
    giftwrapAvailable: (isGiftMode || isLabelMode) && giftwrapParam !== '0',
    giftwrapSelected:  false,
    gimmickCode:       (isGiftMode || isLabelMode) ? (gimmickParam || null) : null,
    gimmickConfig:     (isGiftMode || isLabelMode) && gimmickParam && GIMMICKS[gimmickParam] ? GIMMICKS[gimmickParam] : null,
    gimmickAvailable:  (isGiftMode || isLabelMode) && !!(gimmickParam && GIMMICKS[gimmickParam]),
    gimmickSelected:   false,
    greetCardSelected: false,

      // NEU: merkt sich, ob die Karte ursprünglich in der Bestellung enthalten war
  greetCardOriginallySelected: false,
// Gift/Label: startet standardmäßig ohne Baumpflanzung – außer bei speziellen Gift-Varianten
treeAddonSelected: (isGiftMode || isLabelMode) ? isGiftAlwaysTree : true,


    // NEU: Deko-Extras in Step 9
    extraHeartAvailable: false,
    extraHeartSelected:  false,
    extraJustAvailable:  false,
    extraJustSelected:   false,
    bookmarkAvailable:   false,
    bookmarkSelected:    false,
    bookmarkChoice:      null,

giftVariantId:    (isGiftMode || isLabelMode) && giftVariantParam ? giftVariantParam : null,
// Gift-/Label-Basispreis wird immer aus Shopify geladen, nicht aus der URL
giftBasePrice:    null,
certVariantId: (!isGiftMode && !isLabelMode && certVariantParam ? certVariantParam : null),
    certBasePrice: null,
    previewOriginStep:null,
    digitalConfirmed:false,

    /* Label state */
    labelLine1:'',
    labelLine2:'',
    labelLine3:'',
    labelEdited1:false,
    labelEdited2:false,
    labelEdited3:false,
    labelBorderColor: FRAME_COLOR_DEFAULT,
        // NEU: Flow "Nur Produkt ohne Baumpflanzung" (Gift/Label)
    noTreeExtrasMode:false
  };

  state.b2bPortal = {
    active: isB2BPortalFlow(),
    customerRef: portalCustomerRef,
    subscriptionId: portalSubscriptionId,
    token: portalToken,
    orderType: portalOrderType,
    billingMode: portalBillingMode,
    mode: portalB2BMode,
    monthlyMode: portalMonthlyMode,
    monthlyMonth: portalMonthlyKey,
    partnerName: portalPartnerName,
    landingSlug: '',
    partnerUrl: '',
    returnToMonthlyFromStep1: false,
    quickMonthly: isB2BQuickMonthlyPortalFlow(),
    eventPhase: isB2BEventPortalFlow() ? 'event' : '',
    eventSnapshot: null
  };

  if (isB2BSubscriptionPortalFlow() && portalSubscriptionFixedTrees > 0){
    state.subscriptionFixedTrees = portalSubscriptionFixedTrees;
  }
  if (isB2BSubscriptionPortalFlow() && portalSubscriptionCountMode){
    state.subscriptionCountMode = normalizeSubscriptionCountMode(portalSubscriptionCountMode);
  }
  if (isB2BSubscriptionPortalFlow() && portalSubscriptionForestCode){
    state.subscriptionForestCode = normalizeSubscriptionForestCode(portalSubscriptionForestCode);
  }
  if (isB2BSubscriptionPortalFlow() && portalSubscriptionStartDate){
    state.subscriptionStartDate = normalizeSubscriptionStartDate(portalSubscriptionStartDate);
  }

let FORCE_MONTHLY_RENDER = false;

function isMonthlyCertState(){
  return !!(
    isB2B &&
    state.mode === 'cert' &&
    (
      FORCE_MONTHLY_RENDER ||
      state.step === 10 ||
      isB2BEventSummaryPhase() ||
      (isB2BSummaryOnlyPortalFlow() && state.step === totalSteps())
    )
  );
}


  const rootEl = $('pt-cert-wizard');
  if(rootEl){
    rootEl.classList.add(
      state.mode === 'gift' ? 'mode-gift' :
      (state.mode === 'label' ? 'mode-gift' : 'mode-cert') /* label basiert optisch auf gift */
    );
  }

    // Basis-Produktvariante (ohne Baum/Zertifikat)
  const baseVariantIdFromData = rootEl && rootEl.dataset.baseVariantId;
  const baseVariantId =
    baseVariantIdFromData ||
    giftVariantParam ||
    certVariantParam ||
    null;

  
function monthlyStorageKey(){
  return 'ptw:monthly:' + (DRAFT_KEY || 'session');
}

function getSummarySenderPersistentDraftKey(){
  const ref = String(portalCustomerRef || '').trim();
  if (!ref) return '';
  return 'WD-b2b-summary-sender:' + ref + (isB2BSubscriptionPortalFlow() ? (':subscription:' + (portalSubscriptionId || 'new')) : ':summary');
}

function getFreshMonthlyPlaceDefault(){
  const now = new Date();
  const dd  = String(now.getDate()).padStart(2,'0');
  const mm  = String(now.getMonth()+1).padStart(2,'0');
  const yy  = now.getFullYear();
  return `Hanau, ${dd}.${mm}.${yy}`;
}

function resetSummaryOnlyPlaceTextFresh(){
  if (!isB2BSummaryOnlyPortalFlow()) return;
  state.monthlyPlaceText = getFreshMonthlyPlaceDefault();
  const placeTa = $('monthlyPlaceText');
  if (placeTa) placeTa.value = state.monthlyPlaceText;
}

function ensureMonthlyId(){
  if (state.monthlyId) return state.monthlyId;

  try{
    const k = monthlyStorageKey() + ':id';
    const existing = window.localStorage.getItem(k);
    if (existing && /^[A-Z0-9]{10}$/.test(existing)){
      state.monthlyId = existing;
      return state.monthlyId;
    }
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let out = '';
    for (let i=0;i<10;i++){
      out += chars[Math.floor(Math.random()*chars.length)];
    }
    state.monthlyId = out;
    window.localStorage.setItem(k, out);
    return out;
  }catch(_){
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let out = '';
    for (let i=0;i<10;i++) out += chars[Math.floor(Math.random()*chars.length)];
    state.monthlyId = out;
    return out;
  }
}

function getMonthlySelectedForests(){
  const valid = ['mv','by','rp'];
  const arr = Array.isArray(state.monthlyForests) ? state.monthlyForests : [];
  const out = arr.filter(x => valid.includes(x));
  return out;
}

function getMonthlyForestTrees(){
  const raw = state.monthlyForestTrees || {};
  return {
    mv: Math.max(0, parseInt(raw.mv, 10) || 0),
    by: Math.max(0, parseInt(raw.by, 10) || 0),
    rp: Math.max(0, parseInt(raw.rp, 10) || 0)
  };
}

function getMonthlyBaseForestTrees(){
  const raw = state.monthlyServerBaseForestTrees || {};
  return {
    mv: Math.max(0, parseInt(raw.mv, 10) || 0),
    by: Math.max(0, parseInt(raw.by, 10) || 0),
    rp: Math.max(0, parseInt(raw.rp, 10) || 0)
  };
}

function getMonthlyProjectForestTrees(){
  const raw = state.monthlyProjectForestTrees || {};
  return {
    mv: Math.max(0, parseInt(raw.mv, 10) || 0),
    by: Math.max(0, parseInt(raw.by, 10) || 0),
    rp: Math.max(0, parseInt(raw.rp, 10) || 0)
  };
}

function getMonthlyProjectTreeCount(){
  const dist = getMonthlyProjectForestTrees();
  return (dist.mv || 0) + (dist.by || 0) + (dist.rp || 0);
}

function normalizeSubscriptionFrequency(value){
  return 'monthly';
}

function normalizeSubscriptionCountMode(value){
  const raw = String(value || '').trim().toLowerCase();
  return raw === 'days_in_month' ? 'days_in_month' : 'fixed';
}

function normalizeSubscriptionForestCode(value){
  const raw = String(value || '').trim().toLowerCase();
  return FORESTS[raw] ? raw : 'mv';
}

function todayIsoDate(){
  const now = new Date();
  return String(now.getFullYear()) + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
}

function normalizeSubscriptionStartDate(value){
  const raw = String(value || '').trim();
  return /^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw : todayIsoDate();
}

function monthKeyFromIsoDate(value){
  const iso = normalizeSubscriptionStartDate(value);
  return iso.slice(0, 7);
}

function subscriptionLocale(lang){
  const wanted = normalizeLang(lang);
  if (wanted === 'en') return 'en-US';
  if (wanted === 'es') return 'es-ES';
  if (wanted === 'fr') return 'fr-FR';
  if (wanted === 'tr') return 'tr-TR';
  return 'de-DE';
}

function parseIsoDateUtc(value){
  const iso = normalizeSubscriptionStartDate(value);
  const year = parseInt(iso.slice(0, 4), 10) || (new Date()).getFullYear();
  const month = parseInt(iso.slice(5, 7), 10) || 1;
  const day = parseInt(iso.slice(8, 10), 10) || 1;
  return new Date(Date.UTC(year, Math.max(0, month - 1), day));
}

function shiftUtcDate(dateObj, days){
  const base = dateObj instanceof Date ? dateObj : parseIsoDateUtc(todayIsoDate());
  return new Date(base.getTime() + (days * 86400000));
}

function subscriptionWeekStart(dateValue){
  const current = (dateValue instanceof Date) ? new Date(dateValue.getTime()) : parseIsoDateUtc(dateValue);
  const day = current.getUTCDay() || 7;
  return shiftUtcDate(current, 1 - day);
}

function formatSubscriptionPeriodLabel(startDate, lang, frequency){
  const locale = subscriptionLocale(lang);
  const anchor = parseIsoDateUtc(startDate);
  return new Intl.DateTimeFormat(locale, { month:'long', year:'numeric' }).format(anchor);
}

function getDaysInMonthForKey(monthKey){
  let ref = String(monthKey || '').trim();
  if (!/^\d{4}-\d{2}$/.test(ref)){
    ref = monthKeyFromIsoDate(todayIsoDate());
  }
  const year = parseInt(ref.slice(0, 4), 10) || (new Date()).getFullYear();
  const month = parseInt(ref.slice(5, 7), 10) || ((new Date()).getMonth() + 1);
  return new Date(year, month, 0).getDate();
}

function formatSubscriptionPlaceText(startDate, lang, frequency){
  return formatSubscriptionPeriodLabel(startDate, lang || getMonthlyCertLang(), frequency || state.subscriptionFrequency);
}

function getSubscriptionPreviewTreeCount(monthKey){
  if (normalizeSubscriptionCountMode(state.subscriptionCountMode) === 'days_in_month'){
    return Math.max(1, getDaysInMonthForKey(monthKey));
  }
  return Math.max(1, parseInt(state.subscriptionFixedTrees, 10) || 1);
}

function getSubscriptionPreviewForestMap(monthKey){
  const trees = getSubscriptionPreviewTreeCount(monthKey);
  const code = normalizeSubscriptionForestCode(state.subscriptionForestCode);
  return {
    mv: code === 'mv' ? trees : 0,
    by: code === 'by' ? trees : 0,
    rp: code === 'rp' ? trees : 0
  };
}

function syncSubscriptionMonthlyState(){
  if (!isB2BSubscriptionPortalFlow()) return;
  const startDate = normalizeSubscriptionStartDate(state.subscriptionStartDate || '');
  const monthKey = monthKeyFromIsoDate(startDate);
  const forestMap = getSubscriptionPreviewForestMap(monthKey);
  const treeCount = (forestMap.mv || 0) + (forestMap.by || 0) + (forestMap.rp || 0);
  const forestCode = normalizeSubscriptionForestCode(state.subscriptionForestCode);
  state.subscriptionActive = !!state.subscriptionActive;
  state.subscriptionFrequency = normalizeSubscriptionFrequency(state.subscriptionFrequency);
  state.subscriptionCountMode = normalizeSubscriptionCountMode(state.subscriptionCountMode);
  state.subscriptionFixedTrees = Math.max(1, parseInt(state.subscriptionFixedTrees, 10) || 1);
  state.subscriptionForestCode = forestCode;
  state.subscriptionStartDate = startDate;
  state.monthlyMonth = monthKey;
  state.monthlyUserEdited = false;
  state.monthlyServerBaseTrees = 0;
  state.monthlyServerLoadedMonth = monthKey;
  state.monthlyServerBaseForestTrees = { mv:0, by:0, rp:0 };
  state.monthlyForests = [forestCode];
  state.monthlyForestTrees = Object.assign({}, forestMap);
  state.monthlyProjectForestTrees = Object.assign({}, forestMap);
  state.monthlyTrees = treeCount;
  state.monthlyPlaceText = formatSubscriptionPlaceText(startDate, getMonthlyCertLang(), state.subscriptionFrequency);
}

function getCurrentPreviewTreeCount(){
  if (isB2B && state.mode === 'cert'){
    const monthlyTotal = Math.max(0, parseInt(state.monthlyTrees, 10) || 0);
    return monthlyTotal;
  }
  return Math.max(1, parseInt(state.trees, 10) || 1);
}

function getMonthlyCertLang(){
  if (isB2BPersonalizedPortalFlow()){
    return normalizeLang(state.monthlyLang || state.lang);
  }
  return getActiveLang();
}

function cloneSenderPhotoState(src){
  const s = src || {};
  return {
    scale: parseFloat(s.scale) || 1,
    offX: parseFloat(s.offX) || 0,
    offY: parseFloat(s.offY) || 0,
    w: parseInt(s.w, 10) || 0,
    h: parseInt(s.h, 10) || 0,
    rotation: parseFloat(s.rotation) || 0,
    prevText: typeof s.prevText === 'string' ? s.prevText : '',
    mode: s.mode || 'contain',
    file: s.file || null,
    dataUrl: s.dataUrl || null,
    combine: !!s.combine
  };
}

function setMonthlyAggregateFromBaseAndProject(){
  const base = getMonthlyBaseForestTrees();
  const add = getMonthlyProjectForestTrees();
  const merged = {
    mv: Math.max(0, (parseInt(add.mv, 10) || 0) + (parseInt(base.mv, 10) || 0)),
    by: Math.max(0, (parseInt(add.by, 10) || 0) + (parseInt(base.by, 10) || 0)),
    rp: Math.max(0, (parseInt(add.rp, 10) || 0) + (parseInt(base.rp, 10) || 0))
  };
  state.monthlyForestTrees = merged;
  syncMonthlySelectionFromForestTrees();
}

function syncMonthlySelectionFromForestTrees(){
  const dist = getMonthlyForestTrees();
  const selected = ['mv','by','rp'].filter(code => dist[code] > 0);
  state.monthlyForestTrees = dist;
  state.monthlyForests = selected;
  const total = dist.mv + dist.by + dist.rp;
  state.monthlyTrees = total;
}

function syncMonthlyStateFromCurrentCertFlow(){
  if (isB2BEventSummaryPhase() && state.b2bPortal && state.b2bPortal.eventSnapshot){
    const saved = state.b2bPortal.eventSnapshot;
    const dist = {
      mv: Math.max(0, parseInt(saved.forestTrees && saved.forestTrees.mv, 10) || 0),
      by: Math.max(0, parseInt(saved.forestTrees && saved.forestTrees.by, 10) || 0),
      rp: Math.max(0, parseInt(saved.forestTrees && saved.forestTrees.rp, 10) || 0)
    };
    state.monthlyProjectForestTrees = dist;
    setMonthlyAggregateFromBaseAndProject();
    return true;
  }
  let totalTrees = 0;
  const forestSet = new Set();
  const dist = { mv:0, by:0, rp:0 };

  if (state.seriesEnabled && Array.isArray(state.seriesRows) && state.seriesRows.length){
    for (let i = 0; i < state.seriesRows.length; i++){
      const trees = getTreesForIndex(i);
      const forest = getForestForIndex(i);
      const safeTrees = (isFinite(trees) && trees > 0) ? trees : 1;
      totalTrees += safeTrees;
      if (forest && FORESTS[forest]){
        forestSet.add(forest);
        dist[forest] = (dist[forest] || 0) + safeTrees;
      }
    }
  } else {
    totalTrees = (isFinite(state.trees) && state.trees > 0) ? state.trees : 1;
    if (state.forest && FORESTS[state.forest]){
      forestSet.add(state.forest);
      dist[state.forest] = totalTrees;
    }
  }

  state.monthlyProjectForestTrees = dist;
  setMonthlyAggregateFromBaseAndProject();
  return true;
}

function resetB2BPortalPersonalizedInputs(){
  state.seriesEnabled = false;
  state.seriesRows = [];
  state.seriesTrees = [];
  state.seriesSender = [];
  state.seriesOccasion = [];
  state.seriesVerb = [];
  state.seriesDecoBalloon = [];
  state.seriesDecoHat = [];
  state.seriesForest = [];
  state.seriesFrameColor = [];
  state.seriesDelivery = [];
  state.seriesPaperType = [];
  state.seriesIndex = 0;

  state.verb = 'HAT';
  state.trees = 1;
  state.forest = null;
  state.delivery = 'digital';
  state.paperType = 'white';
  state.monthlyLang = normalizeLang(state.lang || 'de');

  if (txt4){
    txt4.value = '';
    if (typeof fit4 === 'function') fit4();
  }
  if (txt6){
    txt6.value = '';
    if (typeof fit6 === 'function') fit6();
  }
  if (qVal){
    qVal.value = '1';
  }
  try{
    const inpD = document.querySelector('input[name="delivery"][value="digital"]');
    const inpP = document.querySelector('input[name="paperType"][value="white"]');
    if (inpD) inpD.checked = true;
    if (inpP) inpP.checked = true;
    applyDeliverySelectionUI();
    togglePaperOptions();
  }catch(_){}
  state.personalizedMonthlySenderCustomized = false;
  Object.assign(state.personalizedMonthlyPhoto1State, {scale:1,offX:0,offY:0,w:0,h:0,rotation:0,prevText:undefined,mode:'contain',file:null,dataUrl:null, combine:false});
  if (personalizedMonthlyTxt1){
    personalizedMonthlyTxt1.value = '';
    if (typeof fitPersonalizedMonthly1 === 'function') fitPersonalizedMonthly1();
  }
  if (personalizedMonthlyCombineTextInput) personalizedMonthlyCombineTextInput.value = '';
}

function getEventMonthFieldWrap(){
  const monthIn = $('monthlyMonthInput');
  if (!monthIn) return null;
  return monthIn.closest('.monthly-field') || monthIn.parentElement || null;
}

async function fetchExistingMonthlyBaseState(){
  if (!isB2BPortalFlow() || !state.b2bPortal || !state.b2bPortal.customerRef || !state.monthlyMonth) return false;
  const wantedMonth = String(state.monthlyMonth || '').trim();
  if (!/^\d{4}-\d{2}$/.test(wantedMonth)) return false;
  try{
    const res = await fetch(
      API_BASE + '/api2/b2b/monthly/get?customer_ref=' + encodeURIComponent(state.b2bPortal.customerRef) + '&month=' + encodeURIComponent(wantedMonth),
      { credentials:'omit' }
    );
    const js = await res.json().catch(function(){ return {}; });
    if (!res.ok || !js || js.ok !== true) return false;
    state.monthlyServerBaseTrees = Math.max(0, parseInt(js.tree_count || 0, 10) || 0);
    state.monthlyServerLoadedMonth = wantedMonth;
    state.monthlyServerBaseForestTrees = {
      mv: Math.max(0, parseInt(js.forest_tree_map && js.forest_tree_map.mv || 0, 10) || 0),
      by: Math.max(0, parseInt(js.forest_tree_map && js.forest_tree_map.by || 0, 10) || 0),
      rp: Math.max(0, parseInt(js.forest_tree_map && js.forest_tree_map.rp || 0, 10) || 0)
    };
    return true;
  }catch(_){
    return false;
  }
}

function buildEventPortalSnapshot(){
  return {
    senderText: String(txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,''),
    senderCombineText: String(summaryCombineTextInput && summaryCombineTextInput.value || txt1 && txt1.value || '').replace(/\r/g,'').replace(/\n+/g,' '),
    photo1State: (function(){
      const cloned = cloneSenderPhotoState(state.photo1State);
      try{
        if ((!cloned.dataUrl || !String(cloned.dataUrl).trim()) && img1 && img1.src){
          cloned.dataUrl = String(img1.src || '');
        }
      }catch(_){}
      return cloned;
    })(),
    forestTrees: getMonthlyProjectForestTrees(),
    month: String(state.monthlyMonth || ''),
    placeText: String(state.monthlyPlaceText || ''),
    eventClaimText: String($('eventClaimText') && $('eventClaimText').value || '').replace(/\r/g,''),
    canvasPng: ''
  };
}

function restoreEventPortalSnapshotToEventPhase(){
  const fallback = buildEventPortalSnapshot();
  const saved = state && state.b2bPortal ? state.b2bPortal.eventSnapshot : null;
  const snap = Object.assign({}, fallback, saved || {});
  snap.photo1State = cloneSenderPhotoState((saved && saved.photo1State) || fallback.photo1State);
  if (!snap) return;

  state.monthlyMonth = snap.month || state.monthlyMonth;
  state.monthlyPlaceText = snap.placeText || '';
  state.eventClaimText = snap.eventClaimText || '';
  state.monthlyProjectForestTrees = {
    mv: Math.max(0, parseInt(snap.forestTrees && snap.forestTrees.mv, 10) || 0),
    by: Math.max(0, parseInt(snap.forestTrees && snap.forestTrees.by, 10) || 0),
    rp: Math.max(0, parseInt(snap.forestTrees && snap.forestTrees.rp, 10) || 0)
  };
  state.monthlyUserEdited = false;
  state.monthlyServerBaseTrees = 0;
  state.monthlyServerLoadedMonth = '';
  state.monthlyServerBaseForestTrees = { mv:0, by:0, rp:0 };
  setMonthlyAggregateFromBaseAndProject();

  Object.assign(state.photo1State, cloneSenderPhotoState(snap.photo1State));
  if (photo1Combine) photo1Combine.checked = !!state.photo1State.combine;
  if (!state.photo1State.prevText && snap.senderText){
    state.photo1State.prevText = String(snap.senderText || '').replace(/\r/g,'');
  }
  if (summaryCombineTextInput){
    summaryCombineTextInput.value = String(snap.senderCombineText || '').replace(/\r/g,'').replace(/\n+/g,' ');
  }
  if (txt1){
    txt1.value = String(snap.senderText || '').replace(/\r/g,'');
    if (typeof fit1 === 'function') fit1();
  }
  try{
    const dataUrl = snap.photo1State && snap.photo1State.dataUrl ? snap.photo1State.dataUrl : (img1 && img1.src || '');
    if (dataUrl && photo1 && typeof photo1.hydrateFromDataUrl === 'function'){
      photo1.hydrateFromDataUrl(String(dataUrl), cloneSenderPhotoState(snap.photo1State));
    } else if (snap.photo1State && snap.photo1State.file && typeof fileToDataURL === 'function' && photo1 && typeof photo1.hydrateFromDataUrl === 'function'){
      fileToDataURL(snap.photo1State.file).then(function(fileDataUrl){
        if (fileDataUrl){
          photo1.hydrateFromDataUrl(String(fileDataUrl), cloneSenderPhotoState(snap.photo1State));
        }
      }).catch(function(){});
    } else if (photo1 && typeof photo1.switchToText === 'function'){
      photo1.switchToText();
      if (txt1) txt1.value = String(snap.senderText || '').replace(/\r/g,'');
      if (typeof fit1 === 'function') fit1();
    }
  }catch(_){}

  if (state && state.b2bPortal){
    state.b2bPortal.eventSnapshot = Object.assign({}, state.b2bPortal.eventSnapshot || {}, snap, {
      photo1State: cloneSenderPhotoState(snap.photo1State)
    });
  }

  try{ placeA4Boxes(); }catch(_){}
  try{ updatePreview(); }catch(_){}
  try{ scaleA4(); }catch(_){}
}

function applyMonthlyForestsToPreview(){
  const row = document.querySelector('#pvInnerFinal .a4-forests-row');
  if (!row) return;

  const sel = getMonthlySelectedForests();
  const lang = getMonthlyCertLang();

  // Forst-TEXT-Zeilen ein/aus
  const mv = row.querySelector('.a4-forest-card-mv');
  const by = row.querySelector('.a4-forest-card-by');
  const rp = row.querySelector('.a4-forest-card-rp');
  const mvName = row.querySelector('.a4-forest-card-mv .a4-forest-card-name');
  const byName = row.querySelector('.a4-forest-card-by .a4-forest-card-name');
  const rpName = row.querySelector('.a4-forest-card-rp .a4-forest-card-name');

  if (mvName) mvName.textContent = getForestDisplayName('mv', lang);
  if (byName) byName.textContent = getForestDisplayName('by', lang);
  if (rpName) rpName.textContent = getForestDisplayName('rp', lang);

  if (mv) mv.style.display = sel.includes('mv') ? '' : 'none';
  if (by) by.style.display = sel.includes('by') ? '' : 'none';
  if (rp) rp.style.display = sel.includes('rp') ? '' : 'none';

  row.classList.remove('count-1','count-2','count-3');
  if (sel.length > 0){
    row.classList.add('count-' + Math.min(sel.length, 3));
  }
}

function renderMonthlyQr(){
  const wrap   = $('pvMonthlyQrWrap');
  const canvas = $('pvMonthlyQr');
  const urlEl  = $('pvMonthlyQrUrl');

  if (!wrap || !canvas) return;

  // URL unter dem QR anzeigen (ohne https://)
  if (urlEl){
    const printed = (typeof getB2BPrintedUrl === 'function')
      ? getB2BPrintedUrl()
      : String(state.monthlyQrUrl || '').replace(/^https?:\/\//i,'');
    const lines = getMonthlyPrintedUrlLines(printed);
    urlEl.innerHTML = '';
    if (lines.length){
      lines.forEach(function(line, idx){
        const span = document.createElement('span');
        span.className = 'a4-monthly-qr-url-line a4-monthly-qr-url-line-' + (idx + 1);
        span.textContent = line;
        urlEl.appendChild(span);
      });
    }
    urlEl.style.display = lines.length ? 'flex' : 'none';
  }

  const url = String(state.monthlyQrUrl || '').trim();

  // >>> PATCH: QR wirklich kleiner erzeugen
  const QR_SIZE = 220;

  canvas.width  = QR_SIZE;
  canvas.height = QR_SIZE;

  try{ canvas.style.borderColor = (state.frameColor || '#337451'); }catch(_){}

  const ctx = canvas.getContext('2d');
  if (ctx){
    ctx.clearRect(0,0,QR_SIZE,QR_SIZE);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0,0,QR_SIZE,QR_SIZE);
  }

  if (!url) return;

  ensurePtQrLib().then((QR)=>{
    if (QR && typeof QR.toCanvas === 'function'){
      QR.toCanvas(
        canvas,
        url,
        { width: QR_SIZE, margin: 1, color:{ dark:'#000000', light:'#ffffff' } },
        (err)=>{ if(err) console.warn('QR.toCanvas failed:', err); }
      );
      return;
    }
    console.warn('No compatible QR library found (ensurePtQrLib returned null).');
  });
}

function safeDecodeUrlPart(value){
  try{
    return decodeURIComponent(String(value || '').replace(/\+/g, '%20'));
  }catch(_){
    return String(value || '');
  }
}

function decodePrintedUrlDisplay(value){
  return String(value || '')
    .split('/')
    .map(function(part, idx){
      return idx === 0 ? String(part || '') : safeDecodeUrlPart(part);
    })
    .join('/');
}

function getMonthlyPrintedUrlLines(raw){
  const printed = String(raw || '').replace(/^https?:\/\//i, '').replace(/\/+$/,'').trim();
  if (!printed) return [];

  const slashIdx = printed.lastIndexOf('/');
  if (slashIdx > 0 && slashIdx < printed.length - 1){
    const line1 = decodePrintedUrlDisplay(printed.slice(0, slashIdx + 1));
    const line2 = decodePrintedUrlDisplay(printed.slice(slashIdx + 1));
    if (line1 && line2) return [line1, line2];
  }

  return [decodePrintedUrlDisplay(printed)];
}





function renderMonthlyId(){
  const id = ensureMonthlyId();

  const sealId = $('pvSealId');
  if (sealId) sealId.textContent = 'ID #' + id;

  // Jahr (aus monthlyMonth oder fallback: aktuelles Jahr)
  let year = (new Date()).getFullYear();
  if (state.monthlyMonth && /^\d{4}-\d{2}$/.test(state.monthlyMonth)){
    const y = parseInt(state.monthlyMonth.slice(0,4), 10);
    if (isFinite(y)) year = y;
  }

  const sealYear = $('pvSealYear');
  if (sealYear) sealYear.textContent = String(year);
}

function initMonthlyControls(){
  const controls = $('monthlyControls');
  if (!controls) return;

  // nur im B2B relevant
  controls.style.display = (isB2B ? 'block' : 'none');

  const treesIn = $('monthlyTreesInput');
  const monthIn = $('monthlyMonthInput');
  const treesField = $('monthlyTreesField');
  const monthField = $('monthlyMonthField');
  const treesLabel = $('monthlyTreesLabel');
  const monthLabel = $('monthlyMonthLabel');
  const mvCb    = $('monthlyForestMV');
  const byCb    = $('monthlyForestBY');
  const rpCb    = $('monthlyForestRP');
  const mvTreesIn = $('monthlyTreesMV');
  const byTreesIn = $('monthlyTreesBY');
  const rpTreesIn = $('monthlyTreesRP');
  const subscriptionControls = $('subscriptionControls');
  const subscriptionActiveEl = $('subscriptionActive');
  const subscriptionFrequencyEl = $('subscriptionFrequency');
  const subscriptionCountModeEl = $('subscriptionCountMode');
  const subscriptionForestCodeEl = $('subscriptionForestCode');
  const subscriptionStartDateEl = $('subscriptionStartDate');
  const subscriptionStartNowEl = $('subscriptionStartNow');
  const mvDelta = $('monthlyTreesMVDelta');
  const byDelta = $('monthlyTreesBYDelta');
  const rpDelta = $('monthlyTreesRPDelta');
  const placeTa = $('monthlyPlaceText');
  const monthlyPlaceRow = $('monthlyPlaceRow');
  const eventClaimWrap = $('eventClaimFieldWrap');
  const eventClaimTa = $('eventClaimText');
  const monthlyAggregationNote = $('monthlyAggregationNote');
  const monthlyAggregationNoteTextEl = monthlyAggregationNote ? monthlyAggregationNote.querySelector('.monthly-flow-note__text') : null;
  const monthlyPreviewJump = $('monthlyPreviewJump');
  const monthlyStepIntro = $('monthlyStepIntro');
  const monthlyStepRibbonText = $('monthlyStepRibbonText');
  const summarySenderRibbonTextEl = $('summarySenderRibbonText');
  const quickMonthlyMode = isB2BQuickMonthlyPortalFlow();
  const subscriptionMode = isB2BSubscriptionPortalFlow();
  const forestSplitWrap = $('monthlyForestSplit') || (mvTreesIn ? mvTreesIn.closest('.monthly-forest-split') : null);
  const monthlyAggregationNoteBaseText = 'Die auf dem Zertifikat angezeigte Anzahl an Bäumen spiegelt den aktuellen Stand aller in diesem Monat bereits gesponserten Bäume wider.';
  const monthlyAggregationNoteFullText = monthlyAggregationNoteBaseText + ' Für ein Zertifikat mit einer festen Anzahl an Bäumen nutze das Event-Zertifikat.';
  const monthlySubscriptionNoteText = 'Mit dem Beginn deines Abos erhältst du einmal pro Monat einen Link zum Bezahlen per E-Mail.';

  function syncSubscriptionFrequencyUi(){
    if (!subscriptionMode) return;
    state.subscriptionFrequency = 'monthly';
    if (subscriptionFrequencyEl) subscriptionFrequencyEl.value = 'monthly';
  }

  function renderPersonalizedMonthlyFieldDisplay(){
    const fields = [
      { input: mvTreesIn, delta: mvDelta, value: (state.monthlyProjectForestTrees && state.monthlyProjectForestTrees.mv) || 0 },
      { input: byTreesIn, delta: byDelta, value: (state.monthlyProjectForestTrees && state.monthlyProjectForestTrees.by) || 0 },
      { input: rpTreesIn, delta: rpDelta, value: (state.monthlyProjectForestTrees && state.monthlyProjectForestTrees.rp) || 0 }
    ];

    fields.forEach(({ input, delta, value })=>{
      if (delta) delta.textContent = '';
      if (!input) return;
      if (usesLockedMonthlyProjectDeltaFlow()){
        const n = Math.max(0, parseInt(value, 10) || 0);
        try{ input.type = 'text'; }catch(_){}
        input.inputMode = 'none';
        input.value = n > 0 ? ('+' + String(n)) : '+0';
      } else {
        try{ input.type = 'number'; }catch(_){}
        input.inputMode = 'numeric';
      }
    });
  }

  function renderMonthlyIntroAndDeltas(){
    const isEventCertificatePhase = isB2BEventCertificatePhase();
    if (monthlyStepRibbonText){
      monthlyStepRibbonText.textContent = subscriptionMode
        ? 'Baum-Abo'
        : (isEventCertificatePhase ? 'Event-Zertifikat' : 'Sammel-Zertifikat');
    }
    if (summarySenderRibbonTextEl){
      summarySenderRibbonTextEl.textContent = subscriptionMode
        ? 'Name oder Logo auf dem Abo-Zertifikat'
        : 'Name oder Logo auf dem Zertifikat';
    }
    if (monthlyStepIntro){
      monthlyStepIntro.textContent = subscriptionMode
        ? 'Starte hier dein Baum-Abonnement und pflanze regelmäßig Bäume. Gestalte dein Zertifikat, bestimme Anzahl, Forst und Häufigkeit und freut euch über euren wachsenden Firmenwald.'
        : quickMonthlyMode
        ? 'Dieses Monatszertifikat übernimmt automatisch den aktuellen Stand der Schnellausstellung. Monat und Baumanzahl sind fest vorgegeben, Logo und Gestaltung kannst du hier noch anpassen.'
        : isB2BPersonalizedPortalFlow()
        ? 'Dieses Sammel-Zertifikat zeigt den aktuellen Stand des gewählten Monats und wird durch die Bäume aus diesem Projekt ergänzt.'
        : (isB2BEventSummaryPhase()
            ? 'Dieses Sammel-Zertifikat zeigt den aktuellen Stand des gewählten Monats und wird durch die Bäume aus diesem Event ergänzt.'
            : (isEventCertificatePhase
                ? 'Hier gestaltest du dein Event-Zertifikat für diesen Anlass.'
                : 'Hier kannst du eine beliebige Anzahl an Bäumen sponsern.'));
    }
    const shouldUseFullAggregationNote = !subscriptionMode && !quickMonthlyMode && !isB2BPersonalizedPortalFlow() && !isB2BEventSummaryPhase() && !isEventCertificatePhase;
    if (monthlyAggregationNoteTextEl){
      monthlyAggregationNoteTextEl.textContent = subscriptionMode
        ? monthlySubscriptionNoteText
        : shouldUseFullAggregationNote
        ? monthlyAggregationNoteFullText
        : monthlyAggregationNoteBaseText;
    }
    if (monthlyAggregationNote){
      monthlyAggregationNote.style.display = isEventCertificatePhase ? 'none' : 'block';
    }
    if (monthlyPreviewJump){
      monthlyPreviewJump.style.display = 'inline-flex';
    }

    if (!mvDelta || !byDelta || !rpDelta) return;
    if (!usesLockedMonthlyProjectDeltaFlow()){
      mvDelta.textContent = '';
      byDelta.textContent = '';
      rpDelta.textContent = '';
      return;
    }
    mvDelta.textContent = '';
    byDelta.textContent = '';
    rpDelta.textContent = '';
  }

  const shouldLockMonthlySelection = usesLockedMonthlyProjectDeltaFlow();
  if (shouldLockMonthlySelection){
    if (!quickMonthlyMode){
      syncMonthlyStateFromCurrentCertFlow();
    }
  }
  if (subscriptionControls){
    subscriptionControls.style.display = subscriptionMode ? 'block' : 'none';
  }
  if (treesField){
    treesField.style.display = subscriptionMode ? '' : 'none';
  }
  if (monthField){
    monthField.style.display = subscriptionMode ? 'none' : '';
  }
  if (treesLabel){
    treesLabel.textContent = subscriptionMode ? 'Anzahl der Bäume' : 'Bäume';
  }
  if (monthLabel){
    monthLabel.textContent = subscriptionMode ? 'Beginn' : 'Monat';
  }
  if (subscriptionActiveEl){
    subscriptionActiveEl.checked = state.subscriptionActive !== false;
  }
  if (subscriptionFrequencyEl){
    subscriptionFrequencyEl.value = normalizeSubscriptionFrequency(state.subscriptionFrequency);
  }
  if (subscriptionCountModeEl){
    subscriptionCountModeEl.value = normalizeSubscriptionCountMode(state.subscriptionCountMode);
  }
  if (subscriptionForestCodeEl){
    subscriptionForestCodeEl.value = normalizeSubscriptionForestCode(state.subscriptionForestCode);
  }
  if (subscriptionStartDateEl){
    subscriptionStartDateEl.value = normalizeSubscriptionStartDate(state.subscriptionStartDate || '');
  }
  const monthFieldWrap = getEventMonthFieldWrap();
  if (monthFieldWrap){
    monthFieldWrap.style.display = (subscriptionMode || isB2BEventCertificatePhase() || quickMonthlyMode) ? 'none' : '';
  }
  if (eventClaimWrap){
    eventClaimWrap.style.display = (!subscriptionMode && isB2BEventCertificatePhase()) ? '' : 'none';
  }
  if (forestSplitWrap){
    forestSplitWrap.style.display = (quickMonthlyMode || subscriptionMode) ? 'none' : 'grid';
  }
  if (monthlyPlaceRow){
    monthlyPlaceRow.style.display = subscriptionMode ? 'none' : '';
  }

  function currentMonthlyContributionEstimate(){
    if (usesLockedMonthlyProjectDeltaFlow()){
      try{
        if (state.seriesEnabled && Array.isArray(state.seriesRows) && state.seriesRows.length){
          let sum = 0;
          for (let i = 0; i < state.seriesRows.length; i++){
            sum += Math.max(1, parseInt(getTreesForIndex(i), 10) || 1);
          }
          return Math.max(1, sum);
        }
      }catch(_){}
      return Math.max(1, parseInt(state.trees || 1, 10) || 1);
    }
    return 0;
  }

  async function loadExistingMonthlyState(){
    if (!isB2BPortalFlow() || !state.b2bPortal || !state.b2bPortal.customerRef || !state.monthlyMonth) return;
    const wantedMonth = String(state.monthlyMonth || '').trim();
    if (!/^\d{4}-\d{2}$/.test(wantedMonth)) return;
    try{
      const res = await fetch(
        API_BASE + '/api2/b2b/monthly/get?customer_ref=' + encodeURIComponent(state.b2bPortal.customerRef) + '&month=' + encodeURIComponent(wantedMonth),
        { credentials:'omit' }
      );
      const js = await res.json().catch(function(){ return {}; });
      if (!res.ok || !js || js.ok !== true) return;
      if (isB2BEventCertificatePhase()) return;
      const baseTrees = Math.max(0, parseInt(js.tree_count || 0, 10) || 0);
      const baseForestMap = {
        mv: Math.max(0, parseInt(js.forest_tree_map && js.forest_tree_map.mv || 0, 10) || 0),
        by: Math.max(0, parseInt(js.forest_tree_map && js.forest_tree_map.by || 0, 10) || 0),
        rp: Math.max(0, parseInt(js.forest_tree_map && js.forest_tree_map.rp || 0, 10) || 0)
      };
      if (quickMonthlyMode){
        state.monthlyServerBaseTrees = 0;
        state.monthlyServerLoadedMonth = wantedMonth;
        state.monthlyServerBaseForestTrees = { mv:0, by:0, rp:0 };
        state.monthlyProjectForestTrees = {
          mv: Math.max(0, parseInt(baseForestMap.mv, 10) || 0),
          by: Math.max(0, parseInt(baseForestMap.by, 10) || 0),
          rp: Math.max(0, parseInt(baseForestMap.rp, 10) || 0)
        };
        setMonthlyAggregateFromBaseAndProject();
        if (treesIn) treesIn.value = String(Math.max(0, parseInt(baseTrees, 10) || 0));
        if (mvTreesIn) mvTreesIn.value = String(state.monthlyProjectForestTrees.mv || 0);
        if (byTreesIn) byTreesIn.value = String(state.monthlyProjectForestTrees.by || 0);
        if (rpTreesIn) rpTreesIn.value = String(state.monthlyProjectForestTrees.rp || 0);
        if (mvCb) mvCb.checked = state.monthlyProjectForestTrees.mv > 0;
        if (byCb) byCb.checked = state.monthlyProjectForestTrees.by > 0;
        if (rpCb) rpCb.checked = state.monthlyProjectForestTrees.rp > 0;
        renderPersonalizedMonthlyFieldDisplay();
        renderMonthlyIntroAndDeltas();
        applyMonthlyChanges();
        updateQtyLabel();
        updateCo2Label();
        return;
      }
      state.monthlyServerBaseTrees = baseTrees;
      state.monthlyServerLoadedMonth = wantedMonth;
      state.monthlyServerBaseForestTrees = baseForestMap;
      if (!state.monthlyUserEdited || usesLockedMonthlyProjectDeltaFlow()){
        if (usesLockedMonthlyProjectDeltaFlow()){
          syncMonthlyStateFromCurrentCertFlow();
        } else {
          let addDist = getMonthlyProjectForestTrees();
          const currentAddTotal = (addDist.mv || 0) + (addDist.by || 0) + (addDist.rp || 0);
          if (currentAddTotal < 0){
            addDist = { mv:0, by:0, rp:0 };
          }
          state.monthlyProjectForestTrees = addDist;
          if (mvTreesIn) mvTreesIn.value = String(addDist.mv || 0);
          if (byTreesIn) byTreesIn.value = String(addDist.by || 0);
          if (rpTreesIn) rpTreesIn.value = String(addDist.rp || 0);
          setMonthlyAggregateFromBaseAndProject();
        }
        if (treesIn) treesIn.value = String(getMonthlyProjectTreeCount());
        const aggregateDist = getMonthlyForestTrees();
        if (mvCb) mvCb.checked = aggregateDist.mv > 0;
        if (byCb) byCb.checked = aggregateDist.by > 0;
        if (rpCb) rpCb.checked = aggregateDist.rp > 0;
        applyMonthlyChanges();
        updateQtyLabel();
        updateCo2Label();
      }
    }catch(_){}
  }

  // Defaults: Monat = aktuell, wenn leer
  if (monthIn && !state.monthlyMonth){
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth()+1).padStart(2,'0');
    state.monthlyMonth = `${y}-${m}`;
  }

  if (subscriptionMode){
    state.subscriptionFrequency = normalizeSubscriptionFrequency(state.subscriptionFrequency);
    state.subscriptionCountMode = normalizeSubscriptionCountMode(state.subscriptionCountMode);
    state.subscriptionForestCode = normalizeSubscriptionForestCode(state.subscriptionForestCode);
    state.subscriptionFixedTrees = Math.max(1, parseInt(state.subscriptionFixedTrees, 10) || 1);
    state.subscriptionStartDate = normalizeSubscriptionStartDate(state.subscriptionStartDate || '');
    if (typeof state.subscriptionActive !== 'boolean'){
      state.subscriptionActive = true;
    }
    syncSubscriptionFrequencyUi();
    if (subscriptionFrequencyEl) subscriptionFrequencyEl.value = state.subscriptionFrequency;
    if (subscriptionCountModeEl) subscriptionCountModeEl.value = state.subscriptionCountMode;
    if (subscriptionForestCodeEl) subscriptionForestCodeEl.value = state.subscriptionForestCode;
    if (subscriptionActiveEl) subscriptionActiveEl.checked = state.subscriptionActive !== false;
    if (subscriptionStartDateEl) subscriptionStartDateEl.value = state.subscriptionStartDate;
  }

  // Default Ort/Datum: heute (wie bisher)
  if (placeTa && !state.monthlyPlaceText){
    state.monthlyPlaceText = getFreshMonthlyPlaceDefault();
  }
  if (placeTa) placeTa.value = String(state.monthlyPlaceText || '');
  if (eventClaimTa) eventClaimTa.value = String(state.eventClaimText || '');

  if (subscriptionMode){
    syncSubscriptionMonthlyState();
    if (placeTa) placeTa.value = String(state.monthlyPlaceText || '');
  } else if (!usesLockedMonthlyProjectDeltaFlow() && !quickMonthlyMode){
    if (!state.monthlyProjectForestTrees){
      state.monthlyProjectForestTrees = { mv:0, by:0, rp:0 };
    }
    setMonthlyAggregateFromBaseAndProject();
  }
  syncMonthlySelectionFromForestTrees();

  if (treesIn) treesIn.value = String(
    subscriptionMode
      ? Math.max(1, parseInt(state.subscriptionFixedTrees, 10) || 1)
      : usesLockedMonthlyProjectDeltaFlow()
      ? (parseInt(state.monthlyTrees, 10) || 0)
      : getMonthlyProjectTreeCount()
  );
  if (monthIn) monthIn.value = String(state.monthlyMonth || '');

  const sel = getMonthlySelectedForests();
  if (mvCb) mvCb.checked = sel.includes('mv');
  if (byCb) byCb.checked = sel.includes('by');
  if (rpCb) rpCb.checked = sel.includes('rp');
  const dist = getMonthlyProjectForestTrees();
  if (mvTreesIn) mvTreesIn.value = String(dist.mv || 0);
  if (byTreesIn) byTreesIn.value = String(dist.by || 0);
  if (rpTreesIn) rpTreesIn.value = String(dist.rp || 0);
  renderPersonalizedMonthlyFieldDisplay();
  renderMonthlyIntroAndDeltas();

  if (treesIn) treesIn.disabled = subscriptionMode ? (state.subscriptionCountMode === 'days_in_month') : shouldLockMonthlySelection;
  if (mvCb) mvCb.disabled = shouldLockMonthlySelection;
  if (byCb) byCb.disabled = shouldLockMonthlySelection;
  if (rpCb) rpCb.disabled = shouldLockMonthlySelection;
  if (mvTreesIn) mvTreesIn.disabled = shouldLockMonthlySelection;
  if (byTreesIn) byTreesIn.disabled = shouldLockMonthlySelection;
  if (rpTreesIn) rpTreesIn.disabled = shouldLockMonthlySelection;

  function applyMonthlyChanges(ev){
    const changedEl = ev && ev.target ? ev.target : null;
    if (changedEl === treesIn || changedEl === mvTreesIn || changedEl === byTreesIn || changedEl === rpTreesIn){
      state.monthlyUserEdited = true;
    }
    if (subscriptionMode){
      if (subscriptionActiveEl){
        state.subscriptionActive = !!subscriptionActiveEl.checked;
      }
      if (subscriptionFrequencyEl){
        state.subscriptionFrequency = normalizeSubscriptionFrequency(subscriptionFrequencyEl.value);
      }
      if (subscriptionCountModeEl){
        state.subscriptionCountMode = normalizeSubscriptionCountMode(subscriptionCountModeEl.value);
      }
      if (subscriptionForestCodeEl){
        state.subscriptionForestCode = normalizeSubscriptionForestCode(subscriptionForestCodeEl.value);
      }
      if (subscriptionStartDateEl){
        state.subscriptionStartDate = normalizeSubscriptionStartDate(subscriptionStartDateEl.value);
      }
      if (monthIn){
        const v = String(monthIn.value || '').trim();
        if (/^\d{4}-\d{2}$/.test(v)){
          state.monthlyMonth = v;
        }
      }
      if (treesIn){
        const fixedTrees = parseInt(String(treesIn.value || '').replace(/\D/g,''), 10);
        state.subscriptionFixedTrees = Math.max(1, fixedTrees || 1);
      }
      syncSubscriptionFrequencyUi();
      syncSubscriptionMonthlyState();
      if (subscriptionFrequencyEl) subscriptionFrequencyEl.value = state.subscriptionFrequency;
      if (subscriptionCountModeEl) subscriptionCountModeEl.value = state.subscriptionCountMode;
      if (subscriptionForestCodeEl) subscriptionForestCodeEl.value = state.subscriptionForestCode;
      if (subscriptionActiveEl) subscriptionActiveEl.checked = state.subscriptionActive !== false;
      if (subscriptionStartDateEl) subscriptionStartDateEl.value = state.subscriptionStartDate;
      if (treesIn){
        treesIn.disabled = state.subscriptionCountMode === 'days_in_month';
        treesIn.value = String(Math.max(1, parseInt(state.subscriptionFixedTrees, 10) || 1));
      }
      if (monthIn){
        monthIn.value = String(state.monthlyMonth || '');
      }
      if (placeTa){
        placeTa.value = String(state.monthlyPlaceText || '');
      }
      updatePrice();
      updateClaim();
      updatePreview();
      applyMonthlyForestsToPreview();
      renderMonthlyQr();
      renderMonthlyId();
      renderMonthlyUrl();
      renderPersonalizedMonthlyFieldDisplay();
      renderMonthlyIntroAndDeltas();
      if (!hasEditOrClone && DRAFT_KEY){
        scheduleDraftSave();
      }
      invalidateMonthlyFinalCache();
      const tot = totalSteps();
      if (!isB2BSummaryOnlyPortalFlow()
          && !(isB2BPersonalizedPortalFlow() && state.mode === 'cert' && useLiveSeriesFinalPreviewMode())
          && state.step === tot
          && typeof renderMonthlyFinalPreviewIfNeeded === 'function'){
        setTimeout(()=>{ renderMonthlyFinalPreviewIfNeeded(true); }, 0);
      }
      return;
    }
    const prevMonth = String(state.monthlyMonth || '');
    // Month
    if (monthIn){
      const v = String(monthIn.value || '').trim();
      state.monthlyMonth = (/^\d{4}-\d{2}$/.test(v)) ? v : state.monthlyMonth;
      if (state.monthlyMonth !== prevMonth){
        state.monthlyUserEdited = false;
        state.monthlyCoordsLoaded = false;
        state.monthlyCoordsCacheKey = '';
      }
    }

    const nextDist = {
      mv: Math.max(0, parseInt(String(mvTreesIn && mvTreesIn.value || '').replace(/\D/g,''), 10) || 0),
      by: Math.max(0, parseInt(String(byTreesIn && byTreesIn.value || '').replace(/\D/g,''), 10) || 0),
      rp: Math.max(0, parseInt(String(rpTreesIn && rpTreesIn.value || '').replace(/\D/g,''), 10) || 0)
    };

    const hasSplitValues = (nextDist.mv + nextDist.by + nextDist.rp) > 0;
    if (hasSplitValues){
      state.monthlyProjectForestTrees = nextDist;
      setMonthlyAggregateFromBaseAndProject();
      if (mvCb) mvCb.checked = nextDist.mv > 0;
      if (byCb) byCb.checked = nextDist.by > 0;
      if (rpCb) rpCb.checked = nextDist.rp > 0;
      if (treesIn) treesIn.value = String(
        usesLockedMonthlyProjectDeltaFlow()
          ? Math.max(0, parseInt(state.monthlyTrees, 10) || 0)
          : getMonthlyProjectTreeCount()
      );
    } else {
      // Fallback auf alte Logik für vorhandene Checkbox-/Gesamtsummen-Fälle
      if (treesIn){
        const v = parseInt(String(treesIn.value || '').replace(/\D/g,''), 10);
        if (usesLockedMonthlyProjectDeltaFlow()){
          state.monthlyTrees = (isFinite(v) && v >= 0) ? v : 0;
        }
      }

      const forests = [];
      if (mvCb && mvCb.checked) forests.push('mv');
      if (byCb && byCb.checked) forests.push('by');
      if (rpCb && rpCb.checked) forests.push('rp');
      state.monthlyForests = forests;

      const changedForestSplitField =
        changedEl === mvTreesIn ||
        changedEl === byTreesIn ||
        changedEl === rpTreesIn;
      const selected = getMonthlySelectedForests();
      const sourceTotal = usesLockedMonthlyProjectDeltaFlow()
        ? Math.max(0, parseInt(state.monthlyTrees, 10) || 0)
        : (
            changedForestSplitField
              ? (nextDist.mv + nextDist.by + nextDist.rp)
              : Math.max(0, parseInt(String(treesIn && treesIn.value || '').replace(/\D/g,''), 10) || 0)
          );
      const shareBase = Math.floor(sourceTotal / selected.length);
      let remainder = sourceTotal - (shareBase * selected.length);
      const fallbackDist = { mv:0, by:0, rp:0 };
      selected.forEach((code)=>{
        fallbackDist[code] = shareBase + (remainder > 0 ? 1 : 0);
        if (remainder > 0) remainder--;
      });
      if (usesLockedMonthlyProjectDeltaFlow()){
        state.monthlyForestTrees = fallbackDist;
        syncMonthlySelectionFromForestTrees();
        state.monthlyProjectForestTrees = Object.assign({}, fallbackDist);
      } else {
        state.monthlyProjectForestTrees = fallbackDist;
        setMonthlyAggregateFromBaseAndProject();
      }
      if (mvTreesIn) mvTreesIn.value = String(fallbackDist.mv || 0);
      if (byTreesIn) byTreesIn.value = String(fallbackDist.by || 0);
      if (rpTreesIn) rpTreesIn.value = String(fallbackDist.rp || 0);
      if (treesIn) treesIn.value = String(usesLockedMonthlyProjectDeltaFlow() ? Math.max(0, parseInt(state.monthlyTrees, 10) || 0) : getMonthlyProjectTreeCount());
    }

    // Ort/Datum (max. 2 Zeilen) übernehmen
if (placeTa){
  // max 2 Zeilen / je Zeile max 50 Zeichen (wie die anderen Textfelder)
  let v = (placeTa.value || '').replace(/\r/g,'');
  let maxLines = isB2BEventCertificatePhase() ? 1 : 2;
  let lines = v.split('\n').slice(0,maxLines).map(l => (l || '').slice(0,50));
  v = lines.join('\n');

  if (v !== placeTa.value) placeTa.value = v;

  state.monthlyPlaceText = v;
}

    if (eventClaimTa){
      state.eventClaimText = String(eventClaimTa.value || '').replace(/\r/g,'');
    }

    // URL

    // Apply to preview
    updatePrice();
    updateClaim();
    updatePreview();
    applyMonthlyForestsToPreview();
renderMonthlyQr();
renderMonthlyId();
renderMonthlyUrl();
renderPersonalizedMonthlyFieldDisplay();
renderMonthlyIntroAndDeltas();

    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }

    if (state.monthlyMonth !== prevMonth){
      loadExistingMonthlyState();
    }

// WICHTIG: Step-11 Monats-PNG ist gecached → bei jeder Änderung invalidieren
invalidateMonthlyFinalCache();

// Optional: wenn du gerade in der Vorschau bist, sofort neu rendern
const tot = totalSteps();
if (!isB2BSummaryOnlyPortalFlow()
    && !(isB2BPersonalizedPortalFlow() && state.mode === 'cert' && useLiveSeriesFinalPreviewMode())
    && state.step === tot
    && typeof renderMonthlyFinalPreviewIfNeeded === 'function'){
  setTimeout(()=>{ renderMonthlyFinalPreviewIfNeeded(true); }, 0);
}


  }

  // Bind listeners (idempotent)
  [treesIn, monthIn, mvCb, byCb, rpCb, mvTreesIn, byTreesIn, rpTreesIn, placeTa, eventClaimTa, subscriptionActiveEl, subscriptionFrequencyEl, subscriptionCountModeEl, subscriptionForestCodeEl, subscriptionStartDateEl].forEach(el=>{
    if (!el) return;
    if (el.dataset && el.dataset.boundMonthly === '1') return;
    if (el.dataset) el.dataset.boundMonthly = '1';
    el.addEventListener('input', applyMonthlyChanges);
    el.addEventListener('change', applyMonthlyChanges);
  });
  if (subscriptionStartNowEl && subscriptionStartNowEl.dataset.ptBoundMonthly !== '1'){
    subscriptionStartNowEl.dataset.ptBoundMonthly = '1';
    subscriptionStartNowEl.addEventListener('click', function(ev){
      if (ev && typeof ev.preventDefault === 'function') ev.preventDefault();
      if (subscriptionStartDateEl) subscriptionStartDateEl.value = todayIsoDate();
      applyMonthlyChanges({ target: subscriptionStartDateEl || subscriptionStartNowEl });
    });
  }
  if (monthlyPreviewJump && monthlyPreviewJump.dataset.boundMonthlyPreview !== '1'){
    monthlyPreviewJump.dataset.boundMonthlyPreview = '1';
    monthlyPreviewJump.addEventListener('click', function(ev){
      ev.preventDefault();
      scrollActiveStepToPreview();
    });
  }

  // Initial apply
  applyMonthlyChanges();
  if (!subscriptionMode){
    loadExistingMonthlyState();
  }
}


// >>> NEU: Helfer für "ohne Baumpflanzung"
function getBaseVariantIdForNoTree(){
  // 1) Falls wir eine Base-Variante aus dem DOM/URL haben – nimm die
  if (baseVariantId) return baseVariantId;

  // 2) Gift/Label: aus Wizard-State oder URL
  if (state.mode === 'gift' || state.mode === 'label'){
    if (state.giftVariantId) return state.giftVariantId;
    if (giftVariantParam)    return giftVariantParam;
  }

  // 3) Cert (zur Sicherheit – "ohne Baum" wird hier eigentlich nie angezeigt)
  if (state.mode === 'cert'){
    if (state.certVariantId) return state.certVariantId;
    if (certVariantParam)    return certVariantParam;
  }

  return null;
}

    // Produkt-Tags aus dem Section-Attribut lesen (für Extras in Step 9)
  let productTags = [];
  if(rootEl && rootEl.dataset.ptTags){
    productTags = rootEl.dataset.ptTags
      .toLowerCase()
      .split(',')
      .map(t => t.trim())
      .filter(Boolean);
  }

  // NEU: URL-Tags IMMER dazumergen (Produktseite schickt Gift-Produkt-Tags per ?tags=…)
  const urlTags = (params.get('tags') || '')
    .toLowerCase()
    .split(',')
    .map(t => t.trim())
    .filter(Boolean);

  urlTags.forEach(function(t){
    if (t && !productTags.includes(t)){
      productTags.push(t);
    }
  });

  const hasTag = tag => productTags.includes(String(tag).toLowerCase());

  // Verfügbarkeit der Extras per Tag steuern
  state.extraHeartAvailable = hasTag('pt_herzstecker');
  state.extraJustAvailable  = hasTag('pt_justmarried');
  state.bookmarkAvailable   = hasTag('pt_lesezeichen');

  const wiz=$('wiz');
  const btnPreview=$('btnPreview');
  const btnCart=$('btnCart');
  const btnCheckout=$('btnCheckout');
  const btnCartHeader=$('btnCartHeader');
  const introNoTreePriceEl   = $('introNoTreePrice');
  const introWithTreePriceEl = $('introWithTreePrice');
  const wizPrev=$('wizPrev');
  const wizNext=$('wizNext');
  const wizBody=document.querySelector('.wiz-body');
  const wizClose=$('wizClose');
const wizExtNote = $('wizExtNote');

if (wizExtNote && isExternalWizard){
  wizExtNote.style.display = 'block';
}


    const wizLoading = $('wizLoading');
  const wizLoadingClose = $('wizLoadingClose');
  const pvBackToStep=$('pvBackToStep');
  const introNext=$('introNext');
    // Mini-Preview-Container aus Schritt 8 für alle Schritte wiederverwenden
  const miniPreviewWrap = document.querySelector('#step8 .frame-preview-wrap');
  const miniPreviewHost = $('a4Host8');

  if (isLockedEdit && loadingTextEl){
    loadingTextEl.textContent = 'Dein Zertifikat wird im Hintergrund aktualisiert.';
  }

  /* Mode-abhängige UI (nur Text im Step 9) */
  function applyModeUi(){
    const step9Ribbon  = document.querySelector('#step9 .wiz-ribbon__text');
    const step9Intro   = document.querySelector('#step9 .wiz-intro');
    const step9Hint    = document.querySelector('#step9 .wiz-hint');

    if(state.mode === 'gift' || state.mode === 'label'){
      if(step9Ribbon){ step9Ribbon.textContent = 'Papier & Extras'; }
      if(step9Intro){
        step9Intro.textContent =
          'Wähle das Papier und optionale Geschenk-Extras.';
      }
      if(step9Hint){
        step9Hint.textContent =
          '';
      }
    } else {
      if(step9Ribbon){ step9Ribbon.textContent = 'Versandart'; }
      if(step9Intro){
        step9Intro.textContent = 'Wähle, wie du dein Zertifikat erhalten möchtest.';
      }
      if(step9Hint){
        step9Hint.textContent =
          'Digital ist perfekt zum Sofort-Verschenken. Beim Druck in der Mappe kannst du Weiß oder Graspapier wählen.';
      }
    }
  }
  applyModeUi();

  /* ===== Mobile: Floating-Navigation beim Tippen ===== */
  const wizCard = document.querySelector('.wiz-card');
  const wizNav  = document.querySelector('.wiz-nav');
  const isIOS   = /iP(hone|ad|od)/.test((window.navigator && window.navigator.userAgent) || '');

  // Popup-Elemente (PDF-Hinweis)
  const dlgDigital   = $('wizConfirmDigital');
  const dlgOk        = $('wizConfirmOk');
  const dlgChange    = $('wizConfirmChange');

    function updateDigitalConfirmText(){
    if (!dlgDigital) return;

    const titleEl = dlgDigital.querySelector('.wiz-confirm__title');
    const texts   = dlgDigital.querySelectorAll('.wiz-confirm__text');
    const main    = texts[0];
    const hint    = texts[1];

    if (!titleEl || !main || !hint) return;

    // Serienmodus im Cert-Mode?
    if (state.mode === 'cert' && state.seriesEnabled && hasSeriesRows()){
      const total = state.seriesRows.length;
      let digitalCount = 0;
      let printCount   = 0;

      for (let i = 0; i < total; i++){
        const d = getDeliveryForIndex(i);
        if (d === 'digital') digitalCount++;
        else printCount++;
      }

      // Sicherheits-Fallback, sollte praktisch nicht passieren
      if (digitalCount === 0){
        titleEl.textContent = 'Du bestellst ein PDF-Zertifikat 📄';
        main.innerHTML =
          'Aktuell ist <strong>„Digital als PDF zum Herunterladen“</strong> ausgewählt. ' +
          'Du erhältst dein Baumzertifikat also als <strong>Download-PDF</strong>, ' +
          '<strong>nicht</strong> als gedruckte Urkunde per Post.';
        hint.innerHTML =
          'Wenn du eine <strong>gedruckte Urkunde in einer Mappe</strong> möchtest, ' +
          'wähle im Schritt „Versandart“ die Option ' +
          '<strong>„Gedruckt in einer Urkundenmappe“</strong>.';
        return;
      }

      // Fall 1: ALLE Zertifikate digital → Mehrzahl
      if (digitalCount === total){
        titleEl.textContent = 'Du bestellst PDF-Zertifikate 📄';
        main.innerHTML =
          'Aktuell sind <strong>alle Zertifikate</strong> auf ' +
          '<strong>„Digital als PDF zum Herunterladen“</strong> eingestellt. ' +
          'Du erhältst deine Baumzertifikate also als <strong>Download-PDFs</strong>, ' +
          '<strong>nicht</strong> als gedruckte Urkunden per Post.';
        hint.innerHTML =
          'Wenn du <strong>gedruckte Urkunden in einer Mappe</strong> möchtest, ' +
          'gehe zurück zum Schritt „Versandart“ und wähle dort für die Serie ' +
          'die Option <strong>„Gedruckt in einer Urkundenmappe“</strong>.';
        return;
      }

      // Fall 2: Mischung aus digital & Druck
      const pluralDigital = digitalCount === 1 ? '1 Zertifikat' : digitalCount + ' Zertifikate';
      const pluralPrint   = printCount   === 1 ? '1 Zertifikat' : printCount   + ' Zertifikate';

      titleEl.textContent = 'Achtung: Mischung aus PDF und Druck';
      main.innerHTML =
        'In deiner Serie sind aktuell <strong>' + pluralDigital + '</strong> als ' +
        '<strong>„Digital als PDF zum Herunterladen“</strong> ' +
        'und <strong>' + pluralPrint + '</strong> als ' +
        '<strong>gedruckte Urkunden in Mappen</strong> eingestellt.';
      hint.innerHTML =
        'Bitte prüfe, ob diese Mischung so gewünscht ist. ' +
        'Wenn <strong>alle Zertifikate gedruckt</strong> werden sollen, ' +
        'gehe zurück zum Schritt „Versandart“ und stelle bei allen Zertifikaten ' +
        '<strong>„Gedruckt in einer Urkundenmappe“</strong> ein.';
      return;
    }

    // Standard-Fall (kein Serienmodus): ursprünglicher Text (Singular)
    titleEl.textContent = 'Du bestellst ein PDF-Zertifikat 📄';
    main.innerHTML =
      'Aktuell ist <strong>„Digital als PDF zum Herunterladen“</strong> ausgewählt. ' +
      'Du erhältst dein Baumzertifikat also als <strong>Download-PDF</strong>, ' +
      '<strong>nicht</strong> als gedruckte Urkunde per Post.';
    hint.innerHTML =
      'Wenn du eine <strong>gedruckte Urkunde in einer Mappe</strong> möchtest, ' +
      'wähle im Schritt „Versandart“ die Option ' +
      '<strong>„Gedruckt in einer Urkundenmappe“</strong>.';
  }



    // NEU: Popup für "ohne Baumpflanzung"
  const dlgNoTree    = $('wizConfirmNoTree');
  const dlgNoTreeOk  = $('wizNoTreeOk');
  const dlgNoTreeCancel = $('wizNoTreeCancel');
  let pendingCheckoutMode = null; // false = Warenkorb, true = Kasse

  let noTreeExtrasInitialized = false;

  function setupNoTreeExtrasInPopup(){
    if(!(state.mode === 'gift' || state.mode === 'label')) return;
    if(!dlgNoTree) return;

    const card = dlgNoTree.querySelector('.wiz-confirm__card');
    if(!card) return;

    // Host und Grid nur EINMAL erzeugen
    let host = dlgNoTree.querySelector('#noTreeExtrasHost');
    let grid = host && host.querySelector('.wiz-notree-extras-grid');

    if(!noTreeExtrasInitialized){
      noTreeExtrasInitialized = true;

      const buttonsRow = card.querySelector('.wiz-confirm__buttons');

      host = document.createElement('div');
      host.id = 'noTreeExtrasHost';
      host.className = 'wiz-notree-extras';
      card.insertBefore(host, buttonsRow);

  //    const intro = document.createElement('p');
  //    intro.className = 'wiz-confirm__text wiz-confirm__text--hint';
  //    intro.textContent =
  //      '';
  //    host.appendChild(intro);

      grid = document.createElement('div');
      grid.className = 'wiz-notree-extras-grid';
      host.appendChild(grid);
    }

    if(!grid) return;

    // Bestehende Gift/Extras-Blöcke aus Step 9 TEMPORÄR ins Popup verschieben
    const giftWrapStep   = $('giftWrapStep');
    const giftExtrasStep = $('giftExtrasStep');

    if(giftWrapStep && giftWrapStep.parentNode !== grid){
      grid.appendChild(giftWrapStep);
    }
    if(giftExtrasStep && giftExtrasStep.parentNode !== grid){
      grid.appendChild(giftExtrasStep);
    }

    // Papierauswahl macht ohne Zertifikat/Bäume keinen Sinn → ausblenden
    const printPaper = $('printPaperOptions');
    if(printPaper){ printPaper.style.display = 'none'; }

    updatePrice();
  }

    // Hilfsfunktion: Extras wieder in Step 9 zurückschieben
  function restoreNoTreeExtrasToStep9(){
    const giftWrapStep   = $('giftWrapStep');
    const giftExtrasStep = $('giftExtrasStep');

    if(step9ExtrasGrid){
      if(giftWrapStep && giftWrapStep.parentNode !== step9ExtrasGrid){
        step9ExtrasGrid.appendChild(giftWrapStep);
      }
      if(giftExtrasStep && giftExtrasStep.parentNode !== step9ExtrasGrid){
        step9ExtrasGrid.appendChild(giftExtrasStep);
      }
    }

    // Papier-Auswahl wieder normal einblenden (je nach Modus)
    togglePaperOptions();
  }

  // Zustand der Extras komplett zurücksetzen (für Baum-Flow)
  function resetNoTreeExtrasState(){
    state.giftwrapSelected   = false;
    state.extraHeartSelected = false;
    state.extraJustSelected  = false;
    state.bookmarkSelected   = false;
    state.bookmarkChoice     = null;
    syncGiftExtrasFromState();
  }

  function openNoTreeConfirm(){
    if(!dlgNoTree){
      // Fallback: Produkt ohne Baum direkt in den Warenkorb
      addBaseProductWithExtras(false);
      return;
    }

    // No-Tree-Modus aktivieren: keine Baumpflanzung, aber Extras erlaubt
    state.noTreeExtrasMode = true;
    state.treeAddonSelected = false;
    updatePrice();
    togglePaperOptions();

    setupNoTreeExtrasInPopup();

    dlgNoTree.classList.add('open');
    dlgNoTree.setAttribute('aria-hidden','false');
    if(dlgNoTreeOk) dlgNoTreeOk.focus();
  }

  function closeNoTreeConfirm(){
    if(!dlgNoTree) return;
    dlgNoTree.classList.remove('open');
    dlgNoTree.setAttribute('aria-hidden','true');
  }

  if(dlgNoTreeOk){
    // "Weiter ohne Baumpflanzung" → Produkt + Extras in den Warenkorb
    dlgNoTreeOk.addEventListener('click', ()=>{
      addBaseProductWithExtras(false);
    });
  }

  if(dlgNoTreeCancel){
    // "Doch mit Baumpflanzung" → Popup schließen, Extras zurück nach Step 9 + resetten
    dlgNoTreeCancel.addEventListener('click', ()=>{
      state.noTreeExtrasMode = false;
      resetNoTreeExtrasState();
      restoreNoTreeExtrasToStep9();
      closeNoTreeConfirm();
      updatePrice();
    });
  }

  if(dlgNoTree){
    dlgNoTree.addEventListener('click',(e)=>{
      if(e.target === dlgNoTree || e.target.classList.contains('wiz-confirm__backdrop')){
        state.noTreeExtrasMode = false;
        resetNoTreeExtrasState();
        restoreNoTreeExtrasToStep9();
        closeNoTreeConfirm();
        updatePrice();
      }
    });
  }

  function openDigitalConfirm(goCheckout){
    if(!dlgDigital){
      addToCart(goCheckout);
      return;
    }

    // NEU: Text je nach Serien-/Versand-Konfiguration dynamisch setzen
    updateDigitalConfirmText();

    pendingCheckoutMode = !!goCheckout;
    dlgDigital.classList.add('open');
    dlgDigital.setAttribute('aria-hidden','false');
    if(dlgOk){ dlgOk.focus(); }
  }
  
  function closeDigitalConfirm(){
    if(!dlgDigital) return;
    dlgDigital.classList.remove('open');
    dlgDigital.setAttribute('aria-hidden','true');
  }
  if(dlgOk){
    dlgOk.addEventListener('click', ()=>{
      state.digitalConfirmed = true;
      closeDigitalConfirm();
      const mode = (pendingCheckoutMode === null) ? false : pendingCheckoutMode;
      addToCart(mode);
    });
  }
  if(dlgChange){
    dlgChange.addEventListener('click', ()=>{
      closeDigitalConfirm();
      state.digitalConfirmed = false;
      setStep(9);
    });
  }
  if(dlgDigital){
    dlgDigital.addEventListener('click',(e)=>{
      if(e.target === dlgDigital || e.target.classList.contains('wiz-confirm__backdrop')){
        closeDigitalConfirm();
      }
    });
  }

  function isSmallScreen(){
    return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  }
  function setEditingMode(on){
    if(!wizCard) return;
    if(on && isSmallScreen()){
      wizCard.classList.add('wiz-editing');
      if (wizNav) wizNav.classList.add('wiz-nav--compact');
    }else{
      wizCard.classList.remove('wiz-editing');
      if (wizNav) wizNav.classList.remove('wiz-nav--compact');
    }
  }
  if(wiz){
    wiz.addEventListener('focusin', (e)=>{
      if(!isSmallScreen()) return;
      const t = e.target; if(!t) return;
      if(t.tagName === 'TEXTAREA' ||
         (t.tagName === 'INPUT' && /^(text|number|email|tel|search)$/i.test(t.type))){
        setEditingMode(true);
      }
    });
    wiz.addEventListener('focusout', ()=>{
      if(!isSmallScreen()) return;
      setTimeout(()=>{
        const stillFocused = wiz.querySelector(
          'textarea:focus,'+
          'input[type="text"]:focus,'+
          'input[type="number"]:focus,'+
          'input[type="email"]:focus,'+
          'input[type="tel"]:focus,'+
          'input[type="search"]:focus'
        );
        if(!stillFocused){ setEditingMode(false); }
      }, 0);
    });
  }

  function setSubmitting(isSubmitting){
    [btnCart, btnCheckout].forEach(btn=>{
      if(!btn) return;
      btn.disabled = !!isSubmitting;
    });
  }

    // NEU: Loading-Overlay steuern
  function showLoadingOverlay(){
    if(!wizLoading) return;
    wizLoading.classList.add('open');
    wizLoading.setAttribute('aria-hidden','false');
  }

  function hideLoadingOverlay(){
    if(!wizLoading) return;
    wizLoading.classList.remove('open');
    wizLoading.setAttribute('aria-hidden','true');
  }

  if(wizLoadingClose){
    wizLoadingClose.addEventListener('click', ()=>{
      // User bricht „Warten“ ab – Buttons wieder freigeben, Overlay zu
      hideLoadingOverlay();
      setSubmitting(false);
    });
  }

  /* ===== Schritte / Navigation dynamisch (mit Grußkarten-Step) ===== */
function totalSteps(){
  // label: 0..12 (12 = Vorschau)
  if (state.mode === 'label') return 12;

  if (isB2BEventPortalFlow() && state.mode === 'cert') return 12;

  // ✅ B2B (cert): IMMER
  // 0..11 (10 = Monats-Zertifikat, 11 = Vorschau)
  if (isB2B && state.mode === 'cert') return 11;

  // cert + Serienmodus (B2C): 0..10 (10 = Vorschau, Grußkarte entfällt)
  if (state.mode === 'cert' && state.seriesEnabled) return 10;

  // normal: 0..11 (10 = Grußkarte, 11 = Vorschau)
  return 11;
}

function getEventFlowSteps(){
  return [10, 11, 12];
}

function getEventStepPosition(step){
  const steps = getEventFlowSteps();
  const idx = steps.indexOf(step);
  return idx >= 0 ? idx : -1;
}

function getNextEventStep(step){
  const steps = getEventFlowSteps();
  const idx = steps.indexOf(step);
  if (idx < 0) return step;
  return steps[Math.min(idx + 1, steps.length - 1)];
}

function getPrevEventStep(step){
  const steps = getEventFlowSteps();
  const idx = steps.indexOf(step);
  if (idx < 0) return step;
  return steps[Math.max(idx - 1, 0)];
}

function getDisplayStepInfo(step){
  if (isB2BEventPortalFlow() && state.mode === 'cert'){
    const pos = getEventStepPosition(step);
    if (pos >= 0) return { current: pos + 1, total: getEventFlowSteps().length };
  }
  if (isB2BSummaryOnlyPortalFlow() && state.mode === 'cert'){
    if (step === 10) return { current: 1, total: 2 };
    if (step === 11) return { current: 2, total: 2 };
  }
  return { current: step, total: totalSteps() };
}

function scrollWizardViewportToTop(stepId){
  const doScrollTop = function(){
    if (wizBody){
      wizBody.scrollTop = 0;
      if (typeof wizBody.scrollTo === 'function') wizBody.scrollTo(0, 0);
    }

    const stepInner =
      (stepId ? document.querySelector('#' + stepId + ' .step-inner') : null) ||
      document.querySelector('.step.active .step-inner');

    if (stepInner){
      stepInner.scrollTop = 0;
      if (typeof stepInner.scrollTo === 'function') stepInner.scrollTo(0, 0);
    }

    if (typeof window.scrollTo === 'function'){
      window.scrollTo(0, 0);
    }
  };

  requestAnimationFrame(function(){
    doScrollTop();
    requestAnimationFrame(doScrollTop);
  });
  setTimeout(doScrollTop, 120);
}

  function stepDomId(idx){
    // Neue logische Reihenfolge:
    // 0: Intro       -> #step0
    // 1: Schenkende  -> #step1
    // 2: Grammatik   -> #step4   (Claim)
    // 3: Beschenkte  -> #step2
    // 4: Anlass      -> #step3
    // 5..9 bleiben 1:1 (#step5..#step9)

    if (state.mode === 'label'){
      if (idx === 0) return 'step0';
      if (idx === 1) return 'step1';
      if (idx === 2) return 'step4';      // Grammatik
      if (idx === 3) return 'step2';      // Beschenkte:r
      if (idx === 4) return 'step3';      // Anlass
      if (idx >= 5 && idx <= 9) return 'step' + idx;
      if (idx === 10) return 'step10Label'; // Etikett bearbeiten
      if (idx === 11) return 'step10Greet'; // Grußkarte
      if (idx === 12) return 'step11';      // Vorschau (Etikett & Zertifikat)
} else {
  // cert / gift
  if (idx === 0) return 'step0';
  if (idx === 1) return 'step1';
  if (idx === 2) return 'step4';      // Grammatik
  if (idx === 3) return 'step2';      // Beschenkte:r
  if (idx === 4) return 'step3';      // Anlass

  if (idx >= 5 && idx <= 9) return 'step' + idx;

// Serienmodus im cert-Mode (NUR B2C): kein Grußkarten-Step,
// Index 10 ist direkt die Vorschau (#step10)
if (state.mode === 'cert' && state.seriesEnabled && !isB2B){
  if (idx === 10) return 'step10';   // Vorschau
  return;
}

  if (isB2BEventPortalFlow() && state.mode === 'cert'){
    if (idx === 10 || idx === 11) return 'step10Label';
    if (idx === 12) return 'step10';
  }

  // Normalfall (kein Serienmodus):
  // B2C: 10 = Grußkarte, 11 = Vorschau
  // B2B (?b2b=1): 10 = Monats-Zertifikat (alter Label-Step), 11 = Vorschau
  if (idx === 10){
    if (isB2B){ return 'step10Label'; }   // Monats-Zertifikat-Step
    return 'step10Greet';                 // Grußkarte
  }
  if (idx === 11) return 'step10';        // Vorschau
}
  }

function hasIntroScreen(){
  // Intro-/Anleitungsseite existiert in allen Modi,
  // aber im Admin-/Customer-Edit nicht sinnvoll.
  if (isB2BPortalFlow()) return false;
  if (isLockedEdit || isAdminEdit) return false;
  return true;
}


function updateFooterForStep(step){
  const tot = totalSteps();
  const btnAdminUpdate    = $('btnAdminUpdate');
  const btnCustomerUpdate = $('btnCustomerUpdate');

  // Kunden-Edit: einmalige Änderung für Kund:innen
  if (isLockedEdit){
    if (btnPreview)        btnPreview.style.display = (step < tot && step !== 0 ? 'inline-flex' : 'none');
    if (btnCart)           btnCart.style.display    = 'none';
    if (btnCheckout)       btnCheckout.style.display= 'none';
    if (btnAdminUpdate)    btnAdminUpdate.style.display = 'none';
    if (btnCustomerUpdate) btnCustomerUpdate.style.display = (step === tot ? 'inline-flex' : 'none');
    return;
  }

  // NEU: Admin-God-Mode – alles frei, aber Checkout/Warenkorb ausgeblendet
  if (isAdminEdit){
    if (btnPreview)        btnPreview.style.display = (step < tot && step !== 0 ? 'inline-flex' : 'none');
    if (btnCart)           btnCart.style.display    = 'none';
    if (btnCheckout)       btnCheckout.style.display= 'none';
    if (btnCustomerUpdate) btnCustomerUpdate.style.display = 'none';
    if (btnAdminUpdate)    btnAdminUpdate.style.display = (step === tot ? 'inline-flex' : 'none');
    return;
  }

  // Standard für normale Kund:innen vor dem Kauf
  if(step<tot){
    if(btnPreview)  btnPreview.style.display = (step === 0 ? 'none' : 'inline-flex');
    if(btnCart)     btnCart.style.display    = 'none';
    if(btnCheckout) btnCheckout.style.display= 'none';
    if(btnAdminUpdate)    btnAdminUpdate.style.display = 'none';
    if(btnCustomerUpdate) btnCustomerUpdate.style.display = 'none';
  }else{
    if(btnPreview)  btnPreview.style.display='none';
    if(btnCart)     btnCart.style.display='inline-flex';
    if(btnCheckout) btnCheckout.style.display='inline-flex';
    if(btnAdminUpdate)    btnAdminUpdate.style.display = 'none';
    if(btnCustomerUpdate) btnCustomerUpdate.style.display = 'none';
  }
}

function updateNavForStep(step){
  const tot = totalSteps();
if(wizPrev){
  const labelEl = wizPrev.querySelector('.wiz-arrow-label');

  // Kein "Zurück" wenn:
  // - wir im Intro sind oder
  // - wir in Schritt 1 sind, aber gar keinen Intro-Screen haben
  if(
    step === 0 ||
    isB2BEventCertificatePhase() ||
    (step === 1 && !hasIntroScreen()) ||
    (isB2BSummaryOnlyPortalFlow() && step === 10)
  ){
    wizPrev.style.display = 'none';
    wizPrev.disabled = true;
  }else{
    wizPrev.style.display = '';
    wizPrev.disabled = false;

    if(labelEl){
      if (isB2BSummaryOnlyPortalFlow() && step === 1 && state.b2bPortal && state.b2bPortal.returnToMonthlyFromStep1){
        labelEl.textContent = 'Sammel-Zertifikat';
      }
      // Step 1: "Anleitung" nur, wenn es den Intro-Screen wirklich gibt
      else if(step === 1 && hasIntroScreen()){
        labelEl.textContent = 'Anleitung';
      }else{
        labelEl.textContent = 'Zurück';
      }
    }
  }
}
    if(wizNext){
      if(step===0 || step===tot){ wizNext.style.display='none'; wizNext.disabled = true; }
      else{ wizNext.style.display=''; wizNext.disabled = false; }
    }
  }

  function updatePreviewReturnUI(){
    const tot = totalSteps();
    if(!pvBackToStep) return;
    if(state.step===tot && state.previewOriginStep !== null && state.previewOriginStep !== 9){
      pvBackToStep.style.display='inline-flex';
    }else{
      pvBackToStep.style.display='none';
    }
  }

  function blurActive(){
    const ae=document.activeElement;
    if(ae && typeof ae.blur==='function') ae.blur();
  }


function saveSeriesSnapshotFromUI(){
  // Nur relevant, wenn Serienmodus wirklich aktiv ist
  if (!state.seriesEnabled || !hasSeriesRows()) return;

  clampSeriesIndex();
  const idx = state.seriesIndex || 0;

  if (!Array.isArray(state.seriesSender))    state.seriesSender    = [];
  if (!Array.isArray(state.seriesRows))      state.seriesRows      = [];
  if (!Array.isArray(state.seriesOccasion))  state.seriesOccasion  = [];
  if (!Array.isArray(state.seriesTrees))     state.seriesTrees     = [];
  if (!Array.isArray(state.seriesVerb))      state.seriesVerb      = [];

  switch (state.step) {
    case 1: // Schenkende:r
      if (txt1){
        state.seriesSender[idx] = txt1.value || '';
      }
      break;

    case 2: // Grammatik HAT/HABEN
      if (typeof state.verb === 'string'){
        setSeriesVerb(idx, state.verb);
      }
      break;

    case 3: // Beschenkte:r
      if (seriesRecipientText && seriesRecipientText.value){
        state.seriesRows[idx] = textToSeriesRow(seriesRecipientText.value || '');
      } else if (isSeriesBlankRecipientRow(state.seriesRows[idx])){
        state.seriesRows[idx] = {
          line1: '',
          line2: '',
          blank_recipient: true
        };
      } else if (txt4){
        state.seriesRows[idx] = textToSeriesRow(txt4.value || '');
      }
      break;

    case 4: // Anlass/Datum/Message
      if (txt6){
        state.seriesOccasion[idx] = txt6.value || '';
      }
      break;

    case 5: // Baumanzahl
      if (typeof state.trees === 'number'){
        state.seriesTrees[idx] = state.trees;
      }
      break;

    case 9: // NEU: Versandart & Papier aus Step 9 sichern
      if (state.mode === 'cert') {
        // aktuelle Auswahl aus der UI lesen
        const d = getCurrentDeliveryFromUI();    // 'digital' | 'print'
        const p = getCurrentPaperTypeFromUI();   // 'white' | 'grass'
        setDeliveryForIndex(idx, d);
        setPaperTypeForIndex(idx, p);
      }
      break;

    default:
      // In anderen Steps keine Serien-Felder überschreiben
      break;
  }
}



function setStep(n){
  blurActive();

  if (state.step === 10 && n === totalSteps() && isB2BPersonalizedPortalFlow() && state.mode === 'cert'){
    captureMonthlyFinalStepPreview();
  }
  if (state.step === 11 && n === totalSteps() && isB2BEventPortalFlow() && state.mode === 'cert'){
    captureMonthlyFinalStepPreview();
  }

  if (isB2BPortalFlow && typeof isB2BPortalFlow === 'function' && isB2BPortalFlow() && n === 0){
    n = (isB2BSummaryOnlyPortalFlow() || isB2BEventPortalFlow()) ? 10 : 1;
  }

  // BEVOR wir den Step wechseln: aktuellen Serien-Slot sichern
  if (state.seriesEnabled && hasSeriesRows()){
    saveSeriesSnapshotFromUI();
  }

  const prevStep = state.step || 0;

  if (prevStep === 7 && n > 7){
    const hasForest = !!(state.forest && FORESTS[state.forest]);
    if (!hasForest){
      alert('Bitte wähle zuerst einen Pflanzort (Forst).');
      return;
    }
  }



  state.step = n;

  const titlesCert={
    0:'Gestalte dein Zertifikat',
    1:'Schritt 1: Schenkende:r',
    2:'Schritt 2: Grammatik',
    3:'Schritt 3: Beschenkte:r',
    4:'Schritt 4: Anlass/Datum/Message',
    5:'Schritt 5: Anzahl & Preis',
    6:'Schritt 6: Deko wählen',
    7:'Schritt 7: Pflanzort',
    8:'Schritt 8: Rahmenfarbe',
    9:'Schritt 9: Versandart',
    10:'Schritt 10: Grußkarte',
    11:'Schritt 11: Vorschau'
  };
// Serienmodus (NUR B2C): kein Grußkarten-Step, Vorschau rutscht auf 10
if (state.mode === 'cert' && state.seriesEnabled && !isB2B){
  titlesCert[10] = 'Schritt 10: Vorschau';
  delete titlesCert[11];
}

  const titlesGift={
    0:'Gestalte dein Geschenk-Zertifikat',
    1:'Schritt 1: Schenkende:r',
    2:'Schritt 2: Grammatik',
    3:'Schritt 3: Beschenkte:r',
    4:'Schritt 4: Anlass/Datum/Message',
    5:'Schritt 5: Anzahl & Preis',
    6:'Schritt 6: Deko wählen',
    7:'Schritt 7: Pflanzort',
    8:'Schritt 8: Rahmenfarbe',
    9:'Schritt 9: Papier & Extras',
    10:'Schritt 10: Grußkarte',
    11:'Schritt 11: Vorschau'
  };

  // B2B: Schritt 10 ist der Monats-Zertifikat-Step
  if (isB2B){
    titlesCert[10] = 'Schritt 10: Monats-Zertifikat';
    titlesCert[11] = 'Schritt 11: Vorschau';
  }
  if (isB2BEventPortalFlow()){
    titlesCert[10] = 'Schritt 1: Event-Zertifikat';
    titlesCert[11] = 'Schritt 2: Sammel-Zertifikat';
    titlesCert[12] = 'Schritt 3: Übersicht';
  }
  if (isB2BSummaryOnlyPortalFlow()){
    titlesCert[10] = isB2BSubscriptionPortalFlow()
      ? 'Schritt 1: Baum-Abo'
      : (isB2BEventPortalFlow() ? 'Schritt 1: Event-Zertifikat' : 'Schritt 1: Sammel-Zertifikat');
    titlesCert[11] = isB2BSubscriptionPortalFlow() ? 'Schritt 2: Dein Abo-Zertifikat' : 'Schritt 2: Vorschau';
  }

  const titlesLabel={
    0:'Gestalte Etikett & Zertifikat',
    1:'Schritt 1: Schenkende:r',
    2:'Schritt 2: Grammatik',
    3:'Schritt 3: Beschenkte:r',
    4:'Schritt 4: Anlass/Datum/Message',
    5:'Schritt 5: Anzahl & Preis',
    6:'Schritt 6: Deko wählen',
    7:'Schritt 7: Pflanzort',
    8:'Schritt 8: Rahmenfarbe',
    9:'Schritt 9: Papier & Extras',
    10:'Schritt 10: Etikett',
    11:'Schritt 11: Grußkarte',
    12:'Schritt 12: Vorschau (Etikett & Zertifikat)'
  };

  const titles =
    (state.mode === 'label') ? titlesLabel :
    (state.mode === 'gift')  ? titlesGift : titlesCert;

  $('wizTitle').textContent = titles[n] || 'Personalisieren';

  const tot = totalSteps();
  const display = getDisplayStepInfo(n);
  const stepsEl = $('wizSteps');

  if (stepsEl){
    if (n === 0){
      // In Step 0 keine „Einführung…“-Zeile anzeigen
      stepsEl.textContent = '';
      stepsEl.style.display = 'none';
    } else {
      stepsEl.textContent = 'Schritt ' + display.current + ' von ' + display.total;
      stepsEl.style.display = 'inline-block';
    }
  }

  // Step-Klassen setzen
  if (isB2BEventPortalFlow() && state.mode === 'cert'){
    const handled = new Set(['step10Label','step10']);
    const ids = new Set();
    for (let i = 0; i <= tot; i++){
      const id = stepDomId(i);
      if (id) ids.add(id);
      if (!id || handled.has(id)) continue;
      const el = $(id);
      if (!el) continue;
      if(i===n) el.className='step active';
      else if(i<n) el.className='step left';
      else el.className='step right';
    }
    const monthlyEditorEl = $('step10Label');
    const finalPreviewEl = $('step10');
    if (monthlyEditorEl){
      if (n === 10 || n === 11) monthlyEditorEl.className = 'step active';
      else if (n > 11) monthlyEditorEl.className = 'step left';
      else monthlyEditorEl.className = 'step right';
    }
    if (finalPreviewEl){
      if (n === 12) finalPreviewEl.className = 'step active';
      else finalPreviewEl.className = 'step right';
    }
  } else {
    for(let i=0;i<=tot;i++){
      const id = stepDomId(i);
      const el = $(id);
      if(!el) continue;
      if(i===n) el.className='step active';
      else if(i<n) el.className='step left';
      else el.className='step right';
    }
  }

  const progressBar=$('wizProgressBar');
  if(progressBar){
    const pct = n<=0 ? 0 : (Math.min(tot,n)/tot*100);
    progressBar.style.width=pct+'%';
  }

  scrollWizardViewportToTop(stepDomId(n));

  const totSteps = totalSteps();

  // Wenn wir in den finalen Schritt wechseln, Layouts skalieren
  if(n===totSteps && !isB2BEventSummaryPhase()){
    if (isB2BSummaryOnlyPortalFlow() && state.mode === 'cert'){
      FORCE_MONTHLY_RENDER = true;
    }
    const a4Block  = $('a4Block');
    const a4Host10 = $('a4Host10');
    const a4Host11 = $('a4Host11');

    let fullHost = a4Host10;
    if(state.mode === 'label' && a4Host11){
      fullHost = a4Host11;
    }
    if(a4Block && fullHost && a4Block.parentNode !== fullHost){
      fullHost.appendChild(a4Block);
    }

    if (isB2BPersonalizedPortalFlow() && state.mode === 'cert' && !useLiveSeriesFinalPreviewMode()){
      resetFinalStaticPreview();
      parkFinalLiveStageOffscreen();
      try{
        const loading = $('pvFinalLoading');
        if (loading) loading.style.display = 'grid';
      }catch(_){}
    } else {
      resetFinalLiveStagePlacement();
      try{
        const loading = $('pvFinalLoading');
        if (loading) loading.style.display = 'none';
      }catch(_){}
    }

    placeA4Boxes();
    updatePreview();
    if (!(isB2BPersonalizedPortalFlow() && state.mode === 'cert' && !useLiveSeriesFinalPreviewMode())){
      scaleA4();
      requestAnimationFrame(()=>{ try{ scaleA4(); }catch(_e){} });
      setTimeout(()=>{ try{ scaleA4(); }catch(_e){} }, 45);
    }

    updateLabelFinal();
    scaleLabel('Final');

    syncSummaryOnlyFinalPreviewUi();

    if (isB2BPersonalizedPortalFlow() && state.mode === 'cert' && useLiveSeriesFinalPreviewMode()){
      setTimeout(()=>{ try{ showExistingMonthlyFinalPreview(); }catch(_){} }, 0);
    }

    if (isB2BEventFinalOverviewPhase()){
      setTimeout(()=>{ try{ renderB2BEventFinalDualPreview(true); }catch(_){} }, 20);
    } else if (isB2BPersonalizedPortalFlow() && state.mode === 'cert' && !useLiveSeriesFinalPreviewMode()){
      setTimeout(()=>{ try{ renderB2BPersonalizedFinalDualPreview(true); }catch(_){} }, 20);
    } else if (isB2B && !isB2BPersonalizedPortalFlow() && state.mode === 'cert' && !isB2BSummaryOnlyPortalFlow()){
      setTimeout(()=>{ try{ renderMonthlyFinalPreviewIfNeeded(true); }catch(_){} }, 40);
    }


    if(state.mode === 'label'){
      const block  = $('a4Block');
      const host11 = $('a4Host11');
      if(block && host11 && block.parentNode !== host11){
        host11.appendChild(block);
      }

      const metaBar   = block ? block.querySelector('.a4-meta-bar') : document.querySelector('.a4-meta-bar');
      const labelWrap = document.querySelector('#step11 .label-preview-wrap');
      if(metaBar && labelWrap && metaBar.parentNode !== labelWrap.parentNode){
        labelWrap.insertAdjacentElement('afterend', metaBar);
      }
    }

    // NEU: Im Serienmodus im letzten Schritt "Deine Zertifikate" anzeigen
    const mainRibbonText = document.querySelector('#a4Block .wiz-ribbon-main__text');
    if (mainRibbonText){
      if (isB2BSubscriptionPortalFlow() && state.mode === 'cert'){
        mainRibbonText.textContent = 'Dein Abo-Zertifikat';
      } else if ((isB2BPersonalizedPortalFlow() && state.mode === 'cert') || (state.mode === 'cert' && state.seriesEnabled && hasSeriesRows())){
        mainRibbonText.textContent = 'Deine Zertifikate';
      } else {
        mainRibbonText.textContent = 'Dein Zertifikat';
      }
    }
  } else {
    if (!(isB2B && n === 10)){
      FORCE_MONTHLY_RENDER = false;
    }
    clearFinalPersonalizedPreviewCache();
    resetFinalStaticPreview();
    if(state.mode === 'label'){
      const block  = $('a4Block');
      const host10 = $('a4Host10');
      if(block && host10 && block.parentNode !== host10){
        host10.appendChild(block);
      }
    }

    const a4Block  = $('a4Block');
    const miniWrap = miniPreviewWrap;
    const miniHost = miniPreviewHost;
    const a4Host10 = $('a4Host10');
    const a4Host11 = $('a4Host11');

if (a4Block && miniWrap && miniHost) {
  // Mini-Preview NICHT im B2B-Monats-Step 10
  if (n > 0 && n < totSteps && !(isB2B && n === 10)) {
    const currentStepEl = $(stepDomId(n));
    if (currentStepEl) {
      const container =
        currentStepEl.querySelector('.wiz-field-block') ||
        currentStepEl.querySelector('.step-inner');

      if (container && miniWrap.parentNode !== container) {
        container.appendChild(miniWrap);
      }
    }

    if (a4Block.parentNode !== miniHost) {
      miniHost.appendChild(a4Block);
    }

    placeA4Boxes();
    updatePreview();
    scaleA4();
  }
}

// B2B: Monats-Zertifikat-Step (A4-Block in monthlyCertHost schieben)
  if (isB2B && (n === 10 || isB2BEventSummaryPhase())) {
  const a4BlockMonthly = $('a4Block');
  const monthlyHost    = $('monthlyCertHost');

  if (a4BlockMonthly && monthlyHost && a4BlockMonthly.parentNode !== monthlyHost){
    a4BlockMonthly.style.marginTop = '0';
    monthlyHost.appendChild(a4BlockMonthly);
  }

  // NEU: Koordinaten nur einmal laden und anzeigen
  ensureMonthlyCoords();
  initMonthlyControls();
applyMonthlyForestsToPreview();
renderMonthlyQr();
renderMonthlyId();
renderMonthlyUrl();

if (isB2BSummaryOnlyPortalFlow() && n === 10){
  try{
    const stepSnap = loadSummarySenderLocalSnapshot();
    if (stepSnap) applySummarySenderLocalSnapshot(stepSnap);
  }catch(_){}
  setTimeout(function(){
    try{
      const delayedStepSnap = loadSummarySenderLocalSnapshot();
      if (delayedStepSnap) applySummarySenderLocalSnapshot(delayedStepSnap);
    }catch(_){}
  }, 180);
}

}

if(n===10 && state.mode==='label'){
  updateLabelEdit();
  scaleLabel('Edit');
}

if ((n===10 || isB2BEventSummaryPhase()) && state.mode!=='label'){
  placeA4Boxes();

  if (isB2B && state.mode === 'cert'){
    const pvBox4El = $('pvBox4');
    const pvBox6El = $('pvBox6');
    const treeEl = document.querySelector('.decor-tree-final');
    const treeHotspot = document.querySelector('.pv-tree-hotspot');
    if (pvBox4El){
      const CLAIM_TOP       = 640;   // Claim-Top bleibt
      const GAP_AFTER_CLAIM = isB2BEventCertificatePhase() ? 92 : 188;

      pvBox4El.style.top    = (CLAIM_TOP + GAP_AFTER_CLAIM) + 'px';
      pvBox4El.style.height = '480px'; // statt 360px – genug Platz für "XX BÄUME" + Subline
    }
      if (isB2BEventCertificatePhase()){
        if (pvBox6El){
          pvBox6El.style.top = '2085px';
          pvBox6El.style.height = '170px';
        }
        if (treeEl){
          treeEl.style.setProperty('top', '1375px', 'important');
          treeEl.style.setProperty('width', '520px', 'important');
        }
        if (treeHotspot){
          treeHotspot.style.setProperty('top', '1295px', 'important');
          treeHotspot.style.setProperty('width', '520px', 'important');
        }
      }
  }

  updatePreview();
  scaleA4();
}
    if(n===8){
      placeA4Boxes();
      updatePreview();
      scaleA4();
    }
  }

  syncSummaryOnlyFinalPreviewUi();
  syncSummaryOnlySenderEditor();
  syncPersonalizedStep1SenderUi();
  if (usesDedicatedMonthlySenderEditor() && (state.step === 10 || isB2BEventSummaryPhase())){
    syncPersonalizedMonthlyEditorFromStep1(false);
  }
  syncPersonalizedMonthlySenderUi();

  (function(){
    const a4Block = $('a4Block');
    if (!a4Block) return;

    const innerRibbon = a4Block.querySelector('.wiz-ribbon-main-wrap');
    const hotspotInfo = a4Block.querySelector('.pv-hotspot-info');
    const totStepsVal = totalSteps();

    if (innerRibbon){
      innerRibbon.style.display = (n === totStepsVal ? '' : 'none');
    }
    if (hotspotInfo){
      hotspotInfo.style.display = (n === totStepsVal ? '' : 'none');
    }
  })();

  const gcBlock      = $('greetCardBlock');
  const gcHostGreet  = $('greetCardHost10');
  const gcHostFinal  = (state.mode === 'label')
    ? $('greetCardHostFinal11')
    : $('greetCardHostFinal10');

  const greetStep = (state.mode === 'label') ? 11 : 10;

  if (gcBlock && gcHostGreet){
    if (n === greetStep){
      if (gcBlock.parentNode !== gcHostGreet) gcHostGreet.appendChild(gcBlock);
    } else if (n === totSteps && gcHostFinal && state.greetCardSelected){
      if (gcBlock.parentNode !== gcHostFinal) gcHostFinal.appendChild(gcBlock);
    } else {
      if (gcBlock.parentNode !== gcHostGreet) gcHostGreet.appendChild(gcBlock);
    }
  }

  if (state.greetCardSelected && (n === greetStep || n === totSteps)){
    scaleGreetingCard();
  }

  if (state.greetCardSelected){
    if (n === greetStep){
      setGreetCardReadonly(false);
    } else if (n === totSteps){
      setGreetCardReadonly(true);
    }
  }

  if (n === totSteps && state.greetCardSelected) {
    if (state.mode === 'label') {
      const step11Inner   = document.querySelector('#step11 .step-inner');
      const gcHostFinal11 = $('greetCardHostFinal11');
      if (step11Inner && gcHostFinal11) {
        step11Inner.appendChild(gcHostFinal11);
      }
    } else {
      const a4Host10 = $('a4Host10');
      const a4Block  = $('a4Block');
      const gcHost10 = $('greetCardHostFinal10');
      if (a4Host10 && a4Block && gcHost10) {
        a4Host10.appendChild(a4Block);
        a4Host10.appendChild(gcHost10);
      }
    }
  }

  updateFooterForStep(n);
  updateNavForStep(n);
  updatePreviewReturnUI();

if (n === 1){
  if (state.seriesEnabled && hasSeriesRows()){
    ensureSeriesLangLen();
  }
  updateLangToggleUI();
  updateSeriesSenderUI();
}

  if (n === 2) {
    updateSeriesVerbUI();
  }
  if (n === 3){
    updateSeriesNavigatorUI();
  }
  if (n === 5){
    updateSeriesTreeUI();
  }
  if (n === 4){
    updateSeriesOccasionUI();
  }
  // NEU: Step 6 – Deko
  if (n === 6){
    if (state.seriesEnabled && hasSeriesRows()){
      // Deko für den aktuellen Serien-Slot laden
      syncDecorFromSeriesIndex();
    }
    updateSeriesDecorUI();
  }
   if (n === 7){
   if (state.seriesEnabled && hasSeriesRows()){
     syncForestFromSeriesIndex();
   }
   updateSeriesForestUI();
 }

  if (n === 8){
   if (state.seriesEnabled && hasSeriesRows()){
     syncFrameColorFromSeriesIndex();
   }
   updateSeriesFrameUI();
 }

  if (n === 9){
    if (state.seriesEnabled && hasSeriesRows()){
      syncDeliveryFromSeriesIndex();
      syncPaperTypeFromSeriesIndex();
    }
    updateSeriesDeliveryUI();
  }

  updateSeriesFinalPagerUI();

  syncGreetCardUI();

  updateIntroPrices();
  updatePrice();

  if(btnCartHeader){
    if (isCustomerEdit || isB2B){
      btnCartHeader.style.display = 'none';
    } else {
      btnCartHeader.style.display = (n === totSteps ? 'inline-flex' : 'none');
    }
  }

  if (!hasEditOrClone && DRAFT_KEY){
    scheduleDraftSave();
  }
}

  function openWizard(){
    wiz.classList.add('open');
    wiz.setAttribute('aria-hidden','false');

    // Gift/Label starten mit Entscheidungs-Screen (Step 0), Cert direkt bei Schritt 1
const initialStep =
  (isCustomerEdit || isAdminEdit)
    ? totalSteps()
    : (
        (isB2BSummaryOnlyPortalFlow() || isB2BEventPortalFlow())
          ? 10
          :
        (state.mode === 'gift' || state.mode === 'label')
          ? (isGiftAlwaysTree ? 1 : 0)  // Always-Tree-Gift: direkt Step 1
          : 1                           // cert: immer bei Step 1 starten
      );

    setStep(initialStep);
    fit1(); fit4(); fit6();
    initLabelDefaultsFromSteps();
    hideLoadingOverlay();
    setSubmitting(false);
  }
async function closeWizard(){
  blurActive();

  try{
    flushSummaryTemplateAutosave();
  }catch(_){}

  try{
    if (isB2BPersonalizedPortalFlow()){
      try{
        await savePersistentPersonalizedSenderDraft();
      }catch(_){}
      try{
        await savePersistentPortalSenderDraft();
      }catch(_){}
      try{
        await savePersonalizedLogoSnapshot();
      }catch(_){}
      try{
        const profile = (typeof getB2BInputs === 'function') ? getB2BInputs() : {};
        await saveTemplateSnapshotSilentlyForAliases([
          state && state.b2bPortal && state.b2bPortal.customerRef,
          state && state.b2bPortal && state.b2bPortal.landingSlug,
          profile && profile.customer_ref,
          profile && profile.landing_slug,
          profile && (profile.partner_name || profile.partner),
          state && state.b2bPortal && state.b2bPortal.partnerName,
          (typeof getPartnerName === 'function') ? getPartnerName() : ''
        ]);
      }catch(_){}
    } else if (isB2BPortalFlow()){
      try{
        await savePortalSenderSnapshot();
      }catch(_){}
      try{
        await savePersistentPortalSenderDraft();
      }catch(_){}
      try{
        if (isB2BSummaryOnlyPortalFlow()){
          await savePersistentSummarySenderDraft();
        }
      }catch(_){}
    }
  }catch(_){}

  try{
    if (!hasEditOrClone && DRAFT_KEY){
      await saveDraft();
    }
  }catch(_){}

  // NEU: Ad-/External-Modus → direkt auf Startseite, NICHT zurückspringen
  if (isExternalWizard){
    try {
      window.location.href = "/";
    } catch(e){
      window.location = "/";
    }
    return;
  }

  // Standardverhalten wie bisher
  wiz.classList.remove('open');
  wiz.setAttribute('aria-hidden','true');

  if (isB2BPortalFlow()){
    redirectBackToPortal();
    return;
  }

  if (window.history.length > 1) {
    window.history.back();
    return;
  }

  try {
    const ref = document.referrer || "";
    if (ref && ref.indexOf(window.location.href) === -1) {
      window.location.href = ref;
    } else {
      window.location.href = "/collections/zertifikate";
    }
  } catch (e) {
    console.warn("closeWizard navigation failed", e);
    window.location.href = "/collections/zertifikate";
  }
}

  const openWizardBtn=$('openWizard');
  if(openWizardBtn) openWizardBtn.addEventListener('click',openWizard);

  if(wizClose) wizClose.addEventListener('click',closeWizard);
if (wiz){
  let mouseDownOnOverlay = false;

  wiz.addEventListener('mousedown', (e)=>{
    // Nur markieren, wenn der erste Klick direkt auf dem Overlay war
    if (e.target === wiz){
      mouseDownOnOverlay = true;
    } else {
      mouseDownOnOverlay = false;
    }
  });

  wiz.addEventListener('mouseup', (e)=>{
    // Nur schließen, wenn mousedown UND mouseup auf dem Overlay waren
    if (mouseDownOnOverlay && e.target === wiz){
      closeWizard();
    }
    mouseDownOnOverlay = false;
  });
}
document.addEventListener('keydown',e=>{
  if(e.key==='Escape' && wiz.classList.contains('open')) closeWizard();
});

if (wizPrev) {
  wizPrev.addEventListener('click', async () => {
    const tot = totalSteps();

    // aus der Vorschau zurück zum ursprünglichen Step
    if (state.step === tot && state.previewOriginStep !== null && state.previewOriginStep !== 9) {
      let target = state.previewOriginStep;
      if (target === 0) target = 1;
      state.previewOriginStep = null;
      setStep(target);

} else if (state.step > 0) {
      // Speziallogik: in Step 1 heißt der Button "Anleitung" und führt zurück zu Step 0
if (state.step === 1) {
  if (isB2BSummaryOnlyPortalFlow() && state.b2bPortal && state.b2bPortal.returnToMonthlyFromStep1){
    state.b2bPortal.returnToMonthlyFromStep1 = false;
    setStep(10);
    return;
  }
  if (hasIntroScreen()){
    setStep(0);
  } else {
    // kein Intro-Screen → Schritt 1 ist der erste Schritt
    return;
  }
} else {
  if (isB2BEventSummaryPhase() && state.b2bPortal){
    try{
      if (!hasEditOrClone && DRAFT_KEY) await saveDraft();
    }catch(_){}
    state.b2bPortal.eventPhase = 'event';
    setStep(10);
    restoreEventPortalSnapshotToEventPhase();
    initMonthlyControls();
    placeA4Boxes();
    updatePreview();
    scaleA4();
    return;
  }
  if (isB2BEventPortalFlow()){
    try{
      if (!hasEditOrClone && DRAFT_KEY) await saveDraft();
    }catch(_){}
    setStep(getPrevEventStep(state.step));
  } else {
    setStep(state.step - 1);
  }
}
    }
  });
}
  if(wizNext){
    wizNext.addEventListener('click', async ()=>{
      const tot = totalSteps();
      if (isB2BEventCertificatePhase()){
        const eventTrees = getMonthlyProjectTreeCount();
        if (eventTrees <= 0){
          alert('Bitte trage mindestens einen Baum für das Event ein.');
          return;
        }
        const snap = buildEventPortalSnapshot();
        try{
          const eventCanvas = await captureMonthlyCertificatePng();
          if (eventCanvas && eventCanvas.dataUrl){
            snap.canvasPng = eventCanvas.dataUrl;
          }
        }catch(_){}
        state.b2bPortal.eventSnapshot = snap;
        state.b2bPortal.eventPhase = 'monthly';
        state.monthlyUserEdited = false;
        if (!state.personalizedMonthlySenderCustomized){
          syncPersonalizedMonthlyEditorFromStep1(true);
        } else {
          syncPersonalizedMonthlySenderUi();
        }
        initMonthlyControls();
        updatePreview();
        try{
          if (!hasEditOrClone && DRAFT_KEY) await saveDraft();
        }catch(_){}
        setStep(11);
        return;
      }
      if (isB2BSummaryOnlyPortalFlow() && state.step === 10){
        if (getMonthlyProjectTreeCount() <= 0){
          alert('Bitte trage mindestens einen Baum ein.');
          return;
        }
        try{ await flushSummaryTemplateAutosave(); }catch(_){}
      }
      if (isB2BSummaryOnlyPortalFlow() && state.step === 1 && state.b2bPortal && state.b2bPortal.returnToMonthlyFromStep1){
        state.b2bPortal.returnToMonthlyFromStep1 = false;
        setStep(10);
        return;
      }
      if(state.step===9){ state.previewOriginStep=null; }
      if(state.step<tot){
        if (isB2BEventPortalFlow()){
          try{
            if (!hasEditOrClone && DRAFT_KEY) await saveDraft();
          }catch(_){}
          setStep(getNextEventStep(state.step));
        } else {
          setStep(state.step+1);
        }
      }
    });
  }

  if (wizNext && isIOS){
    wizNext.addEventListener('touchend', (e)=>{
      if (!isSmallScreen()) return;
      const ae = document.activeElement;
      const isTextInput = ae && (
        ae.tagName === 'TEXTAREA' ||
        (ae.tagName === 'INPUT' && /^(text|number|email|tel|search)$/i.test(ae.type))
      );
      if(!isTextInput) return;
      e.preventDefault();
      ae.blur();
      setTimeout(async ()=>{
        const tot = totalSteps();
        if (isB2BEventCertificatePhase()){
          const eventTrees = getMonthlyProjectTreeCount();
          if (eventTrees <= 0){
            alert('Bitte trage mindestens einen Baum für das Event ein.');
            return;
          }
          const snap = buildEventPortalSnapshot();
          try{
            const eventCanvas = await captureMonthlyCertificatePng();
            if (eventCanvas && eventCanvas.dataUrl){
              snap.canvasPng = eventCanvas.dataUrl;
            }
          }catch(_){}
          state.b2bPortal.eventSnapshot = snap;
          state.b2bPortal.eventPhase = 'monthly';
          state.monthlyUserEdited = false;
          if (!state.personalizedMonthlySenderCustomized){
            syncPersonalizedMonthlyEditorFromStep1(true);
          } else {
            syncPersonalizedMonthlySenderUi();
          }
          initMonthlyControls();
          updatePreview();
          try{
            if (!hasEditOrClone && DRAFT_KEY) await saveDraft();
          }catch(_){}
          setStep(11);
          return;
        }
        if (isB2BSummaryOnlyPortalFlow() && state.step === 10){
          if (getMonthlyProjectTreeCount() <= 0){
            alert('Bitte trage mindestens einen Baum ein.');
            return;
          }
          try{ await flushSummaryTemplateAutosave(); }catch(_){}
        }
        if (isB2BSummaryOnlyPortalFlow() && state.step === 1 && state.b2bPortal && state.b2bPortal.returnToMonthlyFromStep1){
          state.b2bPortal.returnToMonthlyFromStep1 = false;
          setStep(10);
          return;
        }
        if(state.step===9){ state.previewOriginStep = null; }
        if(state.step<tot){
          if (isB2BEventPortalFlow()){
            try{
              if (!hasEditOrClone && DRAFT_KEY) await saveDraft();
            }catch(_){}
            setStep(getNextEventStep(state.step));
          } else {
            setStep(state.step+1);
          }
        }
      }, 30);
    }, {passive:false});
  }

if(introNext){
  introNext.addEventListener('click',()=>{
    // Nur in Gift/Label: hier entscheidet sich der Kunde bewusst für Baumpflanzung
    if(state.mode === 'gift' || state.mode === 'label'){
      state.treeAddonSelected = true;
      // KEIN updatePrice() hier – das passiert nach dem Stepwechsel
    }
    setStep(1);
  });
}

const introNoTree = $('introNoTree');

// kleine Helferfunktion, die Anzeige am aktuellen Modus ausrichtet
function refreshIntroNoTreeVisibility(){
  if(!introNoTree) return;

  if(state.mode === 'gift' || state.mode === 'label'){
    if (isGiftAlwaysTree){
      introNoTree.style.display = 'none';
    } else {
      introNoTree.style.display = ''; // sichtbar (Standard-Display)
    }
  } else {
    introNoTree.style.display = 'none';
  }
}

// Klick-Handler nur EINMAL registrieren, Logik prüft Modus zur Laufzeit
if(introNoTree){
  introNoTree.addEventListener('click', (e)=>{
    // nur im Gift/Label-Mode und nicht bei Always-Tree
    if(!(state.mode === 'gift' || state.mode === 'label')) return;
    if(isGiftAlwaysTree) return;

    e.preventDefault();
    openNoTreeConfirm();
  });

  // Initialer Zustand beim ersten Laden
  refreshIntroNoTreeVisibility();
}

function scrollActiveStepToPreview(){
  const activeInner = document.querySelector('.step.active .step-inner');
  if (!activeInner) return false;

  const target =
    activeInner.querySelector('.frame-preview-wrap') ||
    activeInner.querySelector('.a4-preview-wrap') ||
    activeInner.querySelector('#monthlyCertHost') ||
    activeInner.querySelector('.monthly-stage');
  if (!target) return false;

  const innerRect  = activeInner.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const offset = targetRect.top - innerRect.top;

  activeInner.scrollTo({
    top: Math.max(0, activeInner.scrollTop + offset - 10),
    behavior: 'smooth'
  });
  return true;
}

if (btnPreview){
  btnPreview.addEventListener('click', ()=>{
    scrollActiveStepToPreview();
  });
}

  if(pvBackToStep){
    pvBackToStep.addEventListener('click',()=>{
      const tot = totalSteps();
      if(state.previewOriginStep !== null && state.previewOriginStep!==tot){
        let target = state.previewOriginStep;
        if(target===0) target = 1;
        state.previewOriginStep=null;
        setStep(target);
      }else{
        setStep(9);
      }
    });
  }

  /* Swipe Navigation */
  if(wizBody){
    let sx=0, sy=0, st=0, dragging=false;
    const DX=50, DY=40, VEL=0.4;

    const isInteractiveTarget = (target)=> !!target.closest('textarea, input, button, select, label');

    wizBody.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse' && e.buttons!==1) return;
      if(isInteractiveTarget(e.target)) return;
      dragging=true; sx=e.clientX; sy=e.clientY; st=performance.now();
    },{passive:true});

    wizBody.addEventListener('pointerup',e=>{
      if(!dragging) return;
      dragging=false;
      const dx=e.clientX-sx; const dy=e.clientY-sy; const dt=Math.max(1,performance.now()-st); const v=Math.abs(dx)/dt;
      if((Math.abs(dx)>DX || v>VEL) && Math.abs(dy)<DY){
        if(dx>0 && state.step>0) setStep(state.step-1);
        else if(dx<0 && state.step<totalSteps()) setStep(state.step+1);
      }
    },{passive:true});

    wizBody.addEventListener('touchstart',e=>{
      if(e.touches.length!==1) return;
      if(isInteractiveTarget(e.target)) return;
      const t=e.touches[0];
      dragging=true; sx=t.clientX; sy=t.clientY; st=performance.now();
    },{passive:true});

    wizBody.addEventListener('touchend',e=>{
      if(!dragging) return;
      dragging=false;
      const t=(e.changedTouches&&e.changedTouches[0])||{clientX:sx,clientY:sy};
      const dx=t.clientX-sx; const dy=t.clientY-sy; const dt=Math.max(1,performance.now()-st); const v=Math.abs(dx)/dt;
      if((Math.abs(dx)>DX || v>VEL) && Math.abs(dy)<DY){
        if(dx>0 && state.step>0) setStep(state.step-1);
        else if(dx<0 && state.step<totalSteps()) setStep(state.step+1);
      }
    },{passive:true});
  }

  /* ===== Auto-Fit (Wizard-Felder) ===== */
  const txt1=$('txt1'), box1=$('box1');
  const personalizedMonthlyTxt1=$('personalizedMonthlyTxt1'), personalizedMonthlyBox1=$('personalizedMonthlyBox1');
  const txt4=$('txt4'), box4=$('box4');
  const txt6=$('txt6'), box6=$('box6');

  // NEU: Serien-UI im Schritt "Beschenkte:r"
  const seriesModeSingle     = $('seriesModeSingle');
  const seriesModeMulti      = $('seriesModeMulti');
  const seriesModeBlank      = $('seriesModeBlank');
  const seriesNamesTA        = $('seriesNames');
  const seriesCompaniesTA    = $('seriesCompanies');
  const seriesBlankCountInput= $('seriesBlankCount');
  const seriesExcelFile      = $('seriesExcelFile');
  const seriesExcelStatus    = $('seriesExcelStatus');
  const recipientSingleWrap  = $('recipientSingleWrap');
  const recipientSeriesWrap  = $('recipientSeriesWrap');
  const recipientBlankWrap   = $('recipientBlankWrap');
  const seriesToggleEl       = $('seriesToggle');

  const seriesInlineToggle = $('seriesInlineToggle');
  const seriesInlineBtn    = $('seriesInlineBtn');
  const seriesBlankInlineBtn = $('seriesBlankInlineBtn');

    // Serien-Navigation & Editor in Schritt 3
  const seriesPager         = $('seriesPager');
  const seriesPagerLabel    = $('seriesPagerLabel');
  const seriesPagerHint     = $('seriesPagerHint');
  const seriesPrevBtn       = $('seriesPrev');
  const seriesNextBtn       = $('seriesNext');
  const seriesRecipientEdit = $('seriesRecipientEdit');   // NEU
  const seriesRecipientText = $('seriesRecipientText');

    // Serien-Pager in Schritt 5 (Baumanzahl) und in der finalen Vorschau
  const seriesPagerStep5       = $('seriesPagerStep5');
  const seriesPagerLabelStep5  = $('seriesPagerLabelStep5');
  const seriesPagerHintStep5   = $('seriesPagerHintStep5');
  const seriesPrevStep5        = $('seriesPrevStep5');
  const seriesNextStep5        = $('seriesNextStep5');
  const seriesTreesApplyAll    = $('seriesTreesApplyAll');      // NEU
  const seriesTreesApplyAllBtn = $('seriesTreesApplyAllBtn');   // NEU

  // NEU: Serien-Pager in Schritt 6 (Deko)
  const seriesPagerStep6       = $('seriesPagerStep6');
  const seriesPagerLabelStep6  = $('seriesPagerLabelStep6');
  const seriesPagerHintStep6   = $('seriesPagerHintStep6');
  const seriesPrevStep6        = $('seriesPrevStep6');
  const seriesNextStep6        = $('seriesNextStep6');
  const seriesDecorApplyAll    = $('seriesDecorApplyAll');
  const seriesDecorApplyAllBtn = $('seriesDecorApplyAllBtn');

  // NEU: Serien-Pager in Schritt 7 (Forst)
  const seriesPagerStep7       = $('seriesPagerStep7');
  const seriesPagerLabelStep7  = $('seriesPagerLabelStep7');
  const seriesPagerHintStep7   = $('seriesPagerHintStep7');
  const seriesPrevStep7        = $('seriesPrevStep7');
  const seriesNextStep7        = $('seriesNextStep7');
  const seriesForestApplyAll   = $('seriesForestApplyAll');
  const seriesForestApplyAllBtn= $('seriesForestApplyAllBtn');

  // NEU: Serien-Pager in Schritt 8 (Rahmenfarbe)
  const seriesPagerStep8       = $('seriesPagerStep8');
  const seriesPagerLabelStep8  = $('seriesPagerLabelStep8');
  const seriesPagerHintStep8   = $('seriesPagerHintStep8');
  const seriesPrevStep8        = $('seriesPrevStep8');
  const seriesNextStep8        = $('seriesNextStep8');
  const seriesFrameApplyAll    = $('seriesFrameApplyAll');
  const seriesFrameApplyAllBtn = $('seriesFrameApplyAllBtn');

  // NEU: Serien-Pager in Schritt 9 (Versandart)
  const seriesPagerStep9       = $('seriesPagerStep9');
  const seriesPagerLabelStep9  = $('seriesPagerLabelStep9');
  const seriesPagerHintStep9   = $('seriesPagerHintStep9');
  const seriesPrevStep9        = $('seriesPrevStep9');
  const seriesNextStep9        = $('seriesNextStep9');
  const seriesDeliveryApplyAll   = $('seriesDeliveryApplyAll');
  const seriesDeliveryApplyAllBtn= $('seriesDeliveryApplyAllBtn');

  const seriesPagerFinal       = $('seriesPagerFinal');
  const seriesPagerLabelFinal  = $('seriesPagerLabelFinal');
  const seriesPrevFinal        = $('seriesPrevFinal');
  const seriesNextFinal        = $('seriesNextFinal');

  // Serien-Pager in Schritt 1 (Schenkende:r)
  const seriesPagerStep1       = $('seriesPagerStep1');
  const seriesPagerLabelStep1  = $('seriesPagerLabelStep1');
  const seriesPagerHintStep1   = $('seriesPagerHintStep1');
  const seriesPrevStep1        = $('seriesPrevStep1');
  const seriesNextStep1        = $('seriesNextStep1');
  const seriesLogoHint         = $('seriesLogoHint'); // NEU

    // Serien-Pager in Schritt 4 (Anlass)
  const seriesPagerStep4       = $('seriesPagerStep4');
  const seriesPagerLabelStep4  = $('seriesPagerLabelStep4');
  const seriesPagerHintStep4   = $('seriesPagerHintStep4');
  const seriesPrevStep4        = $('seriesPrevStep4');
  const seriesNextStep4        = $('seriesNextStep4');

  // Serien-Pager in Schritt 2 (Grammatik)
  const seriesPagerStep2       = $('seriesPagerStep2');
  const seriesPagerLabelStep2  = $('seriesPagerLabelStep2');
  const seriesPagerHintStep2   = $('seriesPagerHintStep2');
  const seriesPrevStep2        = $('seriesPrevStep2');
  const seriesNextStep2        = $('seriesNextStep2');
  const seriesVerbApplyAll     = $('seriesVerbApplyAll');
  const seriesVerbApplyAllBtn  = $('seriesVerbApplyAllBtn');

  // "Für alle übernehmen" – Anlass
  const seriesOccasionApplyAll    = $('seriesOccasionApplyAll');
  const seriesOccasionApplyAllBtn = $('seriesOccasionApplyAllBtn');

  // NEU: "Für alle übernehmen" – Step 1 & Step 3
  const seriesSenderApplyAll      = $('seriesSenderApplyAll');
  const seriesSenderApplyAllBtn   = $('seriesSenderApplyAllBtn');
  const seriesRecipientApplyAll   = $('seriesRecipientApplyAll');
  const seriesRecipientApplyAllBtn= $('seriesRecipientApplyAllBtn');
  // Sprache UI
const certLangDe = $('certLangDe');
const certLangEn = $('certLangEn');
const certLangEs = $('certLangEs');
const certLangFr = $('certLangFr');
const certLangTr = $('certLangTr');

const langToggleDe = $('langToggleDe');
const langToggleEn = $('langToggleEn');
const langToggleEs = $('langToggleEs');
const langToggleFr = $('langToggleFr');
const langToggleTr = $('langToggleTr');
const monthlyLangToggleDe = $('monthlyLangToggleDe');
const monthlyLangToggleEn = $('monthlyLangToggleEn');
const monthlyLangToggleEs = $('monthlyLangToggleEs');
const monthlyLangToggleFr = $('monthlyLangToggleFr');
const monthlyLangToggleTr = $('monthlyLangToggleTr');
const monthlyVerbToggle = $('monthlyVerbToggle');
const monthlyVerbHat = $('monthlyVerbHat');
const monthlyVerbHaben = $('monthlyVerbHaben');

const seriesLangApplyAll = $('seriesLangApplyAll');
const seriesLangApplyAllBtn = $('seriesLangApplyAllBtn');

function setActiveLang(l){
  l = normalizeLang(l);

  if (state.seriesEnabled && hasSeriesRows()){
    ensureSeriesLangLen();
    clampSeriesIndex();
    state.seriesLang[state.seriesIndex] = l;
  }else{
    state.lang = l;
  }

  updateLangToggleUI();
  if (isB2BSubscriptionPortalFlow()){
    syncSubscriptionMonthlyState();
  }
  updateClaim();
  updatePreview();
  try{ applyMonthlyForestsToPreview(); }catch(_){}
  try{ updateMetaBar(); }catch(_){}

  if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
}

function syncMonthlyLangToggleUI(){
  const l = getMonthlyCertLang();
  if (monthlyLangToggleDe) monthlyLangToggleDe.classList.toggle('active', l === 'de');
  if (monthlyLangToggleEn) monthlyLangToggleEn.classList.toggle('active', l === 'en');
  if (monthlyLangToggleEs) monthlyLangToggleEs.classList.toggle('active', l === 'es');
  if (monthlyLangToggleFr) monthlyLangToggleFr.classList.toggle('active', l === 'fr');
  if (monthlyLangToggleTr) monthlyLangToggleTr.classList.toggle('active', l === 'tr');
  try{
    const active = document.querySelector('input[name="monthlyCertLang"][value="' + l + '"]');
    if (active) active.checked = true;
  }catch(_){}
}

function syncMonthlyVerbToggleUI(){
  const isPlural = state.verb === 'HABEN';
  const l = getMonthlyCertLang();
  if (monthlyVerbHat) monthlyVerbHat.classList.toggle('active', !isPlural);
  if (monthlyVerbHaben) monthlyVerbHaben.classList.toggle('active', isPlural);
  if (monthlyVerbHat && monthlyVerbHaben){
    if (l === 'en'){ monthlyVerbHat.textContent = 'HAS'; monthlyVerbHaben.textContent = 'HAVE'; }
    else if (l === 'es'){ monthlyVerbHat.textContent = 'HA'; monthlyVerbHaben.textContent = 'HAN'; }
    else if (l === 'fr'){ monthlyVerbHat.textContent = 'A'; monthlyVerbHaben.textContent = 'ONT'; }
    else if (l === 'tr'){ monthlyVerbHat.textContent = 'DİKTİ'; monthlyVerbHaben.textContent = 'DİKTİLER'; }
    else { monthlyVerbHat.textContent = 'HAT'; monthlyVerbHaben.textContent = 'HABEN'; }
  }
}

function bindLangRadio(el){
  if(!el) return;
  el.addEventListener('change', ()=>{
    if(!el.checked) return;
    setActiveLang(el.value);
  });
}

bindLangRadio(certLangDe);
bindLangRadio(certLangEn);
bindLangRadio(certLangEs);
bindLangRadio(certLangFr);
bindLangRadio(certLangTr);

document.querySelectorAll('input[name="monthlyCertLang"]').forEach(function(el){
  el.addEventListener('change', function(){
    if(!el.checked) return;
    if (isB2BPersonalizedPortalFlow()){
      state.monthlyLang = normalizeLang(el.value);
      syncMonthlyLangToggleUI();
      syncMonthlyVerbToggleUI();
      updatePreview();
      try{ applyMonthlyForestsToPreview(); }catch(_){}
      if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
      return;
    }
    setActiveLang(el.value);
  });
});

if (monthlyVerbToggle){
  monthlyVerbToggle.addEventListener('click', function(e){
    const btn = e.target.closest('button[data-verb]');
    if(!btn) return;
    state.verb = (btn.getAttribute('data-verb') === 'HABEN') ? 'HABEN' : 'HAT';
    syncMonthlyVerbToggleUI();
    updateClaim();
    updatePreview();
    if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
  });
}

if (seriesLangApplyAllBtn){
  seriesLangApplyAllBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    applyLangToAllSeries();
  });
}

// Initial UI sync
updateLangToggleUI();


  // Serienfunktion nur im reinen Zertifikatsmodus anbieten
  if (seriesToggleEl && state.mode !== 'cert'){
    seriesToggleEl.style.display = 'none';
    if (recipientSeriesWrap) recipientSeriesWrap.style.display = 'none';
    if (recipientSingleWrap) recipientSingleWrap.style.display = 'block';
  }

  // Serien-Hinweis unter dem Feld in Gift/Label ausblenden
if (seriesInlineToggle && state.mode !== 'cert'){
  seriesInlineToggle.style.display = 'none';
}

  function hasSeriesRows(){
    return Array.isArray(state.seriesRows) && state.seriesRows.length > 0;
  }

  function clampSeriesIndex(){
    if (!hasSeriesRows()){
      state.seriesIndex = 0;
      return;
    }
    if (state.seriesIndex < 0) state.seriesIndex = 0;
    if (state.seriesIndex >= state.seriesRows.length){
      state.seriesIndex = state.seriesRows.length - 1;
    }
  }

function getSeriesVerb(idx){
  if (!Array.isArray(state.seriesVerb)) return 'HAT';
  const v = state.seriesVerb[idx];
  return v === 'HABEN' ? 'HABEN' : 'HAT';
}

function setSeriesVerb(idx, verb){
  if (!Array.isArray(state.seriesVerb)) state.seriesVerb = [];
  state.seriesVerb[idx] = (verb === 'HABEN') ? 'HABEN' : 'HAT';
}

// ===== Sprache (wie im B2C Wizard) =====
function normalizeLang(v){
  if (v === null || v === undefined) return 'de';
  let s = String(v).trim().toLowerCase();
  if (!s) return 'de';

  // Locale-Formate abfangen: en-US, en_US, fr-FR, de-DE ...
  s = s.replace(/_/g, '-');
  const base = s.split('-')[0];              // "en-us" -> "en"

  // Direktcodes zuerst
  if (['de','en','es','fr','tr'].includes(base)) return base;

  // Aliase / Freitext
  if (['eng','english','uk','gb','us'].includes(s) || ['uk','gb','us'].includes(base)) return 'en';
  if (['ger','german','deutsch'].includes(s)) return 'de';
  if (['spa','spanish','español','espanol'].includes(s)) return 'es';
  if (['fra','fre','french','français','francais'].includes(s)) return 'fr';
  if (['tur','turkish','türkçe','turkce'].includes(s)) return 'tr';

  return 'de';
}


function getLangText(key, lang){
  const l = normalizeLang(lang);
  if (!LANG_TEXT[key]) return '';
  return (LANG_TEXT[key][l] || LANG_TEXT[key].de || '');
}

// Forst-Displayname je nach Zertifikatssprache (Wizard bleibt DE)
function getForestDisplayName(code, lang){
  if(!code || !FORESTS[code]) return '';
  const f = FORESTS[code];
  const l = normalizeLang(lang);

  if (l === 'en') return (f.name_en || f.name || '').trim();
  if (l === 'es') return (f.name_es || f.name_en || f.name || '').trim();
  if (l === 'fr') return (f.name_fr || f.name_en || f.name || '').trim();
  if (l === 'tr') return (f.name_tr || f.name_en || f.name || '').trim();

  return (f.name || '').trim();
}

function ensureSeriesLangLen(){
  if (!state.seriesEnabled || !hasSeriesRows()) return;
  if (!Array.isArray(state.seriesLang)) state.seriesLang = [];

  const def = normalizeLang(state.lang);
  for (let i = 0; i < state.seriesRows.length; i++){
    const cur = state.seriesLang[i];
    state.seriesLang[i] = cur ? normalizeLang(cur) : def;
  }
}

function getActiveLang(){
  if (state.seriesEnabled){
    if (Array.isArray(state.seriesLang)){
      const v = state.seriesLang[state.seriesIndex];
      if (v) return normalizeLang(v);
    }
  }
  return normalizeLang(state.lang);
}

function updateLangToggleUI(){
  const l = getActiveLang();

  if (certLangDe) certLangDe.checked = (l === 'de');
  if (certLangEn) certLangEn.checked = (l === 'en');
  if (certLangEs) certLangEs.checked = (l === 'es');
  if (certLangFr) certLangFr.checked = (l === 'fr');
  if (certLangTr) certLangTr.checked = (l === 'tr');

  if (langToggleDe) langToggleDe.classList.toggle('active', l === 'de');
  if (langToggleEn) langToggleEn.classList.toggle('active', l === 'en');
  if (langToggleEs) langToggleEs.classList.toggle('active', l === 'es');
  if (langToggleFr) langToggleFr.classList.toggle('active', l === 'fr');
  if (langToggleTr) langToggleTr.classList.toggle('active', l === 'tr');
  syncMonthlyLangToggleUI();
  syncMonthlyVerbToggleUI();

  // Verb-Buttons passend zur Zertifikat-Sprache (intern bleibt HAT/HABEN)
  try{
    const seg = document.getElementById('segVerb');
    if (seg){
      const bHat   = seg.querySelector('button[data-verb="HAT"]');
      const bHaben = seg.querySelector('button[data-verb="HABEN"]');

      if (bHat && bHaben){
        if (l === 'en'){ bHat.textContent='HAS';  bHaben.textContent='HAVE'; }
        else if (l === 'es'){ bHat.textContent='HA';   bHaben.textContent='HAN'; }
        else if (l === 'fr'){ bHat.textContent='A';    bHaben.textContent='ONT'; }
        else if (l === 'tr'){ bHat.textContent='DİKTİ'; bHaben.textContent='DİKTİLER'; }
        else { bHat.textContent='HAT'; bHaben.textContent='HABEN'; }
      }
    }
  }catch(_){}

  if (seriesLangApplyAll){
    seriesLangApplyAll.style.display = (state.seriesEnabled && hasSeriesRows()) ? 'block' : 'none';
  }
}

function applyLangToAllSeries(){
  if (!state.seriesEnabled || !hasSeriesRows()) return;
  ensureSeriesLangLen();
  const l = getActiveLang();
  for (let i = 0; i < state.seriesRows.length; i++){
    state.seriesLang[i] = l;
  }
  updateLangToggleUI();
  updateClaim();
  updatePreview();
  if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
}


const SERIES_BLANK_RECIPIENT_MARKER = '   ';

function isSeriesBlankRecipientMarker(value){
  const raw = String(value == null ? '' : value).replace(/\r/g, '');
  return raw.length >= 3 && !/\S/.test(raw);
}

function isSeriesBlankRecipientRow(row){
  return !!(row && row.blank_recipient);
}

function seriesNameLineForTextarea(row){
  if (isSeriesBlankRecipientRow(row)) return SERIES_BLANK_RECIPIENT_MARKER;
  return (row && row.line1) ? row.line1 : '';
}

function seriesCompanyLineForTextarea(row){
  if (isSeriesBlankRecipientRow(row)) return '';
  return (row && row.line2) ? row.line2 : '';
}

function isSeriesBlankMode(){
  return !!(state.seriesEnabled && state.seriesBlankMode);
}

function clampSeriesBlankCount(value){
  const parsed = parseInt(String(value == null ? '' : value).replace(/[^\d]/g, ''), 10);
  if (!isFinite(parsed) || parsed <= 0) return 1;
  return Math.max(1, Math.min(2000, parsed));
}

function getSeriesBlankCount(){
  const raw = seriesBlankCountInput ? seriesBlankCountInput.value : state.seriesBlankCount;
  return clampSeriesBlankCount(raw || state.seriesBlankCount || 10);
}

function syncSeriesBlankCountInput(){
  const count = clampSeriesBlankCount(state.seriesBlankCount || getSeriesBlankCount());
  state.seriesBlankCount = count;
  if (seriesBlankCountInput && String(seriesBlankCountInput.value || '') !== String(count)){
    seriesBlankCountInput.value = String(count);
  }
}

function buildBlankSeriesEntries(count){
  const n = clampSeriesBlankCount(count);
  const baseSender = txt1 ? String(txt1.value || '') : '';
  const baseOccasion = txt6 ? String(txt6.value || '') : '';
  const baseVerb = (state.verb === 'HABEN') ? 'HABEN' : 'HAT';
  const baseForest = state.forest || '';
  const baseFrameColor = state.frameColor || FRAME_COLOR_DEFAULT;
  const baseDelivery = getCurrentDeliveryFromUI();
  const basePaperType = getCurrentPaperTypeFromUI();
  const baseLang = (typeof getActiveLang === 'function') ? getActiveLang() : normalizeLang(state.lang);
  const baseTrees = state.trees || 1;

  const oldSender = Array.isArray(state.seriesSender) ? state.seriesSender : [];
  const oldOccasion = Array.isArray(state.seriesOccasion) ? state.seriesOccasion : [];
  const oldTrees = Array.isArray(state.seriesTrees) ? state.seriesTrees : [];
  const oldVerb = Array.isArray(state.seriesVerb) ? state.seriesVerb : [];
  const oldForest = Array.isArray(state.seriesForest) ? state.seriesForest : [];
  const oldFrameColor = Array.isArray(state.seriesFrameColor) ? state.seriesFrameColor : [];
  const oldDelivery = Array.isArray(state.seriesDelivery) ? state.seriesDelivery : [];
  const oldPaperType = Array.isArray(state.seriesPaperType) ? state.seriesPaperType : [];
  const oldLang = Array.isArray(state.seriesLang) ? state.seriesLang : [];

  return Array.from({ length:n }, (_, idx) => ({
    sender: typeof oldSender[idx] === 'string' ? oldSender[idx] : baseSender,
    recipient: '',
    message: typeof oldOccasion[idx] === 'string' ? oldOccasion[idx] : baseOccasion,
    trees: (typeof oldTrees[idx] === 'number' && oldTrees[idx] > 0) ? oldTrees[idx] : baseTrees,
    verb: oldVerb[idx] === 'HABEN' ? 'HABEN' : baseVerb,
    forest_code: oldForest[idx] || baseForest,
    frame_color: oldFrameColor[idx] || baseFrameColor,
    delivery: (oldDelivery[idx] === 'print' || oldDelivery[idx] === 'digital') ? oldDelivery[idx] : baseDelivery,
    paper_type: (oldPaperType[idx] === 'grass' || oldPaperType[idx] === 'white') ? oldPaperType[idx] : basePaperType,
    lang: oldLang[idx] ? normalizeLang(oldLang[idx]) : baseLang,
    blank_recipient: true
  }));
}

function seriesRecipientTextFromRow(row){
  if (!row || isSeriesBlankRecipientRow(row)) return '';
  const l1 = row.line1 || '';
  const l2 = row.line2 || '';
  return l2 ? (l1 + '\n' + l2) : l1;
}

function seriesRowToText(row){
  return seriesRecipientTextFromRow(row);
}

function getCurrentDeliveryFromUI(){
  // Wenn wir gar keine Radios haben, nimm den aktuellen State
  if (!deliveryOptionsEl){
    return state.delivery || 'digital';
  }
  const checked = deliveryOptionsEl.querySelector('input[name="delivery"]:checked');
  if (checked){
    const val = checked.value === 'print' ? 'print' : 'digital';
    return val;
  }
  return state.delivery || 'digital';
}

function getCurrentPaperTypeFromUI(){
  if (!printPaperOptionsEl){
    return state.paperType || 'white';
  }
  const checked = printPaperOptionsEl.querySelector('input[name="paperType"]:checked');
  if (checked){
    const val = (checked.value === 'grass') ? 'grass' : 'white';
    return val;
  }
  return state.paperType || 'white';
}


function initSeriesDeliveryDefaults(){
  if (!state.seriesEnabled || !hasSeriesRows()) return;

  // NEU: Wenn es bereits pro-Zertifikat-Einstellungen gibt,
  // dann NICHT nochmal alles mit dem aktuellen UI-Stand überschreiben.
  let hasExisting = false;
  if (Array.isArray(state.seriesDelivery)){
    for (let i = 0; i < state.seriesRows.length; i++){
      const d = state.seriesDelivery[i];
      if (d === 'print' || d === 'digital'){
        hasExisting = true;
        break;
      }
    }
  }
  if (hasExisting){
    // Serienfunktion war schon mal aktiv – bestehende Einstellungen behalten
    return;
  }

  // Erstes Mal Serienmodus: Defaults aus dem aktuellen UI ableiten
  if (!Array.isArray(state.seriesDelivery))   state.seriesDelivery   = [];
  if (!Array.isArray(state.seriesPaperType))  state.seriesPaperType  = [];

  const d = getCurrentDeliveryFromUI();    // z.B. "digital" oder "print"
  const p = getCurrentPaperTypeFromUI();   // z.B. "white" oder "grass"

  // Globalen State daran angleichen
  state.delivery  = d;
  state.paperType = p;

  // Und für alle Zertifikate als Startwert setzen
  for (let i = 0; i < state.seriesRows.length; i++){
    state.seriesDelivery[i]  = d;
    state.seriesPaperType[i] = p;
  }
}

function textToSeriesRow(text){
  const raw   = (text || '').replace(/\r/g, '');
  const lines = raw.split('\n');
  const blankRecipient = isSeriesBlankRecipientMarker(lines[0] || '');
  return {
    // KEIN trim() mehr → Leerzeichen am Ende bleiben erhalten
    line1: blankRecipient ? '' : (lines[0] || ''),
    line2: blankRecipient ? '' : (lines[1] || ''),
    blank_recipient: !!blankRecipient
  };
}

function getTreesForIndex(idx){
  // Wenn Serienfunktion aus ist → wie bisher globaler Wert
  if (!state.seriesEnabled || !hasSeriesRows()) {
    return state.trees || 1;
  }

  if (!Array.isArray(state.seriesTrees)) state.seriesTrees = [];

  const t = state.seriesTrees[idx];
  return (typeof t === 'number' && t > 0) ? t : 1;
}

function getDecoBalloonForIndex(idx){
  if (!state.seriesEnabled || !hasSeriesRows()){
    return !!state.decoBalloon;
  }
  if (!Array.isArray(state.seriesDecoBalloon)) state.seriesDecoBalloon = [];
  const v = state.seriesDecoBalloon[idx];
  // Wenn kein expliziter Wert vorhanden ist, Standard = false
  return (typeof v === 'boolean') ? v : false;
}

function getDecoHatForIndex(idx){
  if (!state.seriesEnabled || !hasSeriesRows()){
    return !!state.decoHat;
  }
  if (!Array.isArray(state.seriesDecoHat)) state.seriesDecoHat = [];
  const v = state.seriesDecoHat[idx];
  // Wenn kein expliziter Wert vorhanden ist, Standard = false
  return (typeof v === 'boolean') ? v : false;
}

function getForestForIndex(idx){
  if (!state.seriesEnabled || !hasSeriesRows()){
    return state.forest || null;
  }
  if (!Array.isArray(state.seriesForest)) state.seriesForest = [];
  const code = state.seriesForest[idx];
  if (code && FORESTS[code]) return code;
  // Fallback: globaler Pflanzort, falls gesetzt
  return state.forest || null;
}

function setForestForIndex(idx, code){
  if (!FORESTS[code]) return;
  if (!Array.isArray(state.seriesForest)) state.seriesForest = [];
  state.seriesForest[idx] = code;
}


 function getFrameColorForIndex(idx){
   if (!state.seriesEnabled || !hasSeriesRows()){
     return state.frameColor || FRAME_COLOR_DEFAULT;
   }
   if (!Array.isArray(state.seriesFrameColor)) state.seriesFrameColor = [];
   const c = state.seriesFrameColor[idx];
   if (c && /^#[0-9A-Fa-f]{6}$/.test(c)) return c.toUpperCase();
   return state.frameColor || FRAME_COLOR_DEFAULT;
 }

 function setFrameColorForIndex(idx, hex){
   const n = normalizeAndEnsureHex(hex) || FRAME_COLOR_DEFAULT;
   if (!Array.isArray(state.seriesFrameColor)) state.seriesFrameColor = [];
   state.seriesFrameColor[idx] = n;
 }

function getDeliveryForIndex(idx){
  // Kein Serienmodus → wie bisher global
  if (!state.seriesEnabled || !hasSeriesRows()){
    return state.delivery || 'digital';
  }

  if (!Array.isArray(state.seriesDelivery)) state.seriesDelivery = [];

  let d = state.seriesDelivery[idx];

  // Wenn noch nie explizit gesetzt: Slot einmalig initialisieren
  // und dann NIE wieder über state.delivery "infizieren"
  if (d !== 'print' && d !== 'digital'){
    // konservativer Default für Serien-Slots: digital
    d = 'digital';
    state.seriesDelivery[idx] = d;
  }

  return d;
}

  function setDeliveryForIndex(idx, val){
    if (!Array.isArray(state.seriesDelivery)) state.seriesDelivery = [];
    state.seriesDelivery[idx] = (val === 'print') ? 'print' : 'digital';
  }

function getPaperTypeForIndex(idx){
  if (!state.seriesEnabled || !hasSeriesRows()){
    // Einzel-Modus: wie bisher global
    return state.paperType || 'white';
  }
  if (!Array.isArray(state.seriesPaperType)) state.seriesPaperType = [];
  const p = state.seriesPaperType[idx];
  if (p === 'grass' || p === 'white') return p;

  // Nicht mehr vom globalen state.paperType abhängig machen,
  // sonst "infiziert" ein Slot alle anderen.
  return 'white'; // fixer Default für Serien-Slots ohne eigenen Wert
}

 function setPaperTypeForIndex(idx, val){
   if (!Array.isArray(state.seriesPaperType)) state.seriesPaperType = [];
   state.seriesPaperType[idx] = (val === 'grass') ? 'grass' : 'white';
 }


  function syncTreesFromSeriesIndex(){
    if(!state.seriesEnabled || !hasSeriesRows()) return;
    clampSeriesIndex();
    const t = getTreesForIndex(state.seriesIndex);
    state.trees = t;
    if(qVal) qVal.value = t;
    updateClaim();
    updateQtyLabel();
    updateCo2Label();
    updatePrice();
    updatePreview();
  }

    function syncDeliveryFromSeriesIndex(){
    if (!state.seriesEnabled || !hasSeriesRows()) return;
    clampSeriesIndex();

    const d = getDeliveryForIndex(state.seriesIndex);
    state.delivery = d;

    if (deliveryOptionsEl){
      deliveryOptionsEl.querySelectorAll('input[name="delivery"]').forEach(inp=>{
        inp.checked = !!(inp.value === d);
      });
      applyDeliverySelectionUI();
    }

    togglePaperOptions();
    updatePrice();
    updateMetaBar();
    updatePreview();
  }


 function syncPaperTypeFromSeriesIndex(){
   if (!state.seriesEnabled || !hasSeriesRows()) return;
   clampSeriesIndex();

   const p = getPaperTypeForIndex(state.seriesIndex);
   state.paperType = p || 'white';

   if (printPaperOptionsEl){
     printPaperOptionsEl.querySelectorAll('input[name="paperType"]').forEach(inp=>{
       inp.checked = !!(inp.value === state.paperType);
     });
     applyPaperSelectionUI();
   }

   updatePrice();
   updateMetaBar();
   updatePreview();
 }


  function syncDecorFromSeriesIndex(){
    if(!state.seriesEnabled || !hasSeriesRows()) return;
    clampSeriesIndex();
    if (!Array.isArray(state.seriesDecoBalloon)) state.seriesDecoBalloon = [];
    if (!Array.isArray(state.seriesDecoHat))     state.seriesDecoHat     = [];
    const idx = state.seriesIndex;

    state.decoBalloon = !!state.seriesDecoBalloon[idx];
    state.decoHat     = !!state.seriesDecoHat[idx];

    const optBalloon = $('optBalloon');
    const optHat     = $('optHat');
    if (optBalloon) optBalloon.checked = state.decoBalloon;
    if (optHat)     optHat.checked     = state.decoHat;

    applyDecor();
  }


  function syncForestFromSeriesIndex(){
    if (!state.seriesEnabled || !hasSeriesRows()) return;
    clampSeriesIndex(); 

    const code = getForestForIndex(state.seriesIndex) || null;
    state.forest = code;

    // Radio-Buttons setzen
   if (forestOptionsEl){
     forestOptionsEl.querySelectorAll('input[name="forest"]').forEach(inp=>{
       inp.checked = !!(code && inp.value === code);
     });
     applyForestSelectionUI();
   }

   applyForestToPreview();
   applyForestToLabel();
 }

 function syncFrameColorFromSeriesIndex(){
   if (!state.seriesEnabled || !hasSeriesRows()) return;
   clampSeriesIndex();

   const c = getFrameColorForIndex(state.seriesIndex);
   state.frameColor = c || FRAME_COLOR_DEFAULT;

   // UI-Picker setzen
   syncFrameColorInputs();
   applyFrameColor();
 }


    function syncSeriesSenderFromInput(){
    if (!state.seriesEnabled || !hasSeriesRows() || !txt1) return;
    clampSeriesIndex();
    if (!Array.isArray(state.seriesSender)) state.seriesSender = [];
    state.seriesSender[state.seriesIndex] = txt1.value || '';
    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }
  }

    function syncSeriesOccasionFromInput(){
    if (!state.seriesEnabled || !hasSeriesRows() || !txt6) return;
    clampSeriesIndex();
    if (!Array.isArray(state.seriesOccasion)) state.seriesOccasion = [];
    state.seriesOccasion[state.seriesIndex] = txt6.value || '';
    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }
  }


function refreshSeriesRowsFromInputs(){
  if (!seriesNamesTA) return;

  if (isSeriesBlankMode()){
    applyBlankSeriesMode(getSeriesBlankCount());
    return;
  }

  // NEU: Serien-Textareas hart auf 50 Zeichen pro Zeile begrenzen
  limitSeriesTextareaLines(seriesNamesTA);
  if (seriesCompaniesTA){
    limitSeriesTextareaLines(seriesCompaniesTA);
  }

  // Eingaben einlesen. Eine Namenszeile mit mindestens 3 Leerzeichen ist
  // ein bewusster Blanko-Empfänger und zählt als eigenes Zertifikat.
  const rawNames = (seriesNamesTA.value || '').replace(/\r/g, '').split('\n');
  const rawComps = seriesCompaniesTA
    ? (seriesCompaniesTA.value || '').replace(/\r/g, '').split('\n')
    : [];
  const parsedRows = [];
  rawNames.forEach((rawName, sourceIdx)=>{
    const blankRecipient = isSeriesBlankRecipientMarker(rawName);
    const name = blankRecipient ? '' : limitSeriesLine(String(rawName || '').trim());
    const comp = blankRecipient ? '' : limitSeriesLine(String(rawComps[sourceIdx] || '').trim());
    if (!name && !blankRecipient && !comp) return;
    parsedRows.push({
      line1: name,
      line2: comp,
      blank_recipient: !!blankRecipient
    });
  });

  const oldRows    = Array.isArray(state.seriesRows)    ? state.seriesRows    : [];
  const oldTrees   = Array.isArray(state.seriesTrees)   ? state.seriesTrees   : [];
  const oldSender  = Array.isArray(state.seriesSender)  ? state.seriesSender  : [];
  const baseSender = txt1 ? (txt1.value || '') : '';
  const oldOccasion = Array.isArray(state.seriesOccasion) ? state.seriesOccasion : [];
  const baseMessage = txt6 ? (txt6.value || '') : '';

  state.seriesOccasion = parsedRows.map((_, idx)=>{
    const m = oldOccasion[idx];
    if (typeof m === 'string' && m.length) return m;
    return baseMessage;
  });

  state.seriesRows = parsedRows.map((row, idx)=>({
    line1: row.line1 || '',
    line2: row.blank_recipient ? '' : (row.line2 || (oldRows[idx] && oldRows[idx].line2) || ''),
    blank_recipient: !!row.blank_recipient
  }));

  state.seriesTrees = parsedRows.map((_, idx)=>{
    const t = oldTrees[idx];
    return (typeof t === 'number' && t > 0) ? t : 1;
  });

  state.seriesSender = parsedRows.map((_, idx)=>{
    const s = oldSender[idx];
    if (typeof s === 'string' && s.length){ return s; }
    return baseSender;
  });

  // Nicht im Serienmodus? Dann nur Preview updaten und raus.
  if (!state.seriesEnabled){
    updatePreview();
    return;
  }

  // Index im gültigen Bereich halten
  clampSeriesIndex();

  // Aktuelle Person in Editor + Zertifikat spiegeln
  if (hasSeriesRows()){
    const current = state.seriesRows[state.seriesIndex];
    const text    = seriesRowToText(current);

    if (seriesRecipientText){
      seriesRecipientText.value = text;
    }

    if (txt4){
      txt4.value = text;
      if (typeof fit4 === 'function') fit4();
      else updatePreview();
    } else {
      updatePreview();
    }
  } else {
    if (seriesRecipientText) seriesRecipientText.value = '';
    if (txt4){
      txt4.value = '';
      if (typeof fit4 === 'function') fit4();
      else updatePreview();
    } else {
      updatePreview();
    }
  }

  updateSeriesNavigatorUI();
  if(state.seriesEnabled && hasSeriesRows()){
    syncTreesFromSeriesIndex();
    updateSeriesTreeUI();
    updateSeriesFinalPagerUI();
  }

  if(state.seriesEnabled && hasSeriesRows()){
    syncTreesFromSeriesIndex();
    updateSeriesTreeUI();
    updateSeriesSenderUI();
    updateSeriesFinalPagerUI();
  }
}

// NEU: 50-Zeichen-Limiter für Serien-Textareas
function limitSeriesLine(str){
  return (str || '').replace(/\r/g, '').slice(0, 50);
}

function limitSeriesTextareaLines(el){
  if(!el) return;
  const max = 50;
  const raw = (el.value || '').replace(/\r/g, '');
  const parts = raw.split('\n');
  let changed = false;

  const limited = parts.map(line => {
    const s = line || '';
    if (s.length > max){
      changed = true;
      return s.slice(0, max);
    }
    return s;
  });

  if (changed){
    const newVal = limited.join('\n');
    let pos = el.selectionStart || newVal.length;
    if (pos > newVal.length) pos = newVal.length;
    el.value = newVal;
    try{
      el.setSelectionRange(pos, pos);
    }catch(_){}
  }
}

function setSeriesExcelStatus(message, tone){
  if (!seriesExcelStatus) return;
  const text = String(message || '').trim();
  seriesExcelStatus.textContent = text || 'Unterstützt werden aktuell `.xlsx`, `.xlsm` und `.csv`.';
  seriesExcelStatus.classList.remove('is-success', 'is-error');
  if (tone === 'success') seriesExcelStatus.classList.add('is-success');
  if (tone === 'error') seriesExcelStatus.classList.add('is-error');
}

function buildSeriesEntriesFromImportItems(items){
  const list = Array.isArray(items) ? items : [];
  const baseSender = txt1 ? String(txt1.value || '') : '';
  const baseOccasion = txt6 ? String(txt6.value || '') : '';
  const baseForest = state.forest || '';
  const baseVerb = (state.verb === 'HABEN') ? 'HABEN' : 'HAT';
  const baseFrameColor = state.frameColor || FRAME_COLOR_DEFAULT;
  const baseLang = (typeof getActiveLang === 'function') ? getActiveLang() : normalizeLang(state.lang);

  return list.map((item)=>{
    const blankRecipient = !!(item && item.blank_recipient) || isSeriesBlankRecipientMarker(item && item.line1);
    const line1 = blankRecipient ? '' : limitSeriesLine(String((item && item.line1) || '').trim());
    const line2 = blankRecipient ? '' : limitSeriesLine(String((item && item.line2) || '').trim());
    const recipient = blankRecipient ? '' : (line2 ? (line1 + '\n' + line2) : line1);
    const occasion = String((item && item.occasion) || '').trim() || baseOccasion;
    const rawTrees = parseInt(String((item && item.trees) || '').replace(/\D/g,''), 10);
    const trees = (isFinite(rawTrees) && rawTrees > 0) ? rawTrees : 1;
    const forestCode = String((item && item.forest_code) || '').trim().toLowerCase();
    const rawDelivery = String((item && item.delivery) || '').trim().toLowerCase();
    const rawPaperType = String((item && item.paper_type) || '').trim().toLowerCase();
    const rawLang = String((item && item.lang) || '').trim().toLowerCase();
    const delivery = (rawDelivery === 'print')
      ? 'print'
      : ((rawDelivery === 'digital') ? 'digital' : 'digital');
    const paperType = (delivery === 'print' && rawPaperType === 'grass') ? 'grass' : 'white';
    const lang = ['de','en','es','fr','tr'].includes(rawLang) ? rawLang : baseLang;

    return {
      sender: baseSender,
      recipient,
      message: occasion,
      trees,
      verb: baseVerb,
      forest_code: forestCode || baseForest || '',
      frame_color: baseFrameColor,
      delivery,
      paper_type: paperType,
      lang,
      blank_recipient: !!blankRecipient
    };
  }).filter(entry => entry.blank_recipient || String(entry.recipient || '').trim());
}

function applyB2BEntriesAsTemplate(entries, opts){
  const list = Array.isArray(entries) ? entries : [];
  if(!list.length) return false;

  const count = list.length;
  const forceSeriesMode = !!(opts && opts.forceSeriesMode);

  state.seriesEnabled = forceSeriesMode || (count > 1);
  state.seriesIndex = 0;

  state.seriesRows = list.map(e => {
    const raw = String((e && e.recipient) || '').replace(/\r/g,'');
    const blankRecipient = !!(e && e.blank_recipient) || isSeriesBlankRecipientMarker(raw);
    const lines = raw.split('\n');
    return {
      line1: blankRecipient ? '' : (lines[0] || ''),
      line2: blankRecipient ? '' : (lines[1] || ''),
      blank_recipient: !!blankRecipient
    };
  });
  state.seriesSender = list.map(e => String((e && e.sender) || ''));
  state.seriesOccasion = list.map(e => String((e && e.message) || ''));
  state.seriesTrees = list.map(e => {
    const n = parseInt(String((e && e.trees) ?? '').replace(/\D/g,''), 10);
    return (isFinite(n) && n > 0) ? n : 1;
  });
  state.seriesVerb = list.map(e => (String((e && e.verb) || '').toUpperCase() === 'HABEN') ? 'HABEN' : 'HAT');
  state.seriesForest = list.map(e => {
    const c = String((e && e.forest_code) || '').toLowerCase();
    return FORESTS[c] ? c : null;
  });
  state.seriesFrameColor = list.map(e => normalizeAndEnsureHex((e && e.frame_color) || '') || null);
  state.seriesDelivery = list.map(e => (String((e && e.delivery) || '').toLowerCase() === 'print') ? 'print' : 'digital');
  state.seriesPaperType = list.map(e => (String((e && e.paper_type) || '').toLowerCase() === 'grass') ? 'grass' : 'white');

  const prevLang = normalizeLang(state.lang);
  const prevSeriesLang = Array.isArray(state.seriesLang)
    ? state.seriesLang.map(normalizeLang)
    : [];

  function extractLangFromEntry(e){
    if(!e) return null;
    const raw =
      e.lang ??
      e.language ??
      e.lang_code ??
      e.langCode ??
      e.language_code ??
      e.locale ??
      e.cert_lang ??
      e.certificate_lang ??
      e.certificate_language ??
      e.certificateLanguage ??
      e.certLanguage ??
      '';

    const s = String(raw || '').trim();
    if (s) return normalizeLang(s);

    const u = String(e.download_url || e.pdf_url || e.preview_url || '');
    let m = u.match(/[?&]lang=([a-zA-Z_-]{2,10})/);
    if (m && m[1]) return normalizeLang(m[1]);
    m = u.match(/(?:_|-|\/)(de|en|es|fr|tr)(?:_|-|\/|\.|$)/i);
    if (m && m[1]) return normalizeLang(m[1]);
    return null;
  }

  const detected = list.map(extractLangFromEntry);
  const hasAnyDetected = detected.some(x => !!x);

  if (count > 1){
    if (hasAnyDetected){
      state.seriesLang = detected.map((l, i) => l || prevSeriesLang[i] || prevLang);
    } else {
      if (prevSeriesLang.length === count){
        state.seriesLang = prevSeriesLang;
      } else {
        state.seriesLang = Array(count).fill(prevLang);
      }
    }
    state.lang = state.seriesLang[0] || prevLang;
  } else {
    const l0 = hasAnyDetected ? (detected[0] || prevLang) : prevLang;
    state.seriesLang = [];
    state.lang = l0;
  }

  state.seriesDecoBalloon = list.map(e => !!(e && e.deco_balloon));
  state.seriesDecoHat = list.map(e => !!(e && e.deco_hat));

  if (seriesNamesTA) seriesNamesTA.value = state.seriesRows.map(seriesNameLineForTextarea).join('\n');
  if (seriesCompaniesTA) seriesCompaniesTA.value = state.seriesRows.map(seriesCompanyLineForTextarea).join('\n');

  clampSeriesIndex();

  try{ ensureSeriesLangLen(); }catch(_){}
  try{ updateLangToggleUI(); }catch(_){}

  const first = list[0] || {};
  if (txt1 && first.sender != null){ txt1.value = String(first.sender || ''); if (typeof fit1 === 'function') fit1(); }
  if (txt4 && first.recipient != null){ txt4.value = String(first.recipient || ''); if (typeof fit4 === 'function') fit4(); }
  if (txt6 && first.message != null){ txt6.value = String(first.message || ''); if (typeof fit6 === 'function') fit6(); }

  state.verb = getSeriesVerb(0);
  state.trees = getTreesForIndex(0);
  state.forest = getForestForIndex(0) || state.forest || null;
  state.frameColor = getFrameColorForIndex(0) || FRAME_COLOR_DEFAULT;
  state.delivery = getDeliveryForIndex(0) || 'digital';
  state.paperType = getPaperTypeForIndex(0) || 'white';
  state.decoBalloon = !!state.seriesDecoBalloon[0];
  state.decoHat = !!state.seriesDecoHat[0];

  const qValEl = $('qVal');
  if (qValEl) qValEl.value = String(state.trees || 1);

  applySeriesModeUI();
  applyDecor();
  applyForestSelectionUI();
  applyForestToPreview();
  applyFrameColor();
  togglePaperOptions();
  updateClaim();
  updatePrice();
  updateQtyLabel();
  updateCo2Label();
  updateMetaBar();
  updatePreview();

  return true;
}

function applySeriesImportItems(items){
  const entries = buildSeriesEntriesFromImportItems(items);
  if (!entries.length){
    return false;
  }
  state.seriesBlankMode = false;
  applyB2BEntriesAsTemplate(entries, { forceSeriesMode:true });
  state.seriesEnabled = true;
  state.seriesIndex = 0;
  if (seriesModeMulti) seriesModeMulti.checked = true;
  if (seriesModeSingle) seriesModeSingle.checked = false;
  if (seriesModeBlank) seriesModeBlank.checked = false;
  applySeriesModeUI();
  updateSeriesDeliveryUI();
  updatePreview();
  if (!hasEditOrClone && DRAFT_KEY){
    scheduleDraftSave();
  }
  return true;
}

function applyBlankSeriesMode(count){
  if (state.mode !== 'cert'){
    alert('Die Blanko-Funktion ist aktuell nur für reine Zertifikate verfügbar.');
    return false;
  }

  const n = clampSeriesBlankCount(count || getSeriesBlankCount());
  state.seriesBlankMode = true;
  state.seriesBlankCount = n;

  const applied = applyB2BEntriesAsTemplate(buildBlankSeriesEntries(n), { forceSeriesMode:true });
  if (!applied) return false;

  state.seriesEnabled = true;
  state.seriesBlankMode = true;
  state.seriesBlankCount = n;
  state.seriesIndex = 0;
  syncSeriesBlankCountInput();

  if (seriesModeBlank) seriesModeBlank.checked = true;
  if (seriesModeMulti) seriesModeMulti.checked = false;
  if (seriesModeSingle) seriesModeSingle.checked = false;

  applySeriesModeUI();
  updateSeriesDeliveryUI();
  updatePreview();
  if (!hasEditOrClone && DRAFT_KEY){
    scheduleDraftSave();
  }
  return true;
}

async function importSeriesExcelFile(file){
  if (!file) return;
  if (state.mode !== 'cert'){
    alert('Der Excel-Import ist aktuell nur für reine Zertifikate verfügbar.');
    return;
  }

  const formData = new FormData();
  formData.append('file', file);
  setSeriesExcelStatus('Datei wird eingelesen …');

  try{
    const resp = await fetch(API_BASE + '/api2/cert/b2b_series_import_excel', {
      method:'POST',
      body: formData
    });
    const data = await resp.json().catch(()=> ({}));
    if (!resp.ok || !data || data.ok !== true){
      throw new Error(String((data && (data.detail || data.reason)) || 'Import fehlgeschlagen.'));
    }

    const items = Array.isArray(data.items) ? data.items : [];
    if (!applySeriesImportItems(items)){
      throw new Error('Es konnten keine gültigen Zertifikate aus der Datei übernommen werden.');
    }

    const warnings = Array.isArray(data.warnings) ? data.warnings : [];
    const warningSuffix = warnings.length ? (' ' + warnings.length + ' Hinweis(e) wurden berücksichtigt.') : '';
    setSeriesExcelStatus(items.length + ' Zertifikat(e) aus der Datei übernommen.' + warningSuffix, 'success');
  }catch(err){
    console.warn('series excel import failed', err);
    setSeriesExcelStatus(String((err && err.message) || 'Import fehlgeschlagen.'), 'error');
  }finally{
    if (seriesExcelFile) seriesExcelFile.value = '';
  }
}

function syncCurrentSeriesRowFromEditor(){
  if (!state.seriesEnabled || !hasSeriesRows() || !seriesRecipientText) return;
  if (isSeriesBlankMode()) return;

  // 50-Zeichen-Limit pro Zeile auch im Einzel-Editor
  limitSeriesTextareaLines(seriesRecipientText);

  // Editor → aktuelles Serienobjekt
  const row = textToSeriesRow(seriesRecipientText.value);
  state.seriesRows[state.seriesIndex] = row;

  // In das "normale" Empfängerfeld spiegeln (für A4-Preview)
  if (txt4){
    txt4.value = seriesRowToText(row);
    if (typeof fit4 === 'function') fit4();
    // WICHTIG: Preview nach dem Fit explizit aktualisieren
    updatePreview();
  } else {
    updatePreview();
  }

  // Bulk-Textareas oben (Namenslisten) neu aus dem State aufbauen
  if (seriesNamesTA){
    seriesNamesTA.value = state.seriesRows.map(seriesNameLineForTextarea).join('\n');
  }
  if (seriesCompaniesTA){
    seriesCompaniesTA.value = state.seriesRows.map(seriesCompanyLineForTextarea).join('\n');
  }

  if (!hasEditOrClone && DRAFT_KEY){
    scheduleDraftSave();
  }
}

  function applySeriesModeUI(){
    const enabled = !!state.seriesEnabled;
    const blankMode = isSeriesBlankMode();

    if (recipientSingleWrap){
      recipientSingleWrap.style.display = enabled ? 'none' : 'block';
    }
    if (recipientSeriesWrap){
      recipientSeriesWrap.style.display = (enabled && !blankMode) ? 'block' : 'none';
    }
    if (recipientBlankWrap){
      recipientBlankWrap.style.display = blankMode ? 'block' : 'none';
    }

    if (seriesModeSingle) seriesModeSingle.checked = !enabled;
    if (seriesModeMulti)  seriesModeMulti.checked  = enabled && !blankMode;
    if (seriesModeBlank)  seriesModeBlank.checked  = blankMode;
    syncSeriesBlankCountInput();

    // alte Toggle-Optik oben (falls sichtbar) trotzdem korrekt halten
    if (seriesToggleEl && seriesModeSingle && seriesModeMulti){
      const singleLabel = seriesModeSingle.closest('label');
      const multiLabel  = seriesModeMulti.closest('label');
      const blankLabel  = seriesModeBlank ? seriesModeBlank.closest('label') : null;

      if (singleLabel){
        singleLabel.classList.toggle('active', !enabled);
      }
      if (multiLabel){
        multiLabel.classList.toggle('active', enabled && !blankMode);
      }
      if (blankLabel){
        blankLabel.classList.toggle('active', blankMode);
      }
    }

// NEU: Inline-Hinweis unter dem Feld
if (seriesInlineToggle && seriesInlineBtn){
  seriesInlineToggle.classList.toggle('series-inline-toggle--active', enabled && !blankMode);
  seriesInlineToggle.classList.toggle('series-inline-toggle--blank-active', blankMode);

  const textSpan = seriesInlineBtn.querySelector('.series-inline-text');
  if (textSpan){
    textSpan.textContent = enabled
      ? (blankMode ? 'Serienmodus starten – mehrere Zertifikate mit Namen erstellen' : 'Serienmodus aktiv – hier klicken, um wieder auf ein einzelnes Zertifikat zu wechseln')
      : 'NEU: Serienmodus starten – mehrere Zertifikate auf einmal erstellen';
  }
}
  if (seriesBlankInlineBtn){
  const textSpan = seriesBlankInlineBtn.querySelector('.series-inline-text');
  if (textSpan){
    const count = getSeriesBlankCount();
    textSpan.textContent = blankMode
      ? ('Blanko-Modus aktiv - ' + count + (count === 1 ? ' Zertifikat' : ' Zertifikate'))
      : 'Blanko-Zertifikate erstellen';
  }
}

    updateSeriesNavigatorUI();
    updateSeriesTreeUI();
    updateSeriesSenderUI();
    updateSeriesOccasionUI();
    updateSeriesVerbUI();
    updateSeriesDecorUI();
    updateSeriesForestUI();
    updateSeriesFrameUI()
    updateSeriesFinalPagerUI();
    updateSeriesDeliveryUI();
  }

function updateSeriesNavigatorUI(){
  if (!seriesPager || !seriesPagerLabel || !seriesPagerHint) return;

  const enabled = !!state.seriesEnabled;
  const blankMode = isSeriesBlankMode();
  const count   = hasSeriesRows() ? state.seriesRows.length : 0;
  const inStep3 = (state.step === 3); // „Schritt 3: Beschenkte:r“

  if (enabled && count > 0 && inStep3){
    clampSeriesIndex();

    seriesPager.style.display      = 'flex';
    seriesPagerHint.style.display  = (count > 1) ? 'block' : 'none';
    seriesPagerHint.innerHTML = blankMode
      ? 'Alle Zertifikate werden mit <strong>leerem Empfängerfeld</strong> erstellt.'
      : 'Du kannst hier die <strong>einzelnen Zertifikate der Serie durchblättern</strong> und den Namen für dieses Zertifikat anpassen.';
    if (seriesRecipientEdit) {
      seriesRecipientEdit.style.display = blankMode ? 'none' : 'block';
    }

    const currentHuman = state.seriesIndex + 1;
    if (count > 1){
      seriesPagerLabel.textContent = (blankMode ? 'Blanko-Zertifikat ' : 'Zertifikat ') + currentHuman + ' von ' + count;
    } else {
      seriesPagerLabel.textContent = blankMode ? '1 Blanko-Zertifikat' : '1 Zertifikat in dieser Serie';
    }

    if (seriesPrevBtn){
      seriesPrevBtn.disabled = (state.seriesIndex <= 0);
    }
    if (seriesNextBtn){
      seriesNextBtn.disabled = (state.seriesIndex >= count - 1);
    }

    if (seriesRecipientText){
      const row = state.seriesRows[state.seriesIndex];
      seriesRecipientText.value = seriesRowToText(row);
    }

    // Hinweis/CTA "Diesen Namen für alle Zertifikate übernehmen"
    // in Step 3 komplett ausblenden
    if (seriesRecipientApplyAll){
      seriesRecipientApplyAll.style.display = 'none';
    }

  } else {
    // Alles ausblenden
    seriesPager.style.display     = 'none';
    seriesPagerHint.style.display = 'none';
    if (seriesRecipientEdit) {
      seriesRecipientEdit.style.display = 'none';
    }

    if (seriesRecipientText && (!enabled || count === 0)){
      seriesRecipientText.value = '';
    }

    if (seriesRecipientApplyAll){
      seriesRecipientApplyAll.style.display = 'none';
    }
  }
}

    // NEU: aktuellen Empfänger in Step 3 auf alle Zertifikate übertragen
  function applyRecipientToAllSeries(){
    if (!state.seriesEnabled || !hasSeriesRows()) return;

    // Basis: aktueller Editor-Inhalt, notfalls txt4
    const text = (seriesRecipientText && seriesRecipientText.value)
      ? seriesRecipientText.value
      : (txt4 ? txt4.value : '');

    const row  = textToSeriesRow(text);
    const count= state.seriesRows.length;

    // Alle Rows auf diesen Wert setzen
    state.seriesRows = state.seriesRows.map(()=>({
      line1: row.line1,
      line2: row.line2,
      blank_recipient: !!row.blank_recipient
    }));

    // Bulk-Textareas aktualisieren
    if (seriesNamesTA){
      seriesNamesTA.value = state.seriesRows.map(seriesNameLineForTextarea).join('\n');
    }
    if (seriesCompaniesTA){
      seriesCompaniesTA.value = state.seriesRows.map(seriesCompanyLineForTextarea).join('\n');
    }

    // Aktuelles Feld + Zertifikat-Text aktualisieren
    if (seriesRecipientText){
      seriesRecipientText.value = seriesRowToText(row);
    }
    if (txt4){
      txt4.value = seriesRowToText(row);
      if (typeof fit4 === 'function') fit4();
    }

    updateSeriesNavigatorUI();
    updatePreview();

    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }
  }

  function applyOccasionToAllSeries(){
    if (!state.seriesEnabled || !hasSeriesRows() || !txt6) return;

    const val = txt6.value || '';
    const count = state.seriesRows.length;

    if (!Array.isArray(state.seriesOccasion)) state.seriesOccasion = [];

    for (let i = 0; i < count; i++){
      state.seriesOccasion[i] = val;
    }

    updateSeriesOccasionUI();
    updatePreview();

    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }
  }

  function applyVerbToAllSeries(){
    if (!state.seriesEnabled || !hasSeriesRows()) return;

    const v = (state.verb === 'HABEN') ? 'HABEN' : 'HAT';
    const count = state.seriesRows.length;

    if (!Array.isArray(state.seriesVerb)) state.seriesVerb = [];

    for (let i = 0; i < count; i++){
      state.seriesVerb[i] = v;
    }

    updateSeriesVerbUI();
    updateClaim();
    updatePreview();

    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }
  }

  if (seriesVerbApplyAllBtn){
    seriesVerbApplyAllBtn.addEventListener('click', (e)=>{
      e.preventDefault();
      applyVerbToAllSeries();
    });
  }


  function applyDecorToAllSeries(){
    if (!state.seriesEnabled || !hasSeriesRows()) return;

    const count = state.seriesRows.length;
    if (!Array.isArray(state.seriesDecoBalloon)) state.seriesDecoBalloon = [];
    if (!Array.isArray(state.seriesDecoHat))     state.seriesDecoHat     = [];

    const balloon = !!state.decoBalloon;
    const hat     = !!state.decoHat;

    for (let i = 0; i < count; i++){
      state.seriesDecoBalloon[i] = balloon;
      state.seriesDecoHat[i]     = hat;
    }

    syncDecorFromSeriesIndex();
    updateSeriesDecorUI();

    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }
  }

  function applyTreesToAllSeries(){
  if (!state.seriesEnabled || !hasSeriesRows()) return;

  // Basis: aktuelle Baumanzahl im UI
  const t = Math.max(1, state.trees || 1);
  const count = state.seriesRows.length;

  if (!Array.isArray(state.seriesTrees)) state.seriesTrees = [];

  for (let i = 0; i < count; i++){
    state.seriesTrees[i] = t;
  }

  // aktuellen Slot + Preview aktualisieren
  clampSeriesIndex();
  state.trees = t;
  if (qVal) qVal.value = t;

  updateClaim();
  updateQtyLabel();
  updateCo2Label();
  updatePrice();
  updatePreview();
  updateSeriesTreeUI();
  updateSeriesFinalPagerUI();

  if (!hasEditOrClone && DRAFT_KEY){
    scheduleDraftSave();
  }
}

  function applyForestToAllSeries(){
    if (!state.seriesEnabled || !hasSeriesRows()) return;
    const code = state.forest;
    if (!code || !FORESTS[code]) return;

    const count = state.seriesRows.length;
    if (!Array.isArray(state.seriesForest)) state.seriesForest = [];

    for (let i = 0; i < count; i++){
      state.seriesForest[i] = code;
    }

    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }

    // aktuelle Anzeige aktualisieren
    syncForestFromSeriesIndex();
    updateSeriesForestUI();
  }

  function applyFrameColorToAllSeries(){
    if (!state.seriesEnabled || !hasSeriesRows()) return;
    const c = state.frameColor || FRAME_COLOR_DEFAULT;
    if (!c) return;

    const count = state.seriesRows.length;
    if (!Array.isArray(state.seriesFrameColor)) state.seriesFrameColor = [];

    for (let i = 0; i < count; i++){
      state.seriesFrameColor[i] = c;
    }

    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }

    syncFrameColorFromSeriesIndex();
    updateSeriesFrameUI();
  }

  

function updateSeriesTreeUI(){
  if (!seriesPagerStep5 || !seriesPagerLabelStep5 || !seriesPagerHintStep5) return;

  const enabled = !!state.seriesEnabled;
  const count   = hasSeriesRows() ? state.seriesRows.length : 0;
  const inStep5 = (state.step === 5);

  if (enabled && count > 0 && inStep5){
    clampSeriesIndex();
    seriesPagerStep5.style.display     = 'flex';
    seriesPagerHintStep5.style.display = 'block';

    const currentHuman = state.seriesIndex + 1;
    seriesPagerLabelStep5.textContent =
      'Baumanzahl für Zertifikat ' + currentHuman + ' von ' + count;

    if (seriesPrevStep5) seriesPrevStep5.disabled = (state.seriesIndex <= 0);
    if (seriesNextStep5) seriesNextStep5.disabled = (state.seriesIndex >= count - 1);

    // NEU: CTA nur bei mehreren Zertifikaten anzeigen
    if (seriesTreesApplyAll){
      seriesTreesApplyAll.style.display = (count > 1) ? 'block' : 'none';
    }

  } else {
    seriesPagerStep5.style.display     = 'none';
    seriesPagerHintStep5.style.display = 'none';
    if (seriesTreesApplyAll){
      seriesTreesApplyAll.style.display = 'none';
    }
  }
}


function updateSeriesSenderUI(){
  if (!seriesPagerStep1 || !seriesPagerLabelStep1 || !seriesPagerHintStep1) return;

  const enabled = !!state.seriesEnabled;
  const count   = hasSeriesRows() ? state.seriesRows.length : 0;
  const inStep1 = (state.step === 1);

  // 1) txt1 IMMER mit dem aktuellen Serien-Slot synchronisieren,
  //    solange Serienmodus + Rows aktiv sind
  if (enabled && count > 0 && txt1){
    clampSeriesIndex();
    const sendArr = Array.isArray(state.seriesSender) ? state.seriesSender : [];
    const val = sendArr[state.seriesIndex] || '';
    txt1.value = val;
    if (typeof fit1 === 'function') fit1();
  }

  // 2) Pager / Hint / "Für alle übernehmen" / Logo-Hinweis
  //    NUR in Step 1 anzeigen
  if (enabled && count > 0 && inStep1){
    seriesPagerStep1.style.display     = 'flex';
    seriesPagerHintStep1.style.display = 'block';

    const currentHuman = state.seriesIndex + 1;
    seriesPagerLabelStep1.textContent =
      'Schenkende:r für Zertifikat ' + currentHuman + ' von ' + count;

    if (seriesPrevStep1) seriesPrevStep1.disabled = (state.seriesIndex <= 0);
    if (seriesNextStep1) seriesNextStep1.disabled = (state.seriesIndex >= count - 1);

    if (seriesSenderApplyAll){
      seriesSenderApplyAll.style.display = (count > 1) ? 'block' : 'none';
    }

    if (seriesLogoHint){
      seriesLogoHint.style.display = 'block';
    }

  } else {
    seriesPagerStep1.style.display     = 'none';
    seriesPagerHintStep1.style.display = 'none';

    if (seriesSenderApplyAll){
      seriesSenderApplyAll.style.display = 'none';
    }
    if (seriesLogoHint){
      seriesLogoHint.style.display = 'none';
    }
  }
}

function updateSeriesOccasionUI(){
  if (!seriesPagerStep4 || !seriesPagerLabelStep4 || !seriesPagerHintStep4) return;

  const enabled = !!state.seriesEnabled;
  const count   = hasSeriesRows() ? state.seriesRows.length : 0;
  const inStep4 = (state.step === 4); // „Schritt 4: Anlass/Datum/Message“

  // 1) txt6 IMMER mit dem aktuellen Serien-Slot synchronisieren,
  //    solange Serienmodus + Rows aktiv sind
  if (enabled && count > 0 && txt6){
    clampSeriesIndex();

    const occArr = Array.isArray(state.seriesOccasion) ? state.seriesOccasion : [];
    const val = occArr[state.seriesIndex] || '';

    txt6.value = val;
    if (typeof fit6 === 'function') fit6();
  }

  // 2) Pager / Hint / "Für alle übernehmen" NUR in Step 4 anzeigen
  if (enabled && count > 0 && inStep4){
    seriesPagerStep4.style.display     = 'flex';
    seriesPagerHintStep4.style.display = 'block';

    const currentHuman = state.seriesIndex + 1;
    seriesPagerLabelStep4.textContent =
      'Anlass für Zertifikat ' + currentHuman + ' von ' + count;

    if (seriesPrevStep4) seriesPrevStep4.disabled = (state.seriesIndex <= 0);
    if (seriesNextStep4) seriesNextStep4.disabled = (state.seriesIndex >= count - 1);

    if (seriesOccasionApplyAll){
      seriesOccasionApplyAll.style.display = (count > 1) ? 'block' : 'none';
    }

  } else {
    seriesPagerStep4.style.display     = 'none';
    seriesPagerHintStep4.style.display = 'none';
    if (seriesOccasionApplyAll){
      seriesOccasionApplyAll.style.display = 'none';
    }
  }
}

  function updateSeriesDecorUI(){
    if (!seriesPagerStep6 || !seriesPagerLabelStep6 || !seriesPagerHintStep6) return;

    const enabled = !!state.seriesEnabled;
    const count   = hasSeriesRows() ? state.seriesRows.length : 0;
    const inStep6 = (state.step === 6);

    if (enabled && count > 0 && inStep6){
      clampSeriesIndex();

      seriesPagerStep6.style.display     = 'flex';
      seriesPagerHintStep6.style.display = 'block';

      const currentHuman = state.seriesIndex + 1;
      seriesPagerLabelStep6.textContent =
        'Deko für Zertifikat ' + currentHuman + ' von ' + count;

      if (seriesPrevStep6) seriesPrevStep6.disabled = (state.seriesIndex <= 0);
      if (seriesNextStep6) seriesNextStep6.disabled = (state.seriesIndex >= count - 1);

      // „Für alle übernehmen“ nur, wenn es wirklich mehrere Zertifikate gibt
      if (seriesDecorApplyAll){
        seriesDecorApplyAll.style.display = (count > 1) ? 'block' : 'none';
      }

    } else {
      seriesPagerStep6.style.display     = 'none';
      seriesPagerHintStep6.style.display = 'none';
      if (seriesDecorApplyAll){
        seriesDecorApplyAll.style.display = 'none';
      }
    }
  }


 function updateSeriesForestUI(){
   if (!seriesPagerStep7 || !seriesPagerLabelStep7 || !seriesPagerHintStep7) return;

   const enabled = !!state.seriesEnabled;
   const count   = hasSeriesRows() ? state.seriesRows.length : 0;
   const inStep7 = (state.step === 7);

   if (enabled && count > 0 && inStep7){
     clampSeriesIndex();

     seriesPagerStep7.style.display     = 'flex';
     seriesPagerHintStep7.style.display = 'block';

     const currentHuman = state.seriesIndex + 1;
     seriesPagerLabelStep7.textContent =
       'Pflanzort für Zertifikat ' + currentHuman + ' von ' + count;

     if (seriesPrevStep7) seriesPrevStep7.disabled = (state.seriesIndex <= 0);
     if (seriesNextStep7) seriesNextStep7.disabled = (state.seriesIndex >= count - 1);

     // Forst-Auswahl für diesen Slot in die Radios spiegeln
     syncForestFromSeriesIndex();

     if (seriesForestApplyAll){
       seriesForestApplyAll.style.display = (count > 1) ? 'block' : 'none';
     }
   } else {
     seriesPagerStep7.style.display     = 'none';
     seriesPagerHintStep7.style.display = 'none';
     if (seriesForestApplyAll){
       seriesForestApplyAll.style.display = 'none';
     }
   }
 }

 function updateSeriesFrameUI(){
   if (!seriesPagerStep8 || !seriesPagerLabelStep8 || !seriesPagerHintStep8) return;

   const enabled = !!state.seriesEnabled;
   const count   = hasSeriesRows() ? state.seriesRows.length : 0;
   const inStep8 = (state.step === 8);

   if (enabled && count > 0 && inStep8){
     clampSeriesIndex();

     seriesPagerStep8.style.display     = 'flex';
     seriesPagerHintStep8.style.display = 'block';

     const currentHuman = state.seriesIndex + 1;
     seriesPagerLabelStep8.textContent =
       'Rahmenfarbe für Zertifikat ' + currentHuman + ' von ' + count;

     if (seriesPrevStep8) seriesPrevStep8.disabled = (state.seriesIndex <= 0);
     if (seriesNextStep8) seriesNextStep8.disabled = (state.seriesIndex >= count - 1);

     if (seriesFrameApplyAll){
       seriesFrameApplyAll.style.display = (count > 1) ? 'block' : 'none';
     }

     // Farbe aus diesem Slot in den Picker spiegeln
     syncFrameColorFromSeriesIndex();

   } else {
     seriesPagerStep8.style.display     = 'none';
     seriesPagerHintStep8.style.display = 'none';
     if (seriesFrameApplyAll){
       seriesFrameApplyAll.style.display = 'none';
     }
   }
 }

   function updateSeriesDeliveryUI(){
    if (!seriesPagerStep9 || !seriesPagerLabelStep9 || !seriesPagerHintStep9) return;

    const enabled = !!state.seriesEnabled;
    const count   = hasSeriesRows() ? state.seriesRows.length : 0;
    const inStep9 = (state.step === 9);
    const isCert  = (state.mode === 'cert');

    if (enabled && count > 0 && inStep9 && isCert){
      clampSeriesIndex();

      seriesPagerStep9.style.display     = 'flex';
      seriesPagerHintStep9.style.display = 'block';

      const currentHuman = state.seriesIndex + 1;
      seriesPagerLabelStep9.textContent =
        'Versandart für Zertifikat ' + currentHuman + ' von ' + count;

      if (seriesPrevStep9) seriesPrevStep9.disabled = (state.seriesIndex <= 0);
      if (seriesNextStep9) seriesNextStep9.disabled = (state.seriesIndex >= count - 1);

      // Radios & Papier auf den Wert dieses Zertifikats spiegeln
      syncDeliveryFromSeriesIndex();
      syncPaperTypeFromSeriesIndex();

      if (seriesDeliveryApplyAll){
        seriesDeliveryApplyAll.style.display = (count > 1) ? 'block' : 'none';
      }
    } else {
      seriesPagerStep9.style.display     = 'none';
      seriesPagerHintStep9.style.display = 'none';
      if (seriesDeliveryApplyAll){
        seriesDeliveryApplyAll.style.display = 'none';
      }
    }
  }


    function updateSeriesVerbUI(){
    if (!seriesPagerStep2 || !seriesPagerLabelStep2 || !seriesPagerHintStep2) return;

    const enabled = !!state.seriesEnabled;
    const count   = hasSeriesRows() ? state.seriesRows.length : 0;
    const inStep2 = (state.step === 2); // „Schritt 2: Grammatik“

    if (enabled && count > 0 && inStep2){
      clampSeriesIndex();

      seriesPagerStep2.style.display    = 'flex';
      seriesPagerHintStep2.style.display= 'block';

      const currentHuman = state.seriesIndex + 1;
      seriesPagerLabelStep2.textContent =
        'Grammatik für Zertifikat ' + currentHuman + ' von ' + count;

      if (seriesPrevStep2) seriesPrevStep2.disabled = (state.seriesIndex <= 0);
      if (seriesNextStep2) seriesNextStep2.disabled = (state.seriesIndex >= count - 1);

      // Verb aus der Serienliste oder globalem State ziehen
const v = getSeriesVerb(state.seriesIndex);
state.verb = v;
setSeriesVerb(state.seriesIndex, v); // stellt sicher, dass der Eintrag existiert

      // Buttons HAT / HABEN optisch setzen
      if (segVerb){
        segVerb.querySelectorAll('button').forEach(b=>{
          b.classList.toggle('active', b.getAttribute('data-verb') === state.verb);
        });
      }

      if (seriesVerbApplyAll){
        seriesVerbApplyAll.style.display = (count > 1) ? 'block' : 'none';
      }

    } else {
      seriesPagerStep2.style.display    = 'none';
      seriesPagerHintStep2.style.display= 'none';
      if (seriesVerbApplyAll){
        seriesVerbApplyAll.style.display = 'none';
      }
    }
  }


    // NEU: aktuellen Schenkenden in Step 1 auf alle Zertifikate der Serie übertragen
  function applySenderToAllSeries(){
    if (!state.seriesEnabled || !hasSeriesRows() || !txt1) return;

    const val = txt1.value || '';
    const count = state.seriesRows.length;

    if (!Array.isArray(state.seriesSender)) state.seriesSender = [];

    for (let i = 0; i < count; i++){
      state.seriesSender[i] = val;
    }

    // Preview bleibt beim aktuellen Zertifikat, aber die anderen nutzen denselben Sender
    updateSeriesSenderUI();
    updatePreview();

    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }
  }


  function updateSeriesFinalPagerUI(){
    if (!seriesPagerFinal || !seriesPagerLabelFinal) return;
    const enabled = !!state.seriesEnabled && state.mode === 'cert';
    const count   = hasSeriesRows() ? state.seriesRows.length : 0;
    const tot     = totalSteps();
    const inFinal = (state.step === tot);

    if (enabled && count > 0 && inFinal){
      clampSeriesIndex();
      seriesPagerFinal.style.display = 'flex';

      const currentHuman = state.seriesIndex + 1;
      seriesPagerLabelFinal.textContent =
        (isSeriesBlankMode() ? 'Blanko-Zertifikat ' : 'Zertifikat ') + currentHuman + ' von ' + count;

      if (seriesPrevFinal) seriesPrevFinal.disabled = (state.seriesIndex <= 0);
      if (seriesNextFinal) seriesNextFinal.disabled = (state.seriesIndex >= count - 1);
    } else {
      seriesPagerFinal.style.display = 'none';
    }
  }

if (seriesModeSingle && seriesModeMulti){
  seriesModeSingle.addEventListener('change', ()=>{
    if (!seriesModeSingle.checked) return;
    state.seriesEnabled = false;
    state.seriesBlankMode = false;
    applySeriesModeUI();
    // Im Single-Modus bleibt txt4 einfach so, wie der User es dort eingibt

    // NEU: Preis nach Umschalten neu berechnen
    updatePrice();
    updateQtyLabel();
    updateCo2Label();
  });

  seriesModeMulti.addEventListener('change', ()=>{
    if (!seriesModeMulti.checked) return;
    if (state.mode !== 'cert'){
      alert('Die Serienfunktion ist aktuell nur für reine Zertifikate verfügbar.');
      seriesModeSingle.checked = true;
      seriesModeMulti.checked  = false;
      return;
    }

    const wasBlankMode = isSeriesBlankMode();
    state.seriesEnabled = true;
    state.seriesBlankMode = false;
    state.seriesIndex   = 0;            // immer bei 1. Zertifikat starten
    if (wasBlankMode){
      if (seriesNamesTA) seriesNamesTA.value = '';
      if (seriesCompaniesTA) seriesCompaniesTA.value = '';
      state.seriesRows = [];
    }

    // 1) Erst Namen einlesen (damit seriesRows korrekt ist)
    refreshSeriesRowsFromInputs();

    // 2) Dann auf Basis des aktuellen UI-Zustands (Step 9) Defaults setzen
    initSeriesDeliveryDefaults();

    // 3) UI für Serienmodus aktualisieren
    applySeriesModeUI();

    // 4) Serien-UI in Step 9 korrekt durchziehen (wenn/ sobald du dort bist)
    updateSeriesDeliveryUI();

    // NEU: Preis für Serienmodus neu berechnen
    updatePrice();
    updateQtyLabel();
    updateCo2Label();
  });
}
if (seriesModeBlank){
  seriesModeBlank.addEventListener('change', ()=>{
    if (!seriesModeBlank.checked) return;
    applyBlankSeriesMode(getSeriesBlankCount());
    updatePrice();
    updateQtyLabel();
    updateCo2Label();
  });
}
// NEU: Inline-Toggle schaltet Serienfunktion an/aus
if (seriesInlineBtn){
  seriesInlineBtn.addEventListener('click', ()=>{
    // nur im reinen Zertifikatsmodus sinnvoll
    if (state.mode !== 'cert'){
      alert('Die Serienfunktion ist aktuell nur für reine Zertifikate verfügbar.');
      return;
    }

    const wasEnabled = !!state.seriesEnabled;
    const wasBlankMode = isSeriesBlankMode();

    if (wasEnabled && !wasBlankMode){
      // zurück zu "Einzelnes Zertifikat"
      state.seriesEnabled = false;
      state.seriesBlankMode = false;
      if (seriesModeSingle){
        seriesModeSingle.checked = true;
      }
      if (seriesModeMulti){
        seriesModeMulti.checked = false;
      }
      if (seriesModeBlank){
        seriesModeBlank.checked = false;
      }

      // aktuellen Serien-Empfänger ggf. zurück ins normale Feld spiegeln
      if (seriesRecipientText && txt4 && seriesRecipientText.value){
        txt4.value = seriesRecipientText.value;
        if (typeof fit4 === 'function') fit4();
        else updatePreview();
      }
    } else {
      // Serienfunktion aktivieren
      state.seriesEnabled = true;
      state.seriesBlankMode = false;
      state.seriesIndex   = 0;
      if (seriesModeMulti){
        seriesModeMulti.checked = true;
      }
      if (seriesModeSingle){
        seriesModeSingle.checked = false;
      }
      if (seriesModeBlank){
        seriesModeBlank.checked = false;
      }

      if (wasBlankMode){
        if (seriesNamesTA) seriesNamesTA.value = '';
        if (seriesCompaniesTA) seriesCompaniesTA.value = '';
        state.seriesRows = [];
      }

      // Bulk-Listen einlesen und erstes Zertifikat in den Editor spiegeln
      refreshSeriesRowsFromInputs();

      // 🔹 NEU: initiale Defaults für Versandart & Papier je Slot setzen
      initSeriesDeliveryDefaults();
      updateSeriesDeliveryUI();
    }

    applySeriesModeUI();
    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }

    // NEU: nach jedem Umschalten Serie <-> Einzel Preis neu berechnen
    updatePrice();
    updateQtyLabel();
    updateCo2Label();
  });
}

if (seriesBlankInlineBtn){
  seriesBlankInlineBtn.addEventListener('click', ()=>{
    if (isSeriesBlankMode()){
      state.seriesEnabled = false;
      state.seriesBlankMode = false;
      if (seriesModeSingle) seriesModeSingle.checked = true;
      if (seriesModeMulti) seriesModeMulti.checked = false;
      if (seriesModeBlank) seriesModeBlank.checked = false;
      applySeriesModeUI();
    } else {
      applyBlankSeriesMode(getSeriesBlankCount());
    }
    updatePrice();
    updateQtyLabel();
    updateCo2Label();
  });
}

if (seriesBlankCountInput){
  seriesBlankCountInput.addEventListener('input', ()=>{
    const count = getSeriesBlankCount();
    state.seriesBlankCount = count;
    if (isSeriesBlankMode()){
      applyBlankSeriesMode(count);
    } else {
      applySeriesModeUI();
    }
    updatePrice();
    updateQtyLabel();
    updateCo2Label();
  });
  seriesBlankCountInput.addEventListener('blur', syncSeriesBlankCountInput);
}


function goSeries(delta){
  if (!state.seriesEnabled || !hasSeriesRows()) return;

  const n   = state.seriesRows.length;
  let idx   = state.seriesIndex || 0;
  const old = idx;

  idx = Math.min(n - 1, Math.max(0, idx + delta));
  if (idx === old) return;

  // ZUERST aktuellen Slot komplett sichern
  saveSeriesSnapshotFromUI();

  // Jetzt auf den neuen Slot springen
  state.seriesIndex = idx;

    // ✅ Sprache-UI für dieses Zertifikat synchronisieren
  ensureSeriesLangLen();
  updateLangToggleUI();


  if (hasSeriesRows()){
    const row  = state.seriesRows[state.seriesIndex];
    const text = seriesRowToText(row);

    if (seriesRecipientText){
      seriesRecipientText.value = text;
    }
    if (txt4){
      txt4.value = text;
      if (typeof fit4 === 'function') fit4();
      else updatePreview();
    } else {
      updatePreview();
    }

    // Grammatik (HAT/HABEN) aus diesem Slot holen
    if (state.seriesEnabled){
      const v = getSeriesVerb(state.seriesIndex);
      state.verb = v;

      if (segVerb){
        segVerb.querySelectorAll('button').forEach(b=>{
          b.classList.toggle('active', b.getAttribute('data-verb') === state.verb);
        });
      }
    }

    const t = getTreesForIndex(state.seriesIndex);
    state.trees = t;
    if (qVal) qVal.value = t;
    updateClaim();
    updateQtyLabel();
    updateCo2Label();
    updatePrice();
    updatePreview();
    syncDecorFromSeriesIndex();
    syncForestFromSeriesIndex();
    syncFrameColorFromSeriesIndex();
  }

  updateSeriesNavigatorUI();
  updateSeriesTreeUI();
  updateSeriesSenderUI();
  updateSeriesOccasionUI();
  updateSeriesVerbUI();
  updateSeriesDecorUI();
  updateSeriesForestUI();
  updateSeriesFrameUI();
  updateSeriesFinalPagerUI();
  syncDeliveryFromSeriesIndex();
  syncPaperTypeFromSeriesIndex();
  updateSeriesDeliveryUI();
}

  if (seriesPrevBtn){
    seriesPrevBtn.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(-1);
    });
  }

  if (seriesNextBtn){
    seriesNextBtn.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(1);
    });
  }

    if (seriesPrevStep1){
    seriesPrevStep1.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(-1);
    });
  }
  if (seriesNextStep1){
    seriesNextStep1.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(1);
    });
  }


    if (seriesPrevStep5){
    seriesPrevStep5.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(-1);
    });
  }
  if (seriesNextStep5){
    seriesNextStep5.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(1);
    });
  }

    // NEU: Step 6 – Deko
    if (seriesPrevStep6){
      seriesPrevStep6.addEventListener('click', function(e){
        e.preventDefault();
        goSeries(-1);
      });
    }
    if (seriesNextStep6){
      seriesNextStep6.addEventListener('click', function(e){
        e.preventDefault();
        goSeries(1);
      });
    }


  if (seriesPrevStep4){
    seriesPrevStep4.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(-1);
    });
  }
  if (seriesNextStep4){
    seriesNextStep4.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(1);
    });
  }

  if (seriesPrevStep2){
    seriesPrevStep2.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(-1);
    });
  }
  if (seriesNextStep2){
    seriesNextStep2.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(1);
    });
  }

    if (seriesPrevStep7){
    seriesPrevStep7.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(-1);
    });
  }
  if (seriesNextStep7){
    seriesNextStep7.addEventListener('click', function(e){
      e.preventDefault();
      goSeries(1);
    });
  }

 if (seriesPrevStep8){
   seriesPrevStep8.addEventListener('click', function(e){
     e.preventDefault();
     goSeries(-1);
   });
 }
 if (seriesNextStep8){
   seriesNextStep8.addEventListener('click', function(e){
     e.preventDefault();
     goSeries(1);
   });
 }

 if (seriesPrevStep9){
   seriesPrevStep9.addEventListener('click', function(e){
     e.preventDefault();
     goSeries(-1);
   });
 }
 if (seriesNextStep9){
   seriesNextStep9.addEventListener('click', function(e){
     e.preventDefault();
     goSeries(1);
   });
 }

    // "Für alle übernehmen" – Schenkende:r
  if (seriesSenderApplyAllBtn){
    seriesSenderApplyAllBtn.addEventListener('click', (e)=>{
      e.preventDefault();
      applySenderToAllSeries();
    });
  }

  // "Für alle übernehmen" – Beschenkte:r
  if (seriesRecipientApplyAllBtn){
    seriesRecipientApplyAllBtn.addEventListener('click', (e)=>{
      e.preventDefault();
      applyRecipientToAllSeries();
    });
  }

    // "Für alle übernehmen" – Anlass
  if (seriesOccasionApplyAllBtn){
    seriesOccasionApplyAllBtn.addEventListener('click', (e)=>{
      e.preventDefault();
      applyOccasionToAllSeries();
    });
  }

  // NEU: "Für alle übernehmen" – Baumanzahl (Step 5)
if (seriesTreesApplyAllBtn){
  seriesTreesApplyAllBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    applyTreesToAllSeries();
  });
}

    // NEU: "Für alle übernehmen" – Deko (Step 6)
  if (seriesDecorApplyAllBtn){
    seriesDecorApplyAllBtn.addEventListener('click', (e)=>{
      e.preventDefault();
      applyDecorToAllSeries();
    });
  }

  if (seriesForestApplyAllBtn){
   seriesForestApplyAllBtn.addEventListener('click', (e)=>{
     e.preventDefault();
     applyForestToAllSeries();
   });
 }

 if (seriesFrameApplyAllBtn){
   seriesFrameApplyAllBtn.addEventListener('click', (e)=>{
     e.preventDefault();
     applyFrameColorToAllSeries();
   });
 }

function goSeriesFinal(delta){
  if (!state.seriesEnabled || !hasSeriesRows() || state.mode !== 'cert') return;

  const n   = state.seriesRows.length;
  let idx   = state.seriesIndex || 0;
  const old = idx;
  idx = Math.min(n - 1, Math.max(0, idx + delta));
  if (idx === old) return;

  // vor Umschalten Slot sichern
  saveSeriesSnapshotFromUI();

  state.seriesIndex = idx;

    // ✅ Sprache-UI für dieses Zertifikat synchronisieren
  ensureSeriesLangLen();
  updateLangToggleUI();


  syncDecorFromSeriesIndex();
  syncForestFromSeriesIndex();
  syncFrameColorFromSeriesIndex();

  // --- NEU: Sender für diesen Slot in txt1 spiegeln ---
  if (txt1){
    const sendArr = Array.isArray(state.seriesSender) ? state.seriesSender : [];
    const senderVal = sendArr[idx] || '';
    txt1.value = senderVal;
    if (typeof fit1 === 'function') fit1();
  }

  const row  = state.seriesRows[idx];
  const text = seriesRowToText(row);

  if (txt4){
    txt4.value = text;
    if (typeof fit4 === 'function') fit4();
  }

  if (txt6){
    const occArr = Array.isArray(state.seriesOccasion) ? state.seriesOccasion : [];
    const msg = occArr[idx] || '';
    txt6.value = msg;
    if (typeof fit6 === 'function') fit6();
  }

  // Grammatik für dieses Zertifikat in der Vorschau anwenden
  if (state.seriesEnabled){
    const v = getSeriesVerb(state.seriesIndex);
    state.verb = v;

    if (segVerb){
      segVerb.querySelectorAll('button').forEach(b=>{
        b.classList.toggle('active', b.getAttribute('data-verb') === state.verb);
      });
    }
  }

  const t = getTreesForIndex(idx);
  state.trees = t;
  if (qVal) qVal.value = t;

  updateClaim();
  updateQtyLabel();
  updateCo2Label();
  updatePrice();
  updatePreview();
  updateSeriesFinalPagerUI();

  if (isB2BPersonalizedPortalFlow() && state.step === totalSteps()){
    renderB2BPersonalizedFinalDualPreview(false).catch(function(err){
      console.warn('renderB2BPersonalizedFinalDualPreview after final pager failed', err);
    });
  }
}

  if (seriesPrevFinal){
    seriesPrevFinal.addEventListener('click', function(e){
      e.preventDefault();
      goSeriesFinal(-1);
    });
  }
  if (seriesNextFinal){
    seriesNextFinal.addEventListener('click', function(e){
      e.preventDefault();
      goSeriesFinal(1);
    });
  }



if (seriesRecipientText){
  // Enter: max. 1 Umbruch → 2 Zeilen im Feld erlaubt
  seriesRecipientText.addEventListener('keydown', function(e){
    if (e.key === 'Enter'){
      const value = seriesRecipientText.value || '';
      const lines = value.split('\n');

      if (lines.length >= 2){
        e.preventDefault();
        return;
      }
      // sonst Enter durchlassen
    }
  });

  // Inhalt 1:1 in seriesRows + Names/Firma-Boxen spiegeln
  seriesRecipientText.addEventListener('input', function(){
    if (!state.seriesEnabled || !hasSeriesRows()) return;

    limitSeriesTextareaLines(seriesRecipientText);

    // Editor → aktueller Serien-Slot → txt4 + seriesNames/seriesCompanies
    syncCurrentSeriesRowFromEditor();

    // WICHTIG: KEIN updateSeriesNavigatorUI() hier,
    // sonst wird der frische Umbruch wieder entfernt.
  });
}



  if (seriesNamesTA){
    seriesNamesTA.addEventListener('input', refreshSeriesRowsFromInputs);
  }
  if (seriesCompaniesTA){
    seriesCompaniesTA.addEventListener('input', refreshSeriesRowsFromInputs);
  }
  if (seriesExcelFile){
    seriesExcelFile.addEventListener('change', ()=>{
      const file = (seriesExcelFile.files && seriesExcelFile.files[0]) ? seriesExcelFile.files[0] : null;
      if (file){
        importSeriesExcelFile(file);
      }
    });
  }

  // Initialzustand
  applySeriesModeUI();


  const probe=document.createElement('span');
  probe.style.cssText='position:fixed;left:-99999px;top:-99999px;visibility:hidden;white-space:pre;text-align:center;';
  document.body.appendChild(probe);

  function syncProbe(fs,el){
    const cs=getComputedStyle(el);
    probe.style.fontFamily=cs.fontFamily;
    probe.style.fontWeight=cs.fontWeight;
    probe.style.letterSpacing=cs.letterSpacing;
    probe.style.fontSize=fs+'px';
    probe.style.lineHeight='1.06';
    probe.style.textAlign='center';
  }

  function normalizeLines(val,maxPerLine,maxLines){
    let raw=(val||'').replace(/\r/g,'');
    let parts=raw.split('\n');
    if(parts.length>maxLines){ parts=parts.slice(0,maxLines); }
    parts=parts.map(l=> (l||'').slice(0,maxPerLine));
    return parts.join('\n');
  }

function setupAutoFit(textarea, box, baseFSDesktop, baseFSMobileSmall, baseFSMobileLarge, maxLines){
  // Falls das Feld oder die Box nicht existieren → nichts tun
  if (!textarea || !box) return function(){};

  const maxLinesLocal = maxLines || 2;   // harte Zeilen (\n)
  const maxPerLine    = 50;
  const maxTotal      = maxLinesLocal * maxPerLine;

  function computeFontSize(){
    const w = window.innerWidth || document.documentElement.clientWidth || 0;

    const isDesktop   = w >= 1025;
    const isMobile    = w <= 768;
    const isBigMobile = isMobile && w >= 430;  // z.B. iPhone 17 Pro Max

    if (isDesktop)   return baseFSDesktop;
    if (isBigMobile) return baseFSMobileLarge;
    return baseFSMobileSmall;
  }

  function normalizeAndFit(){
    let v = (textarea.value || '').replace(/\r/g, '');
    // COMBINE-SPECIAL: Step 1 (txt1) soll im Combine-Modus nur 1 Zeile sein + kleiner
const isComboSender =
  (textarea && textarea.id === 'txt1' &&
   state && state.photo1State &&
   state.photo1State.combine &&
   (state.photo1State.w > 0 && state.photo1State.h > 0));

const maxLinesEff = isComboSender ? 1 : maxLinesLocal;

// im Combine-Modus: harte Umbrüche entfernen
if (isComboSender){
  v = v.replace(/\n+/g,' ');
}

    // 1) Gesamtlimit: max. 2 × 50 Zeichen
    if (v.length > maxTotal){
      v = v.slice(0, maxTotal);
    }

// 2) Automatischer Umbruch nach 50 Zeichen (nur wenn NICHT Combine)
if (!isComboSender && v.indexOf('\n') === -1 && v.length > maxPerLine){
  v = v.slice(0, maxPerLine) + '\n' + v.slice(maxPerLine);
}

    // 3) Zeilen-Fixing: max. 2 Hardlines, jede max. 50 Zeichen
let lines = v.split('\n');

if (lines.length > maxLinesEff){
  lines = lines.slice(0, maxLinesEff);
}
lines = lines.map(line => line.slice(0, maxPerLine));

const vFinal = lines.join('\n');

    if (vFinal !== textarea.value){
      let pos = textarea.selectionStart || vFinal.length;
      if (pos > vFinal.length) pos = vFinal.length;
      textarea.value = vFinal;
      try{
        textarea.setSelectionRange(pos, pos);
      }catch(_){}
    }

    // 4) Schriftgröße nach Device
const fsBase = computeFontSize();
const fs = isComboSender ? Math.max(12, Math.round(fsBase * 0.78)) : fsBase;

textarea.style.fontSize     = fs + 'px';
textarea.style.whiteSpace   = isComboSender ? 'nowrap' : 'pre-wrap';
textarea.style.overflowWrap = isComboSender ? 'normal' : 'break-word';
  }

  textarea.addEventListener('input', () => {
    normalizeAndFit();

    if (typeof updatePreview === 'function') updatePreview();
    if (!hasEditOrClone && DRAFT_KEY){
      scheduleDraftSave();
    }
  });

  window.addEventListener('resize', () => {
    if (!document.body.contains(textarea)) return;
    normalizeAndFit();
    if (typeof updatePreview === 'function') updatePreview();
  }, { passive:true });

  // Beim Fokus nochmal kurz neu ausrichten (für iOS Keyboard/Layout)
  textarea.addEventListener('focus', () => {
    requestAnimationFrame(() => {
      normalizeAndFit();
      if (typeof updatePreview === 'function') updatePreview();
    });
  });

  // Initiale Ausrichtung (Reload / Draft-Load)
  normalizeAndFit();

  // Fit-Helper für fit1()/fit4()/fit6()
  return normalizeAndFit;
}

// Schritt 1 – Schenkende:r
const fit1 = setupAutoFit(
  txt1,
  box1,
  22,  // Desktop
  16,  // kleines/“normales“ Handy
  18,  // großes Handy (iPhone Pro Max etc.)
  2
);

const fitPersonalizedMonthly1 = (personalizedMonthlyTxt1 && personalizedMonthlyBox1)
  ? setupAutoFit(
      personalizedMonthlyTxt1,
      personalizedMonthlyBox1,
      22,
      16,
      18,
      2
    )
  : null;

// Schritt 3 – Beschenkte:r (oft wichtig → darf etwas größer sein)
const fit4 = setupAutoFit(
  txt4,
  box4,
  22,  // Desktop
  16,  // kleines/“normales“ Handy
  18,  // großes Handy
  2
);

// Schritt 4 – Anlass / Datum / Message
const fit6 = setupAutoFit(
  txt6,
  box6,
  22,  // Desktop
  16,  // kleines/“normales“ Handy
  18,  // großes Handy
  2
);

function enforceOneLine(el, maxChars){
  if(!el) return;
  const max = (typeof maxChars === 'number' && maxChars > 0) ? maxChars : 50;

  let v = (el.value || '').replace(/\r/g,'');
  v = v.replace(/\n+/g,' ');          // harte Umbrüche raus, Leerzeichen aber erlauben

  if(v.length > max) v = v.slice(0, max);

  if (v !== el.value){
    const pos = Math.min(el.selectionStart || v.length, v.length);
    el.value = v;
    try{ el.setSelectionRange(pos, pos); }catch(_){}
  }
}

function applyTxt1WrapMode(){
  if(!txt1) return;
  if (state.photo1State && state.photo1State.combine){
    txt1.style.whiteSpace   = 'nowrap';
    txt1.style.overflowWrap = 'normal';
  }else{
    txt1.style.whiteSpace   = 'pre-wrap';
    txt1.style.overflowWrap = 'break-word';
  }
}

if (txt1){
  txt1.addEventListener('keydown', (e)=>{
    if (state.photo1State && state.photo1State.combine && e.key === 'Enter'){
      e.preventDefault(); // im Combine-Fall nie Enter
    }
  });

  txt1.addEventListener('input', ()=>{
    if (state.photo1State && state.photo1State.combine){
      enforceOneLine(txt1, 50);
    }
    applyTxt1WrapMode();
    scheduleSummaryTemplateAutosave();
  });

  txt1.addEventListener('focus', applyTxt1WrapMode);
  window.addEventListener('resize', applyTxt1WrapMode, { passive:true });
}

  if (txt6){
    txt6.addEventListener('input', ()=>{
      if (isB2BEventPortalFlow() && txt4){
        txt4.value = txt6.value || '';
        if (typeof fit4 === 'function') fit4();
      }
      if (state.seriesEnabled && hasSeriesRows()){
        if (!Array.isArray(state.seriesOccasion)) state.seriesOccasion = [];
        clampSeriesIndex();
        state.seriesOccasion[state.seriesIndex] = txt6.value || '';
        if (!hasEditOrClone && DRAFT_KEY){
          scheduleDraftSave();
        }
      }
    });
  }

  // Serienmodus: Schenkende:r pro Zertifikat aktualisieren
if (txt1){
  txt1.addEventListener('input', ()=>{
    if (state.seriesEnabled && hasSeriesRows()){
      clampSeriesIndex();
      if (!Array.isArray(state.seriesSender)) state.seriesSender = [];
      state.seriesSender[state.seriesIndex] = txt1.value || '';
      if (!hasEditOrClone && DRAFT_KEY){
        scheduleDraftSave();
      }
    }
    scheduleSummaryTemplateAutosave();
  });
}

    // NEU: Auto-Fit für Grußkarte (je Slot bis zu 6 Zeilen)
  const gcTxt1=$('gcTxt1'), gcBox1=$('gcBox1');
  const gcTxt2=$('gcTxt2'), gcBox2=$('gcBox2');
  const gcTxt3=$('gcTxt3'), gcBox3=$('gcBox3');

    // NEU: Preview-Overlays
  const gcTxt1Preview = $('gcTxt1Preview');
  const gcTxt2Preview = $('gcTxt2Preview');
  const gcTxt3Preview = $('gcTxt3Preview');
    // Original-Platzhalter sichern, damit wir sie im Edit-Step anzeigen
  const GC_PLACEHOLDERS = {
    top:    gcTxt1 ? gcTxt1.getAttribute('placeholder') || '' : '',
    middle: gcTxt2 ? gcTxt2.getAttribute('placeholder') || '' : '',
    bottom: gcTxt3 ? gcTxt3.getAttribute('placeholder') || '' : ''
  };

  // Platzhalter ein-/ausschalten (Edit ↔ Vorschau)
  function setGreetPlaceholdersVisible(visible){
    if(gcTxt1){
      gcTxt1.placeholder = visible ? GC_PLACEHOLDERS.top : '';
    }
    if(gcTxt2){
      gcTxt2.placeholder = visible ? GC_PLACEHOLDERS.middle : '';
    }
    if(gcTxt3){
      gcTxt3.placeholder = visible ? GC_PLACEHOLDERS.bottom : '';
    }
  }

  function toggleGreetPreview(show){
  const pairs = [
    [gcTxt1, gcTxt1Preview],
    [gcTxt2, gcTxt2Preview],
    [gcTxt3, gcTxt3Preview],
  ];
  pairs.forEach(([ta, pv])=>{
    if(!ta || !pv) return;
    pv.style.display = show ? 'block' : 'none';
    ta.style.visibility = show ? 'hidden' : 'visible';
  });
}

  // Grußkarte: feste Schriftgröße (kein Auto-Fit)
  const fitGc1 = ()=>{};
  const fitGc2 = ()=>{};
  const fitGc3 = ()=>{};
    // Grußkarte: einfache Zeichenbegrenzung pro Feld (basic & easy)
  const MAX_GC_CHARS = 150;

  [gcTxt1, gcTxt2, gcTxt3].forEach(el=>{
    if(!el) return;
    el.addEventListener('input', ()=>{
      if(el.value.length > MAX_GC_CHARS){
        const pos = el.selectionStart || MAX_GC_CHARS;
        el.value = el.value.slice(0, MAX_GC_CHARS);
        try{
          el.setSelectionRange(Math.min(pos, MAX_GC_CHARS), Math.min(pos, MAX_GC_CHARS));
        }catch(_){}
      }
    });
  });

    // NEU: Text aus Textareas in die Preview-Layer spiegeln
  function updateGreetPreviews(){
    if(gcTxt1 && gcTxt1Preview){
      gcTxt1Preview.textContent = gcTxt1.value || '';
    }
    if(gcTxt2 && gcTxt2Preview){
      gcTxt2Preview.textContent = gcTxt2.value || '';
    }
    if(gcTxt3 && gcTxt3Preview){
      gcTxt3Preview.textContent = gcTxt3.value || '';
    }
  }

  // Bei Eingabe jeweils Vorschau aktualisieren
  [gcTxt1, gcTxt2, gcTxt3].forEach(el=>{
    if(!el) return;
    el.addEventListener('input', updateGreetPreviews);
  });

  // einmal initial aufrufen (falls Draft geladen / vorbefüllt)
  updateGreetPreviews();

  let __summaryTemplateAutosaveTimer = null;
  function getSummaryTemplateAliases(){
    const aliases = [];
    function add(v){
      const s = String(v || '').trim();
      if (s && !aliases.includes(s)) aliases.push(s);
    }
    add(state && state.b2bPortal && state.b2bPortal.customerRef);
    try{
      const prof = getB2BInputs();
      if (prof){
        add(prof.customer_ref);
        add(prof.landing_slug);
      }
    }catch(_){}
    add(state && state.b2bPortal && state.b2bPortal.partnerName);
    add(getPartnerName());
    try{
      const prof = getB2BInputs();
      if (prof){
        add(prof.partner_name);
      }
    }catch(_){}
    return aliases;
  }
  function getSummarySenderPersistentKey(){
    const stablePortalRef = String(
      (state && state.b2bPortal && state.b2bPortal.customerRef) ||
      portalCustomerRef ||
      ''
    ).trim();
    if (!stablePortalRef) return '';
    return 'ptw:b2b:summary-sender:persistent:' + stablePortalRef + (isB2BSubscriptionPortalFlow() ? (':subscription:' + ((state && state.b2bPortal && state.b2bPortal.subscriptionId) || portalSubscriptionId || 'new')) : ':summary');
  }
  function getPortalSenderSnapshotKey(){
    const stablePortalRef = String(
      (state && state.b2bPortal && state.b2bPortal.customerRef) ||
      portalCustomerRef ||
      ''
    ).trim();
    return stablePortalRef ? ('ptw:b2b:portal-sender:persistent:' + stablePortalRef) : '';
  }
  function getPortalSenderPersistentDraftKey(){
    const stablePortalRef = String(
      (state && state.b2bPortal && state.b2bPortal.customerRef) ||
      portalCustomerRef ||
      ''
    ).trim();
    return stablePortalRef ? ('WD-b2b-portal-sender:' + stablePortalRef) : '';
  }
  function normalizeSenderSnapshotPhoto(info){
    if (!info || typeof info !== 'object') return null;
    const dataUrl = String(
      info.data_url ||
      info.dataUrl ||
      info.url ||
      info.src ||
      info.preview_url ||
      ''
    ).trim();
    if (!dataUrl || !dataUrl.startsWith('data:image')) return null;
    return {
      data_url: dataUrl,
      scale: info.scale || 1,
      offX: info.offX || 0,
      offY: info.offY || 0,
      rotation: info.rotation || 0,
      mode: info.mode || 'contain'
    };
  }
  async function buildPortalSenderSnapshotPhoto(st, imgEl){
    let dataUrl = '';
    try{
      if (st && st.dataUrl && String(st.dataUrl).startsWith('data:image')){
        dataUrl = String(st.dataUrl);
      } else if (st && st.file){
        dataUrl = String(await fileToDataURL(st.file) || '');
      } else if (imgEl && imgEl.src && String(imgEl.src).startsWith('data:image')){
        dataUrl = String(imgEl.src || '');
      }
    }catch(_){}
    if (!dataUrl) return null;
    return {
      data_url: dataUrl,
      scale: st && st.scale || 1,
      offX: st && st.offX || 0,
      offY: st && st.offY || 0,
      rotation: st && st.rotation || 0,
      mode: st && st.mode || 'contain'
    };
  }
  function isPortalSenderSnapshotShape(snap){
    return !!(
      snap &&
      typeof snap === 'object' &&
      (
        Object.prototype.hasOwnProperty.call(snap, 'sender_text') ||
        Object.prototype.hasOwnProperty.call(snap, 'sender_photo') ||
        Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_text') ||
        Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_photo')
      )
    );
  }
  function normalizePortalSenderSnapshot(snap){
    if (!snap || typeof snap !== 'object') return null;
    if (isPortalSenderSnapshotShape(snap)){
      return {
        saved_at: snap.saved_at || Date.now(),
        sender_text: Object.prototype.hasOwnProperty.call(snap, 'sender_text') ? String(snap.sender_text || '').replace(/\r/g,'') : undefined,
        sender_combine: Object.prototype.hasOwnProperty.call(snap, 'sender_combine') ? !!snap.sender_combine : undefined,
        sender_combine_text: Object.prototype.hasOwnProperty.call(snap, 'sender_combine_text') ? String(snap.sender_combine_text || '').replace(/\r/g,'').replace(/\n+/g,' ') : undefined,
        sender_photo: normalizeSenderSnapshotPhoto(snap.sender_photo),
        monthly_sender_text: Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_text') ? String(snap.monthly_sender_text || '').replace(/\r/g,'') : undefined,
        monthly_sender_combine: Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_combine') ? !!snap.monthly_sender_combine : undefined,
        monthly_sender_combine_text: Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_combine_text') ? String(snap.monthly_sender_combine_text || '').replace(/\r/g,'').replace(/\n+/g,' ') : undefined,
        monthly_sender_customized: Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_customized') ? !!snap.monthly_sender_customized : undefined,
        monthly_sender_photo: normalizeSenderSnapshotPhoto(snap.monthly_sender_photo)
      };
    }
    if (
      Object.prototype.hasOwnProperty.call(snap, 'sender') ||
      Object.prototype.hasOwnProperty.call(snap, 'monthly_sender')
    ){
      return {
        saved_at: snap.saved_at || Date.now(),
        sender_text: Object.prototype.hasOwnProperty.call(snap, 'sender_text') ? String(snap.sender_text || '').replace(/\r/g,'') : undefined,
        sender_combine: Object.prototype.hasOwnProperty.call(snap, 'sender_combine') ? !!snap.sender_combine : undefined,
        sender_combine_text: Object.prototype.hasOwnProperty.call(snap, 'sender_combine_text') ? String(snap.sender_combine_text || '').replace(/\r/g,'').replace(/\n+/g,' ') : undefined,
        sender_photo: normalizeSenderSnapshotPhoto(snap.sender),
        monthly_sender_text: Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_text') ? String(snap.monthly_sender_text || '').replace(/\r/g,'') : undefined,
        monthly_sender_combine: Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_combine') ? !!snap.monthly_sender_combine : undefined,
        monthly_sender_combine_text: Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_combine_text') ? String(snap.monthly_sender_combine_text || '').replace(/\r/g,'').replace(/\n+/g,' ') : undefined,
        monthly_sender_customized: Object.prototype.hasOwnProperty.call(snap, 'monthly_sender_customized') ? !!snap.monthly_sender_customized : undefined,
        monthly_sender_photo: normalizeSenderSnapshotPhoto(snap.monthly_sender)
      };
    }
    if (
      Object.prototype.hasOwnProperty.call(snap, 'text') ||
      Object.prototype.hasOwnProperty.call(snap, 'combine') ||
      Object.prototype.hasOwnProperty.call(snap, 'photo')
    ){
      const text = String(snap.text || '').replace(/\r/g,'');
      return {
        saved_at: snap.saved_at || Date.now(),
        sender_text: text,
        sender_combine: !!snap.combine,
        sender_combine_text: text.replace(/\n+/g,' '),
        sender_photo: normalizeSenderSnapshotPhoto(snap.photo)
      };
    }
    return null;
  }
  function getPortalSenderSnapshotSavedAt(snap){
    const normalized = normalizePortalSenderSnapshot(snap);
    if (!normalized) return 0;
    const ts = Number(normalized.saved_at || 0);
    return Number.isFinite(ts) && ts > 0 ? ts : 0;
  }
  function hasMeaningfulPortalSenderSnapshot(snap){
    const normalized = normalizePortalSenderSnapshot(snap);
    if (!normalized) return false;
    return !!(
      normalizeSenderSnapshotPhoto(normalized.sender_photo) ||
      normalizeSenderSnapshotPhoto(normalized.monthly_sender_photo) ||
      String(normalized.sender_text || '').trim() ||
      String(normalized.sender_combine_text || '').trim() ||
      String(normalized.monthly_sender_text || '').trim() ||
      String(normalized.monthly_sender_combine_text || '').trim() ||
      normalized.sender_combine === true ||
      normalized.monthly_sender_combine === true ||
      normalized.monthly_sender_customized === true
    );
  }
  function rememberAppliedPortalSenderSnapshot(snap){
    if (!state || !state.b2bPortal) return;
    const normalized = normalizePortalSenderSnapshot(snap);
    if (!normalized) return;
    state.b2bPortal.portalSenderSnapshotMeta = {
      saved_at: getPortalSenderSnapshotSavedAt(normalized),
      has_meaningful: hasMeaningfulPortalSenderSnapshot(normalized),
      has_top_photo: !!normalizeSenderSnapshotPhoto(normalized.sender_photo),
      has_monthly_photo: !!normalizeSenderSnapshotPhoto(normalized.monthly_sender_photo),
      has_photo_any: !!(
        normalizeSenderSnapshotPhoto(normalized.sender_photo) ||
        normalizeSenderSnapshotPhoto(normalized.monthly_sender_photo)
      )
    };
  }
  function shouldSkipOlderPortalSenderSnapshot(snap){
    if (!state || !state.b2bPortal) return false;
    const normalized = normalizePortalSenderSnapshot(snap);
    const currentMeta = state.b2bPortal.portalSenderSnapshotMeta;
    if (!normalized || !currentMeta || typeof currentMeta !== 'object') return false;
    const incomingTs = getPortalSenderSnapshotSavedAt(normalized);
    const currentTs = Number(currentMeta.saved_at || 0);
    const incomingHasMeaningful = hasMeaningfulPortalSenderSnapshot(normalized);
    const incomingHasPhotoAny = !!(
      normalizeSenderSnapshotPhoto(normalized.sender_photo) ||
      normalizeSenderSnapshotPhoto(normalized.monthly_sender_photo)
    );
    const currentHasMeaningful = !!currentMeta.has_meaningful;
    const currentHasPhotoAny = !!currentMeta.has_photo_any;
    if (!currentHasMeaningful && !currentHasPhotoAny) return false;
    if (!incomingHasMeaningful && !incomingHasPhotoAny) return true;
    if (currentTs > 0){
      if (incomingTs > 0 && incomingTs < currentTs){
        return true;
      }
      if (!incomingTs && currentHasMeaningful){
        return true;
      }
    }
    return false;
  }
  function buildPortalSenderSnapshotFromWizardPayload(data){
    if (!data || typeof data !== 'object') return null;
    const photos = (data.photos && typeof data.photos === 'object') ? data.photos : {};
    const eventSnap = (data.b2b_event_snapshot && typeof data.b2b_event_snapshot === 'object')
      ? data.b2b_event_snapshot
      : {};
    const eventPhoto = (eventSnap.photo1State && typeof eventSnap.photo1State === 'object')
      ? eventSnap.photo1State
      : {};
    const senderText = String(
      data.sender ||
      eventSnap.sender_text ||
      eventSnap.senderText ||
      ''
    ).replace(/\r/g,'');
    const senderCombineText = String(
      data.sender_combine_text ||
      eventSnap.sender_combine_text ||
      eventSnap.senderCombineText ||
      senderText
    ).replace(/\r/g,'').replace(/\n+/g,' ');
    const senderPhoto = normalizeSenderSnapshotPhoto(photos.sender) || normalizeSenderSnapshotPhoto(eventPhoto);
    const monthlySenderText = String(data.personalized_monthly_sender_text || '').replace(/\r/g,'');
    const monthlySenderCombineText = String(
      data.personalized_monthly_sender_combine_text ||
      monthlySenderText
    ).replace(/\r/g,'').replace(/\n+/g,' ');
    return normalizePortalSenderSnapshot({
      saved_at: data.saved_at || Date.now(),
      sender_text: senderText,
      sender_combine: !!data.photo1_combine,
      sender_combine_text: senderCombineText,
      sender_photo: senderPhoto,
      monthly_sender_text: monthlySenderText,
      monthly_sender_combine: !!data.personalized_monthly_sender_combine,
      monthly_sender_combine_text: monthlySenderCombineText,
      monthly_sender_customized: !!data.personalized_monthly_sender_customized,
      monthly_sender_photo: normalizeSenderSnapshotPhoto(photos.monthly_sender)
    });
  }
  async function buildPortalSenderSnapshot(){
    const senderText = String((txt1 && txt1.value) || (state && state.photo1State && state.photo1State.prevText) || '').replace(/\r/g,'');
    const senderCombineText = String(
      (isB2BPersonalizedPortalFlow() && personalizedSenderCombineTextInput && personalizedSenderCombineTextInput.value) ||
      ((isB2BSummaryOnlyPortalFlow() || isB2BEventPortalFlow()) && summaryCombineTextInput && summaryCombineTextInput.value) ||
      senderText
    ).replace(/\r/g,'').replace(/\n+/g,' ');
    const monthlySenderText = String(
      (personalizedMonthlyTxt1 && personalizedMonthlyTxt1.value) ||
      (state && state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.prevText) ||
      ''
    ).replace(/\r/g,'');
    const monthlySenderCombineText = String(
      (personalizedMonthlyCombineTextInput && personalizedMonthlyCombineTextInput.value) ||
      monthlySenderText
    ).replace(/\r/g,'').replace(/\n+/g,' ');
    return {
      saved_at: Date.now(),
      sender_text: senderText,
      sender_combine: !!(state && state.photo1State && state.photo1State.combine),
      sender_combine_text: senderCombineText,
      sender_photo: await buildPortalSenderSnapshotPhoto(state && state.photo1State, img1),
      monthly_sender_text: monthlySenderText,
      monthly_sender_combine: !!(state && state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.combine),
      monthly_sender_combine_text: monthlySenderCombineText,
      monthly_sender_customized: !!(state && state.personalizedMonthlySenderCustomized),
      monthly_sender_photo: await buildPortalSenderSnapshotPhoto(state && state.personalizedMonthlyPhoto1State, personalizedMonthlyImg1)
    };
  }
  async function savePortalSenderSnapshot(){
    if (!isB2BPortalFlow()) return false;
    const key = getPortalSenderSnapshotKey();
    if (!key) return false;
    try{
      const snap = await buildPortalSenderSnapshot();
      window.localStorage.setItem(key, JSON.stringify(snap));
      return true;
    }catch(_){
      return false;
    }
  }
  async function savePersistentPortalSenderDraft(){
    if (!isB2BPortalFlow() || hasEditOrClone) return false;
    const key = getPortalSenderPersistentDraftKey();
    if (!key) return false;
    try{
      const snap = await buildPortalSenderSnapshot();
      await fetch('https://partner.planet-tree.de/api2/wizard/draft/save', {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ key: key, mode: 'b2b-portal-sender', data: snap })
      });
      return true;
    }catch(e){
      console.warn('persistent portal sender draft save failed', e);
      return false;
    }
  }
  function loadPortalSenderSnapshot(){
    const key = getPortalSenderSnapshotKey();
    if (!key) return null;
    try{
      const raw = window.localStorage.getItem(key);
      if (!raw) return null;
      return normalizePortalSenderSnapshot(JSON.parse(raw));
    }catch(_){
      return null;
    }
  }
  async function loadPersistentPortalSenderDraft(options){
    const opts = (options && typeof options === 'object') ? options : {};
    const key = getPortalSenderPersistentDraftKey();
    if (!key || hasEditOrClone || !isB2BPortalFlow()) return null;
    try{
      const res = await fetch(
        'https://partner.planet-tree.de/api2/wizard/draft/load?key=' + encodeURIComponent(key),
        { headers:{ 'Accept':'application/json' } }
      );
      if (!res.ok) return null;
      const js = await res.json().catch(function(){ return {}; });
      const snap = normalizePortalSenderSnapshot(js && js.data);
      if (!snap) return null;
      if (opts.apply !== false){
        try{ applyPortalSenderSnapshot(snap, { force: !!opts.force }); }catch(_){}
      }
      return snap;
    }catch(e){
      console.warn('persistent portal sender draft load failed', e);
      return null;
    }
  }
  function applyPortalSenderSnapshot(snap, options){
    if (!isB2BPortalFlow()) return false;
    const opts = (options && typeof options === 'object') ? options : {};
    const forceApply = !!opts.force;
    const normalized = normalizePortalSenderSnapshot(snap);
    if (!normalized) return false;
    if (shouldSkipOlderPortalSenderSnapshot(normalized)) return false;
    try{
      const portalPartnerName = String(state && state.b2bPortal && state.b2bPortal.partnerName || '').trim();
      const currentSenderText = String((txt1 && txt1.value) || (state && state.photo1State && state.photo1State.prevText) || '').replace(/\r/g,'');
      const currentSenderCombineText = String(
        (isB2BPersonalizedPortalFlow() && personalizedSenderCombineTextInput && personalizedSenderCombineTextInput.value) ||
        ((isB2BSummaryOnlyPortalFlow() || isB2BEventPortalFlow()) && summaryCombineTextInput && summaryCombineTextInput.value) ||
        currentSenderText
      ).replace(/\r/g,'').replace(/\n+/g,' ');
      const currentSenderHasPhoto = !!(
        state &&
        state.photo1State &&
        (
          state.photo1State.file ||
          state.photo1State.dataUrl ||
          ((state.photo1State.w || 0) > 0 && (state.photo1State.h || 0) > 0)
        )
      );
      const currentSenderLooksDefault =
        !String(currentSenderText || '').trim() ||
        (!!portalPartnerName && String(currentSenderText || '').trim() === portalPartnerName);
      const incomingTopHasMeaningful = !!(
        normalized.sender_photo ||
        String(normalized.sender_text || '').trim() ||
        String(normalized.sender_combine_text || '').trim()
      );
      const hasTopPayload =
        Object.prototype.hasOwnProperty.call(normalized, 'sender_text') ||
        Object.prototype.hasOwnProperty.call(normalized, 'sender_combine') ||
        Object.prototype.hasOwnProperty.call(normalized, 'sender_combine_text') ||
        !!normalized.sender_photo;
      const shouldApplyTopPayload = !!(
        hasTopPayload && incomingTopHasMeaningful && (
          forceApply ||
          (!!normalized.sender_photo && !currentSenderHasPhoto) ||
          (!currentSenderHasPhoto && currentSenderLooksDefault) ||
          (!String(currentSenderText || '').trim() && Object.prototype.hasOwnProperty.call(normalized, 'sender_text'))
        )
      );
      if (shouldApplyTopPayload){
        const senderText = Object.prototype.hasOwnProperty.call(normalized, 'sender_text')
          ? String(normalized.sender_text || '').replace(/\r/g,'')
          : currentSenderText;
        const senderCombine = Object.prototype.hasOwnProperty.call(normalized, 'sender_combine')
          ? !!normalized.sender_combine
          : !!(state && state.photo1State && state.photo1State.combine);
        const senderCombineText = Object.prototype.hasOwnProperty.call(normalized, 'sender_combine_text')
          ? String(normalized.sender_combine_text || '').replace(/\r/g,'').replace(/\n+/g,' ')
          : currentSenderCombineText || senderText.replace(/\n+/g,' ');
        if (photo1Combine) photo1Combine.checked = senderCombine;
        if (state && state.photo1State){
          state.photo1State.combine = senderCombine;
          state.photo1State.prevText = senderText || senderCombineText || '';
        }
        if (txt1){
          txt1.value = senderText;
          if (typeof fit1 === 'function') fit1();
        }
        if (personalizedSenderCombineTextInput){
          personalizedSenderCombineTextInput.value = senderCombineText;
        }
        if (summaryCombineTextInput){
          summaryCombineTextInput.value = senderCombineText;
        }
        if (normalized.sender_photo && photo1 && typeof photo1.hydrateFromDataUrl === 'function'){
          photo1.hydrateFromDataUrl(String(normalized.sender_photo.data_url || ''), {
            scale: normalized.sender_photo.scale || 1,
            offX: normalized.sender_photo.offX || 0,
            offY: normalized.sender_photo.offY || 0,
            rotation: normalized.sender_photo.rotation || 0,
            mode: normalized.sender_photo.mode || 'contain'
          });
        } else if (photo1 && typeof photo1.switchToText === 'function'){
          photo1.switchToText();
          if (txt1){
            txt1.value = senderText;
            if (typeof fit1 === 'function') fit1();
          }
        }
        try{ syncPersonalizedStep1SenderUi(); }catch(_){}
        try{ syncSummaryOnlySenderEditor(); }catch(_){}
        if (isB2BEventPortalFlow() && state && state.b2bPortal){
          state.b2bPortal.eventSnapshot = Object.assign({}, state.b2bPortal.eventSnapshot || {}, {
            senderText: senderText,
            senderCombineText: senderCombineText,
            photo1State: cloneSenderPhotoState(state.photo1State)
          });
        }
      }

      const hasMonthlyPayload =
        Object.prototype.hasOwnProperty.call(normalized, 'monthly_sender_text') ||
        Object.prototype.hasOwnProperty.call(normalized, 'monthly_sender_combine') ||
        Object.prototype.hasOwnProperty.call(normalized, 'monthly_sender_combine_text') ||
        Object.prototype.hasOwnProperty.call(normalized, 'monthly_sender_customized') ||
        !!normalized.monthly_sender_photo;
      const currentMonthlyText = String(
        (personalizedMonthlyTxt1 && personalizedMonthlyTxt1.value) ||
        (state && state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.prevText) ||
        ''
      ).replace(/\r/g,'');
      const currentMonthlyHasPhoto = !!(
        state &&
        state.personalizedMonthlyPhoto1State &&
        (
          state.personalizedMonthlyPhoto1State.file ||
          state.personalizedMonthlyPhoto1State.dataUrl ||
          ((state.personalizedMonthlyPhoto1State.w || 0) > 0 && (state.personalizedMonthlyPhoto1State.h || 0) > 0)
        )
      );
      const currentMonthlyLooksDefault =
        !String(currentMonthlyText || '').trim() ||
        String(currentMonthlyText || '').trim() === String(currentSenderText || '').trim() ||
        (!!portalPartnerName && String(currentMonthlyText || '').trim() === portalPartnerName);
      const incomingMonthlyHasMeaningful = !!(
        normalized.monthly_sender_photo ||
        String(normalized.monthly_sender_text || '').trim() ||
        String(normalized.monthly_sender_combine_text || '').trim()
      );
      const shouldApplyMonthlyPayload = !!(
        hasMonthlyPayload && (incomingMonthlyHasMeaningful || !!normalized.monthly_sender_customized) && (
          forceApply ||
          (!!normalized.monthly_sender_photo && !currentMonthlyHasPhoto) ||
          (!state.personalizedMonthlySenderCustomized && !currentMonthlyHasPhoto && currentMonthlyLooksDefault)
        )
      );
      if (shouldApplyMonthlyPayload){
        const monthlyCustomized = !!normalized.monthly_sender_customized;
        if (!monthlyCustomized){
          state.personalizedMonthlySenderCustomized = false;
          try{ syncPersonalizedMonthlyEditorFromStep1(true); }catch(_){}
        } else {
          restorePersonalizedMonthlySenderFromData({
            personalized_monthly_sender_text: String(normalized.monthly_sender_text || '').replace(/\r/g,''),
            personalized_monthly_sender_combine: !!normalized.monthly_sender_combine,
            personalized_monthly_sender_combine_text: String(normalized.monthly_sender_combine_text || normalized.monthly_sender_text || '').replace(/\r/g,'').replace(/\n+/g,' '),
            personalized_monthly_sender_customized: true,
            photos: normalized.monthly_sender_photo ? { monthly_sender: normalized.monthly_sender_photo } : {}
          });
        }
        try{ syncPersonalizedMonthlySenderUi(); }catch(_){}
      } else if (usesDedicatedMonthlySenderEditor()){
        state.personalizedMonthlySenderCustomized = false;
        try{ syncPersonalizedMonthlyEditorFromStep1(true); }catch(_){}
        try{ syncPersonalizedMonthlySenderUi(); }catch(_){}
      }

      if (typeof updatePreview === 'function') updatePreview();
      rememberAppliedPortalSenderSnapshot(normalized);
      return true;
    }catch(_){
      return false;
    }
  }
  async function buildSummarySenderLocalSnapshot(){
    const text = String(
      (summaryCombineTextInput && summaryCombineTextInput.value) ||
      (txt1 && txt1.value) ||
      (state && state.photo1State && state.photo1State.prevText) ||
      ''
    ).replace(/\r/g,'').replace(/\n+/g,' ').slice(0, 200);
    let dataUrl = '';
    try{
      if (state && state.photo1State){
        if (state.photo1State.dataUrl && String(state.photo1State.dataUrl).startsWith('data:image')){
          dataUrl = state.photo1State.dataUrl;
        } else if (state.photo1State.file){
          dataUrl = String(await fileToDataURL(state.photo1State.file) || '');
        } else if (img1 && img1.src && String(img1.src).startsWith('data:image')){
          dataUrl = String(img1.src || '');
        }
      }
    }catch(_){}
    return {
      saved_at: Date.now(),
      text: text,
      combine: !!(state && state.photo1State && state.photo1State.combine),
      photo: dataUrl ? {
        data_url: dataUrl,
        scale: state.photo1State && state.photo1State.scale || 1,
        offX: state.photo1State && state.photo1State.offX || 0,
        offY: state.photo1State && state.photo1State.offY || 0,
        rotation: state.photo1State && state.photo1State.rotation || 0,
        mode: state.photo1State && state.photo1State.mode || 'contain'
      } : null
    };
  }
  async function saveSummarySenderLocalSnapshot(){
    if (!isB2BSummaryOnlyPortalFlow()) return false;
    const key = getSummarySenderPersistentKey();
    if (!key) return false;
    try{
      const snap = await buildSummarySenderLocalSnapshot();
      window.localStorage.setItem(key, JSON.stringify(snap));
      try{ await savePortalSenderSnapshot(); }catch(_){}
      return true;
    }catch(_){
      return false;
    }
  }
  function loadSummarySenderLocalSnapshot(){
    const key = getSummarySenderPersistentKey();
    if (!key){
      return loadPortalSenderSnapshot();
    }
    try{
      const raw = window.localStorage.getItem(key);
      if (raw) return JSON.parse(raw);
    }catch(_){
    }
    return loadPortalSenderSnapshot();
  }
  function buildPortalSenderSnapshotFromSummaryLocal(snap){
    if (isPortalSenderSnapshotShape(snap)) return normalizePortalSenderSnapshot(snap);
    const text = String(snap && snap.text || '').replace(/\r/g,'');
    return {
      saved_at: snap && snap.saved_at || Date.now(),
      sender_text: text,
      sender_combine: !!(snap && snap.combine),
      sender_combine_text: text.replace(/\n+/g,' '),
      sender_photo: normalizeSenderSnapshotPhoto(snap && snap.photo)
    };
  }
  function buildPortalSenderSnapshotFromPersonalizedLocal(snap){
    if (isPortalSenderSnapshotShape(snap)) return normalizePortalSenderSnapshot(snap);
    return {
      saved_at: snap && snap.saved_at || Date.now(),
      sender_text: Object.prototype.hasOwnProperty.call(snap || {}, 'sender_text') ? String(snap.sender_text || '').replace(/\r/g,'') : undefined,
      sender_combine: Object.prototype.hasOwnProperty.call(snap || {}, 'sender_combine') ? !!snap.sender_combine : undefined,
      sender_combine_text: Object.prototype.hasOwnProperty.call(snap || {}, 'sender_combine_text') ? String(snap.sender_combine_text || '').replace(/\r/g,'').replace(/\n+/g,' ') : undefined,
      sender_photo: normalizeSenderSnapshotPhoto(snap && snap.sender),
      monthly_sender_text: Object.prototype.hasOwnProperty.call(snap || {}, 'monthly_sender_text') ? String(snap.monthly_sender_text || '').replace(/\r/g,'') : undefined,
      monthly_sender_combine: Object.prototype.hasOwnProperty.call(snap || {}, 'monthly_sender_combine') ? !!snap.monthly_sender_combine : undefined,
      monthly_sender_combine_text: Object.prototype.hasOwnProperty.call(snap || {}, 'monthly_sender_combine_text') ? String(snap.monthly_sender_combine_text || '').replace(/\r/g,'').replace(/\n+/g,' ') : undefined,
      monthly_sender_customized: Object.prototype.hasOwnProperty.call(snap || {}, 'monthly_sender_customized') ? !!snap.monthly_sender_customized : undefined,
      monthly_sender_photo: normalizeSenderSnapshotPhoto(snap && snap.monthly_sender)
    };
  }
  function loadLegacyPersonalizedLogoSnapshot(){
    const key = getPersonalizedLogoSnapshotKey();
    if (!key) return null;
    try{
      const raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    }catch(_){
      return null;
    }
  }
  function applySummarySenderLocalSnapshot(snap){
    if (!snap || !isB2BSummaryOnlyPortalFlow()) return;
    try{ applyPortalSenderSnapshot(buildPortalSenderSnapshotFromSummaryLocal(snap)); }catch(_){}
  }
  function getPersonalizedLogoSnapshotKey(){
    const stablePortalRef = String(
      (state && state.b2bPortal && state.b2bPortal.customerRef) ||
      portalCustomerRef ||
      ''
    ).trim();
    return stablePortalRef ? ('ptw:b2b:personalized-logos:' + stablePortalRef) : '';
  }
  async function buildPersonalizedLogoSnapshot(){
    const portalSnap = await buildPortalSenderSnapshot();
    return {
      saved_at: portalSnap.saved_at || Date.now(),
      sender_text: portalSnap.sender_text,
      sender_combine: portalSnap.sender_combine,
      sender_combine_text: portalSnap.sender_combine_text,
      sender: portalSnap.sender_photo,
      monthly_sender_text: portalSnap.monthly_sender_text,
      monthly_sender_combine: portalSnap.monthly_sender_combine,
      monthly_sender_combine_text: portalSnap.monthly_sender_combine_text,
      monthly_sender_customized: portalSnap.monthly_sender_customized,
      monthly_sender: portalSnap.monthly_sender_photo
    };
  }
  async function savePersonalizedLogoSnapshot(){
    if (!isB2BPortalFlow()) return false;
    const key = getPersonalizedLogoSnapshotKey();
    try{
      const snap = await buildPersonalizedLogoSnapshot();
      if (key) window.localStorage.setItem(key, JSON.stringify(snap));
      try{ await savePortalSenderSnapshot(); }catch(_){}
      return true;
    }catch(_){
      return false;
    }
  }
  function loadPersonalizedLogoSnapshot(){
    return loadPortalSenderSnapshot() || buildPortalSenderSnapshotFromPersonalizedLocal(loadLegacyPersonalizedLogoSnapshot());
  }
  function applyPersonalizedLogoSnapshot(snap){
    if (!snap || !(isB2BPersonalizedPortalFlow() || isB2BEventPortalFlow())) return;
    try{ applyPortalSenderSnapshot(buildPortalSenderSnapshotFromPersonalizedLocal(snap)); }catch(_){}
  }
  function scheduleSummaryTemplateAutosave(){
    if (!isB2BSummaryOnlyPortalFlow()) return;
    const aliases = getSummaryTemplateAliases();
    if (!aliases.length) return;
    try{
      if (__summaryTemplateAutosaveTimer) clearTimeout(__summaryTemplateAutosaveTimer);
    }catch(_){}
    __summaryTemplateAutosaveTimer = setTimeout(()=>{
      __summaryTemplateAutosaveTimer = null;
      saveSummarySenderLocalSnapshot().catch(()=>{});
      saveTemplateSnapshotSilentlyForAliases(aliases).catch(()=>{});
    }, 350);
  }
  async function flushSummaryTemplateAutosave(){
    if (!isB2BSummaryOnlyPortalFlow()) return;
    const aliases = getSummaryTemplateAliases();
    if (!aliases.length) return;
    try{
      if (__summaryTemplateAutosaveTimer){
        clearTimeout(__summaryTemplateAutosaveTimer);
        __summaryTemplateAutosaveTimer = null;
      }
    }catch(_){}
    try{
      await saveSummarySenderLocalSnapshot();
    }catch(_){}
    try{
      await saveTemplateSnapshotSilentlyForAliases(aliases);
    }catch(_){}
  }

  /* ===== PHOTO HANDLING ===== */
function setupPhoto(box,ph,img,fileEl,stateObj,textarea,removeBtn,fitFn,useStepClass){
  if(typeof useStepClass === 'undefined') useStepClass = true;
  const stepInner = useStepClass ? box.closest('.step-inner') : null;
  function useSeparateCombineTextUi(){
    if (!box) return false;
    if (box.id === 'personalizedMonthlyBox1') return true;
    if (box.id === 'box1' && (isB2BPersonalizedPortalFlow() || isB2BEventPortalFlow())) return true;
    return false;
  }
  function currentStepInner(){
    return useStepClass ? box.closest('.step-inner') : null;
  }
  function applyComboInlineLayout(){
    if (!box || box.id !== 'box1' || !textarea || !ph || !img) return;
    if (useSeparateCombineTextUi()){
      box.style.removeProperty('height');
      ph.style.removeProperty('inset');
      textarea.style.removeProperty('inset');
      textarea.style.removeProperty('height');
      textarea.style.removeProperty('min-height');
      textarea.style.removeProperty('max-height');
      textarea.style.removeProperty('padding');
      textarea.style.removeProperty('line-height');
      img.style.removeProperty('top');
      return;
    }
    const combo = !!(stateObj && stateObj.combine);
    const isMobile = (window.innerWidth || 0) <= 768;
    const textHeight = isMobile ? 14 : 16;
    const boxWidth = box.getBoundingClientRect().width || 0;
    const compactHeight = boxWidth ? Math.round(boxWidth * 0.21048) : 0;

    if (combo){
      if (compactHeight){
        box.style.setProperty('height', compactHeight + 'px', 'important');
      }
      ph.style.setProperty('inset', `0 0 ${textHeight}px 0`, 'important');
      textarea.style.setProperty('inset', 'auto 0 0 0', 'important');
      textarea.style.setProperty('height', textHeight + 'px', 'important');
      textarea.style.setProperty('min-height', textHeight + 'px', 'important');
      textarea.style.setProperty('max-height', textHeight + 'px', 'important');
      textarea.style.setProperty('padding', isMobile ? '0 8px' : '0 10px', 'important');
      textarea.style.setProperty('line-height', '1', 'important');
      img.style.setProperty('top', '36%', 'important');
    } else {
      box.style.removeProperty('height');
      ph.style.removeProperty('inset');
      textarea.style.removeProperty('inset');
      textarea.style.removeProperty('height');
      textarea.style.removeProperty('min-height');
      textarea.style.removeProperty('max-height');
      textarea.style.removeProperty('padding');
      textarea.style.removeProperty('line-height');
      img.style.removeProperty('top');
    }
  }

    // Label-CTA zum Dateiupload (z.B. "Foto/Logo verwenden")
  const uploadLabel = fileEl
    ? document.querySelector('label[for="'+fileEl.id+'"]')
    : null;

      // ============================
  // SVG -> PNG Rasterize Helpers
  // ============================
  const SVG_RASTER_MAX_W = 2400; // genug für Druck/Preview

  function isSvgFile(f){
    if(!f) return false;
    const t = (f.type || '').toLowerCase();
    if(t === 'image/svg+xml') return true;
    return /\.svg$/i.test(f.name || '');
  }

  function isSvgDataUrl(u){
    return typeof u === 'string' && /^data:image\/svg\+xml/i.test(u);
  }

  function parseSvgSize(svgText){
    // viewBox bevorzugen
    const vb = svgText.match(/viewBox\s*=\s*["']\s*([-\d.]+)\s+([-\d.]+)\s+([-\d.]+)\s+([-\d.]+)\s*["']/i);
    if(vb){
      const w = Math.abs(parseFloat(vb[3])) || 1000;
      const h = Math.abs(parseFloat(vb[4])) || 1000;
      return { w, h };
    }
    // width/height als Fallback
    const wM = svgText.match(/\bwidth\s*=\s*["']\s*([-\d.]+)(px)?\s*["']/i);
    const hM = svgText.match(/\bheight\s*=\s*["']\s*([-\d.]+)(px)?\s*["']/i);
    const w = wM ? (Math.abs(parseFloat(wM[1])) || 0) : 0;
    const h = hM ? (Math.abs(parseFloat(hM[1])) || 0) : 0;
    if(w > 0 && h > 0) return { w, h };
    return { w: 1000, h: 1000 };
  }

  function ensureSvgHasXmlns(svgText){
    if(/<svg[^>]+xmlns=/.test(svgText)) return svgText;
    return svgText.replace(/<svg\b/i, '<svg xmlns="http://www.w3.org/2000/svg"');
  }

  async function svgTextToPngDataUrl(svgText, maxW){
    svgText = ensureSvgHasXmlns(String(svgText || ''));

    const { w: vbW, h: vbH } = parseSvgSize(svgText);
    const outW = Math.max(256, Math.min(maxW || SVG_RASTER_MAX_W, 3000));
    const outH = Math.max(256, Math.round(outW * (vbH / vbW)));

    const blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
    const url  = URL.createObjectURL(blob);

    try{
      const tmpImg = new Image();
      // wichtig: so früh wie möglich setzen (verhindert Canvas-Tainting in manchen Fällen)
      tmpImg.crossOrigin = 'anonymous';

      await new Promise((resolve, reject)=>{
        tmpImg.onload = resolve;
        tmpImg.onerror = reject;
        tmpImg.src = url;
      });

      const c = document.createElement('canvas');
      c.width  = outW;
      c.height = outH;

      const ctx = c.getContext('2d');
      // transparent lassen (Logo soll sauber über Hintergrund liegen)
      ctx.clearRect(0,0,outW,outH);
      ctx.drawImage(tmpImg, 0, 0, outW, outH);

      return c.toDataURL('image/png');
    }finally{
      try{ URL.revokeObjectURL(url); }catch(_){}
    }
  }

  async function svgFileToPngDataUrl(file){
    const text = await file.text();
    return svgTextToPngDataUrl(text, SVG_RASTER_MAX_W);
  }

  async function svgDataUrlToPngDataUrl(dataUrl){
    const s = String(dataUrl || '');
    const comma = s.indexOf(',');
    if(comma < 0) throw new Error('bad_svg_dataurl');

    const header = s.slice(0, comma);
    let payload  = s.slice(comma+1);

    let svgText = '';
    if(/;base64/i.test(header)){
      svgText = atob(payload);
    }else{
      svgText = decodeURIComponent(payload);
    }
    return svgTextToPngDataUrl(svgText, SVG_RASTER_MAX_W);
  }

  function markPhotoDirty(){
    if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
    if (box && box.id === 'box1'){
      scheduleSummaryTemplateAutosave();
    }
  }

  function apply(){
    const rot = stateObj.rotation || 0;
    img.style.transform =
      'translate(-50%,-50%) '+
      'translate('+stateObj.offX+'px,'+stateObj.offY+'px) '+
      'rotate('+rot+'deg) '+
      'scale('+stateObj.scale+')';

    // Vorschau immer aktualisieren
    updatePreview();
  }

function comboLiftIfNeeded(){
  const combo = !!(stateObj && stateObj.combine && textarea);
  if(!combo) return;
  if (useSeparateCombineTextUi()) return;

  // wenn bereits manuell/automatisch verschoben -> nicht nochmal
  if (stateObj.__comboLifted) return;

  // nur sinnvoll wenn Bild wirklich da ist
  if(!stateObj.w || !stateObj.h) return;

  const r = box.getBoundingClientRect();
  if(!r || !r.height) return;

  // dynamisch, aber gedeckelt
  const dy = -Math.round(Math.max(120, Math.min(260, r.height * 0.48)));

  if (box && box.id === 'box1' && !stateObj.__comboZoomed){
    const boost = ((window.innerWidth || 0) <= 768) ? 1.08 : 1.14;
    stateObj.scale = Math.max(0.05, Math.min(10, (stateObj.scale || 1) * boost));
    stateObj.__comboZoomed = true;
  }

  // nur setzen, wenn es noch nicht „oben“ ist
  if ((stateObj.offY || 0) > dy/2){
    stateObj.offY = dy;
    stateObj.__comboLifted = true;
    apply();
    markPhotoDirty();
  }
}

  function center(){
    if(!stateObj.w || !stateObj.h) return;
    stateObj.offX = 0;
    stateObj.offY = 0;
    apply();
    markPhotoDirty();
  }

  // Geometrie-Helfer: Box- und Bildverhältnis berechnen
  function calcScales(){
    if(!stateObj.w || !stateObj.h) return null;
    const rect = box.getBoundingClientRect();
    const bw = rect.width  || 0;
    const bh = rect.height || 0;
    if(!bw || !bh) return null;

    const sx = bw / stateObj.w;  // skaliert Bildbreite auf Boxbreite
    const sy = bh / stateObj.h;  // skaliert Bildhöhe auf Boxhöhe

    return { bw, bh, sx, sy };
  }

  // "Füllend": Box komplett ausfüllen, keine weißen Ränder – Beschnitt ist ok
  function cover(){
    const s = calcScales();
    if(!s) return;

    const imgIsLandscape = stateObj.w >= stateObj.h;

    let scale;
    if (imgIsLandscape){
      // Querformat: Breite füllen + etwas Sicherheits-Zoom
      scale = s.sx * 1.15;
    } else {
      // Hochformat: klassisches cover (größerer Faktor) + leichter Boost
      const base = Math.max(s.sx, s.sy);
      scale = base * 1.05;
    }

    stateObj.scale = scale;
    stateObj.mode  = 'cover';
    center();
  }

  // "Fit": möglichst intuitiv
  // - Querformat: Breite füllt die Box (kein Briefmarken-Effekt)
  // - Hochformat: wie bisher an der Höhe orientiert (oben/unten passend)
  function contain(){
    const s = calcScales();
    if(!s) return;

    const imgIsLandscape = stateObj.w >= stateObj.h;

    let scale;
    if (imgIsLandscape){
      // Querformat: Breite passend machen
      scale = s.sx;
    } else {
      // Hochformat: Höhe passend machen
      scale = s.sy;
    }

    stateObj.scale = scale;
    stateObj.mode  = 'contain';
    center();
  }

  // Feinere Zoom-Schritte: ~ +12% / -11% pro Klick
  function zoom(factor){
    if(!stateObj.w || !stateObj.h) return;

    const base = stateObj.scale || 1;
    const STEP_IN  = 1.12;
    const STEP_OUT = 1 / 1.12;

    const step = (typeof factor === 'number' && factor < 1) ? STEP_OUT : STEP_IN;

    let ns = base * step;
    ns = Math.max(0.05, Math.min(10, ns));

    stateObj.scale = ns;
    apply();
    markPhotoDirty();
  }

    function rotate(deltaDeg){
    const cur = stateObj.rotation || 0;
    let next  = cur + deltaDeg;

    // auf -270..270 normalisieren (kein Riesenzahlenschrott)
    if (next > 270)  next -= 360;
    if (next < -270) next += 360;

    stateObj.rotation = next;
    apply();
    markPhotoDirty();
  }

  function nudge(dx,dy){
    stateObj.offX += dx;
    stateObj.offY += dy;
    apply();
    markPhotoDirty();
  }

  function showRemoveBtn(show){
    if(!removeBtn) return;
    removeBtn.style.display = show ? 'inline-flex' : 'none';
  }

  function switchToPhoto(){
    ph.style.display = 'block';
    const combo = !!(stateObj && stateObj.combine && textarea);
if (box){
  box.classList.toggle('photo-combo', combo && !useSeparateCombineTextUi());
}
applyComboInlineLayout();

if(textarea){
  if(stateObj.prevText === undefined){
    stateObj.prevText = textarea.value || '';
  }
  if(!combo){
    textarea.value = '';
    textarea.style.display = 'none';
  }else{
    // Logo + Text: Text bleibt sichtbar
    textarea.style.display = 'block';
  }
  if(fitFn) fitFn();
}

    showRemoveBtn(true);

    // NEU: Upload-CTA ausblenden, solange ein Foto aktiv ist
if (uploadLabel){
  // im Combine-Modus darf der Upload-CTA sichtbar bleiben (Logo ersetzen)
  uploadLabel.style.display = combo ? 'inline-flex' : 'none';
}

    if(useStepClass){
      const activeStepInner = currentStepInner();
      if(stepInner && stepInner !== activeStepInner) stepInner.classList.remove('has-photo');
      if(activeStepInner) activeStepInner.classList.add('has-photo');
    }

    // Preview wird ohnehin in apply() aktualisiert
    if(state.step===10 || state.step===11) updatePreview();
  }

function switchToText(){
  ph.style.display = 'none';
  img.src          = '';
  stateObj.w       = 0;
  stateObj.h       = 0;
  stateObj.scale   = 1;
  stateObj.offX    = 0;
  stateObj.offY    = 0;
  stateObj.file    = null;
  stateObj.dataUrl = null;
  stateObj.rotation = 0;

  // 3B) <<< HIER rein: Combo-Layout wieder entfernen
  if (box){
    box.classList.remove('photo-combo');
  }
  applyComboInlineLayout();

  if(textarea){
    textarea.style.display = 'block';
    textarea.value = (stateObj.prevText != null ? stateObj.prevText : '');
    if(fitFn) fitFn();
  }

  showRemoveBtn(false);

  // NEU: Upload-CTA wieder einblenden, wenn kein Foto aktiv ist
  if (uploadLabel){
    uploadLabel.style.display = 'inline-flex';
  }

  if(useStepClass){
    const activeStepInner = currentStepInner();
    if(stepInner) stepInner.classList.remove('has-photo');
    if(activeStepInner) activeStepInner.classList.remove('has-photo');
  }

  // Wichtig: Vorschau IMMER aktualisieren, nicht nur in Step 10/11
  updatePreview();

  markPhotoDirty();
}

  function hydrateFromDataUrl(dataUrl, saved){
    if(!dataUrl){
      console.warn('hydrateFromDataUrl: empty dataUrl');
      return;
    }

        // SVG aus Draft/Server -> erst in PNG wandeln, sonst kommt beim Render oft nur ein Rechteck
    if (isSvgDataUrl(dataUrl)){
      svgDataUrlToPngDataUrl(dataUrl).then((pngUrl)=>{
        hydrateFromDataUrl(pngUrl, saved);
      }).catch((e)=>{
        console.warn('SVG->PNG rasterize (hydrate) failed, fallback to original SVG', e);
        // fallback: original versuchen (kann trotzdem beim Capture/Backend scheitern)
        stateObj.dataUrl = dataUrl;
        stateObj.file    = null;
        img.src = dataUrl;
      });
      return;
    }

    stateObj.dataUrl = dataUrl;
    stateObj.file    = null;

    img.onload = ()=>{
      stateObj.w = img.naturalWidth  || 0;
      stateObj.h = img.naturalHeight || 0;

      if(saved){
        stateObj.scale = saved.scale || 1;
        stateObj.offX  = saved.offX  || 0;
        stateObj.offY  = saved.offY  || 0;
        stateObj.mode  = saved.mode  || 'contain';
        stateObj.rotation = (typeof saved.rotation === 'number') ? saved.rotation : 0;
      }else{
        stateObj.scale = 1;
        stateObj.offX  = 0;
        stateObj.offY  = 0;
        stateObj.mode  = 'contain';
        stateObj.rotation = 0;
      }

      switchToPhoto();
      if(saved){
        apply();
      }else{
        contain();   // sauberes initiales Einpassen
        comboLiftIfNeeded();
      }
    };
    img.onerror = (e)=>{ console.warn('hydrateFromDataUrl: image load error', e); };
    img.src = dataUrl;
  }

  fileEl.addEventListener('change', async (e)=>{
    const f = e.target.files && e.target.files[0];
    if(!f) return;

        // SVG sofort in PNG rasterizen (html2canvas + Backend sind mit SVG oft instabil)
    if (isSvgFile(f)){
      try{
        const pngDataUrl = await svgFileToPngDataUrl(f);

        stateObj.file    = null;
        stateObj.dataUrl = pngDataUrl;
        stateObj.mode    = 'contain';

        img.onload = ()=>{
          stateObj.w = img.naturalWidth  || 0;
          stateObj.h = img.naturalHeight || 0;
          stateObj.rotation = 0;

          if(stateObj.w && stateObj.h){
            switchToPhoto();
            stateObj.scale = 1;
            stateObj.offX  = 0;
            stateObj.offY  = 0;
            contain();
            comboLiftIfNeeded();
            if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
          }
          fileEl.value = '';
        };

        img.onerror = ()=>{
          fileEl.value = '';
          console.warn('SVG->PNG: erzeugtes PNG konnte nicht geladen werden.');
        };

        img.src = pngDataUrl;
        return;
      }catch(err){
        console.warn('SVG->PNG rasterize (upload) failed, fallback to normal flow', err);
        // fällt unten in den normalen createObjectURL-Flow
      }
    }

    stateObj.file = f;
    stateObj.mode = 'contain';

    const url = URL.createObjectURL(f);
    img.onload = ()=>{
      stateObj.w = img.naturalWidth  || 0;
      stateObj.h = img.naturalHeight || 0;
      stateObj.rotation = 0;

      if(stateObj.w && stateObj.h){
        switchToPhoto();
        stateObj.scale = 1;
        stateObj.offX  = 0;
        stateObj.offY  = 0;
        contain();  // Start immer mit "ganzes Bild sichtbar"
        comboLiftIfNeeded();
        if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
      }
      fileEl.value = '';
    };
    img.onerror = ()=>{
      fileEl.value = '';
      console.warn('Bild konnte nicht geladen werden.');
    };
    img.src = url;
  });

  if(removeBtn){
    removeBtn.addEventListener('click', switchToText);
  }
  showRemoveBtn(false);

  return {
    cover,
    contain,
    center,
    zoom,
    rotate,
    apply,
    nudge,
    switchToText,
    hydrateFromDataUrl
  };
}

  const ph1=$('ph1'), img1=$('img1');
  const personalizedMonthlyPh1=$('personalizedMonthlyPh1'), personalizedMonthlyImg1=$('personalizedMonthlyImg1');
  const ph4=$('ph4'), img4=$('img4');
  const ph6=$('ph6'), img6=$('img6');

  const photo1=setupPhoto(box1,ph1,img1,$('file1'),state.photo1State,txt1,$('remove1'),fit1);
  const personalizedMonthlyPhoto1 = (personalizedMonthlyBox1 && personalizedMonthlyPh1 && personalizedMonthlyImg1)
    ? setupPhoto(
        personalizedMonthlyBox1,
        personalizedMonthlyPh1,
        personalizedMonthlyImg1,
        $('personalizedMonthlyFile1'),
        state.personalizedMonthlyPhoto1State,
        personalizedMonthlyTxt1,
        $('personalizedMonthlyRemove1'),
        fitPersonalizedMonthly1
      )
    : null;
  const photo1Combine = $('photo1Combine');
  const personalizedSenderCombineTextWrap = $('personalizedSenderCombineTextWrap');
  const personalizedSenderCombineTextInput = $('personalizedSenderCombineTextInput');
  const summaryCombineTextWrap = $('summaryCombineTextWrap');
  const summaryCombineTextInput = $('summaryCombineTextInput');
  const personalizedMonthlySenderEditorWrap = $('personalizedMonthlySenderEditorWrap');
  const personalizedMonthlyPhoto1Combine = $('personalizedMonthlyPhoto1Combine');
  const personalizedMonthlyCombineTextWrap = $('personalizedMonthlyCombineTextWrap');
  const personalizedMonthlyCombineTextInput = $('personalizedMonthlyCombineTextInput');

  function isPersonalizedStep1SplitMode(){
    return !!(
      (isB2BPersonalizedPortalFlow() || isB2BEventPortalFlow()) &&
      state.step === 1 &&
      photo1Combine &&
      photo1Combine.checked
    );
  }

  function getPrimarySenderTextForPersonalized(){
    if (isPersonalizedStep1SplitMode() && personalizedSenderCombineTextInput){
      return String(personalizedSenderCombineTextInput.value || txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
    }
    return String(txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,'');
  }

  function getPrimarySenderTextForMonthlyEditor(){
    if (isB2BEventCertificatePhase() && photo1Combine && photo1Combine.checked && summaryCombineTextInput){
      return String(summaryCombineTextInput.value || txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
    }
    if (isB2BPersonalizedPortalFlow() && photo1Combine && photo1Combine.checked && personalizedSenderCombineTextInput){
      return String(personalizedSenderCombineTextInput.value || txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
    }
    if (isB2BSummaryOnlyPortalFlow() && photo1Combine && photo1Combine.checked && summaryCombineTextInput){
      return String(summaryCombineTextInput.value || txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
    }
    return String(txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,'');
  }

  function markPersonalizedMonthlySenderCustomized(){
    state.personalizedMonthlySenderCustomized = true;
  }

  function restorePersonalizedMonthlySenderFromData(data){
    if (!data || !personalizedMonthlyTxt1 || !personalizedMonthlyPhoto1 || !personalizedMonthlyPhoto1Combine) return false;

    const hasText = Object.prototype.hasOwnProperty.call(data, 'personalized_monthly_sender_text');
    const hasCombine = Object.prototype.hasOwnProperty.call(data, 'personalized_monthly_sender_combine');
    const hasCombineText = Object.prototype.hasOwnProperty.call(data, 'personalized_monthly_sender_combine_text');
    const hasCustomized = Object.prototype.hasOwnProperty.call(data, 'personalized_monthly_sender_customized');
    const photoInfo = data.photos && data.photos.monthly_sender;
    const hasPayload = hasText || hasCombine || hasCombineText || hasCustomized || !!photoInfo;

    if (!hasPayload) return false;

    const customized = hasCustomized ? !!data.personalized_monthly_sender_customized : !!photoInfo;

    if (!customized){
      state.personalizedMonthlySenderCustomized = false;
      try{ syncPersonalizedMonthlyEditorFromStep1(true); }catch(_){}
      try{ syncPersonalizedMonthlySenderUi(); }catch(_){}
      return true;
    }

    const text = hasText
      ? String(data.personalized_monthly_sender_text || '').replace(/\r/g,'')
      : '';
    const combine = hasCombine ? !!data.personalized_monthly_sender_combine : false;
    const combineText = hasCombineText
      ? String(data.personalized_monthly_sender_combine_text || '').replace(/\r/g,'').replace(/\n+/g,' ')
      : text.replace(/\r/g,'').replace(/\n+/g,' ');

    state.personalizedMonthlySenderCustomized = true;
    state.personalizedMonthlyPhoto1State.combine = combine;
    state.personalizedMonthlyPhoto1State.prevText = text || combineText || '';

    personalizedMonthlyTxt1.value = text;
    personalizedMonthlyPhoto1Combine.checked = combine;
    if (personalizedMonthlyCombineTextInput){
      personalizedMonthlyCombineTextInput.value = combineText;
    }

    if (photoInfo && photoInfo.data_url && typeof personalizedMonthlyPhoto1.hydrateFromDataUrl === 'function'){
      personalizedMonthlyPhoto1.hydrateFromDataUrl(String(photoInfo.data_url || ''), {
        scale: photoInfo.scale || 1,
        offX: photoInfo.offX || 0,
        offY: photoInfo.offY || 0,
        rotation: photoInfo.rotation || 0,
        mode: photoInfo.mode || 'contain'
      });
    } else if (typeof personalizedMonthlyPhoto1.switchToText === 'function'){
      personalizedMonthlyPhoto1.switchToText();
      personalizedMonthlyTxt1.value = text;
      if (typeof fitPersonalizedMonthly1 === 'function') fitPersonalizedMonthly1();
    }

    try{ syncPersonalizedMonthlySenderUi(); }catch(_){}
    return true;
  }

  function syncPersonalizedStep1SenderUi(){
    if (!personalizedSenderCombineTextWrap || !txt1) return;
    if (!(isB2BPersonalizedPortalFlow() || isB2BEventPortalFlow())){
      personalizedSenderCombineTextWrap.style.display = 'none';
      return;
    }
    const splitMode = isPersonalizedStep1SplitMode();
    personalizedSenderCombineTextWrap.style.display = splitMode ? 'block' : 'none';
    if (splitMode){
      if (box1) {
        box1.classList.remove('photo-combo');
        box1.style.removeProperty('height');
      }
      if (ph1) {
        ph1.style.setProperty('inset', '0', 'important');
      }
      if (personalizedSenderCombineTextInput){
        const v = String(personalizedSenderCombineTextInput.value || txt1.value || state.photo1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
        personalizedSenderCombineTextInput.value = v;
      }
      txt1.style.display = 'none';
      txt1.style.setProperty('visibility', 'hidden', 'important');
    } else {
      if (ph1) {
        ph1.style.removeProperty('inset');
      }
      txt1.style.removeProperty('visibility');
      if (!state.photo1State.w || !state.photo1State.h){
        txt1.style.display = 'block';
      }
    }
  }

  function syncPersonalizedMonthlyEditorFromStep1(force){
    if (!personalizedMonthlyTxt1 || !personalizedMonthlyPhoto1 || !personalizedMonthlyPhoto1Combine) return;
    if (state.personalizedMonthlySenderCustomized && !force) return;
    const text = getPrimarySenderTextForMonthlyEditor();
    const cloned = cloneSenderPhotoState(state.photo1State);
    Object.assign(state.personalizedMonthlyPhoto1State, cloned);
    state.personalizedMonthlyPhoto1State.prevText = text;
    personalizedMonthlyTxt1.value = text;
    personalizedMonthlyPhoto1Combine.checked = !!cloned.combine;
    if (personalizedMonthlyCombineTextInput){
      personalizedMonthlyCombineTextInput.value = text.replace(/\r/g,'').replace(/\n+/g,' ');
    }
    if (cloned.w > 0 && cloned.h > 0 && (cloned.dataUrl || (img1 && img1.src))){
      personalizedMonthlyPhoto1.hydrateFromDataUrl(cloned.dataUrl || img1.src, cloned);
    } else {
      personalizedMonthlyPhoto1.switchToText();
      personalizedMonthlyTxt1.value = text;
      if (typeof fitPersonalizedMonthly1 === 'function') fitPersonalizedMonthly1();
    }
  }

  function syncPersonalizedMonthlySenderUi(){
    if (!personalizedMonthlySenderEditorWrap) return;
    const active = !!(
      usesDedicatedMonthlySenderEditor() &&
      (state.step === 10 || isB2BEventSummaryPhase())
    );
    personalizedMonthlySenderEditorWrap.style.display = active ? 'block' : 'none';
    if (!active || !personalizedMonthlyTxt1) return;
    if (personalizedMonthlyBox1){
      const step1Rect = box1 ? box1.getBoundingClientRect() : null;
      if (step1Rect && step1Rect.width){
        personalizedMonthlyBox1.style.setProperty('width', Math.round(step1Rect.width) + 'px', 'important');
        personalizedMonthlyBox1.style.setProperty('max-width', Math.round(step1Rect.width) + 'px', 'important');
        personalizedMonthlyBox1.style.setProperty('margin-left', 'auto', 'important');
        personalizedMonthlyBox1.style.setProperty('margin-right', 'auto', 'important');
      }
      const step1Height = box1 ? box1.getBoundingClientRect().height : 0;
      if (step1Height){
        personalizedMonthlyBox1.style.setProperty('height', Math.round(step1Height) + 'px', 'important');
      }
    }
    const splitMode = !!(personalizedMonthlyPhoto1Combine && personalizedMonthlyPhoto1Combine.checked);
    if (personalizedMonthlyCombineTextWrap){
      personalizedMonthlyCombineTextWrap.style.display = splitMode ? 'block' : 'none';
    }
    if (splitMode){
      if (personalizedMonthlyCombineTextInput){
        const v = String(personalizedMonthlyCombineTextInput.value || personalizedMonthlyTxt1.value || state.personalizedMonthlyPhoto1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
        personalizedMonthlyCombineTextInput.value = v;
        personalizedMonthlyTxt1.value = v;
      }
      personalizedMonthlyTxt1.style.display = 'none';
      personalizedMonthlyTxt1.style.setProperty('visibility', 'hidden', 'important');
    } else {
      personalizedMonthlyTxt1.style.removeProperty('visibility');
      if (!state.personalizedMonthlyPhoto1State.w || !state.personalizedMonthlyPhoto1State.h){
        personalizedMonthlyTxt1.style.display = 'block';
      }
    }
  }
  function forcePhoto1CombineLayout(){
    if (!ph1 || !txt1) return;
    if (isB2BSummaryOnlyPortalFlow() || isB2BPersonalizedPortalFlow()){
      ph1.style.removeProperty('inset');
      txt1.style.removeProperty('top');
      txt1.style.removeProperty('bottom');
      txt1.style.removeProperty('height');
      txt1.style.removeProperty('padding');
      txt1.style.removeProperty('line-height');
      return;
    }
    const combo = !!(state.photo1State && state.photo1State.combine);
    const isMobile = (window.innerWidth || 0) <= 768;
    const textHeight = isMobile ? 16 : 18;

    if (combo){
      ph1.style.setProperty('inset', `0 0 ${textHeight}px 0`, 'important');
      txt1.style.setProperty('top', 'auto', 'important');
      txt1.style.setProperty('bottom', '0', 'important');
      txt1.style.setProperty('height', `${textHeight}px`, 'important');
      txt1.style.setProperty('padding', isMobile ? '0 8px' : '0 10px', 'important');
      txt1.style.setProperty('line-height', '1', 'important');
    } else {
      ph1.style.removeProperty('inset');
      txt1.style.removeProperty('top');
      txt1.style.removeProperty('bottom');
      txt1.style.removeProperty('height');
      txt1.style.removeProperty('padding');
      txt1.style.removeProperty('line-height');
    }
  }
if (photo1Combine){
  // initial
  photo1Combine.checked = !!state.photo1State.combine;
  forcePhoto1CombineLayout();
  try{ syncSummaryOnlySenderEditor(); }catch(_){}
  try{ syncPersonalizedStep1SenderUi(); }catch(_){}

  photo1Combine.addEventListener('change', ()=>{
    state.photo1State.combine = !!photo1Combine.checked;
    forcePhoto1CombineLayout();
    if (isB2BSummaryOnlyPortalFlow() || isB2BEventCertificatePhase()){
      if (summaryCombineTextWrap){
        summaryCombineTextWrap.style.display = state.photo1State.combine ? 'block' : 'none';
      }
      if (summaryCombineTextInput){
        if (state.photo1State.combine){
          summaryCombineTextInput.value = String(txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
        } else {
          summaryCombineTextInput.value = '';
        }
      }
      if (txt1){
        if (state.photo1State.combine){
          txt1.style.display = 'none';
          txt1.style.setProperty('visibility', 'hidden', 'important');
        } else {
          txt1.style.removeProperty('visibility');
          txt1.style.display = (!state.photo1State.w || !state.photo1State.h) ? 'block' : 'none';
        }
      }
    }
    if (isB2BPersonalizedPortalFlow()){
      if (personalizedSenderCombineTextInput){
        if (state.photo1State.combine){
          personalizedSenderCombineTextInput.value = String(txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
        } else {
          personalizedSenderCombineTextInput.value = '';
        }
      }
      syncPersonalizedStep1SenderUi();
    }
    try{ syncSummaryOnlySenderEditor(); }catch(_){}
    try{
      if (photo1 && typeof photo1.switchToText === 'function' && !state.photo1State.w){
        // noop
      }
    }catch(_){}

    // Wenn Foto aktiv und wir Combine aktivieren: Text wiederherstellen, falls er beim Upload geleert wurde
    if (state.photo1State.combine && txt1){
      if ((!txt1.value || !txt1.value.trim()) && typeof state.photo1State.prevText === 'string'){
        txt1.value = state.photo1State.prevText;
      }
      state.photo1State.__comboLifted = false;
      state.photo1State.__comboZoomed = false;
      txt1.style.display = 'block';
      if (typeof fit1 === 'function') fit1();
    }

    // Wenn Combine deaktiviert wird: Text weg (aber merken), damit "Logo-only" wirklich logo-only ist
    if (!state.photo1State.combine && txt1){
      state.photo1State.prevText = txt1.value || state.photo1State.prevText;
      state.photo1State.__comboLifted = false;
      state.photo1State.__comboZoomed = false;
      txt1.value = '';
      txt1.style.display = 'none';
      if (typeof fit1 === 'function') fit1();
    }

    // Wizard-Box styling
    const b1 = $('box1');
    if (b1){
      const hasPhoto = !!(state.photo1State && state.photo1State.w > 0 && state.photo1State.h > 0);
      b1.classList.toggle('photo-combo', !isB2BSummaryOnlyPortalFlow() && !isB2BPersonalizedPortalFlow() && !isB2BEventPortalFlow() && state.photo1State.combine && hasPhoto);
    }

    // Upload-CTA für file1 je nach Combine (Logo ersetzen dürfen)
    const up = document.querySelector('label[for="file1"]');
    if (up){
      up.style.display = state.photo1State.combine ? 'inline-flex' : 'none';
    }
// Wenn Combine AN und ein Foto aktiv ist: Logo sofort nach oben schieben
if (state.photo1State.combine){
  const hasPhoto = !!(state.photo1State && state.photo1State.w > 0 && state.photo1State.h > 0);
  if (hasPhoto && !isB2BSummaryOnlyPortalFlow() && !isB2BPersonalizedPortalFlow() && !isB2BEventPortalFlow()){
    // einmalig anstoßen (setzt offY nur, wenn noch nicht oben)
    try{
      state.photo1State.__comboLifted = false; // erlaubt Lift nach Toggle
      state.photo1State.__comboZoomed = false;
      state.photo1State.scale = Math.max(0.05, Math.min(10, (state.photo1State.scale || 1) * 1.18));
      photo1.apply();
      // emulate lift via box-messung
      const r = box1.getBoundingClientRect();
      const dy = -Math.round(Math.max(140, Math.min(280, r.height * 0.52)));
      if ((state.photo1State.offY || 0) > dy/2){
        state.photo1State.offY = dy;
        state.photo1State.__comboLifted = true;
        photo1.apply();
      }
    }catch(_){}
  }
}
    updatePreview();
    if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
  });
}
if (personalizedSenderCombineTextInput){
  personalizedSenderCombineTextInput.addEventListener('input', ()=>{
    if (!txt1) return;
    let v = String(personalizedSenderCombineTextInput.value || '').replace(/\r/g,'').replace(/\n+/g,' ');
    if (v.length > 50) v = v.slice(0, 50);
    personalizedSenderCombineTextInput.value = v;
    state.photo1State.prevText = v;
    if (typeof fit1 === 'function') fit1();
    if (typeof updatePreview === 'function') updatePreview();
    if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
  });
}
if (summaryCombineTextInput){
  summaryCombineTextInput.addEventListener('input', ()=>{
    if (!txt1) return;
    let v = String(summaryCombineTextInput.value || '').replace(/\r/g,'').replace(/\n+/g,' ');
    if (v.length > 50) v = v.slice(0, 50);
    summaryCombineTextInput.value = v;
    txt1.value = v;
    state.photo1State.prevText = v;
    if (typeof fit1 === 'function') fit1();
    if (typeof updatePreview === 'function') updatePreview();
    if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
    scheduleSummaryTemplateAutosave();
  });
}
if (personalizedMonthlyPhoto1Combine){
  personalizedMonthlyPhoto1Combine.checked = !!state.personalizedMonthlyPhoto1State.combine;
  personalizedMonthlyPhoto1Combine.addEventListener('change', ()=>{
    state.personalizedMonthlyPhoto1State.combine = !!personalizedMonthlyPhoto1Combine.checked;
    markPersonalizedMonthlySenderCustomized();
    if (personalizedMonthlyCombineTextInput){
      if (state.personalizedMonthlyPhoto1State.combine){
        personalizedMonthlyCombineTextInput.value = String(personalizedMonthlyTxt1 && personalizedMonthlyTxt1.value || state.personalizedMonthlyPhoto1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
      } else {
        personalizedMonthlyCombineTextInput.value = '';
      }
    }
    syncPersonalizedMonthlySenderUi();
    if (typeof updatePreview === 'function') updatePreview();
    if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
  });
}
if (personalizedMonthlyCombineTextInput){
  personalizedMonthlyCombineTextInput.addEventListener('input', ()=>{
    if (!personalizedMonthlyTxt1) return;
    let v = String(personalizedMonthlyCombineTextInput.value || '').replace(/\r/g,'').replace(/\n+/g,' ');
    if (v.length > 50) v = v.slice(0, 50);
    personalizedMonthlyCombineTextInput.value = v;
    personalizedMonthlyTxt1.value = v;
    state.personalizedMonthlyPhoto1State.prevText = v;
    markPersonalizedMonthlySenderCustomized();
    if (typeof fitPersonalizedMonthly1 === 'function') fitPersonalizedMonthly1();
    if (typeof updatePreview === 'function') updatePreview();
    if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
  });
}
if (personalizedMonthlyTxt1){
  personalizedMonthlyTxt1.addEventListener('input', ()=>{
    state.personalizedMonthlyPhoto1State.prevText = String(personalizedMonthlyTxt1.value || '').replace(/\r/g,'');
    markPersonalizedMonthlySenderCustomized();
  });
}
  const photo4=setupPhoto(box4,ph4,img4,$('file4'),state.photo4State,txt4,$('remove4'),fit4);
  const photo6=setupPhoto(box6,ph6,img6,$('file6'),state.photo6State,txt6,$('remove6'),fit6);
    // NEU: Grußkarten-Fotos
  const gcPh1=$('gcPh1'), gcImg1=$('gcImg1');
  const gcPh2=$('gcPh2'), gcImg2=$('gcImg2');
  const gcPh3=$('gcPh3'), gcImg3=$('gcImg3');

  const greetPhoto1 = (gcBox1 && gcPh1 && gcImg1)
    ? setupPhoto(gcBox1, gcPh1, gcImg1, $('gcFile1'), state.greetPhoto1State, gcTxt1, $('gcRemove1'), fitGc1, false)
    : null;
  const greetPhoto2 = (gcBox2 && gcPh2 && gcImg2)
    ? setupPhoto(gcBox2, gcPh2, gcImg2, $('gcFile2'), state.greetPhoto2State, gcTxt2, $('gcRemove2'), fitGc2, false)
    : null;
  const greetPhoto3 = (gcBox3 && gcPh3 && gcImg3)
    ? setupPhoto(gcBox3, gcPh3, gcImg3, $('gcFile3'), state.greetPhoto3State, gcTxt3, $('gcRemove3'), fitGc3, false)
    : null;

  if(greetPhoto1){
    $('gcCenter1').addEventListener('click',  greetPhoto1.center);
    $('gcZoomIn1').addEventListener('click', ()=>greetPhoto1.zoom(1.1));
    $('gcZoomOut1').addEventListener('click',()=>greetPhoto1.zoom(0.9));
    $('gcRotateL1').addEventListener('click',()=>greetPhoto1.rotate(-90));
    $('gcRotateR1').addEventListener('click',()=>greetPhoto1.rotate(90));
  }
  if(greetPhoto2){
    $('gcCenter2').addEventListener('click',  greetPhoto2.center);
    $('gcZoomIn2').addEventListener('click', ()=>greetPhoto2.zoom(1.1));
    $('gcZoomOut2').addEventListener('click',()=>greetPhoto2.zoom(0.9));
    $('gcRotateL2').addEventListener('click',()=>greetPhoto2.rotate(-90));
    $('gcRotateR2').addEventListener('click',()=>greetPhoto2.rotate(90));
  }

  if(greetPhoto3){
    $('gcCenter3').addEventListener('click',  greetPhoto3.center);
    $('gcZoomIn3').addEventListener('click', ()=>greetPhoto3.zoom(1.1));
    $('gcZoomOut3').addEventListener('click',()=>greetPhoto3.zoom(0.9));
    $('gcRotateL3').addEventListener('click',()=>greetPhoto3.rotate(-90));
    $('gcRotateR3').addEventListener('click',()=>greetPhoto3.rotate(90));
  }

  $('center1').addEventListener('click',photo1.center);
  $('nLeft1').addEventListener('click',()=>photo1.nudge(-5,0));
  $('nRight1').addEventListener('click',()=>photo1.nudge(5,0));
  $('nUp1').addEventListener('click',()=>photo1.nudge(0,-5));
  $('nDown1').addEventListener('click',()=>photo1.nudge(0,5));

  $('center4').addEventListener('click',photo4.center);
  $('nLeft4').addEventListener('click',()=>photo4.nudge(-5,0));
  $('nRight4').addEventListener('click',()=>photo4.nudge(5,0));
  $('nUp4').addEventListener('click',()=>photo4.nudge(0,-5));
  $('nDown4').addEventListener('click',()=>photo4.nudge(0,5));

  $('center6').addEventListener('click',photo6.center);
  $('nLeft6').addEventListener('click',()=>photo6.nudge(-5,0));
  $('nRight6').addEventListener('click',()=>photo6.nudge(5,0));
  $('nUp6').addEventListener('click',()=>photo6.nudge(0,-5));
  $('nDown6').addEventListener('click',()=>photo6.nudge(0,5));

  // Zoom für Step 1
$('zoomIn1').addEventListener('click', ()=>photo1.zoom(1.1));
$('zoomOut1').addEventListener('click',()=>photo1.zoom(0.9));
$('rotateL1').addEventListener('click',()=>photo1.rotate(-90));
$('rotateR1').addEventListener('click',()=>photo1.rotate(90));

if (personalizedMonthlyPhoto1){
  $('personalizedMonthlyCenter1').addEventListener('click', personalizedMonthlyPhoto1.center);
  $('personalizedMonthlyNLeft1').addEventListener('click',()=>personalizedMonthlyPhoto1.nudge(-5,0));
  $('personalizedMonthlyNRight1').addEventListener('click',()=>personalizedMonthlyPhoto1.nudge(5,0));
  $('personalizedMonthlyNUp1').addEventListener('click',()=>personalizedMonthlyPhoto1.nudge(0,-5));
  $('personalizedMonthlyNDown1').addEventListener('click',()=>personalizedMonthlyPhoto1.nudge(0,5));
  $('personalizedMonthlyZoomIn1').addEventListener('click', ()=>personalizedMonthlyPhoto1.zoom(1.1));
  $('personalizedMonthlyZoomOut1').addEventListener('click',()=>personalizedMonthlyPhoto1.zoom(0.9));
  $('personalizedMonthlyRotateL1').addEventListener('click',()=>personalizedMonthlyPhoto1.rotate(-90));
  $('personalizedMonthlyRotateR1').addEventListener('click',()=>personalizedMonthlyPhoto1.rotate(90));
}

[
  $('personalizedMonthlyFile1'),
  $('personalizedMonthlyRemove1'),
  $('personalizedMonthlyCenter1'),
  $('personalizedMonthlyNLeft1'),
  $('personalizedMonthlyNRight1'),
  $('personalizedMonthlyNUp1'),
  $('personalizedMonthlyNDown1'),
  $('personalizedMonthlyZoomIn1'),
  $('personalizedMonthlyZoomOut1'),
  $('personalizedMonthlyRotateL1'),
  $('personalizedMonthlyRotateR1')
].filter(Boolean).forEach(function(el){
  const evt = (el.id === 'personalizedMonthlyFile1') ? 'change' : 'click';
  el.addEventListener(evt, function(){
    markPersonalizedMonthlySenderCustomized();
  });
});

// Zoom für Step 2
$('zoomIn4').addEventListener('click', ()=>photo4.zoom(1.1));
$('zoomOut4').addEventListener('click',()=>photo4.zoom(0.9));
$('rotateL4').addEventListener('click',()=>photo4.rotate(-90));
$('rotateR4').addEventListener('click',()=>photo4.rotate(90));

// Zoom für Step 3
$('zoomIn6').addEventListener('click', ()=>photo6.zoom(1.1));
$('zoomOut6').addEventListener('click',()=>photo6.zoom(0.9));
$('rotateL6').addEventListener('click',()=>photo6.rotate(-90));
$('rotateR6').addEventListener('click',()=>photo6.rotate(90));

  /* ===== Claim & Preis ===== */
  const claimPrev2=$('claimPreview2');
  const pvClaimVerb=$('pvClaimVerb');
  const pvClaimNoun=$('pvClaimNoun');
  const pvClaimTrailer=$('pvClaimTrailer');
  const pvQtyLabel=$('pvQtyLabel');
  const priceLbl=$('priceLbl');
  const wizPriceEl=$('wizPrice');
  const wizPriceBubble = wizPriceEl ? wizPriceEl.closest('.wiz-price-bubble') : document.querySelector('.wiz-price-bubble');
  const qVal=$('qVal');
  const co2Lbl=$('co2Lbl');
  const qtyHint = document.querySelector('#step5 .qty-hint');

function buildClaimParts(){
  const n = state.trees || 1;

  // Verb bewusst klein lassen: "hat" / "haben"
  const verb = (state.verb === 'HABEN') ? 'haben' : 'hat';

  // 🔸 SPEZIALFALL: B2B-Monatszertifikat (Step 10)
  // Hier soll NICHT mehr "einen Baum / Bäume gepflanzt für" stehen,
  // sondern z.B. "hat im Dezember 2025" / "haben im Dezember 2025".
if (isMonthlyCertState()){
  const lang = getMonthlyCertLang();
  const parts = getMonthlyDateParts(lang);
  const monthName = parts.monthName;
  const year = parts.year;
  const treesLabel = formatMonthlyTreesLabel(state.monthlyTrees || 0, lang);

  if(lang === 'en'){
    const verb = (state.verb === 'HABEN') ? 'have planted' : 'has planted';
    const noun = '';
    const trailer = '';
    return { verb, noun, trailer, full: `${verb}`.trim(), monthName, year };
  }

  if(lang === 'es'){
    const verb = (state.verb === 'HABEN') ? 'han plantado' : 'ha plantado';
    const noun = '';
    const trailer = '';
    return { verb, noun, trailer, full: `${verb}`.trim(), monthName, year };
  }

  if(lang === 'fr'){
    const verb = (state.verb === 'HABEN') ? 'ont plante' : 'a plante';
    const noun = '';
    const trailer = '';
    return { verb, noun, trailer, full: `${verb}`.trim(), monthName, year };
  }

  if(lang === 'tr'){
    const verb = (state.verb === 'HABEN') ? 'diktiler' : 'dikti';
    const noun = '';
    const trailer = '';
    return { verb, noun, trailer, full: `${verb}`.trim(), monthName, year };
  }

  const verb = (state.verb === 'HABEN') ? 'haben' : 'hat';
  const noun = `im ${monthName} ${year}`;
  const trailer = '';
  return { verb, noun, trailer, full: `${verb} ${noun}`.trim(), monthName, year };
}


// 🔸 Standardfall: normales Zertifikat (sprachfähig)
const lang = getActiveLang();

// helper: Zahlwort 2–12, sonst Zahl
const numWord = (fnWord, n) => (n <= 12 ? fnWord(n).toLowerCase() : String(n));

if(lang === 'en'){
  const verb = (state.verb === 'HABEN') ? 'have planted' : 'has planted';
  const noun = (n === 1) ? 'a tree' : (numWord(wordEN, n) + ' trees');
  const trailer = 'for';
  return { verb, noun, trailer, full: `${verb} ${noun} ${trailer}`.trim() };
}

if(lang === 'es'){
  const verb = (state.verb === 'HABEN') ? 'han plantado' : 'ha plantado';
  const noun = (n === 1) ? 'un árbol' : (numWord(wordES, n) + ' árboles');
  const trailer = 'para';
  return { verb, noun, trailer, full: `${verb} ${noun} ${trailer}`.trim() };
}

if(lang === 'fr'){
  const verb = (state.verb === 'HABEN') ? 'ont planté' : 'a planté';
  const noun = (n === 1) ? 'un arbre' : (numWord(wordFR, n) + ' arbres');
  const trailer = 'pour';
  return { verb, noun, trailer, full: `${verb} ${noun} ${trailer}`.trim() };
}

if(lang === 'tr'){
  // Claim = "X ağaç dikti/diktiler" und "için" kommt nach dem Namen (siehe updatePreview Patch)
  const verb = (state.verb === 'HABEN') ? 'diktiler' : 'dikti';
  const noun = (n === 1) ? 'bir ağaç' : (numWord(wordTR, n) + ' ağaç');
  const trailer = '';
  return { verb, noun, trailer, full: `${noun} ${verb}`.trim() };
}

// Default DE
{
  const verb = (state.verb === 'HABEN') ? 'haben' : 'hat';
  const noun = (n === 1) ? 'einen Baum' : (wordDE(n).toLowerCase() + ' Bäume');
  const trailer = 'gepflanzt für';
  return { verb, noun, trailer, full: `${verb} ${noun} ${trailer}`.trim() };
}

}

function buildClaim(){
  return buildClaimParts().full;
}

  function applyProductContextUI(){
    const hasTitle = !!state.giftTitle;
    const hasImg   = !!state.giftImg;

    const introCard   = $('introProductCard');
    const introTitle  = $('introProductTitle');
    const introImg    = $('introProductImg');
    const introLabel  = $('introProductLabel');

    const pvRef       = $('pvProductRef');
    const pvTitle     = $('pvProductTitle');
    const pvImg       = $('pvProductImg');

    const wizThumbWrap = $('wizPriceThumb');
    const wizThumbImg  = $('wizPriceThumbImg');
    const wizTitleEl   = $('wizPriceTitle');

    if(introCard){
      if(hasTitle || hasImg){
        introCard.style.display = 'flex';
        if(introTitle && state.giftTitle){ introTitle.textContent = state.giftTitle; }
        if(introImg && state.giftImg){ introImg.src = state.giftImg; introImg.alt = state.giftTitle || 'Produkt'; }
        if(introLabel){
          introLabel.textContent = (state.mode === 'gift' || state.mode === 'label')
            ? 'Du personalisierst gerade das Zertifikat für:'
            : 'Zertifikat-Produkt:';
        }
      }else{ introCard.style.display = 'none'; }
    }

    if(pvRef){
      if(hasTitle || hasImg){
        pvRef.style.display = 'block';
        if(pvTitle && state.giftTitle){ pvTitle.textContent = state.giftTitle; }
        if(pvImg && state.giftImg){ pvImg.src = state.giftImg; pvImg.alt = state.giftTitle || 'Produkt'; }
      }else{ pvRef.style.display = 'none'; }
    }

    // Produktbild im Header-Badge
    if (wizThumbWrap && wizThumbImg){
      if (hasImg){
        wizThumbWrap.style.display = 'block';
        wizThumbImg.src = state.giftImg;
        wizThumbImg.alt = state.giftTitle || 'Produkt';
      } else {
        wizThumbWrap.style.display = 'none';
        wizThumbImg.removeAttribute('src');
        wizThumbImg.alt = '';
      }
    }

    // Produktname im Header-Badge (gekappt)
    if (wizTitleEl){
      if (hasTitle){
        const raw   = state.giftTitle || '';
        const capped = raw.length > 60 ? raw.slice(0, 57) + '…' : raw;
        wizTitleEl.textContent = capped;
      } else {
        wizTitleEl.textContent = (state.mode === 'cert') ? 'Baum & Zertifikat' : '';
      }
    }
  }

  function updateClaim(){
    const parts=buildClaimParts();
    const txt=parts.full;
    if(claimPrev2) claimPrev2.textContent=txt;
    if(pvClaimVerb)    pvClaimVerb.textContent=parts.verb;
    if(pvClaimNoun)    pvClaimNoun.textContent=parts.noun;
    if(pvClaimTrailer) pvClaimTrailer.textContent=parts.trailer;

    // Auch Label-Claim synchronisieren
    const lbEClaim=$('lbEClaim'); const lbFClaim=$('lbFClaim');
    if(lbEClaim) lbEClaim.textContent = txt;
    if(lbFClaim) lbFClaim.textContent = txt;
    fitLabelLines();
  }

function updatePrice(){
  if (wizPriceBubble){
    wizPriceBubble.style.display = isB2BQuickMonthlyPortalFlow() ? 'none' : '';
  }
  if (isB2B && state.mode === 'cert' && (
    isB2BSummaryOnlyPortalFlow() ||
    isB2BEventCertificatePhase() ||
    isB2BEventSummaryPhase() ||
    isB2BEventFinalOverviewPhase()
  )){
    const monthlyForestMap = (typeof getMonthlyProjectForestTrees === 'function') ? (getMonthlyProjectForestTrees() || {}) : {};
    let monthlyTotal = 0;
    ['mv','by','rp'].forEach(function(code){
      monthlyTotal += (Math.max(0, parseInt(monthlyForestMap[code], 10) || 0) * getB2BTreePriceForForest(code));
    });
    const monthlyCount = (typeof getMonthlyProjectTreeCount === 'function')
      ? Math.max(0, parseInt(getMonthlyProjectTreeCount(), 10) || 0)
      : ['mv','by','rp'].reduce(function(sum, code){
          return sum + (Math.max(0, parseInt(monthlyForestMap[code], 10) || 0));
        }, 0);
    const wizTitleEl = $('wizPriceTitle');

    if (priceLbl){
      priceLbl.textContent = 'Preis: ' + EUR(monthlyTotal);
    }
    if (wizPriceEl){
      wizPriceEl.textContent = EUR(monthlyTotal) + ' netto';
    }
    if (wizTitleEl){
      wizTitleEl.textContent = monthlyCount === 1 ? '1 Baum' : (monthlyCount.toLocaleString('de-DE') + ' Bäume');
    }
    if (qtyHint){
      const eventTreePrice = getB2BTreePriceForForest(state.forest || 'mv');
      qtyHint.innerHTML = isB2BEventPortalFlow()
        ? 'Berechnet werden nur die Bäume aus diesem Event-Projekt mit ' + EUR(eventTreePrice) + ' netto pro Baum.'
        : 'Berechnet werden nur die in diesem Projekt neu hinzugefügten Bäume.';
    }
    return;
  }

  if (isB2BPersonalizedPricingFlow()){
    const total = getB2BPersonalizedProjectNetTotal();
    const singleTreePrice = getB2BTreePriceForForest(state.forest || 'mv');
    const hasShipping = b2bPersonalizedHasShipping();
    const shippingPrice = Number(PRICES.b2bDhl || 0) || 0;
    const wizTitleEl = $('wizPriceTitle');

    if(priceLbl){
      priceLbl.textContent = 'Preis: ' + EUR(total) + (hasShipping ? ' inkl. Versand' : '');
    }
    if(wizPriceEl){
      wizPriceEl.textContent = EUR(total) + ' netto' + (hasShipping ? ' inkl. Versand' : '');
    }
    if(wizTitleEl){
      if(state.seriesEnabled && hasSeriesRows()){
        const count = Array.isArray(state.seriesRows) ? state.seriesRows.length : 0;
        wizTitleEl.textContent = count === 1 ? '1 Zertifikat' : (count.toLocaleString('de-DE') + ' Zertifikate');
      } else {
        const treesNow = Math.max(1, parseInt(state.trees, 10) || 1);
        wizTitleEl.textContent = treesNow === 1 ? '1 Baum + Personalisierung' : (treesNow.toLocaleString('de-DE') + ' Bäume + Personalisierung');
      }
    }
    if(qtyHint){
      let hint =
        '1 Baum kostet ' + EUR(singleTreePrice) +
        ' netto. Pro personalisiertem Zertifikat kommen ' + EUR(PRICES.b2bPersonalization || 0) +
        ' netto hinzu.';
      if(hasShipping){
        hint += ' Druck und Versand sind im angezeigten Gesamtpreis bereits berücksichtigt.';
        if(shippingPrice > 0){
          hint += ' DHL wird einmalig mit ' + EUR(shippingPrice) + ' netto berechnet.';
        }
      }
      qtyHint.innerHTML = hint;
    }
    return;
  }

  const extraTreePrice = PRICES.extraTree || 0;
  const treeAddonPrice = PRICES.treeAddonBase || 0;
  // NEU: Gift-Variante, bei der der erste Baum schon im Produktpreis drin ist
  const isAlwaysTreeGift = (state.mode === 'gift' && isGiftAlwaysTree);

  // Zusatzbäume nur, wenn überhaupt eine Baumpflanzung existiert
  let extraTrees = 0;
  if (state.mode === 'cert' || state.treeAddonSelected){
    extraTrees = Math.max(0, state.trees - 1) * extraTreePrice;
  }

  let base   = 0;
  let extras = 0;

  if (state.mode === 'cert'){
    // Normaler Zertifikatsmodus – IMMER aus PRICES.certBase
    const baseCert = PRICES.certBase || 0;
    base = baseCert;

    if (state.delivery === 'print'){
      extras += state.paperType === 'grass'
        ? (PRICES.printGrass || 0)
        : (PRICES.printWhite || 0);
    }

  } else if (state.mode === 'gift' || state.mode === 'label'){
    // Gift-/Label-Modus
    base = (state.giftBasePrice != null) ? state.giftBasePrice : 0;

    // Grundbaumpflanzung (10 €):
    // - normale Gift-Produkte: Aufpreis +10 €
    // - Always-Tree-Gift: Baum bereits im Produktpreis enthalten → KEIN Aufpreis
    if(state.treeAddonSelected && !isAlwaysTreeGift){
      extras += treeAddonPrice;
    }

    // Papier
    if(state.paperType === 'grass'){
      extras += PRICES.giftPaperGrass || 0;
    }

    // Geschenkverpackung
    if(state.giftwrapAvailable && state.giftwrapSelected){
      extras += PRICES.giftWrap || 0;
    }

    // Gimmick (Ofenhandschuh)
    if(state.gimmickAvailable && state.gimmickSelected && state.gimmickConfig){
      const code = state.gimmickCode;
      const dyn  = (PRICES.gimmicks && PRICES.gimmicks[code] != null)
        ? PRICES.gimmicks[code]
        : state.gimmickConfig.price;
      extras += dyn || 0;
    }

    // NEU: Deko-Extras
    if(state.extraHeartAvailable && state.extraHeartSelected){
      extras += PRICES.extraHeart || 3.50;
    }
    if(state.extraJustAvailable && state.extraJustSelected){
      extras += PRICES.extraJustMarried || 3.50;
    }
    if(state.bookmarkAvailable && state.bookmarkSelected){
      const choice = state.bookmarkChoice || 'eule';
      const priceKey =
        choice === 'libelle' ? 'bookmarkLibelle' :
        choice === 'ginkgo'  ? 'bookmarkGinkgo'  :
                               'bookmarkEule';
      extras += PRICES[priceKey] || 9.00;
    }
  }

  // Grußkarte (alle Modi)
  // Im cert-Modus bei DIGITAL = kostenlos, sonst Aufpreis
  if (state.greetCardSelected) {
    let surcharge = 0;

    if (!(state.mode === 'cert' && state.delivery === 'digital')) {
      // gift, label oder cert + print → Aufpreis
      surcharge = PRICES.greetingCard || 3.50;
    }

    extras += surcharge;
  }

  const total = base + extraTrees + extras;

  // Detailpreis im Step („Preis: …“) – weiterhin nur für das aktuell sichtbare Zertifikat
  if(priceLbl){
    priceLbl.textContent = 'Preis: ' + EUR(total);
  }

  // ===== HEADER-BUBBLE: Serienmodus berücksichtigen =====
  let headerTotal;

  // Serienmodus (nur cert): Summe aller Zertifikate der Serie
  if (state.mode === 'cert' && state.seriesEnabled && hasSeriesRows()){
    const baseCert        = PRICES.certBase || 0;
    const extraTreePriceS = PRICES.extraTree || 0;

    let seriesTotal = 0;
    const count = state.seriesRows.length;

    for (let i = 0; i < count; i++){
      const tRaw      = getTreesForIndex(i);
      const treesThis = (typeof tRaw === 'number' && tRaw > 0) ? tRaw : 1;

      const dThis     = getDeliveryForIndex(i);
      const pThis     = getPaperTypeForIndex(i);

      let perBase   = baseCert;
      let perExtras = Math.max(0, treesThis - 1) * extraTreePriceS;

      if (dThis === 'print'){
        perExtras += (pThis === 'grass'
          ? (PRICES.printGrass || 0)
          : (PRICES.printWhite || 0));
      }

      seriesTotal += perBase + perExtras;
    }

    headerTotal = seriesTotal;

  } else {
    // Normalfall: Einzelzertifikat
    headerTotal = total;

    // Gift/Label Step 0: nur Basispreis (wie bisher)
    if ((state.mode === 'gift' || state.mode === 'label') &&
        state.step === 0 &&
        !state.noTreeExtrasMode){
      headerTotal = base;
    }
  }

  if(wizPriceEl){
    wizPriceEl.textContent = EUR(headerTotal);
  }

  // Hinweis unter der Mengensteuerung
  if(qtyHint){
    if(state.mode === 'gift' || state.mode === 'label'){
      if (isAlwaysTreeGift){
        // NEU: Baum ist schon im Produkt enthalten
        qtyHint.innerHTML =
          'Ein Baum ist in deinem Produktpreis bereits enthalten. Jeder weitere Baum kostet ' +
          EUR(extraTreePrice) + '.';
      } else {
        qtyHint.innerHTML =
          'Der erste Baum kostet ' + EUR(treeAddonPrice) +
          ' zusätzlich zu deinem Produkt. Jeder weitere Baum kostet ' +
          EUR(extraTreePrice) + '.';
      }
    }else{
      const baseCert = PRICES.certBase || 0;
      qtyHint.innerHTML =
        '1 Baum kostet ' + EUR(baseCert) +
        '. Jeder weitere Baum kostet zusätzlich ' + EUR(extraTreePrice) + '.';
    }
  }
}
    
    // Preise im Intro-Step anzeigen (nur Gift/Label)
function updateIntroPrices(){
  if (!(state.mode === 'gift' || state.mode === 'label')) return;
  if (!introNoTreePriceEl && !introWithTreePriceEl) return;

  const base   = (state.giftBasePrice != null) ? state.giftBasePrice : 0;
  const addon  = PRICES.treeAddonBase || 0;

  // 1) „Nur das Produkt bestellen – ohne Baumpflanzung“
  if (introNoTreePriceEl){
    introNoTreePriceEl.textContent = base > 0 ? EUR(base) : '';
  }

  // 2) „Baumpflanzung mit personalisiertem Zertifikat hinzufügen“
  //    → nur den Aufpreis zeigen: +10,00 €
if (introWithTreePriceEl){
  introWithTreePriceEl.textContent =
    addon > 0 ? ('+' + EUR(addon) + ' Aufpreis') : '';
}
}


  function updateQtyLabel(){
    if(!pvQtyLabel) return;
    const n = getCurrentPreviewTreeCount();
    pvQtyLabel.textContent=n===1?'1 Baum':(n+' Bäume');
  }

  function updateCo2Label(){
    if(!co2Lbl) return;
    const n = state.trees || 1;
    const total = n * 15;
    co2Lbl.textContent = 'Jährliche CO₂-Ersparnis: ca. ' +
      total.toLocaleString('de-DE') +
      ' kg (≈ ' + n + ' × 15 kg)';
  }

  const segVerb=$('segVerb');
  if(segVerb){
    segVerb.addEventListener('click',e=>{
      const btn=e.target.closest('button'); if(!btn) return;
      state.verb = (btn.getAttribute('data-verb') === 'HABEN') ? 'HABEN' : 'HAT';

      segVerb.querySelectorAll('button').forEach(b=>{
        b.classList.toggle('active', b===btn);
      });

      // Serienmodus: Verb für das aktuell ausgewählte Zertifikat merken
if (state.seriesEnabled && hasSeriesRows()){
  clampSeriesIndex();
  setSeriesVerb(state.seriesIndex, state.verb);
  if (!hasEditOrClone && DRAFT_KEY){
    scheduleDraftSave();
  }
}

      updateClaim();
      updatePreview();
      updateSeriesVerbUI && updateSeriesVerbUI();
    });
  }

// Hilfsfunktion: Baumanzahl ändern
function changeTrees(delta){
  if (state.seriesEnabled && hasSeriesRows()){
    clampSeriesIndex();
    const idx = state.seriesIndex;

    if (!Array.isArray(state.seriesTrees)) state.seriesTrees = [];

    const currentTrees = getTreesForIndex(idx); // liest aus seriesTrees
    const newTrees     = Math.max(1, currentTrees + delta);

    state.seriesTrees[idx] = newTrees;
    state.trees            = newTrees;  // aktueller Wert fürs UI
  } else {
    // Kein Serienmodus → global wie bisher
    state.trees = Math.max(1, (state.trees || 1) + delta);
  }

  if (qVal) qVal.value = state.trees;
  updateClaim();
  updatePrice();
  updateQtyLabel();
  updateCo2Label();
  updatePreview();
  if (state.seriesEnabled){
    updateSeriesTreeUI();
    updateSeriesFinalPagerUI();
  }
}

// Buttons binden – mit touchstart + preventDefault, damit iOS nicht zoomt
function bindQtyButton(btnId, delta){
  const btn = $(btnId);
  if(!btn) return;

  const handler = function(){
    changeTrees(delta);
  };

  // Klick (Desktop & normale Browser)
  btn.addEventListener('click', function(e){
    e.preventDefault();
    handler();
  });

  // Touch (insb. iOS Safari – verhindert Double-Tap-Zoom)
  btn.addEventListener('touchstart', function(e){
    e.preventDefault();
    handler();
  }, { passive:false });
}

bindQtyButton('qMinus', -1);
bindQtyButton('qPlus',  +1);
  // Kunden dürfen die Baumanzahl nach dem Kauf nicht mehr ändern
  if (isLockedEdit) {
    const btnMinus = $('qMinus');
    const btnPlus  = $('qPlus');
    if (btnMinus) btnMinus.disabled = true;
    if (btnPlus)  btnPlus.disabled  = true;
    if (qVal) {
      qVal.readOnly = true;
      qVal.style.opacity = '0.7';
      qVal.style.cursor  = 'not-allowed';
    }
    const qtyHint = document.querySelector('#step5 .qty-hint');
    if (qtyHint) {
      qtyHint.innerHTML = 'Baumanzahl kann nach dem Kauf nicht mehr geändert werden.';
    }
  }
    updateIntroPrices();

  if(qVal){
    qVal.addEventListener('input',()=>{
      const v = parseInt(qVal.value || '1', 10);
      const n = isNaN(v) ? 1 : Math.max(1, v);

if (state.seriesEnabled && hasSeriesRows()){
  clampSeriesIndex();
  const idx = state.seriesIndex;

  if (!Array.isArray(state.seriesTrees)) state.seriesTrees = [];
  state.seriesTrees[idx] = n;
  state.trees            = n;
} else {
  state.trees = n;
}

      qVal.value = state.trees;
      updateClaim();
      updatePrice();
      updateQtyLabel();
      updateCo2Label();
      updatePreview();
      if(state.seriesEnabled){
        updateSeriesTreeUI();
        updateSeriesFinalPagerUI();
      }
    });
  }

  updateClaim();
  updatePrice();
  updateQtyLabel();
  updateCo2Label();

  // Shopify-Preise dynamisch nachladen
  (async function initVariantPrices(){

    // IMPORTANT:
    // Im Cert-Modus NICHT mehr den Zertifikat-Preis aus Shopify ziehen,
    // sondern den im JS / per URL gesetzten Wert verwenden.
    // So bleibt PRICES.certBase = 9.90 (oder cert_price aus der URL),
    // und nichts springt mehr auf 12,00 €.
    if(state.mode !== 'cert' && VARIANTS.certBase){
      const p = await fetchVariantPrice(VARIANTS.certBase);
      if(p != null) PRICES.certBase = p;
    }

    if(VARIANTS.extraTree){
      const p = await fetchVariantPrice(VARIANTS.extraTree);
      if(p != null) PRICES.extraTree = p;
    }

    if(VARIANTS.printWhite){
      const p = await fetchVariantPrice(VARIANTS.printWhite);
      if(p != null) PRICES.printWhite = p;
    }
    if(VARIANTS.printGrass){
      const p = await fetchVariantPrice(VARIANTS.printGrass);
      if(p != null) PRICES.printGrass = p;
    }

    if(VARIANTS.giftPaperGrass){
      const p = await fetchVariantPrice(VARIANTS.giftPaperGrass);
      if(p != null) PRICES.giftPaperGrass = p;
    }
    if(VARIANTS.giftWrap){
      const p = await fetchVariantPrice(VARIANTS.giftWrap);
      if(p != null) PRICES.giftWrap = p;
    }

    // NEU: Deko-Extras
    if(VARIANTS.extraHeart){
      const p = await fetchVariantPrice(VARIANTS.extraHeart);
      if(p != null) PRICES.extraHeart = p;
    }
    if(VARIANTS.extraJustMarried){
      const p = await fetchVariantPrice(VARIANTS.extraJustMarried);
      if(p != null) PRICES.extraJustMarried = p;
    }
    if(VARIANTS.bookmarkEule){
      const p = await fetchVariantPrice(VARIANTS.bookmarkEule);
      if(p != null) PRICES.bookmarkEule = p;
    }
    if(VARIANTS.bookmarkLibelle){
      const p = await fetchVariantPrice(VARIANTS.bookmarkLibelle);
      if(p != null) PRICES.bookmarkLibelle = p;
    }
    if(VARIANTS.bookmarkGinkgo){
      const p = await fetchVariantPrice(VARIANTS.bookmarkGinkgo);
      if(p != null) PRICES.bookmarkGinkgo = p;
    }

    // NEU: Preis der kostenpflichtigen Grußkarte nachladen
    if (VARIANTS.greetingCardPaid) {
      const p = await fetchVariantPrice(VARIANTS.greetingCardPaid);
      if (p != null) PRICES.greetingCard = p;
    }

    if(VARIANTS.gimmicks){
      for(const code in VARIANTS.gimmicks){
        const vId = VARIANTS.gimmicks[code];
        const p   = await fetchVariantPrice(vId);
        if(p != null){
          if(!PRICES.gimmicks) PRICES.gimmicks = {};
          PRICES.gimmicks[code] = p;
        }
      }
    }

    if(VARIANTS.b2bTreeMV){
      const p = await fetchVariantPrice(VARIANTS.b2bTreeMV);
      if(p != null) PRICES.b2bTreeMV = p;
    }
    if(VARIANTS.b2bTreeBY){
      const p = await fetchVariantPrice(VARIANTS.b2bTreeBY);
      if(p != null) PRICES.b2bTreeBY = p;
    }
    if(VARIANTS.b2bTreeRP){
      const p = await fetchVariantPrice(VARIANTS.b2bTreeRP);
      if(p != null) PRICES.b2bTreeRP = p;
    }
    if(VARIANTS.b2bPersonalization){
      const p = await fetchVariantPrice(VARIANTS.b2bPersonalization);
      if(p != null) PRICES.b2bPersonalization = p;
    }
    if(VARIANTS.b2bPrint){
      const p = await fetchVariantPrice(VARIANTS.b2bPrint);
      if(p != null) PRICES.b2bPrint = p;
    }
    if(VARIANTS.b2bGrass){
      const p = await fetchVariantPrice(VARIANTS.b2bGrass);
      if(p != null) PRICES.b2bGrass = p;
    }
    if(VARIANTS.b2bDhl){
      const p = await fetchVariantPrice(VARIANTS.b2bDhl);
      if(p != null) PRICES.b2bDhl = p;
    }
// Gift-/Label-Basispreis IMMER aus Shopify holen (nie aus alten PTP-Daten oder URL)
if (state.mode === 'gift' || state.mode === 'label'){
  const giftId =
    state.giftVariantId ||
    giftVariantParam ||
    baseVariantId;

  if (giftId){
    const pGift = await fetchVariantPrice(giftId);
    if (pGift != null){
      state.giftBasePrice = pGift;
      updateIntroPrices();
    }
  }
}
    // Am Ende mit den (ggf. aktualisierten) PRICES neu rechnen
    updatePrice();
  })();

if (pvClaimVerb){
  pvClaimVerb.addEventListener('click', () => {
    const tot = totalSteps();
    if (state.step !== tot) return;
    setStep(2);   // Grammatik ist jetzt Schritt 2
  });
}
if (pvClaimTrailer){
  pvClaimTrailer.addEventListener('click', () => {
    const tot = totalSteps();
    if (state.step !== tot) return;
    setStep(2);   // Grammatik
  });
}
if (pvClaimNoun){
  pvClaimNoun.addEventListener('click', () => {
    const tot = totalSteps();
    if (state.step !== tot) return;
    setStep(5);   // Anzahl & Preis bleibt Schritt 5
  });
}

  /* ===== Deko Schritt & A4-Deko ===== */
  const optBalloon=$('optBalloon');
  const optHat=$('optHat');
  const decoBalloonPv=$('decoBalloonPv');
  const decoHatPv=$('decoHatPv');
  const balloonFinal=$('balloonFinal');
  const hatFinal=$('hatFinal');
  const treeFinal=document.querySelector('.decor-tree-final');

  function applyDecor(){
    const hideInMonthlyPreview = isMonthlyCertState();
    if(decoBalloonPv) decoBalloonPv.style.display=(!hideInMonthlyPreview && state.decoBalloon)?'block':'none';
    if(decoHatPv)     decoHatPv.style.display=(!hideInMonthlyPreview && state.decoHat)?'block':'none';
    if(balloonFinal)  balloonFinal.style.display=(!hideInMonthlyPreview && state.decoBalloon)?'block':'none';
    if(hatFinal)      hatFinal.style.display=(!hideInMonthlyPreview && state.decoHat)?'block':'none';
  }

  if(optBalloon) optBalloon.addEventListener('change',()=>{
    state.decoBalloon = !!optBalloon.checked;

    // Serienmodus: Wert für aktuellen Slot merken
    if (state.seriesEnabled && hasSeriesRows()){
      clampSeriesIndex();
      if (!Array.isArray(state.seriesDecoBalloon)) state.seriesDecoBalloon = [];
      state.seriesDecoBalloon[state.seriesIndex] = state.decoBalloon;
      if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
    }

    applyDecor();
  });

  if(optHat) optHat.addEventListener('change',()=>{
    state.decoHat = !!optHat.checked;

    if (state.seriesEnabled && hasSeriesRows()){
      clampSeriesIndex();
      if (!Array.isArray(state.seriesDecoHat)) state.seriesDecoHat = [];
      state.seriesDecoHat[state.seriesIndex] = state.decoHat;
      if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
    }

    applyDecor();
  });

  applyDecor();

  let decorImagesReadyPromise = null;
  function ensureDecorImagesLoaded(){
    if (decorImagesReadyPromise) return decorImagesReadyPromise;
    decorImagesReadyPromise = new Promise(resolve=>{
      const imgs = [ treeFinal, balloonFinal, hatFinal ].filter(Boolean);
      if (!imgs.length){ resolve(); return; }
      let remaining = imgs.length;
      const done = () => { remaining--; if (remaining <= 0) resolve(); };
      imgs.forEach(img=>{
        if (img.complete && img.naturalWidth > 0){ done(); }
        else{
          img.addEventListener('load', done,  { once:true });
          img.addEventListener('error', done, { once:true });
        }
      });
    });
    return decorImagesReadyPromise;
  }

  /* ===== Forstwahl / Pflanzort ===== */
  const forestOptionsEl = $('forestOptions');
  const pvBox1=$('pvBox1');
  const pvBox4=$('pvBox4');
  const pvBox6=$('pvBox6');
  const pvTxt1=$('pvTxt1');
  const pvTxt4=$('pvTxt4');
  const pvTxt6=$('pvTxt6');
  const pvEventClaimLine=$('pvEventClaimLine');
  const pvImg1=$('pvImg1');
  const pvImg4=$('pvImg4');
  const pvImg6=$('pvImg6');
  const pvForestName=$('pvForestName');
  const pvForestCoords=$('pvForestCoords');
  const pvForestId=$('pvForestId');
  const pvForestUrl=$('pvForestUrl');
  const pvMetaForest=$('pvMetaForest');
  const pvMetaDelivery=$('pvMetaDelivery');
  const pvLogoPT=$('pvLogoPT');
  const pvLogoForestMV=$('pvLogoForestMV');
  const pvLogoForestBY=$('pvLogoForestBY');
  const pvLogoForestRP=$('pvLogoForestRP');
  const pvFrameRect=$('pvFrameRect');


  const forestLogos = { mv: pvLogoForestMV, by: pvLogoForestBY, rp: pvLogoForestRP };

  function getDeliveryLabel(deliveryOverride, paperOverride){
    const d = deliveryOverride || state.delivery || 'digital';
    const p = paperOverride   || state.paperType || 'white';

    if(state.mode === 'gift' || state.mode === 'label'){
      if(p === 'grass'){ return 'Dokumente auf Graspapier'; }
      return 'Dokumente auf weißem Papier';
    }

    if(d !== 'print'){ return 'Digital als PDF'; }
    if(p === 'grass'){ return 'Druck auf Graspapier in Urkundenmappe'; }
    return 'Druck auf weißem Papier in Urkundenmappe';
  }

  function applyForestSelectionUI(){
    if(!forestOptionsEl) return;
    forestOptionsEl.querySelectorAll('.forest-option').forEach(label=>{
      const inp = label.querySelector('input[type="radio"]');
      label.classList.toggle('active', inp && inp.checked);
    });
  }

    function applyDeliveryToAllSeries(){
      if (!state.seriesEnabled || !hasSeriesRows()) return;
      const d = (state.delivery === 'print') ? 'print' : 'digital';
      const p = state.paperType || 'white';
      const count = state.seriesRows.length;

      if (!Array.isArray(state.seriesDelivery))   state.seriesDelivery   = [];
      if (!Array.isArray(state.seriesPaperType)) state.seriesPaperType = [];

      for (let i = 0; i < count; i++){
        state.seriesDelivery[i]   = d;
        state.seriesPaperType[i]  = p;
      }

      if (!hasEditOrClone && DRAFT_KEY){
        scheduleDraftSave();
      }

      updateSeriesDeliveryUI();
    }

  if (seriesDeliveryApplyAllBtn){
    seriesDeliveryApplyAllBtn.addEventListener('click', (e)=>{
      e.preventDefault();
      applyDeliveryToAllSeries();
    });
  }

  function updateMetaBar(){
    const lang = getActiveLang();
    if(pvMetaForest){
      if(state.forest && FORESTS[state.forest]){ pvMetaForest.textContent = getForestDisplayName(state.forest, lang); }
      else{ pvMetaForest.textContent = 'noch nicht gewählt'; }
    }
    if(pvMetaDelivery){ pvMetaDelivery.textContent = getDeliveryLabel(); }
  }

function applyForestToPreview(){
  // Alle Forst-Logos unten rechts erstmal ausblenden (inline-style schlägt CSS)
  [pvLogoForestMV, pvLogoForestBY, pvLogoForestRP].forEach(el => {
    if (el) el.style.display = 'none';
  });

  if (!pvForestName || !pvForestCoords || !pvForestId || !pvForestUrl){
    updateMetaBar();
    return;
  }

  // Monatszertifikat:
  // - Klassik wird per CSS ausgeblendet (.a4-forest-classic)
  // - Monats-Layout kommt über .a4-forests-row
  // => hier NICHT überschreiben, nur Meta-Bar
  if (isMonthlyCertState()){
    updateMetaBar();
    return;
  }

  // Sprache des aktuell aktiven Zertifikats bestimmen
  const lang = getActiveLang();

  // Kein Forst gewählt → sprachabhängige Platzhalter
  if (!state.forest){
    pvForestName.textContent   = getLangText('forest_placeholder', lang);
    pvForestCoords.textContent = getLangText('coords_placeholder', lang);
    pvForestId.textContent     = getLangText('id_placeholder', lang);
    pvForestUrl.textContent    = getLangText('url_text', lang);
    updateMetaBar();
    return;
  }

  // Forst gewählt → sprachabhängiger Name + sprachabhängige Platzhalter + URL
  pvForestName.textContent   = getForestDisplayName(state.forest, lang);
  pvForestCoords.textContent = getLangText('coords_placeholder', lang);
  pvForestId.textContent     = getLangText('id_placeholder', lang);
  pvForestUrl.textContent    = getLangText('url_text', lang);

  // passendes Forstlogo unten rechts einblenden
  const logoEl = forestLogos[state.forest];
  if (logoEl) logoEl.style.display = 'block';

  updateMetaBar();

  // Label-Logos mitziehen
  applyForestToLabel();
}


  // ---- Monatszertifikat: Koordinaten aus Server ziehen ----

// Holt genau EINE Koordinate für einen Forst
async function fetchForestCoordOnce(forestCode){
  const params = new URLSearchParams({ forest: forestCode });
  const customerRef = String((state && state.b2bPortal && state.b2bPortal.customerRef) || '').trim();
  if (customerRef){
    params.append('customer_ref', customerRef);
  }

  // Seed: Draft-Key, damit die Koordinaten pro Monats-Zertifikat stabil bleiben
  if (DRAFT_KEY){
    params.append('seed', DRAFT_KEY);
  }

  const url = API_BASE + '/api2/forest/random_coord?' + params.toString();

  try{
    const res = await fetch(url, { headers:{ 'Accept':'application/json' } });

    if (!res.ok){
      console.warn('monthly forest coord: HTTP error', forestCode, res.status);
      return null;
    }

    const js = await res.json();
    console.log('monthly forest coord raw', forestCode, js);

    if (!js || js.ok !== true){
      return null;
    }

    return {
      lat: js.lat ?? null,
      lng: js.lng ?? null,
      dms: typeof js.dms === 'string' ? js.dms : ''
    };
  }catch(e){
    console.warn('monthly forest coord fetch failed for', forestCode, e);
    return null;
  }
}

function currentMonthlyCoordsCacheKey(){
  const customerRef = String((state && state.b2bPortal && state.b2bPortal.customerRef) || '').trim();
  const monthKey = String((state && state.monthlyMonth) || '').trim();
  const draftKey = String(DRAFT_KEY || '').trim();
  return [customerRef, monthKey, draftKey].join('|');
}

// Schreibt die geladenen Koordinaten ins DOM
function applyMonthlyCoordsToDom(){
  const map = state.monthlyCoords || {};
  console.log('applyMonthlyCoordsToDom()', map);

  const mvEl = $('a4ForestCoordMV');
  if (mvEl){
    const c = map.mv;
    mvEl.textContent = c && c.dms ? c.dms : '';
  }

  const byEl = $('a4ForestCoordBY');
  if (byEl){
    const c = map.by;
    byEl.textContent = c && c.dms ? c.dms : '';
  }

  const rpEl = $('a4ForestCoordRP');
  if (rpEl){
    const c = map.rp;
    rpEl.textContent = c && c.dms ? c.dms : '';
  }
}

async function ensureMonthlyCoords(){
  console.log(
    'ensureMonthlyCoords() called – loaded?',
    state.monthlyCoordsLoaded,
    'step=', state.step,
    'mode=', state.mode,
    'isB2B=', isB2B
  );

  // Prüfen, ob wir WIRKLICH Koordinaten haben
  const map = state.monthlyCoords || {};
  const currentCacheKey = currentMonthlyCoordsCacheKey();
  if (state.monthlyCoordsLoaded && currentCacheKey && String(state.monthlyCoordsCacheKey || '') !== currentCacheKey){
    state.monthlyCoordsLoaded = false;
  }
  const hasDms =
    (map.mv && map.mv.dms) ||
    (map.by && map.by.dms) ||
    (map.rp && map.rp.dms);

  // Wenn "schon geladen" aber keine dms -> als NICHT geladen behandeln
  if (!hasDms){
    state.monthlyCoordsLoaded = false;
  }

  // Falls jetzt gültige Daten da sind → nur ins DOM schreiben
  if (state.monthlyCoordsLoaded){
    applyMonthlyCoordsToDom();
    return;
  }

  // Neu laden
  const result = { mv:null, by:null, rp:null };
  const forests = ['mv','by','rp'];

  for (const code of forests){
    result[code] = await fetchForestCoordOnce(code);
  }

  state.monthlyCoords       = result;
  state.monthlyCoordsLoaded = true;
  state.monthlyCoordsCacheKey = currentCacheKey;

  applyMonthlyCoordsToDom();

  // Im Draft speichern, damit beim Reload die gleichen Koordinaten verwendet werden
  if (!hasEditOrClone && DRAFT_KEY){
    scheduleDraftSave();
  }
}


  if(forestOptionsEl){
    forestOptionsEl.addEventListener('change', e=>{
      const inp = e.target.closest('input[type="radio"]');
      if(!inp) return;

      const code = inp.value || null;
      state.forest = code;

      // Serienmodus: Forst für aktuellen Slot merken
      if (state.seriesEnabled && hasSeriesRows() && code){
        clampSeriesIndex();
        setForestForIndex(state.seriesIndex, code);
        if (!hasEditOrClone && DRAFT_KEY){
          scheduleDraftSave();
        }
      }

      applyForestSelectionUI();
      applyForestToPreview();
      applyForestToLabel();
      if(state.step===10 || state.step===11) updatePreview();
    });
    applyForestSelectionUI();
  }

    // Forst im Kunden-Edit nur anzeigen, aber nicht änderbar
  if (isLockedEdit && forestOptionsEl){
    forestOptionsEl.querySelectorAll('input[type="radio"]').forEach(inp=>{
      inp.disabled = true;
    });
    const intro = document.querySelector('#step7 .wiz-intro');
    if (intro){
      intro.textContent = 'Dein Pflanzort wurde bereits festgelegt und kann nicht geändert werden.';
    }
  }

  /* ===== Rahmenfarbe ===== */
  const frameColorPicker = $('frameColorPicker');
  const frameColorHex    = $('frameColorHex');
  const frameColorReset  = $('frameColorReset');
  const monthlyFrameColorPicker = $('monthlyFrameColorPicker');
  const monthlyFrameColorHex    = $('monthlyFrameColorHex');
  const monthlyFrameColorReset  = $('monthlyFrameColorReset');

  function normalizeHex(val){
    if(!val) return null;
    val = val.trim();
    if(!val) return null;
    if(val[0]==='#') val = val.slice(1);
    if(!/^[0-9a-fA-F]{6}$/.test(val)) return null;
    return '#'+val.toUpperCase();
  }
  function normalizeAndEnsureHex(val){
    if(!val) return null;
    let s = String(val).trim();
    if(!s) return null;
    if(s[0] !== '#') s = '#' + s;
    if(!/^#[0-9a-fA-F]{6}$/.test(s)) return null;
    return s.toUpperCase();
  }

function labelPickFirstLine(text){
  if(!text) return '';
  const raw   = String(text).replace(/\r/g, '');
  const first = raw.split('\n')[0] || '';
  return first.trim().slice(0, 50);  // maximale Etikettenlänge
}

function formatMonthlyTreesLabel(n, lang){
  const l = normalizeLang(lang);
  const count = Math.max(0, parseInt(n, 10) || 0);
  if (l === 'en') return count === 1 ? '1 tree' : (count.toLocaleString('en-US') + ' trees');
  if (l === 'es') return count === 1 ? '1 árbol' : (count.toLocaleString('es-ES') + ' árboles');
  if (l === 'fr') return count === 1 ? '1 arbre' : (count.toLocaleString('fr-FR') + ' arbres');
  if (l === 'tr') return count === 1 ? '1 ağaç' : (count.toLocaleString('tr-TR') + ' ağaç');
  return count === 1 ? '1 Baum' : (count.toLocaleString('de-DE') + ' Bäume');
}

function getMonthlyDateParts(lang){
  const l = normalizeLang(lang);
  const monthNamesByLang = {
    de: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    es: ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'],
    fr: ['janvier','fevrier','mars','avril','mai','juin','juillet','aout','septembre','octobre','novembre','decembre'],
    tr: ['Ocak','Subat','Mart','Nisan','Mayis','Haziran','Temmuz','Agustos','Eylul','Ekim','Kasim','Aralik']
  };
  let monthIndex = (new Date()).getMonth();
  let year = (new Date()).getFullYear();
  if (state.monthlyMonth && /^\d{4}-\d{2}$/.test(state.monthlyMonth)){
    const y = parseInt(state.monthlyMonth.slice(0,4), 10);
    const m = parseInt(state.monthlyMonth.slice(5,7), 10);
    year = isFinite(y) ? y : year;
    monthIndex = (isFinite(m) && m >= 1 && m <= 12) ? (m - 1) : monthIndex;
  }
  const monthNames = monthNamesByLang[l] || monthNamesByLang.de;
  return {
    monthName: monthNames[monthIndex] || monthNamesByLang.de[monthIndex] || '',
    year
  };
}

function formatMonthlySubline(lang){
  const l = normalizeLang(lang);
  if (isB2BSubscriptionPortalFlow()){
    if (l === 'en') return 'planted in German forests';
    if (l === 'es') return 'plantado en bosques alemanes';
    if (l === 'fr') return 'plante dans des forets allemandes';
    if (l === 'tr') return 'Alman ormanlarinda dikildi';
    return 'in deutschen Wäldern gepflanzt';
  }
  const parts = getMonthlyDateParts(l);
  if (l === 'en') return 'in German forests in ' + parts.monthName + ' ' + parts.year;
  if (l === 'es') return 'en bosques alemanes en ' + parts.monthName + ' de ' + parts.year;
  if (l === 'fr') return 'dans des forets allemandes en ' + parts.monthName + ' ' + parts.year;
  if (l === 'tr') return 'Alman ormanlarinda ' + parts.monthName + ' ' + parts.year;
  return 'in deutschen Wäldern gepflanzt';
}

function applyFrameColor(){
  const c = (state.frameColor || FRAME_COLOR_DEFAULT).toUpperCase();
  if(pvFrameRect) pvFrameRect.setAttribute('stroke', c);
const qr = document.querySelector('.a4-qr-placeholder');
if(qr) qr.style.borderColor = c;

const mqr = $('pvMonthlyQr');
if(mqr) mqr.style.borderColor = c;

}
  function syncFrameColorInputs(){
    const c = (state.frameColor || FRAME_COLOR_DEFAULT).toUpperCase();
    if(frameColorPicker) frameColorPicker.value = c;
    if(frameColorHex)    frameColorHex.value    = c;
    if(monthlyFrameColorPicker) monthlyFrameColorPicker.value = c;
    if(monthlyFrameColorHex)    monthlyFrameColorHex.value    = c;
    const mqr = $('pvMonthlyQr');
if (mqr) mqr.style.borderColor = c;

  }

  if(frameColorPicker){
    frameColorPicker.addEventListener('input', ()=>{
      state.frameColor = frameColorPicker.value || FRAME_COLOR_DEFAULT;

      // Serienmodus: Farbe in diesem Slot merken
      if (state.seriesEnabled && hasSeriesRows()){
        clampSeriesIndex();
        setFrameColorForIndex(state.seriesIndex, state.frameColor);
        if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
      }

      syncFrameColorInputs(); applyFrameColor();
    });
  }
  if(frameColorHex){
    frameColorHex.addEventListener('input', ()=>{
      const n = normalizeHex(frameColorHex.value); if(!n) return;
      state.frameColor = n;

      if (state.seriesEnabled && hasSeriesRows()){
        clampSeriesIndex();
        setFrameColorForIndex(state.seriesIndex, state.frameColor);
        if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
      }

      syncFrameColorInputs();
      applyFrameColor();
    });
  }
  if(frameColorReset){
    frameColorReset.addEventListener('click', ()=>{
      state.frameColor = FRAME_COLOR_DEFAULT;

      if (state.seriesEnabled && hasSeriesRows()){
        clampSeriesIndex();
        setFrameColorForIndex(state.seriesIndex, state.frameColor);
        if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
      }

      syncFrameColorInputs();
      applyFrameColor();
    });
  }
  if(monthlyFrameColorPicker){
    monthlyFrameColorPicker.addEventListener('input', ()=>{
      state.frameColor = monthlyFrameColorPicker.value || FRAME_COLOR_DEFAULT;
      syncFrameColorInputs();
      applyFrameColor();
      updatePreview();
      if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
    });
  }
  if(monthlyFrameColorHex){
    monthlyFrameColorHex.addEventListener('input', ()=>{
      const n = normalizeHex(monthlyFrameColorHex.value); if(!n) return;
      state.frameColor = n;
      syncFrameColorInputs();
      applyFrameColor();
      updatePreview();
      if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
    });
  }
  if(monthlyFrameColorReset){
    monthlyFrameColorReset.addEventListener('click', ()=>{
      state.frameColor = FRAME_COLOR_DEFAULT;
      syncFrameColorInputs();
      applyFrameColor();
      updatePreview();
      if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
    });
  }

  syncFrameColorInputs();
  applyFrameColor();

if (pvFrameRect){
  pvFrameRect.addEventListener('click', ()=>{
    const tot = totalSteps();
    if (state.step !== tot) return;   // nur aus der Vorschau heraus
    setStep(8);
  });
}

  /* ===== Delivery (PDF / Print) + Papierwahl ===== */
  const deliveryOptionsEl   = $('deliveryOptions');
  const printPaperOptionsEl = $('printPaperOptions');

  function applyDeliverySelectionUI(){
    if(!deliveryOptionsEl) return;
    deliveryOptionsEl.querySelectorAll('.delivery-option').forEach(label=>{
      const inp = label.querySelector('input[type="radio"]');
      label.classList.toggle('active', inp && inp.checked);
    });
  }
  function applyPaperSelectionUI(){
    if(!printPaperOptionsEl) return;
    printPaperOptionsEl.querySelectorAll('.paper-option').forEach(label=>{
      const inp = label.querySelector('input[name="paperType"]');
      const active = inp && inp.value === state.paperType && (state.mode!=='cert' || state.delivery==='print');
      label.classList.toggle('active', active);
    });
  }
  function togglePaperOptions(){
    if(!printPaperOptionsEl) return;

    if(state.mode === 'gift' || state.mode === 'label'){
      // Im No-Tree-Extras-Modus KEINE Papierauswahl anzeigen
      printPaperOptionsEl.style.display = state.noTreeExtrasMode ? 'none' : 'flex';
    }else{
      if(state.delivery === 'print'){ printPaperOptionsEl.style.display='flex'; }
      else{ printPaperOptionsEl.style.display='none'; }
    }

    applyPaperSelectionUI();
  }

    // --- NEU: Step 9 komplett deaktivieren im Customer-Edit ---
  function disableStep9ForCustomer(){
    if (!isLockedEdit) return;
    const step9 = $('step9');
    if (!step9) return;

    // Info-Text anpassen
    const intro = step9.querySelector('.wiz-intro');
    const hint  = step9.querySelector('.wiz-hint');
    if (intro){
      intro.textContent = 'Versandart und Extras wurden bei deiner Bestellung festgelegt.';
    }
    if (hint){
      hint.textContent = 'Diese Angaben können nach dem Kauf nicht mehr geändert werden.';
    }

    // Alle Eingaben in Step 9 deaktivieren
    step9.querySelectorAll('input, button, label').forEach(el=>{
      if (el.tagName === 'LABEL'){
        el.style.opacity = '0.65';
        el.style.cursor  = 'not-allowed';
      } else {
        el.disabled = true;
        el.style.cursor = 'not-allowed';
      }
    });
  }

  if(deliveryOptionsEl){
    if(state.mode === 'gift' || state.mode === 'label'){
      const printRadio  = deliveryOptionsEl.querySelector('input[name="delivery"][value="print"]');
      const digitalRadio= deliveryOptionsEl.querySelector('input[name="delivery"][value="digital"]');
      if(printRadio){ printRadio.checked = true; }
      if(digitalRadio){ digitalRadio.checked = false; }
      state.delivery = 'print';
    }

    deliveryOptionsEl.addEventListener('change', e=>{
      const inp = e.target.closest('input[type="radio"]'); if(!inp) return;
      state.delivery = inp.value || 'digital';

      // Serienmodus: Wert für das aktuelle Zertifikat merken
      if (state.seriesEnabled && hasSeriesRows()){
        clampSeriesIndex();
        setDeliveryForIndex(state.seriesIndex, state.delivery);
        if (!hasEditOrClone && DRAFT_KEY){
          scheduleDraftSave();
        }
      }

      applyDeliverySelectionUI();
      togglePaperOptions();
      updatePrice();
      updateMetaBar();
      updatePreview();
    });
    applyDeliverySelectionUI();
  }

  if(printPaperOptionsEl){
    printPaperOptionsEl.addEventListener('change', e=>{
      const inp = e.target.closest('input[name="paperType"]'); if(!inp) return;
      state.paperType = inp.value || 'white';

      // Serienmodus: Papier-Typ für das aktuelle Zertifikat merken
      if (state.seriesEnabled && hasSeriesRows()){
        clampSeriesIndex();
        setPaperTypeForIndex(state.seriesIndex, state.paperType);
        if (!hasEditOrClone && DRAFT_KEY){
          scheduleDraftSave();
        }
      }

      applyPaperSelectionUI();
      updatePrice();
      updateMetaBar();
      updatePreview();
    });
  }
  togglePaperOptions();

    // NEU: Step 9 für Kund:innen im Edit-Modus sperren
  disableStep9ForCustomer();

  function setLabelBorderColor(hex){
    const n = normalizeAndEnsureHex(hex) || FRAME_COLOR_DEFAULT;
    state.labelBorderColor = n;

    document.documentElement.style.setProperty('--label-border', n);

    const e = $('labelInnerEdit');
    const f = $('labelInnerFinal');
    if (e) e.style.setProperty('--label-border', n);
    if (f) f.style.setProperty('--label-border', n);

    const picker = $('labelBorderColorPicker');
    const hexIn  = $('labelBorderHex');
    if (picker) picker.value = n;
    if (hexIn)  hexIn.value  = n;
  }

  // Bookmark-Designs (Eule / Libelle / Ginkgo) optisch & radio-checked halten
  function setBookmarkDesignUI(){
    const designs = [
      { code:'eule',    el: $('bookmarkDesignEule') },
      { code:'libelle', el: $('bookmarkDesignLibelle') },
      { code:'ginkgo',  el: $('bookmarkDesignGinkgo') }
    ];
    const current = state.bookmarkChoice;
    designs.forEach(d=>{
      if(!d.el) return;
      const input = d.el.querySelector('input[type="radio"]');
      const active = state.bookmarkSelected && current === d.code;
      d.el.classList.toggle('active', active);
      if(input) input.checked = active;
    });
  }

  // Gift-/Label-Extras (Verpackung, Gimmick, Stecker, Lesezeichen) sichtbar/unsichtbar schalten
  // Gift-/Label-Extras (Verpackung, Gimmick, Stecker, Lesezeichen) sichtbar/unsichtbar schalten
  function syncGiftExtrasFromState(){
    if(state.mode !== 'gift' && state.mode !== 'label') return;

    const giftWrapStepEl      = $('giftWrapStep');
    const giftWrapOptionEl    = $('giftWrapOption');
    const giftWrapCheckbox    = $('giftWrapCheckbox');
    const giftGimmickOptionEl = $('giftGimmickOption');
    const giftGimmickCheckbox = $('giftGimmickCheckbox');

    const extrasStep          = $('giftExtrasStep');
    const extraHeartOption    = $('extraHeartOption');
    const extraHeartCheckbox  = $('extraHeartCheckbox');
    const extraJustOption     = $('extraJustOption');
    const extraJustCheckbox   = $('extraJustCheckbox');
    const bookmarkOption      = $('bookmarkOption');
    const bookmarkCheckbox    = $('bookmarkCheckbox');

    const hasWrap = !!state.giftwrapAvailable;
    const hasGim  = !!(state.gimmickAvailable && state.gimmickConfig);

    const hasAnyExtra =
      (state.extraHeartAvailable || state.extraJustAvailable || state.bookmarkAvailable) &&
      (state.mode === 'gift' || state.mode === 'label');

    if(giftWrapStepEl){
      giftWrapStepEl.style.display = (hasWrap || hasGim) ? 'block' : 'none';
    }

    if(giftWrapOptionEl && giftWrapCheckbox){
      giftWrapOptionEl.style.display = hasWrap ? 'flex' : 'none';
      giftWrapCheckbox.checked       = hasWrap && !!state.giftwrapSelected;
      giftWrapOptionEl.classList.toggle('active', giftWrapCheckbox.checked);
    }

    if(giftGimmickOptionEl && giftGimmickCheckbox){
      giftGimmickOptionEl.style.display = hasGim ? 'flex' : 'none';
      giftGimmickCheckbox.checked       = hasGim && !!state.gimmickSelected;
      giftGimmickOptionEl.classList.toggle('active', giftGimmickCheckbox.checked);
    }

    // Deko-Extras
    if(extrasStep){
      extrasStep.style.display = hasAnyExtra ? 'block' : 'none';
    }

    if(extraHeartOption && extraHeartCheckbox){
      extraHeartOption.style.display = state.extraHeartAvailable ? 'flex' : 'none';
      extraHeartCheckbox.checked     = !!state.extraHeartSelected;
      extraHeartOption.classList.toggle('active', !!state.extraHeartSelected);
    }

    if(extraJustOption && extraJustCheckbox){
      extraJustOption.style.display = state.extraJustAvailable ? 'flex' : 'none';
      extraJustCheckbox.checked     = !!state.extraJustSelected;
      extraJustOption.classList.toggle('active', !!state.extraJustSelected);
    }

    if(bookmarkOption && bookmarkCheckbox){
      if(state.bookmarkAvailable){
        bookmarkOption.style.display = 'flex';

        // Wenn Lesezeichen aktiv ist, Standard-Motiv setzen
        if(state.bookmarkSelected && !state.bookmarkChoice){
          state.bookmarkChoice = 'eule';
        }

        bookmarkCheckbox.checked = !!state.bookmarkSelected;
        const isOn = !!state.bookmarkSelected;

        // Optischer "aktiv"-State der Karte
        bookmarkOption.classList.toggle('active', isOn);
        // steuert, ob die drei Motive sichtbar sind
        bookmarkOption.classList.toggle('bookmark-open', isOn);
      }else{
        bookmarkOption.style.display = 'none';
        bookmarkOption.classList.remove('bookmark-open');
      }
    }

    setBookmarkDesignUI();
  }

  /* Gift-/Label-Modus: UI initialisieren */
  /* Gift-/Label-Modus: UI initialisieren */
  function initGiftModeUI(){
    if(state.mode !== 'gift' && state.mode !== 'label') return;

    const giftProductCard  = $('giftProductCard');
    const giftProductImg   = $('giftProductImg');
    const giftProductTitle = $('giftProductTitle');

    if(giftProductCard && (state.giftTitle || state.giftImg)){
      giftProductCard.style.display = 'flex';
      if(giftProductTitle && state.giftTitle){ giftProductTitle.textContent = state.giftTitle; }
      if(giftProductImg && state.giftImg){
        giftProductImg.src = state.giftImg;
        giftProductImg.alt = state.giftTitle || 'Geschenk';
      }
    }

    const giftWrapStepEl      = $('giftWrapStep');
    const giftWrapOptionEl    = $('giftWrapOption');
    const giftWrapCheckbox    = $('giftWrapCheckbox');
    const giftGimmickOptionEl = $('giftGimmickOption');
    const giftGimmickCheckbox = $('giftGimmickCheckbox');
    const extrasStepEl        = $('giftExtrasStep');
    const greetCardStepEl     = $('greetCardStep');
    const printPaperOptionsEl = $('printPaperOptions');

    /* Nur einmal: alle Add-on-Blöcke in ein gemeinsames Grid (#step9 .pt-extras-grid) packen */
    if(!giftUiInited){
      giftUiInited = true;

      const step9Block = document.querySelector('#step9 .wiz-field-block');
      if(step9Block){
        const extrasGrid = document.createElement('div');
        extrasGrid.className = 'pt-extras-grid';

        [printPaperOptionsEl, giftWrapStepEl, extrasStepEl, greetCardStepEl].forEach(node=>{
          if(node && step9Block.contains(node)){
            extrasGrid.appendChild(node);
          }
        });

        step9Block.appendChild(extrasGrid);

        // NEU: Original-Grid referenzieren, damit wir die Extras zurückholen können
        step9ExtrasGrid = extrasGrid;
      }
    }else{
      // Eventhandler sind schon gebunden – nur UI aktualisieren und raus
      syncGiftExtrasFromState();
      return;
    }

    // Geschenkverpackung
    if(giftWrapCheckbox){
      giftWrapCheckbox.addEventListener('change', ()=>{
        state.giftwrapSelected = !!giftWrapCheckbox.checked;
        syncGiftExtrasFromState();
        updatePrice();
      });
    }
    if(giftWrapOptionEl && giftWrapCheckbox){
      giftWrapOptionEl.addEventListener('click',(e)=>{
        if(e.target.tagName === 'INPUT') return;
        giftWrapCheckbox.checked   = !giftWrapCheckbox.checked;
        state.giftwrapSelected     = !!giftWrapCheckbox.checked;
        syncGiftExtrasFromState();
        updatePrice();
      });
    }

    // Gimmick (Ofenhandschuh)
    if(giftGimmickCheckbox){
      giftGimmickCheckbox.addEventListener('change', ()=>{
        state.gimmickSelected = !!giftGimmickCheckbox.checked;
        syncGiftExtrasFromState();
        updatePrice();
      });
    }
    if(giftGimmickOptionEl && giftGimmickCheckbox){
      giftGimmickOptionEl.addEventListener('click',(e)=>{
        if(e.target.tagName === 'INPUT') return;
        giftGimmickCheckbox.checked = !giftGimmickCheckbox.checked;
        state.gimmickSelected       = !!giftGimmickCheckbox.checked;
        syncGiftExtrasFromState();
        updatePrice();
      });
    }

    // Herz-Stecker
    const extraHeartCheckbox = $('extraHeartCheckbox');
    const extraHeartOption   = $('extraHeartOption');
    if(extraHeartCheckbox){
      extraHeartCheckbox.addEventListener('change', ()=>{
        state.extraHeartSelected = !!extraHeartCheckbox.checked;
        syncGiftExtrasFromState();
        updatePrice();
      });
    }
    if(extraHeartOption && extraHeartCheckbox){
      extraHeartOption.addEventListener('click', (e)=>{
        if(e.target.tagName === 'INPUT') return;
        extraHeartCheckbox.checked   = !extraHeartCheckbox.checked;
        state.extraHeartSelected     = !!extraHeartCheckbox.checked;
        syncGiftExtrasFromState();
        updatePrice();
      });
    }

    // Just-married-Stecker
    const extraJustCheckbox = $('extraJustCheckbox');
    const extraJustOption   = $('extraJustOption');
    if(extraJustCheckbox){
      extraJustCheckbox.addEventListener('change', ()=>{
        state.extraJustSelected = !!extraJustCheckbox.checked;
        syncGiftExtrasFromState();
        updatePrice();
      });
    }
    if(extraJustOption && extraJustCheckbox){
      extraJustOption.addEventListener('click', (e)=>{
        if(e.target.tagName === 'INPUT') return;
        extraJustCheckbox.checked   = !extraJustCheckbox.checked;
        state.extraJustSelected     = !!extraJustCheckbox.checked;
        syncGiftExtrasFromState();
        updatePrice();
      });
    }

    // Bookmark + Motiv-Auswahl
    const bookmarkCheckbox     = $('bookmarkCheckbox');
    const bookmarkOption       = $('bookmarkOption');
    const bookmarkDesignRadios = document.querySelectorAll('.bookmark-design input[name="bookmarkDesign"]');

    if(bookmarkCheckbox){
      bookmarkCheckbox.addEventListener('change', ()=>{
        state.bookmarkSelected = !!bookmarkCheckbox.checked;
        if(!state.bookmarkSelected){
          state.bookmarkChoice = null;
        }else if(!state.bookmarkChoice){
          state.bookmarkChoice = 'eule';
        }
        syncGiftExtrasFromState();
        updatePrice();
      });
    }
    if(bookmarkOption && bookmarkCheckbox){
      bookmarkOption.addEventListener('click', (e)=>{
        if(e.target.tagName === 'INPUT' || e.target.closest('.bookmark-design')) return;
        bookmarkCheckbox.checked   = !bookmarkCheckbox.checked;
        state.bookmarkSelected     = !!bookmarkCheckbox.checked;
        if(state.bookmarkSelected && !state.bookmarkChoice){
          state.bookmarkChoice = 'eule';
        }
        syncGiftExtrasFromState();
        updatePrice();
      });
    }
    if(bookmarkDesignRadios && bookmarkDesignRadios.length){
      bookmarkDesignRadios.forEach(inp=>{
        inp.addEventListener('change', ()=>{
          if(!inp.checked) return;
          const value = inp.value || (inp.closest('.bookmark-design') && inp.closest('.bookmark-design').dataset.design) || 'eule';
          state.bookmarkSelected = true;
          state.bookmarkChoice   = value;
          if(bookmarkCheckbox) bookmarkCheckbox.checked = true;

          const bookmarkOptionEl = $('bookmarkOption');
          if(bookmarkOptionEl){
            bookmarkOptionEl.classList.add('bookmark-open');
          }

          syncGiftExtrasFromState();
          updatePrice();
        });
      });
    }

    // zum Schluss alles einmal sauber setzen
    syncGiftExtrasFromState();
  }





  function setGreetCardReadonly(on){
    [gcTxt1, gcTxt2, gcTxt3].forEach(el=>{
      if(!el) return;
      el.readOnly = !!on;
      el.style.pointerEvents = on ? 'none' : '';
    });
  }

function syncGreetCardUI(){
  const stepEl = $('greetCardStep');
  const optEl  = $('greetCardOption');
  const cb     = $('greetCardCheckbox');
  const block  = $('greetCardBlock');

  // Serienmodus im cert-Mode: Grußkarte komplett deaktivieren + ausblenden
  if (state.mode === 'cert' && state.seriesEnabled){
    state.greetCardSelected = false;

    if (stepEl) stepEl.style.display = 'none';
    if (optEl){
      optEl.style.display = 'none';
      optEl.classList.remove('active');
    }
    if (cb){
      cb.checked  = false;
      cb.disabled = true;
    }
    if (block) block.style.display = 'none';

    const ribbon10 = $('greetCardRibbon10');
    const ribbon11 = $('greetCardRibbon11');
    if (ribbon10) ribbon10.style.display = 'none';
    if (ribbon11) ribbon11.style.display = 'none';

    return;
  }

  const available = !!(VARIANTS.greetingCardPaid || VARIANTS.greetingCardFree);
  if (stepEl){
    stepEl.style.display = available ? 'block' : 'none';
  }
  if (!available){
    if (block) block.style.display = 'none';
    state.greetCardSelected = false;
    return;
  }

  const tot       = totalSteps();
  const greetStep = (state.mode === 'label') ? 11 : 10;
  const inEdit    = (state.step === greetStep);
  const inPreview = (state.step === tot) && state.greetCardSelected;

  const ribbon10 = $('greetCardRibbon10');
  const ribbon11 = $('greetCardRibbon11');
  const hintEl   = block ? block.querySelector('.greetcard-hint') : null;

  const originallySelected = !!state.greetCardOriginallySelected;

  // Kund:innen-Edit: Karte darf nicht neu hinzugefügt werden
  if (isLockedEdit) {
    if (!originallySelected) {
      // Kunde hat KEINE Grußkarte gebucht → Option nur informativ
      state.greetCardSelected = false;

      if (cb) {
        cb.checked  = false;
        cb.disabled = true;
      }
      if (optEl) {
        optEl.classList.remove('active');
        optEl.style.cursor = 'not-allowed';
        optEl.style.display = 'block';              // sicherheitshalber sichtbar lassen
      }
      if (block) {
        block.style.display = 'none';
      }
      if (ribbon10) ribbon10.style.display = 'none';
      if (ribbon11) ribbon11.style.display = 'none';
      if (hintEl) {
        hintEl.style.display = 'none';
      }

      const stepHint = stepEl ? stepEl.querySelector('.wiz-hint') : null;
      if (stepHint) {
        stepHint.textContent =
          'Du hast bei deiner Bestellung keine Grußkarte gebucht. ' +
          'Im Änderungsmodus kann diese Option nicht neu hinzugefügt werden.';
      }
      return;
    } else {
      // Kunde HAT eine Grußkarte gebucht → immer aktiv, aber nicht abwählbar
      state.greetCardSelected = true;

      if (cb) {
        cb.checked  = true;
        cb.disabled = true;
      }
      if (optEl) {
        optEl.style.display = 'block';
        optEl.classList.add('active');
        optEl.style.cursor = 'default';
      }
      if (block && (inEdit || inPreview)) {
        block.style.display = 'block';
        scaleGreetingCard();
      }
      if (ribbon10) {
        ribbon10.style.display =
          (inPreview && state.mode !== 'label' && state.greetCardSelected) ? 'block' : 'none';
      }
      if (ribbon11) {
        ribbon11.style.display =
          (inPreview && state.mode === 'label' && state.greetCardSelected) ? 'block' : 'none';
      }
      if (hintEl) {
        if (inEdit) {
          hintEl.style.display = 'block';
          hintEl.textContent =
            'Du hast bei deiner Bestellung eine Grußkarte gebucht. ' +
            'Hier kannst du den Text oder die Fotos korrigieren.';
        } else {
          hintEl.style.display = 'none';
        }
      }
      return;
    }
  }

  // ===== normales Verhalten (Neukauf / Draft) =====

  // Checkbox + Karte aktiv/inaktiv
  if (cb){
    cb.disabled = false;                                   // <--- WICHTIG: wieder aktiv machen
    cb.checked  = !!state.greetCardSelected;
  }
  if (optEl){
    optEl.style.display = 'block';                         // <--- WICHTIG: wieder einblenden
    optEl.classList.toggle('active', !!state.greetCardSelected);
  }

  // Block nur anzeigen, wenn ausgewählt und wir im Grußkarten-Step oder in der Vorschau sind
  if (block){
    if ((inEdit || inPreview) && state.greetCardSelected){
      block.style.display = 'block';
      scaleGreetingCard();
    } else {
      block.style.display = 'none';
    }
  }

  // Preview-Ribbons
  if (ribbon10){
    ribbon10.style.display =
      (inPreview && state.mode !== 'label' && state.greetCardSelected) ? 'block' : 'none';
  }
  if (ribbon11){
    ribbon11.style.display =
      (inPreview && state.mode === 'label' && state.greetCardSelected) ? 'block' : 'none';
  }

  // Hinweistext + Platzhalter
  if (hintEl){
    if (inEdit){
      hintEl.style.display = 'block';
      hintEl.textContent =
        'Klicke zum Bearbeiten in die Felder oder wähle unten den Foto-Upload.';
      setGreetPlaceholdersVisible(true);
    } else {
      hintEl.style.display = 'none';
      setGreetPlaceholdersVisible(false);
    }
  }
}

const greetCardCheckbox = $('greetCardCheckbox');
const greetCardOption   = $('greetCardOption');

if(greetCardCheckbox){
  greetCardCheckbox.addEventListener('change', ()=>{
    // Im Kunden-Edit darf die Auswahl NICHT geändert werden
    if (isLockedEdit) {
      greetCardCheckbox.checked = !!state.greetCardOriginallySelected;
      state.greetCardSelected   = !!state.greetCardOriginallySelected;
      syncGreetCardUI();
      return;
    }

    state.greetCardSelected = !!greetCardCheckbox.checked;
    syncGreetCardUI();
    updatePrice();
    if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
  });
}

if(greetCardOption && greetCardCheckbox){
  greetCardOption.addEventListener('click', (e)=>{
    if(e.target.tagName === 'INPUT') return;

    // Im Kunden-Edit:
    if (isLockedEdit) {
      if (state.greetCardOriginallySelected){
        // Karte war gebucht → ggf. direkt in den Grußkarten-Step springen
        state.greetCardSelected   = true;
        greetCardCheckbox.checked = true;
        syncGreetCardUI();

        const tot       = totalSteps();
        const greetStep = (state.mode === 'label') ? 11 : 10;
        if (state.step !== greetStep && state.step !== tot){
          setStep(greetStep);
        }
      }
      // war nicht gebucht → Klick macht nichts
      return;
    }

    // Normales Verhalten (Neukauf)
    greetCardCheckbox.checked = !greetCardCheckbox.checked;
    state.greetCardSelected   = !!greetCardCheckbox.checked;
    syncGreetCardUI();
    updatePrice();
    if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
  });
}

  /* ===== A4 Preview Layout ===== */
  function placeA4Boxes(){
    const FRAME=120, GAP=120; const L=(FRAME+GAP); const W=(2480-2*(FRAME+GAP));
    const TOP1=0.06, H1=0.12;
    const TOP2=0.225, H2=0.14;
    const TOP3=0.60, H3=0.14;

    const T1=Math.round(3508*TOP1);
    const Hh1=Math.round(3508*H1);
    const T2=Math.round(3508*TOP2);
    const Hh2=Math.round(3508*H2);
    const T3=Math.round(3508*TOP3);
    const Hh3=Math.round(3508*H3);

  if(pvBox1){ pvBox1.style.left=L+'px'; pvBox1.style.top=T1+'px'; pvBox1.style.width=W+'px'; pvBox1.style.height=Hh1+'px'; }
  if(pvBox4){ pvBox4.style.left=L+'px'; pvBox4.style.top=T2+'px'; pvBox4.style.width=W+'px'; pvBox4.style.height=Hh2+'px'; }
  if(pvBox6){ pvBox6.style.left=L+'px'; pvBox6.style.top=T3+'px'; pvBox6.style.width=W+'px'; pvBox6.style.height=Hh3+'px'; }

      // --- B2B Monatszertifikat: Box-Override IMMER anwenden (auch beim PNG-Render) ---
  if (isB2B && state.mode === 'cert' && (FORCE_MONTHLY_RENDER || isMonthlyCertState())){
    const pvBox4El = $('pvBox4');
    const pvBox6El = $('pvBox6');
    const treeEl = document.querySelector('.decor-tree-final');
    const treeHotspot = document.querySelector('.pv-tree-hotspot');
    if (pvBox4El){
      const CLAIM_TOP = 640;
      const GAP_AFTER_CLAIM = isB2BEventCertificatePhase() ? 92 : 188;
      pvBox4El.style.top    = (CLAIM_TOP + GAP_AFTER_CLAIM) + 'px';
      pvBox4El.style.height = '480px';
    }
	    if (isB2BEventCertificatePhase()){
	      if (pvBox6El){
	        pvBox6El.style.top = '2085px';
	        pvBox6El.style.height = '170px';
	      }
	      if (treeEl){
	        treeEl.style.setProperty('top', '1375px', 'important');
	        treeEl.style.setProperty('width', '520px', 'important');
	      }
	      if (treeHotspot){
	        treeHotspot.style.setProperty('top', '1295px', 'important');
	        treeHotspot.style.setProperty('width', '520px', 'important');
	      }
	    } else {
      if (pvBox6El){
        pvBox6El.style.removeProperty('top');
        pvBox6El.style.removeProperty('height');
      }
	      if (treeEl){
	        treeEl.style.removeProperty('top');
	        treeEl.style.removeProperty('width');
	      }
	      if (treeHotspot){
	        treeHotspot.style.removeProperty('top');
	        treeHotspot.style.removeProperty('width');
	      }
	    }
  }    
  }

function scaleA4(){
  const stage = $('pvStageFinal');
  const inner = $('pvInnerFinal');
  if(!stage || !inner) return;

  inner.style.transform = 'translateX(-50%) scale(1)';

  const w = stage.getBoundingClientRect().width || 0;
  if(w < 10){
    requestAnimationFrame(scaleA4);
    return;
  }

  let maxH = (window.innerHeight || 800) - 260; // oben/unten etwas Luft
  const kW   = w / 2480;
  const useWidthOnly =
    !!(isB2BPersonalizedPortalFlow() && state.mode === 'cert' && state.step === totalSteps());
  const kH   = maxH > 0 ? maxH / 3508 : kW;
  const k    = useWidthOnly ? Math.min(1, kW * 0.88) : Math.min(1, kW, kH);

  inner.style.transform = 'translateX(-50%) scale('+k+')';
  stage.style.height    = (3508 * k) + 'px';
}

  function textForPreview(textarea,placeholder){
    const v=(textarea.value||'').trim();
    return v || placeholder;
  }

  function fileToDataURL(file){
    return new Promise((resolve,reject)=>{
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function fitPreviewText(pvText, baseFS, boxW, boxH, maxLines){
    if(!pvText || !boxW || !boxH) return;
    pvText.style.fontSize = baseFS + 'px';

    const linesArr = (pvText.textContent || '').split('\n');
    const lineCount = linesArr.filter(l => l !== '').length || 1;
    const maxL = maxLines || 2;
    const linesUsed = Math.min(maxL, lineCount);

    let fs = baseFS;
    const minFs = Math.max(32, Math.round(baseFS * 0.45));

    while(fs > minFs){
      syncProbe(fs, pvText);
      let widest = 0;
      for(const line of linesArr){
        const txt = line || '';
        probe.textContent = txt;
        const w = probe.getBoundingClientRect().width;
        if(w > widest) widest = w;
      }
      const lh    = fs * 1.06;
      const lines = linesUsed || 1;

      if(widest > boxW - 40 || lines * lh > boxH - 40){
        fs--;
        continue;
      }
      break;
    }

    fs = Math.max(minFs, Math.min(baseFS, fs));
    pvText.style.fontSize = fs + 'px';
  }

  // ===== Empfänger (pvTxt4): Zeile 2 kleiner (Serienmodus) =====
function clearRecipientTwoLine(pvEl){
  if(!pvEl) return;
  pvEl.classList.remove('pv-rec-two');
  pvEl.style.removeProperty('--pv-rec-line2-scale');
}

function setRecipientTwoLine(pvEl, line1, line2){
  if(!pvEl) return;
  pvEl.classList.add('pv-rec-two');
  pvEl.innerHTML = '';

  const s1 = document.createElement('span');
  s1.className = 'pv-rec-line1';
  s1.textContent = line1 || '';

  const s2 = document.createElement('span');
  s2.className = 'pv-rec-line2';
  s2.textContent = line2 || '';

  pvEl.appendChild(s1);
  pvEl.appendChild(document.createTextNode('\n')); // wichtig: Snapshot bekommt \n
  pvEl.appendChild(s2);
}

function fitRecipientTwoLine(pvEl, line1, line2, baseFS, boxW, boxH, scale2){
  if(!pvEl || !boxW || !boxH) return;
  scale2 = (typeof scale2 === 'number' && scale2 > 0 && scale2 < 1) ? scale2 : 0.72;

  let fs = baseFS;
  const minFs = Math.max(32, Math.round(baseFS * 0.45));
  const lh = 1.06;
  const mt = 0.18; // margin-top in em (wie im CSS)

  while(fs > minFs){
    // Breite Zeile 1
    syncProbe(fs, pvEl);
    probe.textContent = line1 || '';
    const w1 = probe.getBoundingClientRect().width;

    // Breite Zeile 2 (kleiner)
    syncProbe(fs * scale2, pvEl);
    probe.textContent = line2 || '';
    const w2 = probe.getBoundingClientRect().width;

    const widest = Math.max(w1, w2);

    // Höhe: Zeile1 + Zeile2 + kleiner Abstand
    const h = (fs * lh) + (fs * scale2 * lh) + (fs * mt);

    if (widest > boxW - 40 || h > boxH - 40){
      fs--;
      continue;
    }
    break;
  }

  pvEl.style.fontSize = fs + 'px';
  pvEl.style.setProperty('--pv-rec-line2-scale', String(scale2));
}


  // Label-Colorpicker → live in den Rahmen schreiben
  const labelBorderPicker = $('labelBorderColorPicker');
  const labelBorderHex    = $('labelBorderHex');
  const labelColorFromCert = $('labelColorFromCert');
  const labelColorReset    = $('labelColorReset');

  const labelTextFromCert = $('labelTextFromCert');
if (labelTextFromCert){
  labelTextFromCert.addEventListener('click', (e)=>{
    e.preventDefault();
    copyLabelTextFromCertificate();
  });
}

  if (labelColorFromCert){
    labelColorFromCert.addEventListener('click', ()=>{
      const src = state.frameColor || FRAME_COLOR_DEFAULT;
      setLabelBorderColor(src);
      fitLabelLines();
    });
  }

  if (labelColorReset){
    labelColorReset.addEventListener('click', ()=>{
      setLabelBorderColor(FRAME_COLOR_DEFAULT);
      fitLabelLines();
    });
  }

  if (labelBorderPicker) {
    labelBorderPicker.addEventListener('input', () => {
      const val = labelBorderPicker.value
        || state.labelBorderColor
        || state.frameColor
        || FRAME_COLOR_DEFAULT;
      setLabelBorderColor(val);
      fitLabelLines();
    });
  }

  if (labelBorderHex) {
    labelBorderHex.addEventListener('input', () => {
      const n = normalizeHex(labelBorderHex.value);
      if (!n) return;
      setLabelBorderColor(n);
      fitLabelLines();
    });
  }

  function singleLine(s){
    return (s || '').replace(/\r?\n/g,' ')
                    .replace(/\s+/g,' ')
                    .trim();
  }

  // Initial: Label-Rand wie Zertifikatsrahmen, Texte leer (mit Placeholder im DOM)
  function initLabelDefaultsFromSteps(){
    const initial = state.labelBorderColor || state.frameColor || FRAME_COLOR_DEFAULT;
    setLabelBorderColor(initial);
    updateLabelEdit();
    updateLabelFinal();
  }

  // Edit-Ansicht im Wizard (Step 10)
  function updateLabelEdit(){
    const l1 = $('lbELine1');
    const l2 = $('lbELine2');
    const l3 = $('lbELine3');
    const cl = $('lbEClaim');

    const line1 = (state.labelLine1 || '').slice(0, 50);
    const line2 = (state.labelLine2 || '').slice(0, 50);
    const line3 = (state.labelLine3 || '').slice(0, 50);

    if(l1) l1.textContent = line1;
    if(l2) l2.textContent = line2;
    if(l3) l3.textContent = line3;

    if(cl) cl.textContent = buildClaim();

    fitLabelLines();
  }

  // Finale Label-Vorschau (Step 11)
  function updateLabelFinal(){
    const l1 = $('lbFLine1');
    const l2 = $('lbFLine2');
    const l3 = $('lbFLine3');
    const cl = $('lbFClaim');

    const line1 = (state.labelLine1 || '').slice(0, 50);
    const line2 = (state.labelLine2 || '').slice(0, 50);
    const line3 = (state.labelLine3 || '').slice(0, 50);

    if(l1) l1.textContent = line1.toUpperCase();
    if(l2) l2.textContent = line2.toUpperCase();
    if(l3) l3.textContent = line3.toUpperCase();
    if(cl) cl.textContent = buildClaim();

    setLabelBorderColor(state.labelBorderColor || state.frameColor || FRAME_COLOR_DEFAULT);
    applyForestToLabel();
    fitLabelLines();
  }

  // CSS-Variable lesen (für Basis-Fontgrößen)
  function getCssNumberVar(name, fallback){
    try{
      const cs  = getComputedStyle(document.documentElement);
      const raw = cs.getPropertyValue(name);
      const n   = parseFloat(raw);
      return (isFinite(n) ? n : fallback);
    }catch(e){
      return fallback;
    }
  }

  // Prüft, ob ein Element horizontal überläuft
  function labelOverflows(el){
    if (!el) return false;
    const cw = el.clientWidth;
    if (!cw) return false;
    return el.scrollWidth > cw + 0.5;
  }

  // Passt eine Zeile (Edit + Final) so an, dass sie möglichst groß ist,
  // aber nicht über den Rahmen hinausläuft.
  function fitLabelLinePair(editId, finalId, basePx){
    const editEl  = document.getElementById(editId);
    const finalEl = document.getElementById(finalId);
    if (!editEl && !finalEl) return;

    const sample = editEl || finalEl;
    if (!sample || !sample.clientWidth) return;

    const minPx = Math.max(24, Math.round(basePx * 0.4));
    const maxPx = basePx * 1.5;

    function applySize(px){
      if (editEl)  editEl.style.fontSize  = px + 'px';
      if (finalEl) finalEl.style.fontSize = px + 'px';
    }

    let low  = minPx;
    let high = maxPx;
    let best = minPx;

    for (let i = 0; i < 8; i++){
      const mid = (low + high) / 2;
      applySize(mid);

      if (labelOverflows(editEl) || labelOverflows(finalEl)){
        high = mid;
      } else {
        best = mid;
        low  = mid;
      }
    }

    applySize(best);
  }

  function fitLabelLines(){
    if (state.step !== 10 && state.step !== 11) return;

    const baseLine1 = getCssNumberVar('--label-line1-size', 240);
    const baseLine2 = getCssNumberVar('--label-line2-size', 320);
    const baseLine3 = getCssNumberVar('--label-line3-size', 220);
    const baseClaim = getCssNumberVar('--label-claim-size', 200);

    fitLabelLinePair('lbELine1', 'lbFLine1', baseLine1);
    fitLabelLinePair('lbELine2', 'lbFLine2', baseLine2);
    fitLabelLinePair('lbELine3', 'lbFLine3', baseLine3);
    fitLabelLinePair('lbEClaim', 'lbFClaim', baseClaim);
  }

  function scaleLabel(suffix){
    const stage = $('labelStage'+suffix);
    const inner = $('labelInner'+suffix);
    if(!stage || !inner) return;

    inner.style.transform = 'translateX(-50%) scale(1)';
    const w = stage.getBoundingClientRect().width || 0;
    if(w < 10){
      requestAnimationFrame(()=>scaleLabel(suffix));
      return;
    }
    const maxH = (window.innerHeight || 800) - 260;
    const kW = w / 3000;
    const kH = maxH > 0 ? maxH / 2000 : kW;
    const k  = Math.min(1, kW, kH);

    inner.style.transform = 'translateX(-50%) scale('+k+')';
    stage.style.height    = (2000 * k)+'px';
  }

  function copyLabelTextFromCertificate(){
  if (state.mode !== 'label') return;

  // Step-Textfelder: können leer sein, aber das ist ok
  const senderVal    = txt1 ? txt1.value : '';
  const recipientVal = txt4 ? txt4.value : '';
  const occasionVal  = txt6 ? txt6.value : '';

  // Erste Zeile + max. 50 Zeichen übernehmen
  state.labelLine1 = labelPickFirstLine(senderVal);
  state.labelLine2 = labelPickFirstLine(recipientVal);
  state.labelLine3 = labelPickFirstLine(occasionVal);

  // Markieren, dass der User das Etikett bewusst bearbeitet hat
  state.labelEdited1 = true;
  state.labelEdited2 = true;
  state.labelEdited3 = true;

  // UI aktualisieren
  updateLabelEdit();
  updateLabelFinal();
  fitLabelLines();

  // Draft speichern, falls aktiv
  if (!hasEditOrClone && DRAFT_KEY){
    scheduleDraftSave();
  }
}

  function scaleGreetingCard(){
    const stage=$('gcStage');
    const inner=$('gcInner');
    if(!stage || !inner) return;
    inner.style.transform='translateX(-50%) scale(1)';
    const w=stage.getBoundingClientRect().width || 0;
    if(w<10){
      requestAnimationFrame(scaleGreetingCard);
      return;
    }
    const maxH=(window.innerHeight||800)-260;
    const kW=w/2480;
    const kH=maxH>0?maxH/3508:kW;
    const k=Math.min(1,kW,kH);
    inner.style.transform='translateX(-50%) scale('+k+')';
    stage.style.height=(3508*k)+'px';
  }

    // Grußkarte in der Vorschau klickbar: zurück zu Schritt 9
  const gcStage = $('gcStage');
  if(gcStage){
    gcStage.style.cursor = 'pointer';
    gcStage.addEventListener('click', ()=>{
      const tot       = totalSteps();
      const greetStep = (state.mode === 'label') ? 11 : 10;
      if(state.greetCardSelected && state.step === tot){
        setStep(greetStep);
      }
    });
  }

  const onResize = debounce(() => {
    const tot       = totalSteps();
    const greetStep = (state.mode === 'label') ? 11 : 10;

    // Zertifikat (A4)
    if (state.step === 10 || state.step === 11){
      scaleA4();
    }

    // Label-Vorschau
    if (state.step === 10){
      scaleLabel('Edit');
    } else if (state.step === 11 && state.mode === 'label'){
      scaleLabel('Final');
    }

    // Grußkarte nur skalieren, wenn sie aktiv und sichtbar ist
    if (state.greetCardSelected && (state.step === greetStep || state.step === tot)){
      scaleGreetingCard();
    }
  }, 120);

  window.addEventListener('resize', onResize, { passive: true });

  function applyForestToLabel(){
    const showMV = (state.forest === 'mv');
    const showBY = (state.forest === 'by');
    const showRP = (state.forest === 'rp');

    const eMV=$('lbELogoForestMV'), eBY=$('lbELogoForestBY'), eRP=$('lbELogoForestRP');
    const fMV=$('lbFLogoForestMV'), fBY=$('lbFLogoForestBY'), fRP=$('lbFLogoForestRP');

    [eMV,fMV].forEach(el=>{ if(el) el.style.display = showMV ? 'block' : 'none'; });
    [eBY,fBY].forEach(el=>{ if(el) el.style.display = showBY ? 'block' : 'none'; });
    [eRP,fRP].forEach(el=>{ if(el) el.style.display = showRP ? 'block' : 'none'; });
  }

  function isControlKey(e){
    const code = e.key || '';
    const ctrl = e.ctrlKey || e.metaKey;

    if (ctrl) return true;

    const allowed = [
      'Backspace','Delete','ArrowLeft','ArrowRight','ArrowUp','ArrowDown',
      'Home','End','Tab'
    ];
    if (allowed.includes(code)) return true;

    if (code.startsWith('F') && code.length <= 3) return true;

    return false;
  }

  // Direkt im Etikett editieren (Step 10)
  function bindLabelInlineEditing(){
    const MAX_LABEL_CHARS = 50;

    const editableMap = [
      { id:'lbELine1', prop:'labelLine1', flag:'labelEdited1' },
      { id:'lbELine2', prop:'labelLine2', flag:'labelEdited2' },
      { id:'lbELine3', prop:'labelLine3', flag:'labelEdited3' }
    ];

    editableMap.forEach(cfg=>{
      const el = $(cfg.id); 
      if(!el) return;

      el.setAttribute('contenteditable','true');
      el.classList.add('label-editable');

      el.addEventListener('keydown',(e)=>{
        const text = singleLine(el.textContent || '');
        if (isControlKey(e)) return;

        if (text.length >= MAX_LABEL_CHARS){
          e.preventDefault();
        }
      });

      el.addEventListener('paste',(e)=>{
        e.preventDefault();
        const textBefore = singleLine(el.textContent || '');
        const remaining  = MAX_LABEL_CHARS - textBefore.length;
        if (remaining <= 0) return;

        const clipboard = (e.clipboardData || window.clipboardData).getData('text') || '';
        const insert    = singleLine(clipboard).slice(0, remaining);

        const final = (textBefore + insert).slice(0, MAX_LABEL_CHARS);
        el.textContent = final;
        
        state[cfg.prop] = final;
        state[cfg.flag] = true;
        updateLabelFinal();
        fitLabelLines();
      });

      el.addEventListener('input', ()=>{
        let val = singleLine(el.textContent || '');
        if (val.length > MAX_LABEL_CHARS){
          val = val.slice(0, MAX_LABEL_CHARS);
          el.textContent = val;
        }
        state[cfg.prop] = val;
        state[cfg.flag] = true;

        updateLabelFinal();
        fitLabelLines();
      });

      el.addEventListener('blur', ()=>{
        let val = singleLine(el.textContent || '');
        if (val.length > MAX_LABEL_CHARS){
          val = val.slice(0, MAX_LABEL_CHARS);
        }
        state[cfg.prop] = val;
        state[cfg.flag] = true;
        el.textContent  = state[cfg.prop];

        updateLabelFinal();
        fitLabelLines();
      });

      el.addEventListener('keydown', (e)=>{
        if(e.key === 'Enter'){
          e.preventDefault();
          el.blur();
        }
      });
    });
  }

  function appendTrIcinAfterRecipient(text){
  let v = String(text || '').replace(/\r/g,'').trim();
  if(!v) return v;

  // nicht doppelt anhängen
  if(/\biçin\b/i.test(v)) return v;

  let lines = v.split('\n').slice(0,2);

  // an letzte Zeile hängen (also "nach dem Namen")
  lines[lines.length - 1] = (lines[lines.length - 1] + ' için').trim();

  // safety: je Zeile max 50 Zeichen
  lines = lines.map(l => (l || '').slice(0,50));

  return lines.join('\n');
}



  /* ===== Preview ===== */
function updatePreview(){
  const innerFinal = $('pvInnerFinal');
  if (innerFinal){
    innerFinal.classList.toggle('is-monthly-cert', isMonthlyCertState());
  }
  try{ applyDecor(); }catch(_){}

  const summaryPartnerName =
    state &&
    state.b2bPortal &&
    isB2BSummaryOnlyPortalFlow()
      ? String(state.b2bPortal.partnerName || '').trim()
      : '';

  function syncPhotoWizardToPreview(boxWizard, imgWizard, photoState, pvBox, pvImg, pvText, textVal){
  const hasPhoto = imgWizard &&
    photoState.w > 0 &&
    photoState.h > 0 &&
    boxWizard &&
    pvBox;

  if(!hasPhoto){
    if(!textVal){
      if(pvImg) pvImg.style.display='none';
      if(pvText){
        pvText.textContent='';
        pvText.style.display='none';
      }
      return false;
    }
    if(pvImg) pvImg.style.display='none';
    if(pvText){
      pvText.style.display='block';
      pvText.textContent = textVal;
    }
    return false;
  }

  const wizRect = boxWizard.getBoundingClientRect();
  const wWiz = wizRect.width;
  const wPv  = parseFloat(pvBox.style.width) || pvBox.getBoundingClientRect().width;
  if(!wWiz || !wPv){
    if(pvImg) pvImg.style.display='none';
    if(pvText){
      pvText.style.display = textVal ? 'block' : 'none';
      pvText.textContent = textVal || '';
    }
    return false;
  }

  const k = wPv / wWiz;

  const scalePreview = photoState.scale * k;
  const offXPreview  = photoState.offX * k;
  const offYPreview  = photoState.offY * k;

  // NEU: Rotationswinkel aus dem State (0, 90, 180, 270 …)
  const rotDeg = photoState.rotation || 0;

  pvImg.src = imgWizard.src || '';
  pvImg.style.display='block';
  pvImg.style.transform =
    'translate(-50%,-50%) '+
    'translate('+offXPreview+'px,'+offYPreview+'px) '+
    'rotate('+rotDeg+'deg) '+
    'scale('+scalePreview+')';

  if(pvText) pvText.style.display='none';

  try{
    const wizImgRect = imgWizard.getBoundingClientRect();
    const wizBoxRect = boxWizard.getBoundingClientRect();
    const pvImgRect  = pvImg.getBoundingClientRect();
    const pvBoxRect  = pvBox.getBoundingClientRect();

    const covWiz = (wizImgRect.right - wizImgRect.left) / wizBoxRect.width;
    const covPv  = (pvImgRect.right  - pvImgRect.left)  / pvBoxRect.width;

    if(covPv > 0 && Math.abs(covPv - covWiz) > 0.01){
      const factor   = covWiz / covPv;
      const newScale = scalePreview * factor;
      pvImg.style.transform =
        'translate(-50%,-50%) '+
        'translate('+offXPreview+'px,'+offYPreview+'px) '+
        'rotate('+rotDeg+'deg) '+
        'scale('+newScale+')';
    }
  }catch(e){
    console.warn('preview photo sync adjust failed', e);
  }

  return true;
}

    const usePersonalizedMonthlySender =
      !!(
        usesDedicatedMonthlySenderEditor() &&
        (state.step === 10 || isB2BEventSummaryPhase()) &&
        personalizedMonthlyBox1 &&
        personalizedMonthlyImg1 &&
        personalizedMonthlyTxt1
      );
    const senderBoxPreview = usePersonalizedMonthlySender ? personalizedMonthlyBox1 : box1;
    const senderImgPreview = usePersonalizedMonthlySender ? personalizedMonthlyImg1 : img1;
    const senderStatePreview = usePersonalizedMonthlySender ? state.personalizedMonthlyPhoto1State : state.photo1State;
    const senderTextInputPreview = usePersonalizedMonthlySender ? personalizedMonthlyTxt1 : txt1;
    const senderFallbackPreview = usePersonalizedMonthlySender ? '' : (summaryPartnerName || '');
    const t1 = textForPreview(senderTextInputPreview, senderFallbackPreview);
    const usedPhoto1 = syncPhotoWizardToPreview(senderBoxPreview, senderImgPreview, senderStatePreview, pvBox1, pvImg1, pvTxt1, t1);
    // Step 1: Combine-Modus (Logo + Text gleichzeitig)
const combo1 = !!(senderStatePreview && senderStatePreview.combine);
const splitInput =
      usePersonalizedMonthlySender
        ? personalizedMonthlyCombineTextInput
        : (
            (isB2BSummaryOnlyPortalFlow() || isB2BEventCertificatePhase())
              ? summaryCombineTextInput
              : (isB2BPersonalizedPortalFlow() ? personalizedSenderCombineTextInput : null)
        );
const summarySplitCombine = !!(combo1 && splitInput);

if (pvBox1){
  pvBox1.classList.toggle('pv-combo', !summarySplitCombine && combo1 && usedPhoto1);
}

// Reset, damit Toggle sauber ist
if (pvTxt1) pvTxt1.style.transform = '';

if (summarySplitCombine && usedPhoto1 && pvTxt1 && pvBox1){
  pvTxt1.style.display = 'block';
  pvTxt1.textContent = String(splitInput && splitInput.value || t1 || '').replace(/\r/g,'').split('\n')[0];
  pvTxt1.style.transform = 'translateY(8px)';
  pvTxt1.style.position = 'relative';
  pvTxt1.style.zIndex = '3';

  if (pvImg1){
    pvImg1.style.transform += ' translateY(-96px) scale(0.64)';
  }

  const baseW = parseFloat(pvBox1.style.width)  || pvBox1.getBoundingClientRect().width;
  const baseH = parseFloat(pvBox1.style.height) || pvBox1.getBoundingClientRect().height;
  fitPreviewText(pvTxt1, 140, baseW, baseH, 1);
}
else if (combo1 && usedPhoto1 && pvTxt1 && pvBox1){
  pvTxt1.style.display = 'block';

  // nur 1 Zeile
  const one = String(t1 || '').replace(/\r/g,'').split('\n')[0];
  pvTxt1.textContent = one;

  // ✅ näher Richtung Claim (nur Combine)
  pvTxt1.style.transform = 'translateY(18px)';

  // ✅ kleiner (nur Combine)
  const baseW = parseFloat(pvBox1.style.width)  || pvBox1.getBoundingClientRect().width;
  const baseH = parseFloat(pvBox1.style.height) || pvBox1.getBoundingClientRect().height;
  fitPreviewText(pvTxt1, 140, baseW, baseH, 1);
}

    if(!usedPhoto1 && pvTxt1 && pvBox1 && t1){
      const baseW = parseFloat(pvBox1.style.width)  || pvBox1.getBoundingClientRect().width;
      const baseH = parseFloat(pvBox1.style.height) || pvBox1.getBoundingClientRect().height;
      const hasBreak = t1.indexOf('\n') !== -1;
      pvBox1.classList.toggle('pv-multi', hasBreak);
      fitPreviewText(pvTxt1, 180, baseW, baseH, 2);
    }

// BOX 2 / Mitte: Beschenkte:r – im Monatszertifikat (B2B Step 10)
let usedPhoto4 = false;

if (isMonthlyCertState()){
  // MONATSZERTIFIKAT: feste Typo
const nRaw = parseInt(String(state.monthlyTrees || '').replace(/\D/g,''), 10);
const n = (isFinite(nRaw) && nRaw >= 0) ? nRaw : 0;
const lang = getMonthlyCertLang();
const treesLabel = formatMonthlyTreesLabel(n, lang);

const t4Html = isB2BEventCertificatePhase()
  ? ('<span class="pv-xxbaeume">' + treesLabel + '</span>')
  : (
      '<span class="pv-xxbaeume">' + treesLabel + '</span>' +
      '<span class="pv-month-subline">' + formatMonthlySubline(lang) + '</span>'
    );


  // Foto im Monatszertifikat ausblenden
  if (pvImg4){
    pvImg4.style.display = 'none';
  }

  if (pvTxt4 && pvBox4){
    pvTxt4.style.display = 'block';
    if (pvTxt4) clearRecipientTwoLine(pvTxt4);
    pvTxt4.innerHTML     = t4Html;

    // Wichtig: HIER KEIN fitPreviewText, damit unsere festen Größen gelten
  }

	  if (pvEventClaimLine){
	    if (isB2BEventCertificatePhase()){
	      const eventClaimTa = $('eventClaimText');
	      const rawEventClaim = String(eventClaimTa && eventClaimTa.value || '').replace(/\r/g,'').trim();
	      const fallbackEventClaim = String(eventClaimTa && eventClaimTa.placeholder || '').replace(/\r/g,'').trim();
	      const eventClaim = rawEventClaim || fallbackEventClaim;
	      pvEventClaimLine.style.display = eventClaim ? 'block' : 'none';
	      pvEventClaimLine.textContent = eventClaim;
	      if (eventClaim){
	        pvEventClaimLine.style.fontSize = '145px';
	        pvEventClaimLine.style.lineHeight = '1.05';
	        pvEventClaimLine.style.opacity = rawEventClaim ? '1' : '0.72';
	      }
	    } else {
	      pvEventClaimLine.style.display = 'none';
	      pvEventClaimLine.textContent = '';
	      pvEventClaimLine.style.opacity = '';
	    }
	  }

} else {
if (pvEventClaimLine){
  pvEventClaimLine.style.display = 'none';
  pvEventClaimLine.textContent = '';
  pvEventClaimLine.style.opacity = '';
}
// NORMALFALL: Empfänger aus Step 2 wie bisher
let t4 = textForPreview(txt4,'');

// Sprache robust holen (Fallback de)
const lang = (typeof getActiveLang === 'function') ? getActiveLang() : 'de';

// Türkisch: "için" NACH dem Namen anhängen (nur Text-Fall)
if (lang === 'tr'){
  t4 = appendTrIcinAfterRecipient(t4);
}

if(!usedPhoto4 && pvTxt4 && pvBox4 && t4){
  const baseW = parseFloat(pvBox4.style.width)  || pvBox4.getBoundingClientRect().width;
  const baseH = parseFloat(pvBox4.style.height) || pvBox4.getBoundingClientRect().height;

  // NUR: Serienmodus + echte zweite Zeile (Firma/Zusatz) => zweite Zeile kleiner
  let useSmallLine2 = false;

  if (state.seriesEnabled && Array.isArray(state.seriesRows) && state.seriesRows.length){
    const row = state.seriesRows[state.seriesIndex] || {};
    if (row && String(row.line2 || '').trim()){
      useSmallLine2 = true;
    }
  }

  if (useSmallLine2){
    const parts = String(t4).replace(/\r/g,'').split('\n');
    const l1 = parts[0] || '';
    const l2 = parts[1] || '';

    setRecipientTwoLine(pvTxt4, l1, l2);
    pvTxt4.style.display = 'block';
    fitRecipientTwoLine(pvTxt4, l1, l2, 250, baseW, baseH, 0.72);
  } else {
    // normaler Modus wie bisher
    clearRecipientTwoLine(pvTxt4);
    pvTxt4.textContent = t4;
    pvTxt4.style.display = 'block';
    fitPreviewText(pvTxt4, 250, baseW, baseH, 2);
  }
}
else if(!usedPhoto4 && pvTxt4 && pvBox4 && !t4){
  clearRecipientTwoLine(pvTxt4);
  pvTxt4.textContent = '';
  pvTxt4.innerHTML = '';
  pvTxt4.style.display = 'none';
  if(pvImg4 && !(img4 && img4.src && String(img4.src).indexOf('data:image') === 0)){
    pvImg4.removeAttribute('src');
    pvImg4.style.display = 'none';
  }
}

}

// BOX 3 / unten: Ort/Datum – im Monatszertifikat (editierbar, max. 2 Zeilen)
if (isMonthlyCertState()){
  let txt = String(state.monthlyPlaceText || '').replace(/\r/g,'').trim();

  // max 2 Zeilen, max 50 Zeichen pro Zeile
  const lines = txt.split('\n').slice(0,2).map(l => (l || '').slice(0,50));
  txt = lines.join('\n');
  state.monthlyPlaceText = txt;

  // kein Foto im Monatszertifikat unten
  if (pvImg6) pvImg6.style.display = 'none';

  if (pvTxt6 && pvBox6){
    pvBox6.style.top = '2088px';
    pvBox6.style.height = '320px';
    pvBox6.style.overflow = 'visible';
    pvTxt6.style.display = 'block';
    try{
      pvTxt6.classList.add('pv-month-subline','pv-month-location');
    }catch(_){}
    pvTxt6.style.position = 'absolute';
    pvTxt6.style.left = '0';
    pvTxt6.style.right = '0';
    pvTxt6.style.top = '18px';
    pvTxt6.style.width = '100%';
    pvTxt6.style.transform = 'none';
    pvTxt6.style.fontFamily = 'var(--cert)';
    pvTxt6.style.fontWeight = '400';
    pvTxt6.style.fontSize = '145px';
    pvTxt6.style.lineHeight = '1.12';
    pvTxt6.style.textAlign = 'center';
    pvTxt6.style.color = '#162716';
    pvTxt6.style.whiteSpace = 'pre-line';
    pvTxt6.style.zIndex = '3';
    pvTxt6.style.visibility = 'visible';
    pvTxt6.style.opacity = '1';
    pvTxt6.textContent = txt;
  }

} else {
  // NORMALFALL: Anlass/Message aus dem Wizard
  const t6 = textForPreview(txt6,'');
  const usedPhoto6 = syncPhotoWizardToPreview(
    box6, img6, state.photo6State,
    pvBox6, pvImg6, pvTxt6, t6
  );
  if(!usedPhoto6 && pvTxt6 && pvBox6 && t6){
    const baseW = parseFloat(pvBox6.style.width)  || pvBox6.getBoundingClientRect().width;
    const baseH = parseFloat(pvBox6.style.height) || pvBox6.getBoundingClientRect().height;
    fitPreviewText(pvTxt6, 160, baseW, baseH, 2);
  }
}



    updateClaim();
    updateQtyLabel();
    applyForestToPreview();
    applyFrameColor();
  }

document.querySelectorAll('.pv-hotspot').forEach(el=>{
  el.addEventListener('click', ()=>{
    const tot = totalSteps();

    // Nur im finalen Vorschau-Step (10 / 11) darf das Zertifikat zur Bearbeitung springen
    if (state.step !== tot) return;
    if (isB2BSummaryOnlyPortalFlow()) return;

    const s = parseInt(el.getAttribute('data-step') || '1', 10);
    if (!isNaN(s)){
      setStep(s);
    }
  });
});

// PATCH: Helfer, um komplett schwarze / leere Canvas-Resultate zu erkennen
function isCanvasMostlyBlack(canvas){
  try{
    const ctx = canvas.getContext('2d');
    if(!ctx) return false;

    const sampleSize = Math.min(80, canvas.width, canvas.height);
    if(sampleSize <= 0) return false;

    const imgData = ctx.getImageData(0, 0, sampleSize, sampleSize).data;

    let nonDark = 0;
    for(let i = 0; i < imgData.length; i += 4){
      const r = imgData[i];
      const g = imgData[i+1];
      const b = imgData[i+2];
      const a = imgData[i+3];

      // irgendwas Sichtbares?
      if(a > 10 && (r > 10 || g > 10 || b > 10)){
        nonDark++;
        if(nonDark > 30){
          // klar: nicht komplett schwarz
          return false;
        }
      }
    }
    // quasi alles schwarz / transparent
    return true;
  }catch(e){
    console.warn('isCanvasMostlyBlack failed', e);
    return false;
  }
}

// PATCH: Fonts-Warte-Helfer mit Fallback für ältere Safari-Versionen
async function waitForFonts(){
  const sleep = (ms)=>new Promise(r=>setTimeout(r, ms));
  try{
    if (document.fonts && document.fonts.load){
      const loadAll = Promise.allSettled([
        document.fonts.load('700 220px "Amatic SC"'),
        document.fonts.load('400 105px "Amatic SC"'),
        document.fonts.load('700 60px "Amatic SC"'),
        document.fonts.load('400 50px "Roboto"'),
        document.fonts.load('700 20px "Roboto"')
      ]).then(()=>document.fonts.ready);

      await Promise.race([loadAll, sleep(2000)]);
      return;
    }

    await sleep(600);
  }catch(e){
    console.warn('waitForFonts failed', e);
    await sleep(400);
  }
}

function toPngDataUrlWithWhiteBackground(srcCanvas){
  const w = srcCanvas.width || 0;
  const h = srcCanvas.height || 0;
  if(!w || !h) return null;

  const out = document.createElement('canvas');
  out.width = w;
  out.height = h;

  const ctx = out.getContext('2d', { alpha: false });
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, w, h);
  ctx.drawImage(srcCanvas, 0, 0);

  return out.toDataURL('image/png');
}

function normalizePaperToWhiteIfGrey(canvas){
  try{
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if(!ctx) return canvas;

    const p = ctx.getImageData(8, 8, 1, 1).data;
    const br = p[0], bg = p[1], bb = p[2], ba = p[3];

    const isWhite = (ba > 200 && br > 245 && bg > 245 && bb > 245);
    if (isWhite) return canvas;

    const isGreyPaper =
      (ba > 200) &&
      (Math.abs(br - bg) < 10) &&
      (Math.abs(br - bb) < 10) &&
      (br < 230);

    if(!isGreyPaper) return canvas;

    const img = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const d = img.data;

    const tol = 24;
    const satTol = 14;

    for(let i=0;i<d.length;i+=4){
      const r=d[i], g=d[i+1], b=d[i+2], a=d[i+3];
      if(a < 240) continue;
      if(Math.abs(r-g) > satTol || Math.abs(r-b) > satTol) continue;
      if(Math.abs(r-br) <= tol && Math.abs(g-bg) <= tol && Math.abs(b-bb) <= tol){
        d[i]=255; d[i+1]=255; d[i+2]=255;
      }
    }

    ctx.putImageData(img, 0, 0);
    return canvas;
  }catch(e){
    console.warn('normalizePaperToWhiteIfGrey failed', e);
    return canvas;
  }
}

// PATCH: robusteres Rendering mit Fallback & Schwarz-Erkennung
async function captureCertificatePng(opts){
  opts = opts || {};
  const skipWarmup = !!opts.skipWarmup;
  const inner = $('pvInnerFinal');

  const stage = $('pvStageFinal');

  const CAP_ID = 'ptCanvasCaptureHost';
  function getCaptureHost(){
    let host = document.getElementById(CAP_ID);
    if(!host){
      host = document.createElement('div');
      host.id = CAP_ID;
      host.style.cssText =
        'position:fixed; left:-10000px; top:0; width:2480px; height:3508px;' +
        'overflow:visible; background:#fff; pointer-events:none; z-index:-1;';
      document.body.appendChild(host);
    }
    return host;
  }

  if (!inner || typeof html2canvas === 'undefined') {
    console.warn('captureCertificatePng: element or html2canvas missing');
    return null;
  }

  if (!skipWarmup){
    try{
      await ensureDecorImagesLoaded();
    }catch(e){
      console.warn('ensureDecorImagesLoaded failed', e);
    }

    await waitForFonts();
  }

  const prevTransform = inner.style.transform;
  const prevLeft      = inner.style.left;
  const prevTop       = inner.style.top;
  const prevPos       = inner.style.position;
  const prevWidth     = inner.style.width;
  const prevHeight    = inner.style.height;
  const decorCaptureVars = [
    ['--dec-tree-x', '1240px'],
    ['--dec-tree-y', '1280px'],
    ['--dec-tree-w', '580px'],
    ['--dec-balloon-x', '700px'],
    ['--dec-balloon-y', '1400px'],
    ['--dec-balloon-w', '310px'],
    ['--dec-hat-x', '1490px'],
    ['--dec-hat-y', '1280px'],
    ['--dec-hat-w', '520px'],
    ['--dec-hat-rot', '10deg']
  ];
  const prevDecorVars = {};

  const origParent = inner.parentNode;
  const origNext   = inner.nextSibling;

  try{
    const cs = window.getComputedStyle(inner);
    decorCaptureVars.forEach(function(entry){
      const name = entry[0];
      const fallback = entry[1];
      prevDecorVars[name] = inner.style.getPropertyValue(name);
      const resolved = String(cs.getPropertyValue(name) || '').trim() || fallback;
      inner.style.setProperty(name, resolved);
    });
  }catch(e){
    console.warn('captureCertificatePng: decor var pinning failed', e);
  }

  const host = getCaptureHost();
  host.appendChild(inner);

  inner.style.position  = 'relative';
  inner.style.left      = '0';
  inner.style.top       = '0';
  inner.style.width     = '2480px';
  inner.style.height    = '3508px';
  inner.style.transform = 'none';

  await new Promise(r => requestAnimationFrame(r));
  await new Promise(r => requestAnimationFrame(r));

  try{
    placeA4Boxes();
    updatePreview();
  }catch(e){
    console.warn('captureCertificatePng: preview refresh failed', e);
  }

  await new Promise(r => requestAnimationFrame(r));

  async function attempt(width, height, scale){
    try{
      const prevBg  = inner.style.background;
      const prevBgc = inner.style.backgroundColor;

      inner.style.setProperty('background', '#ffffff', 'important');
      inner.style.setProperty('background-color', '#ffffff', 'important');

      let canvas = await html2canvas(inner, {
        backgroundColor: '#ffffff',
        width,
        height,
        scale,
        useCORS: true,
        allowTaint: false,
        removeContainer: true,
        imageTimeout: 15000,
        scrollX: 0,
        scrollY: 0,
        windowWidth: width,
        windowHeight: height,
        onclone: (doc) => {
          try{
            doc.documentElement.style.setProperty('color-scheme', 'light', 'important');
            doc.body.style.setProperty('color-scheme', 'light', 'important');
            doc.documentElement.style.setProperty('background', '#ffffff', 'important');
            doc.body.style.setProperty('background', '#ffffff', 'important');
            doc.body.style.setProperty('background-color', '#ffffff', 'important');
            doc.documentElement.style.setProperty('filter', 'none', 'important');
            doc.body.style.setProperty('filter', 'none', 'important');
            doc.documentElement.style.setProperty('-webkit-filter', 'none', 'important');
            doc.body.style.setProperty('-webkit-filter', 'none', 'important');
            doc.documentElement.style.setProperty('forced-color-adjust', 'none', 'important');
            doc.body.style.setProperty('forced-color-adjust', 'none', 'important');
          }catch(_){}

          try{
            const style = doc.createElement('style');
            style.textContent = `
              #pvInnerFinal, #pvInnerFinal *{
                -webkit-text-size-adjust:100% !important;
                text-size-adjust:100% !important;
                font-synthesis:none !important;
              }
              #pvInnerFinal .pv-text,
              #pvInnerFinal .pv-claim,
              #pvInnerFinal #pvForestName,
              #pvInnerFinal #pvForestUrl{
                font-family:"Amatic SC", Arial, sans-serif !important;
              }
              #pvInnerFinal #pvForestCoords,
              #pvInnerFinal #pvForestId{
                font-family:"Roboto", system-ui, -apple-system, "Segoe UI", Arial, sans-serif !important;
              }
            `;
            doc.head.appendChild(style);
          }catch(_){}

          const el = doc.getElementById('pvInnerFinal');
          if (el){
            try{
              el.style.setProperty('background', '#ffffff', 'important');
              el.style.setProperty('background-color', '#ffffff', 'important');
              el.style.setProperty('filter', 'none', 'important');
              el.style.setProperty('opacity', '1', 'important');
              el.style.setProperty('mix-blend-mode', 'normal', 'important');
              el.style.setProperty('color-scheme', 'light', 'important');
              el.style.setProperty('forced-color-adjust', 'none', 'important');

              const firstRect = el.querySelector('svg rect');
              if(firstRect){
                firstRect.setAttribute('fill', '#ffffff');
                firstRect.style.setProperty('fill', '#ffffff', 'important');
              }
            }catch(_){}
          }
        }
      });

      canvas = normalizePaperToWhiteIfGrey(canvas);

      inner.style.background      = prevBg;
      inner.style.backgroundColor = prevBgc;

      if(!canvas || !canvas.width || !canvas.height){
        console.warn('captureCertificatePng: empty canvas from html2canvas');
        return null;
      }

      if (isCanvasMostlyBlack(canvas)){
        console.warn('captureCertificatePng: canvas looks mostly black, treating as failure');
        return null;
      }

      const dataUrl = toPngDataUrlWithWhiteBackground(canvas);
      if(!dataUrl){
        console.warn('captureCertificatePng: flatten failed');
        return null;
      }

      return { dataUrl, width: canvas.width, height: canvas.height };
    }catch(e){
      console.warn('captureCertificatePng: html2canvas attempt failed', e);
      return null;
    }
  }

  const FULL_W  = 2480;
  const FULL_H  = 3508;
  const SMALL_W = 1800;
  const SMALL_H = Math.round(SMALL_W * FULL_H / FULL_W);

  let snap = await attempt(FULL_W, FULL_H, 1);

  if(!snap){
    console.warn('captureCertificatePng: full-res attempt failed, retrying smaller');
    snap = await attempt(SMALL_W, SMALL_H, 1);
  }

  try{
    if(origParent){
      if(origNext) origParent.insertBefore(inner, origNext);
      else origParent.appendChild(inner);
    }
  }catch(_){}

  inner.style.transform = prevTransform;
  inner.style.left      = prevLeft;
  inner.style.top       = prevTop;
  inner.style.position  = prevPos;
  inner.style.width     = prevWidth;
  inner.style.height    = prevHeight;
  try{
    decorCaptureVars.forEach(function(entry){
      const name = entry[0];
      const prev = prevDecorVars[name];
      if (prev){
        inner.style.setProperty(name, prev);
      } else {
        inner.style.removeProperty(name);
      }
    });
  }catch(_){}

  try{ scaleA4(); }catch(_){}

  return snap;
}

async function captureMonthlyCertificatePng(opts){
  opts = opts || {};
  FORCE_MONTHLY_RENDER = true;
  const monthlyDecoEls = [$('decoBalloonPv'), $('decoHatPv'), $('balloonFinal'), $('hatFinal')].filter(Boolean);
  const monthlyDecoPrevDisplay = monthlyDecoEls.map(function(el){ return el.style.display; });

  try{
    // Monats-UI in den DOM rechnen
    placeA4Boxes();
    updateClaim();
    updatePreview();

    monthlyDecoEls.forEach(function(el){
      el.style.display = 'none';
    });

    // Monats-spezifische Elemente aktualisieren
    applyMonthlyForestsToPreview();
    renderMonthlyId();
    renderMonthlyQr();
    renderMonthlyUrl();

    // falls Koordinaten schon geladen sind, in DOM schreiben
    if (typeof applyMonthlyCoordsToDom === 'function'){
      applyMonthlyCoordsToDom();
    }
  }catch(e){
    console.warn('captureMonthlyCertificatePng prep failed', e);
  }

  await new Promise(r => requestAnimationFrame(r));

  const snap = await captureCertificatePng({ offscreen:true, skipWarmup: !!opts.skipWarmup });

  FORCE_MONTHLY_RENDER = false;

  try{
    monthlyDecoEls.forEach(function(el, idx){
      el.style.display = monthlyDecoPrevDisplay[idx] || '';
    });
    updateClaim();
    updatePreview();
  }catch(_){}

  return snap;
}

function resetFinalLiveStagePlacement(){
  const stage = $('pvStageFinal');
  if(!stage) return;
  stage.style.position = '';
  stage.style.left = '';
  stage.style.top = '';
  stage.style.width = '';
  stage.style.maxWidth = '';
  stage.style.opacity = '';
  stage.style.pointerEvents = '';
  stage.style.zIndex = '';
}

function parkFinalLiveStageOffscreen(){
  const stage = $('pvStageFinal');
  if(!stage) return;
  stage.style.position = 'fixed';
  stage.style.left = '-10000px';
  stage.style.top = '0';
  stage.style.width = '760px';
  stage.style.maxWidth = '760px';
  stage.style.opacity = '';
  stage.style.pointerEvents = 'none';
  stage.style.zIndex = '';
}

let finalPersonalizedPreviewCache = {};

function useLiveSeriesFinalPreviewMode(){
  return !!(
    isB2BPersonalizedPortalFlow() &&
    state.mode === 'cert' &&
    state.step === totalSteps() &&
    state.seriesEnabled &&
    hasSeriesRows()
  );
}

function getFinalPersonalizedPreviewCacheKey(){
  if (!isB2BPersonalizedPortalFlow() || state.mode !== 'cert') return 'single';
  if (state.seriesEnabled && hasSeriesRows()){
    return 'series:' + String(state.seriesIndex || 0);
  }
  return 'single';
}

function clearFinalPersonalizedPreviewCache(){
  finalPersonalizedPreviewCache = {};
}

function resetFinalStaticPreview(){
  const wrap = $('pvFinalStaticWrap');
  const img = $('pvFinalStaticImg');
  const loading = $('pvFinalLoading');
  resetFinalLiveStagePlacement();
  if (wrap) wrap.style.display = 'none';
  if (loading) loading.style.display = 'none';
  if (img){
    img.removeAttribute('src');
    img.dataset.rendered = '';
  }
  try{ syncB2BFinalCreateAvailability(); }catch(_){}
}

function fontsSig(){
  try{
    if(document.fonts && document.fonts.check){
      return [
        document.fonts.check('28px Caveat') ? 'caveat1' : 'caveat0',
        document.fonts.check('19px Roboto') ? 'roboto1' : 'roboto0',
        document.fonts.check('220px "Amatic SC"') ? 'amatic1' : 'amatic0'
      ].join(',');
    }
  }catch(_){}
  return 'fonts?';
}


function monthlyRenderSig(){
  const forests = (typeof getMonthlySelectedForests === 'function')
    ? getMonthlySelectedForests()
    : (Array.isArray(state.monthlyForests) ? state.monthlyForests : []);

  const coordsSig = state.monthlyCoordsLoaded ? JSON.stringify(state.monthlyCoords || {}) : '';

  return [
    String(state.monthlyTrees || ''),
    String(state.monthlyMonth || ''),
    forests.join(','),
    String(state.monthlyQrUrl || '').trim(),
    String(state.frameColor || FRAME_COLOR_DEFAULT),
    String(state.monthlyId || ensureMonthlyId()),
    String(state.monthlyPlaceText || '').replace(/\r/g,''),
    coordsSig,
    fontsSig() // <<< NEU
  ].join('|');
}

function invalidateMonthlyFinalCache(){
  const img = $('pvMonthlyFinalImg');
  if (!img) return;
  img.dataset.rendered = '';
  img.dataset.sig = '';
  img.removeAttribute('src');
  const block = $('monthlyFinalBlock');
  if (block) block.style.visibility = 'hidden';
  const link = $('pvMonthlyFinalPngLink');
if(link) link.href = '#';
  try{ syncB2BFinalCreateAvailability(); }catch(_){}

}

let monthlyFinalPreviewClone = null;

function cloneWithCanvasContent(node){
  if (!node) return null;
  const clone = node.cloneNode(true);
  try{
    const srcCanvases = node.querySelectorAll('canvas');
    const dstCanvases = clone.querySelectorAll('canvas');
    srcCanvases.forEach(function(srcCanvas, idx){
      const dstCanvas = dstCanvases[idx];
      if (!dstCanvas) return;
      try{
        dstCanvas.width = srcCanvas.width;
        dstCanvas.height = srcCanvas.height;
        const ctx = dstCanvas.getContext('2d');
        if (ctx) ctx.drawImage(srcCanvas, 0, 0);
      }catch(_){}
    });
  }catch(_){}
  return clone;
}

function getVisibleFinalPreviewWidth(){
  const staticWrap = $('pvFinalStaticWrap');
  const staticImg = $('pvFinalStaticImg');
  const liveStage = $('pvStageFinal');
  const monthlyStage = document.querySelector('#monthlyFinalBlock .monthly-stage');

  const staticImgWidth = staticImg ? (staticImg.getBoundingClientRect().width || 0) : 0;
  if (staticImgWidth > 0) return staticImgWidth;

  const staticWrapWidth = staticWrap ? (staticWrap.getBoundingClientRect().width || 0) : 0;
  if (staticWrapWidth > 0) return staticWrapWidth;

  const liveStageWidth = liveStage ? (liveStage.getBoundingClientRect().width || 0) : 0;
  if (liveStageWidth > 0) return liveStageWidth;

  const monthlyStageWidth = monthlyStage ? (monthlyStage.getBoundingClientRect().width || 0) : 0;
  if (monthlyStageWidth > 0) return monthlyStageWidth;

  return 0;
}

function syncMonthlyPreviewCloneLayout(clone){
  if (!clone) return;
  try{
    const topStage = $('pvStageFinal');
    const topInner = $('pvInnerFinal');
    const cloneStage = clone.querySelector('.a4-stage');
    const cloneInner = clone.querySelector('.a4-inner');
    const sourceStageWidth = parseFloat(clone.dataset.sourceStageWidth || '0') || 0;
    const sourceStageHeight = parseFloat(clone.dataset.sourceStageHeight || '0') || 0;
    const targetStageWidth = getVisibleFinalPreviewWidth();
    const topStageRect = topStage ? topStage.getBoundingClientRect() : null;
    const topStageHeight = topStageRect ? (topStageRect.height || 0) : 0;
    const topInnerTransform = topInner ? topInner.style.transform : '';

    clone.style.width = '';
    clone.style.maxWidth = '';
    clone.style.flex = '0 1 auto';
    clone.style.marginLeft = 'auto';
    clone.style.marginRight = 'auto';
    clone.style.alignItems = 'center';

    if (cloneStage){
      cloneStage.style.marginLeft = 'auto';
      cloneStage.style.marginRight = 'auto';
    }

    if (cloneStage && targetStageWidth > 0){
      clone.style.width = targetStageWidth + 'px';
      clone.style.maxWidth = targetStageWidth + 'px';
      cloneStage.style.width = targetStageWidth + 'px';
      cloneStage.style.maxWidth = targetStageWidth + 'px';
      cloneStage.style.flex = '0 0 auto';
      if (topStageHeight > 0){
        cloneStage.style.height = topStageHeight + 'px';
      } else if (sourceStageWidth > 0 && sourceStageHeight > 0){
        cloneStage.style.height = (sourceStageHeight * (targetStageWidth / sourceStageWidth)) + 'px';
      }
      if (cloneInner){
        cloneInner.style.transform = topInnerTransform || cloneInner.style.transform || 'translateX(-50%) scale(1)';
      }
    } else if (cloneStage && sourceStageWidth > 0){
      clone.style.width = sourceStageWidth + 'px';
      clone.style.maxWidth = sourceStageWidth + 'px';
      cloneStage.style.width = sourceStageWidth + 'px';
      cloneStage.style.maxWidth = sourceStageWidth + 'px';
      if (sourceStageHeight > 0){
        cloneStage.style.height = sourceStageHeight + 'px';
      }
    }
  }catch(e){
    console.warn('syncMonthlyPreviewCloneLayout failed', e);
  }
}

function captureMonthlyFinalStepPreview(){
  const personalizedMonthlyStep = !!(isB2BPersonalizedPortalFlow() && state.mode === 'cert' && state.step === 10);
  const eventMonthlyStep = !!(isB2BEventSummaryPhase() && state.mode === 'cert');
  if (!(personalizedMonthlyStep || eventMonthlyStep)) return;
  const wrap = document.querySelector('#monthlyCertHost .a4-preview-wrap');
  if (!wrap) return;
  try{
    const clone = cloneWithCanvasContent(wrap);
    if (!clone) return;
    const wrapRect = wrap.getBoundingClientRect();
    const srcStage = wrap.querySelector('.a4-stage');
    const dstStage = clone.querySelector('.a4-stage');
    const srcInner = wrap.querySelector('.a4-inner');
    const dstInner = clone.querySelector('.a4-inner');
    const srcBox1 = wrap.querySelector('#pvBox1');
    const dstBox1 = clone.querySelector('#pvBox1');
    const srcImg1 = wrap.querySelector('#pvImg1');
    const dstImg1 = clone.querySelector('#pvImg1');
    const srcTree = wrap.querySelector('.decor-tree-final');
    const dstTree = clone.querySelector('.decor-tree-final');

    if (wrapRect.width){
      clone.style.width = wrapRect.width + 'px';
      clone.style.maxWidth = wrapRect.width + 'px';
      clone.style.flex = '0 0 auto';
      clone.style.marginLeft = 'auto';
      clone.style.marginRight = 'auto';
    }
    if (srcStage && dstStage){
      const stageRect = srcStage.getBoundingClientRect();
      if (stageRect.width){
        dstStage.style.width = stageRect.width + 'px';
        dstStage.style.maxWidth = stageRect.width + 'px';
        dstStage.style.flex = '0 0 auto';
        dstStage.style.marginLeft = 'auto';
        dstStage.style.marginRight = 'auto';
        clone.dataset.sourceStageWidth = String(stageRect.width);
        clone.dataset.sourceStageHeight = String(stageRect.height || 0);
      }
    }
    if (srcInner && dstInner) dstInner.style.transform = srcInner.style.transform;
    if (srcBox1 && dstBox1) dstBox1.style.cssText = srcBox1.style.cssText;
    if (srcImg1 && dstImg1) dstImg1.style.cssText = srcImg1.style.cssText;
    if (srcTree && dstTree) dstTree.style.cssText = srcTree.style.cssText;
    clone.classList.add('monthly-preview-clone');
    monthlyFinalPreviewClone = clone;
  }catch(e){
    console.warn('captureMonthlyFinalStepPreview failed', e);
  }
}

function showExistingMonthlyFinalPreview(){
  const block = $('monthlyFinalBlock');
  const personalizedFinal = !!(isB2BPersonalizedPortalFlow() && state.mode === 'cert' && state.step === totalSteps());
  const eventFinal = !!(isB2BEventFinalOverviewPhase());
  if (!block || !(personalizedFinal || eventFinal)) return false;
  const stage = block.querySelector('.monthly-stage');
  const img = $('pvMonthlyFinalImg');
  if (!stage || !monthlyFinalPreviewClone) return false;
  try{
    stage.querySelectorAll('.monthly-preview-clone').forEach(function(el){ el.remove(); });
    if (img) img.style.display = 'none';
    const liveClone = cloneWithCanvasContent(monthlyFinalPreviewClone);
    if (!liveClone) return false;
    liveClone.classList.add('monthly-preview-clone');
    syncMonthlyPreviewCloneLayout(liveClone);
    stage.appendChild(liveClone);
    block.style.display = 'block';
    block.style.visibility = 'visible';
    return true;
  }catch(e){
    console.warn('showExistingMonthlyFinalPreview failed', e);
    return false;
  }
}

function isB2BPersonalizedFinalPreviewReady(){
  if (!isB2BPersonalizedPortalFlow() || state.mode !== 'cert' || state.step !== totalSteps()) return true;
  const topImg = $('pvFinalStaticImg');
  const topReady = useLiveSeriesFinalPreviewMode()
    ? true
    : !!(topImg && topImg.dataset.rendered === '1' && topImg.getAttribute('src'));
  return topReady;
}

function syncB2BFinalCreateAvailability(){
  if (btnB2BCreate){
    if (window.__PT_B2B_WIZARD_CREATE_IN_FLIGHT__){
      btnB2BCreate.disabled = true;
      btnB2BCreate.title = 'Die Zertifikate werden bereits erstellt.';
    } else {
    const ready = isB2BPersonalizedFinalPreviewReady();
    const gated = !!(isB2BPersonalizedPortalFlow() && state.mode === 'cert' && state.step === totalSteps());
    btnB2BCreate.disabled = gated ? !ready : false;
    btnB2BCreate.title = gated && !ready ? 'Bitte warten, bis beide Zertifikate vollständig geladen sind.' : '';
    }
  }
  if (btnB2BCreateMonthly){
    const eventGated = !!(isB2BEventFinalOverviewPhase());
    const topImg = $('pvFinalStaticImg');
    const monthlyImg = $('pvMonthlyFinalImg');
    const eventReady = !!(
      !eventGated ||
      (
        topImg &&
        topImg.getAttribute('src') &&
        monthlyImg &&
        monthlyImg.dataset.rendered === '1' &&
        monthlyImg.getAttribute('src')
      )
    );
    btnB2BCreateMonthly.disabled = eventGated ? !eventReady : false;
    btnB2BCreateMonthly.title = eventGated && !eventReady ? 'Bitte warten, bis beide Zertifikate vollständig geladen sind.' : '';
  }
}


async function renderMonthlyFinalPreviewIfNeeded(forceRender){
  if(!isB2B || state.mode !== 'cert') return;
  if (isB2BSummaryOnlyPortalFlow()) return;

  const block = $('monthlyFinalBlock');
  const img   = $('pvMonthlyFinalImg');
  const stage = block ? block.querySelector('.monthly-stage') : null;
  const link = $('pvMonthlyFinalPngLink');

  if(!block || !img) return;

  block.style.display = 'block';

  const sig = monthlyRenderSig();
  const clearPreviewClones = function(){
    if (!stage) return;
    try{
      stage.querySelectorAll('.monthly-preview-clone').forEach(function(el){ el.remove(); });
    }catch(_){}
  };
  const hadFallbackClone = !!(stage && stage.querySelector('.monthly-preview-clone'));

  // nur überspringen, wenn die Daten wirklich identisch sind
if (img.dataset.rendered === '1' && img.src && img.dataset.sig === sig){
  clearPreviewClones();
  img.style.display = 'block';
  block.style.visibility = 'visible';
  if (link) link.href = img.src; // << Link auch bei Cache-Treffer korrekt setzen
  return;
}


  if(!forceRender) return;

  img.dataset.sig = sig;
  block.style.visibility = 'hidden';

  // Erst den finalen Step sauber malen lassen, dann die teure Monats-PNG rendern.
  await new Promise(function(resolve){
    requestAnimationFrame(function(){
      requestAnimationFrame(resolve);
    });
  });
  await new Promise(function(resolve){ setTimeout(resolve, 80); });

const snap = await captureMonthlyCertificatePng();
if(snap && snap.dataUrl){
  clearPreviewClones();
  img.src = snap.dataUrl;
  img.style.display = 'block';
  img.dataset.rendered = '1';
  block.style.visibility = 'visible';
  if (link) link.href = snap.dataUrl; // << Link auf das PNG (DataURL)
} else if (img.src) {
  clearPreviewClones();
  img.style.display = 'block';
  block.style.visibility = 'visible';
} else if (hadFallbackClone) {
  block.style.visibility = 'visible';
}
  try{ syncB2BFinalCreateAvailability(); }catch(_){}
  try{ scaleA4(); }catch(_){}
  syncSummaryOnlyFinalPreviewUi();
}

async function renderB2BEventFinalDualPreview(forceRender){
  if (!isB2BEventFinalOverviewPhase()) return;

  const wrap = $('pvFinalStaticWrap');
  const img = $('pvFinalStaticImg');
  const loading = $('pvFinalLoading');
  const block = $('monthlyFinalBlock');
  if (!wrap || !img) {
    await renderMonthlyFinalPreviewIfNeeded(forceRender);
    return;
  }

  const snap = state && state.b2bPortal ? state.b2bPortal.eventSnapshot : null;
  parkFinalLiveStageOffscreen();
  wrap.style.display = 'none';
  if (loading) loading.style.display = 'grid';

  if (snap && snap.canvasPng){
    img.src = snap.canvasPng;
    img.dataset.rendered = '1';
    img.dataset.cacheKey = 'event-final';
    img.alt = 'Event-Zertifikat Vorschau';
    wrap.style.display = 'block';
  } else {
    img.removeAttribute('src');
    img.dataset.rendered = '';
  }

  if (block){
    const ribbon = block.querySelector('.wiz-ribbon-main__text');
    if (ribbon) ribbon.textContent = 'Sammel-Zertifikat';
  }

  try{ showExistingMonthlyFinalPreview(); }catch(_){}
  await renderMonthlyFinalPreviewIfNeeded(forceRender);
  if (loading) loading.style.display = 'none';
  try{ syncB2BFinalCreateAvailability(); }catch(_){}
}

async function renderB2BPersonalizedFinalDualPreview(forceRender){
  if (!isB2BPersonalizedPortalFlow() || state.mode !== 'cert' || state.step !== totalSteps()) return;

  const wrap = $('pvFinalStaticWrap');
  const img = $('pvFinalStaticImg');
  const loading = $('pvFinalLoading');
  const liveStage = $('pvStageFinal');
  if (!wrap || !img) {
    await renderMonthlyFinalPreviewIfNeeded(forceRender);
    return;
  }

  if (useLiveSeriesFinalPreviewMode()){
    if (loading) loading.style.display = 'grid';
    parkFinalLiveStageOffscreen();
    wrap.style.display = 'none';
    try{
      placeA4Boxes();
      updatePreview();
      scaleA4();
    }catch(_){}
    await new Promise(function(resolve){
      requestAnimationFrame(function(){
        requestAnimationFrame(resolve);
      });
    });
    resetFinalLiveStagePlacement();
    if (loading) loading.style.display = 'none';
    try{
      placeA4Boxes();
      updatePreview();
      scaleA4();
      requestAnimationFrame(function(){
        try{
          placeA4Boxes();
          updatePreview();
          scaleA4();
        }catch(_){}
      });
    }catch(_){}
    try{ syncB2BFinalCreateAvailability(); }catch(_){}
    return;
  }

  const cacheKey = getFinalPersonalizedPreviewCacheKey();
  const cachedSrc = finalPersonalizedPreviewCache[cacheKey];
  if (cachedSrc){
    img.src = cachedSrc;
    img.dataset.rendered = '1';
    img.dataset.cacheKey = cacheKey;
    wrap.style.display = 'block';
    if (loading) loading.style.display = 'none';
    parkFinalLiveStageOffscreen();
    await renderMonthlyFinalPreviewIfNeeded(forceRender);
    try{ syncB2BFinalCreateAvailability(); }catch(_){}
    return;
  }

  parkFinalLiveStageOffscreen();
  wrap.style.display = 'none';
  if (loading) loading.style.display = 'grid';

  try{
    placeA4Boxes();
    updatePreview();
  }catch(_){}

  await new Promise(function(resolve){
    requestAnimationFrame(function(){
      requestAnimationFrame(resolve);
    });
  });

  const topSnap = await captureCertificatePng();
  if (topSnap && topSnap.dataUrl){
    img.src = topSnap.dataUrl;
    img.dataset.rendered = '1';
    img.dataset.cacheKey = cacheKey;
    finalPersonalizedPreviewCache[cacheKey] = topSnap.dataUrl;
    wrap.style.display = 'block';
    parkFinalLiveStageOffscreen();
  }

  await renderMonthlyFinalPreviewIfNeeded(forceRender);
  if (loading) loading.style.display = 'none';
  try{ syncB2BFinalCreateAvailability(); }catch(_){}
}

function syncSummaryOnlyFinalPreviewUi(){
  const certHost = $('a4Host10');
  const a4 = $('a4Block');
  const gcStage = $('gcStage');
  const productRef = $('pvProductRef');
  const seriesPager = $('seriesPagerFinal');
  const hotspotInfo = document.querySelector('#step10 .pv-hotspot-info');
  const finalHint = document.querySelector('#step10 .hint-final-only');
  const backCtaWrap = document.querySelector('#step10 .pv-back-cta-wrap');
  const monthlyBlock = $('monthlyFinalBlock');
  const disablePreviewClicks = !!(isB2BPortalFlow() && state.step === totalSteps());

  if (a4) a4.style.pointerEvents = '';
  if (certHost) certHost.style.pointerEvents = disablePreviewClicks ? 'none' : '';
  if (gcStage) gcStage.style.pointerEvents = disablePreviewClicks ? 'none' : '';
  if (seriesPager) seriesPager.style.pointerEvents = 'auto';

  if (isB2BSummaryOnlyPortalFlow() && state.step === totalSteps()){
    if (certHost) certHost.style.display = '';
    if (productRef) productRef.style.display = 'none';
    if (seriesPager) seriesPager.style.display = 'none';
    if (hotspotInfo) hotspotInfo.style.display = 'none';
    if (finalHint) finalHint.style.display = 'none';
    if (backCtaWrap) backCtaWrap.style.display = 'none';
    if (monthlyBlock) monthlyBlock.style.display = 'none';
  } else {
    if (certHost) certHost.style.display = '';
    if (hotspotInfo) hotspotInfo.style.display = '';
    if (finalHint) finalHint.style.display = '';
    if (backCtaWrap) backCtaWrap.style.display = '';
    if (monthlyBlock && (isB2BPersonalizedPortalFlow() || isB2BEventFinalOverviewPhase()) && state.step === totalSteps()){
      monthlyBlock.style.display = 'block';
      if (monthlyBlock.style.visibility === 'hidden'){
        monthlyBlock.style.visibility = 'hidden';
      }
    } else if (monthlyBlock){
      monthlyBlock.style.display = 'none';
    }
  }
}




  async function captureLabelPng(){
    const inner = $('labelInnerFinal') || $('labelInnerEdit');
    if (!inner || typeof html2canvas === 'undefined'){ return null; }
 await waitForFonts();
    const prevTransform = inner.style.transform;
    const prevLeft      = inner.style.left;
    inner.style.transform = 'none'; inner.style.left = '0';
    await new Promise(r => requestAnimationFrame(r));
    const canvas = await html2canvas(inner, {
      backgroundColor: '#ffffff',
      scale: 1, width: 3000, height: 2000, useCORS: true
    });
    inner.style.transform = prevTransform; inner.style.left = prevLeft;
    const dataUrl = canvas.toDataURL('image/png');
    return { dataUrl, width: canvas.width, height: canvas.height };
  }

async function captureGreetingCardPng(){
  const inner = $('gcInner');
  if(!inner || typeof html2canvas === 'undefined' || !state.greetCardSelected){
    return null;
  }
  try{
    if(document.fonts && document.fonts.ready){
      await document.fonts.ready;
    }
  }catch(_){}

  // NEU: Text in Preview layer spiegeln und Preview activarien
  updateGreetPreviews();
  toggleGreetPreview(true);

  const prevTransform = inner.style.transform;
  const prevLeft      = inner.style.left;
  inner.style.transform = 'none';
  inner.style.left      = '0';

  await new Promise(r=>requestAnimationFrame(r));

  const canvas = await html2canvas(inner, {
    backgroundColor:'#ffffff',
    scale:1,
    width:2480,
    height:3508,
    useCORS:true
  });

  // NEU: Preview wieder verstecken, Textareas normal anzeigen
  toggleGreetPreview(false);

  inner.style.transform = prevTransform;
  inner.style.left      = prevLeft;

  const dataUrl = canvas.toDataURL('image/png');
  return { dataUrl, width: canvas.width, height: canvas.height };
}

  async function restorePhotosFromServer(bundleId){
    bundleId = (bundleId || '').trim();
    if(!bundleId) return false;
    try{
      const resp = await fetch(
        'https://partner.planet-tree.de/api2/wizard/state?bundle_id=' + encodeURIComponent(bundleId),
        { headers: { 'Accept': 'application/json' } }
      );
      if(!resp.ok){ console.warn('restorePhotosFromServer: HTTP', resp.status); return false; }
      const js = await resp.json();
      if(!js || !js.data){ console.warn('restorePhotosFromServer: no data in response'); return false; }

      let photos = js.data.photos || {};
      if(typeof photos === 'string'){
        try{ photos = JSON.parse(photos); }catch(e){ console.warn('restorePhotosFromServer: photos parse failed', e); return false; }
      }

      const hydrateSlot = (photoObj, stateObj, info)=>{
        if(!info){ return; }
        const dataUrl = info.data_url || info.dataUrl || info.url;
        if(!dataUrl || typeof dataUrl !== 'string' || dataUrl.indexOf('data:image') !== 0){ return; }
        const saved = {
          scale: (typeof info.scale === 'number' ? info.scale : (stateObj.scale || 1)),
          offX:  (typeof info.offX  === 'number' ? info.offX  : (stateObj.offX  || 0)),
          offY:  (typeof info.offY  === 'number' ? info.offY  : (stateObj.offY  || 0)),
          mode:  info.mode || stateObj.mode || 'contain',
          rotation: (typeof info.rotation === 'number' ? info.rotation : (stateObj.rotation || 0))
        };
        if(typeof photoObj.hydrateFromDataUrl === 'function'){ photoObj.hydrateFromDataUrl(dataUrl, saved); }
      };
            if(photos.greet_top)    hydrateSlot(greetPhoto1, state.greetPhoto1State, photos.greet_top);
      if(photos.greet_middle) hydrateSlot(greetPhoto2, state.greetPhoto2State, photos.greet_middle);
      if(photos.greet_bottom) hydrateSlot(greetPhoto3, state.greetPhoto3State, photos.greet_bottom);
      if(photos.sender)    hydrateSlot(photo1, state.photo1State, photos.sender);
      if(photos.recipient) hydrateSlot(photo4, state.photo4State, photos.recipient);
      if(photos.message)   hydrateSlot(photo6, state.photo6State, photos.message);
      return true;
    }catch(e){
      console.warn('restorePhotosFromServer failed', e);
      return false;
    }
  }

async function addBaseProductOnly(goCheckout){
  // In Admin-/Kunden-Edit: kein „ohne Baum“
  if (isAdminEdit || isCustomerEdit){
    alert('Diese Option steht hier nicht zur Verfügung.');
    return;
  }

  const variantId = getBaseVariantIdForNoTree();
  if(!variantId){
    alert('Dieses Produkt kann aktuell nicht direkt in den Warenkorb gelegt werden. Bitte bestelle ohne Wizard über die Produktseite.');
    return;
  }

  showLoadingOverlay();
  setSubmitting(true);

  try{
    // NEU: altes Bundle entfernen, falls wir aus dem Warenkorb-Edit kommen
    if (editBundleId){
      try{
        await removeExistingBundle(editBundleId);
      }catch(e){
        console.warn('removeExistingBundle (no-tree only) failed', e);
      }
    }

    const formData = new FormData();
    formData.append('items[0][id]', variantId);
    formData.append('items[0][quantity]', '1');

    // kleines Property, falls du später auswerten willst
    formData.append('items[0][properties][Ohne Baumpflanzung]', 'Ja');
    formData.append('items[0][properties][_pt_no_tree]', '1');

    const res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Accept':'application/json' },
      body:formData
    });

    if(!res.ok){
      console.error('cart/add.js (no-tree) error', await res.text());
      alert('Beim Hinzufügen des Produkts in den Warenkorb ist ein Fehler aufgetreten.');
      return;
    }

    window.location.href = goCheckout ? '/checkout' : '/cart';

  }catch(e){
    console.error('addBaseProductOnly failed', e);
    alert('Leider konnte das Produkt nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
  }finally{
    hideLoadingOverlay();
    setSubmitting(false);
  }
}

async function addBaseProductWithExtras(goCheckout){
  // Nur für Gift/Label im Kundenmodus
  if (!(state.mode === 'gift' || state.mode === 'label') || isAdminEdit || isCustomerEdit){
    // Fallback: einfache No-Tree-Variante ohne Extras
    addBaseProductOnly(goCheckout);
    return;
  }

  const variantId = getBaseVariantIdForNoTree();
  if(!variantId){
    alert('Dieses Produkt kann aktuell nicht direkt in den Warenkorb gelegt werden. Bitte bestelle ohne Wizard über die Produktseite.');
    return;
  }

  showLoadingOverlay();
  setSubmitting(true);

  try{
    // NEU: bestehendes Bundle rausnehmen, bevor wir die No-Tree-Variante + Extras hinzufügen
    if (editBundleId){
      try{
        await removeExistingBundle(editBundleId);
      }catch(e){
        console.warn('removeExistingBundle (no-tree extras) failed', e);
      }
    }

    const formData = new FormData();
    let idx = 0;
    const noTreeBundleId = 'NT-' + Date.now();

    // Hauptprodukt ohne Baum
    formData.append(`items[${idx}][id]`, variantId);
    formData.append(`items[${idx}][quantity]`, '1');
    formData.append(`items[${idx}][properties][_pt_no_tree]`, '1');
    formData.append(`items[${idx}][properties][_pt_bundle_id]`, noTreeBundleId);
    idx++;

    // Geschenkverpackung
    if(state.giftwrapAvailable && state.giftwrapSelected && VARIANTS.giftWrap){
      formData.append(`items[${idx}][id]`, VARIANTS.giftWrap);
      formData.append(`items[${idx}][quantity]`, '1');
      formData.append(`items[${idx}][properties][_pt_bundle_id]`, noTreeBundleId);
      formData.append(`items[${idx}][properties][_pt_role]`, 'gift_wrap');
      formData.append(`items[${idx}][properties][_pt_hidden]`, '1');
      idx++;
    }

    // Herz-Stecker
    if(state.extraHeartAvailable && state.extraHeartSelected && VARIANTS.extraHeart){
      formData.append(`items[${idx}][id]`, VARIANTS.extraHeart);
      formData.append(`items[${idx}][quantity]`, '1');
      formData.append(`items[${idx}][properties][_pt_bundle_id]`, noTreeBundleId);
      formData.append(`items[${idx}][properties][_pt_role]`, 'extra_heart');
      formData.append(`items[${idx}][properties][_pt_hidden]`, '1');
      idx++;
    }

    // Just-married-Stecker
    if(state.extraJustAvailable && state.extraJustSelected && VARIANTS.extraJustMarried){
      formData.append(`items[${idx}][id]`, VARIANTS.extraJustMarried);
      formData.append(`items[${idx}][quantity]`, '1');
      formData.append(`items[${idx}][properties][_pt_bundle_id]`, noTreeBundleId);
      formData.append(`items[${idx}][properties][_pt_role]`, 'extra_just_married');
      formData.append(`items[${idx}][properties][_pt_hidden]`, '1');
      idx++;
    }

    // Lesezeichen
    if(state.bookmarkAvailable && state.bookmarkSelected && state.bookmarkChoice){
      let vId = VARIANTS.bookmarkEule;
      let designTitle = 'Eule';

      if(state.bookmarkChoice === 'libelle'){
        vId = VARIANTS.bookmarkLibelle;
        designTitle = 'Libelle';
      }else if(state.bookmarkChoice === 'ginkgo'){
        vId = VARIANTS.bookmarkGinkgo;
        designTitle = 'Ginkgo';
      }

      formData.append(`items[${idx}][id]`, vId);
      formData.append(`items[${idx}][quantity]`, '1');
      formData.append(`items[${idx}][properties][_pt_bundle_id]`, noTreeBundleId);
      formData.append(`items[${idx}][properties][_pt_role]`, 'extra_bookmark');
      formData.append(`items[${idx}][properties][_pt_hidden]`, '1');
      formData.append(`items[${idx}][properties][_pt_bookmark_design]`, designTitle);
      idx++;
    }

    const res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Accept':'application/json' },
      body:formData
    });

    if(!res.ok){
      console.error('cart/add.js (no-tree extras) error', await res.text());
      alert('Beim Hinzufügen des Produkts in den Warenkorb ist ein Fehler aufgetreten.');
      return;
    }

    window.location.href = goCheckout ? '/checkout' : '/cart';

  }catch(e){
    console.error('addBaseProductWithExtras failed', e);
    alert('Leider konnte das Produkt nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
  }finally{
    hideLoadingOverlay();
    setSubmitting(false);
  }
}


// NEU: Serienfunktion – mehrere Zertifikate in einem Rutsch
async function addSeriesToCart(goCheckout){
  // Nur für neue Bestellungen, nicht im Admin-/Customer-Edit
  if (isAdminEdit || isCustomerEdit){
    alert('Die Serienfunktion steht im Änderungsmodus nicht zur Verfügung.');
    return;
  }

  if (state.mode !== 'cert'){
    alert('Die Serienfunktion ist aktuell nur für reine Zertifikate verfügbar.');
    return;
  }

  if (!seriesNamesTA){
    alert('Serienfunktion ist für dieses Produkt nicht aktiviert.');
    return;
  }

  // Namen/Firmen aus den Textfeldern ziehen
  refreshSeriesRowsFromInputs();
  const rows = state.seriesRows || [];

  if (!rows.length){
    alert('Bitte trage mindestens einen Namen für die Serien-Zertifikate ein.');
    return;
  }

  // Wenn nur ein Eintrag → wie gewohnt Einzel-Zertifikat
  if (rows.length === 1 && !isSeriesBlankRecipientRow(rows[0])){
    const r = rows[0] || {};
    txt4.value = seriesRowToText(r);
    fit4();
    state.seriesEnabled = false;
    applySeriesModeUI();
    await addToCart(goCheckout);
    return;
  }

  // Serienmodus weiterhin ohne Grußkarte
  if (state.greetCardSelected){
    alert('Die Serienfunktion ist derzeit ohne zusätzliche Grußkarte verfügbar. Bitte die Grußkarte deaktivieren oder einzelne Zertifikate erstellen.');
    setStep(10);
    return;
  }

  if (!state.forest){
    alert('Bitte wähle zuerst einen Pflanzort (Forst), bevor du Serien-Zertifikate erstellst.');
    setStep(7);
    return;
  }

  const baseForestCode = state.forest || 'mv';
  const baseForest     = FORESTS[baseForestCode] || FORESTS.mv;

  // Globale Defaults (werden pro Zertifikat überschrieben, wenn Serien-Daten existieren)
  const baseSender  = (txt1.value || '').trim();
  const baseMessage = (txt6.value || '').trim();
  const baseVerb    = state.verb || 'HAT';

  // Delivery & Papier gelten als Ausgangspunkt für die Serie
  const defaultDelivery = state.delivery || 'digital';
  const paperType       = state.paperType || 'white';

  const baseVariantId =
    state.certVariantId ||
    VARIANTS.certBase;

  if (!baseVariantId){
    alert('Die Basis-Variante für das Zertifikat konnte nicht ermittelt werden.');
    return;
  }

  showLoadingOverlay();
  setSubmitting(true);

  // Sicherstellen, dass Text-Felder optimal sitzen
  fit1(); fit4(); fit6();

  // Fotos nur einmal aus dem aktuellen State ziehen
  const photos = await (async ()=>{
    const result = {};
    async function addPhoto(key, st, imgEl){
      if(!st) return;
      let dataUrl = null;

      if(st.file){
        try{ dataUrl = await fileToDataURL(st.file); }catch(err){ console.warn('photo encode (Series)', key, err); }
      }
      if(!dataUrl && imgEl && imgEl.src && imgEl.src.indexOf('data:') === 0){
        dataUrl = imgEl.src;
      }
      if(!dataUrl && st.dataUrl){
        dataUrl = st.dataUrl;
      }
      if(!dataUrl) return;

result[key] = {
  data_url: dataUrl,
  mode:  st.mode  || 'contain',
  scale: st.scale || 1,
  offX:  st.offX  || 0,
  offY:  st.offY  || 0,
  rotation: st.rotation || 0,
  // NEU: Text der "unter" dem Foto lag, damit "Foto entfernen" wieder Sinn ergibt
  prev_text: (typeof st.prevText === 'string' ? st.prevText : '')
};
    }

    await Promise.all([
      addPhoto('sender',    state.photo1State, img1),
      addPhoto('recipient', state.photo4State, img4),
      addPhoto('message',   state.photo6State, img6)
    ]);

    return result;
  })();

  const baseTime  = Date.now();
  const results   = [];

  try{
    // 1) Für jede Person ein fertiges Zertifikat-Preview erzeugen
    for (let i = 0; i < rows.length; i++){
      const row = rows[i] || {};

      const decoBalloonThis = getDecoBalloonForIndex(i);
      const decoHatThis     = getDecoHatForIndex(i);
      const forestCodeForThis = getForestForIndex(i) || baseForestCode;
      const forestForThis     = FORESTS[forestCodeForThis] || baseForest;
      const frameColorForThis = getFrameColorForIndex(i) || FRAME_COLOR_DEFAULT;
      const deliveryForThis   = getDeliveryForIndex(i) || defaultDelivery;
      const paperTypeForThis  = getPaperTypeForIndex(i) || paperType;

            // Pro-Zertifikat: Schenkende:r und Grammatik
      const senderForThis = (
        state.seriesEnabled &&
        hasSeriesRows() &&
        Array.isArray(state.seriesSender)
      )
        ? (state.seriesSender[i] || baseSender)
        : baseSender;

      const verbForThis = (
        state.seriesEnabled &&
        hasSeriesRows() &&
        Array.isArray(state.seriesVerb)
      )
        ? getSeriesVerb(i)
        : baseVerb;

      // Namen robust rekonstruieren. Blanko-Zertifikate werden bewusst
      // mit leerem Empfänger gerendert und dürfen nicht aus der Textarea
      // nachbefüllt werden.
      const blankRecipient = isSeriesBlankRecipientRow(row);
      let line1 = blankRecipient ? '' : (row.line1 || '').trim();
      let line2 = blankRecipient ? '' : (row.line2 || '').trim();

      if (!blankRecipient && !line1 && seriesNamesTA){
        const namesArr = seriesNamesTA.value
          .split('\n')
          .map(s => s.trim())
          .filter(Boolean);
        if (i < namesArr.length){
          line1 = namesArr[i];
        }
      }

      if (!blankRecipient && !line2 && seriesCompaniesTA){
        const compsArr = seriesCompaniesTA.value
          .split('\n')
          .map(s => s.trim());
        if (i < compsArr.length){
          line2 = compsArr[i];
        }
      }

      const recipientText = blankRecipient ? '' : (line1 + (line2 ? '\n' + line2 : ''));

      const occArr = Array.isArray(state.seriesOccasion) ? state.seriesOccasion : [];
      const messageForThis = occArr[i] && typeof occArr[i] === 'string'
        ? occArr[i]
        : baseMessage;

      // Baumanzahl für dieses Zertifikat – immer aus seriesTrees
      const treesForThis = getTreesForIndex(i);

      // Globalen Wizard-State auf diesen Slot setzen,
      // damit DOM-Preview & html2canvas das richtige Layout rendern
      state.forest     = forestCodeForThis;
      state.frameColor = frameColorForThis;
      state.delivery   = deliveryForThis;
      state.paperType  = paperTypeForThis;
      state.verb       = verbForThis;
      state.trees      = treesForThis;
      if (qVal) qVal.value = treesForThis;

        // Schenkende:r für dieses Zertifikat in den DOM spiegeln,
  // damit Snapshot & PNG den richtigen Namen enthalten
      if (txt1){
        txt1.value = senderForThis;
        if (typeof fit1 === 'function') fit1();
      }

  // Optional: Serien-Array sauber halten (falls mal leer war)
  if (!Array.isArray(state.seriesSender)) state.seriesSender = [];
  state.seriesSender[i] = senderForThis;

      // Empfänger-Text + Nachricht ins normale Feld spiegeln
      txt4.value   = recipientText;
      fit4();

      txt6.value   = messageForThis;
      fit6();

      // Dekoration für dieses Zertifikat in den State übernehmen
      state.decoBalloon = !!decoBalloonThis;
      state.decoHat     = !!decoHatThis;
      applyDecor();

      try{
        placeA4Boxes();
        updatePreview();
      }catch(e){
        console.warn('updatePreview im Serienlauf fehlgeschlagen', e);
      }

      const bundleId = 'PTB-S-' + baseTime + '-' + (i+1);

      let canvasSnap = null;
      try{
        canvasSnap = await captureCertificatePng();
      }catch(e){
        console.warn('captureCertificatePng (Serie) fehlgeschlagen', e);
      }

      if (!canvasSnap){
        throw new Error('Für einen der Namen konnte kein Zertifikatsbild erzeugt werden.');
      }

      // Für jedes Zertifikat separat render_preview aufrufen
      let previewUrl = '';
      let pdfUrl     = '';

      try{
        const resp = await fetch('https://partner.planet-tree.de/api2/cert/render_preview', {
          method:'POST',
          headers:{ 'Content-Type':'application/json' },
          body: JSON.stringify({
            bundle_id: bundleId,
            mode: state.mode || 'cert',
            verb:        verbForThis,
            trees:       treesForThis,
            sender:      senderForThis,
            recipient:   recipientText,
            blank_recipient: !!blankRecipient,
            message:     messageForThis,
            deco_balloon: !!decoBalloonThis,
            deco_hat:     !!decoHatThis,
            frame_color:  frameColorForThis,
            forest_code:  forestCodeForThis,
            delivery:     deliveryForThis,
            paper_type:   paperTypeForThis,
            gift_title:   '',
            gift_img:     '',
            gift_base_price: null,
            cert_base_price: null,
            gift_variant_id: null,
            cert_variant_id: state.certVariantId || null,
            giftwrap:   false,
            gimmick_code: null,
            snapshot:   buildLayoutSnapshot(),
            photos:     photos,
            canvas_png: canvasSnap.dataUrl,
            label_png:  null,
            label_border_color: state.labelBorderColor || state.frameColor || '#337451',
            label_line1: '',
            label_line2: '',
            label_line3: '',
            label_claim: buildClaim(),
            greet_card:      false,
            greet_card_png:  null,
            greet_card_text1:'',
            greet_card_text2:'',
            greet_card_text3:''
          })
        });
        if (resp.ok){
          const data = await resp.json();
          previewUrl = data.preview_url || '';
          pdfUrl     = data.pdf_url     || '';
        }else{
          console.warn('render_preview (Serie) HTTP', resp.status);
        }
      }catch(e){
        console.warn('render_preview (Serie) failed', e);
      }

results.push({
  bundleId,
  recipientText,
  previewUrl,
  pdfUrl,
  trees: treesForThis,
  messageForThis,
  decoBalloon: !!decoBalloonThis,
  decoHat:     !!decoHatThis,
  delivery:    deliveryForThis,
  forestCode:  forestCodeForThis,
  forestName:  forestForThis.name,
  frameColor:  frameColorForThis,
  paperType:   paperTypeForThis,
  sender:      senderForThis,
  verb:        verbForThis,
  blankRecipient: !!blankRecipient
});
    }

    // 2) Alles in EINEM cart/add-Call in den Warenkorb legen
    const formData = new FormData();
    let idx = 0;

results.forEach(res=>{
  const props = {};

  const deliveryForThis   = res.delivery   || defaultDelivery;
  const forestNameForThis = res.forestName || baseForest.name;
  const forestCodeForThis = res.forestCode || baseForestCode;
  const frameColorForThis = res.frameColor || state.frameColor || FRAME_COLOR_DEFAULT;
  const paperTypeForThis  = res.paperType  || paperType;

  const senderForThis  = res.sender || baseSender;
  const verbForThis    = res.verb   || baseVerb;
  const isPluralForThis= (verbForThis === 'HABEN');

  props['DeinEuer Name für das Zertifikat:'] = senderForThis;
  props['Einzahl oder Mehrzahl:'] = isPluralForThis
    ? 'haben gepflanzt für'
    : 'hat gepflanzt für';

  const keyTrees = isPluralForThis
    ? 'Wie viele Bäume möchtet Ihr pflanzen?'
    : 'Wie viele Bäume möchtest Du pflanzen?';

  const treesForThis = res.trees || 1;
  const valTrees = (treesForThis === 1)
    ? '1 Baum (enthalten)'
    : (treesForThis + ' Bäume');

  props[keyTrees] = valTrees;

  props['Name desder Beschenkten:']  = res.recipientText;
  props['Anlass/Datum/Message:']     = res.messageForThis || '';
  props['Pflanzort (Forst):']        = forestNameForThis;
  props['Zertifikat erhalten als:']  = getDeliveryLabel(deliveryForThis, paperTypeForThis);

  props['_pt_forest_code'] = forestCodeForThis;
  props['_pt_bundle_id']   = res.bundleId;
  props['_pt_role']        = 'base';
  props['_pt_trees']       = String(treesForThis);
  props['_pt_frame_color'] = frameColorForThis;
  props['_pt_delivery']    = deliveryForThis;
  props['_pt_paper_type']  = paperTypeForThis;
  props['_pt_mode']        = state.mode || 'cert';
  if (res.blankRecipient) props['_pt_blank_recipient'] = '1';

  if (res.decoBalloon) props['_pt_deco_balloon'] = '1';
  if (res.decoHat)     props['_pt_deco_hat']     = '1';
  if (res.previewUrl)  props['pt_cert_preview_url'] = res.previewUrl;
  if (res.pdfUrl)      props['pt_cert_pdf_url']     = res.pdfUrl;

  // Basis-Zertifikatsartikel
  const lineIndexBase = idx++;
  formData.append(`items[${lineIndexBase}][id]`, baseVariantId);
  formData.append(`items[${lineIndexBase}][quantity]`, '1');
  Object.entries(props).forEach(([k,v])=>{
    formData.append(`items[${lineIndexBase}][properties][${k}]`, v || '');
  });

  // Print-Zusatz je Zertifikat, falls Serie auf Print steht
  if (deliveryForThis === 'print'){
    const printVariantId =
      paperTypeForThis === 'grass'
        ? VARIANTS.printGrass
        : VARIANTS.printWhite;

    if (printVariantId){
      const lineIndexPrint = idx++;
      formData.append(`items[${lineIndexPrint}][id]`, printVariantId);
      formData.append(`items[${lineIndexPrint}][quantity]`, '1');
      formData.append(`items[${lineIndexPrint}][properties][_pt_bundle_id]`, res.bundleId);
      formData.append(`items[${lineIndexPrint}][properties][_pt_role]`,      'print');
      formData.append(`items[${lineIndexPrint}][properties][_pt_hidden]`,    '1');
      formData.append(`items[${lineIndexPrint}][properties][_pt_paper_type]`, paperTypeForThis || 'white');
    }
  }

  // Zusatzbäume pro Zertifikat, falls >1 Baum gewählt
  if (VARIANTS.extraTree){
    const extraQtyPerCert = Math.max(0, treesForThis - 1);
    if (extraQtyPerCert > 0){
      const lineIndexExtra = idx++;
      formData.append(`items[${lineIndexExtra}][id]`, VARIANTS.extraTree);
      formData.append(`items[${lineIndexExtra}][quantity]`, String(extraQtyPerCert));
      formData.append(`items[${lineIndexExtra}][properties][_pt_bundle_id]`, res.bundleId);
      formData.append(`items[${lineIndexExtra}][properties][_pt_role]`, 'extra');
      formData.append(`items[${lineIndexExtra}][properties][_pt_hidden]`, '1');
    }
  }
});

    const respCart = await fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Accept':'application/json' },
      body:formData
    });

    if (!respCart.ok){
      console.error('cart/add.js (Serie) error', await respCart.text());
      alert('Beim Hinzufügen der Serien-Zertifikate in den Warenkorb ist ein Fehler aufgetreten.');
      return;
    }

    // Draft leeren und weiterleiten
    clearDraft();
    window.location.href = goCheckout ? '/checkout' : '/cart';

  }catch(err){
    console.error('addSeriesToCart failed', err);
    alert('Beim Erstellen der Serien-Zertifikate ist ein Fehler aufgetreten. Bitte versuche es noch einmal oder reduziere die Anzahl der Namen.');
  }finally{
    hideLoadingOverlay();
    setSubmitting(false);
  }
}


  /* ===== Checkout / Warenkorb Integration ===== */
async function addToCart(goCheckout){
  // Fail-safe: Gift/Label + Bäume + Zertifikat, aber kein Tree-Addon → nicht erlauben
  if ((state.mode === 'gift' || state.mode === 'label') &&
      !state.noTreeExtrasMode &&
      (state.trees || 1) > 0 &&
      !state.treeAddonSelected) {

    state.treeAddonSelected = true;
    updatePrice();
  }

  // --- NEU: prüfen, ob IRGENDEIN Zertifikat digital ist ---
  let hasAnyDigital = false;

  if (state.mode === 'cert' && state.seriesEnabled && hasSeriesRows()){
    const count = state.seriesRows.length;
    for (let i = 0; i < count; i++){
      if (getDeliveryForIndex(i) === 'digital'){
        hasAnyDigital = true;
        break;
      }
    }
  } else {
    hasAnyDigital = (state.delivery === 'digital');
  }

  // Wenn digitale Version(en) dabei sind und noch nicht bestätigt wurde(n)
  if (hasAnyDigital && !state.digitalConfirmed) {

    if (dlgDigital) {
      openDigitalConfirm(goCheckout);
      return;
    }

    state.digitalConfirmed = true;
  }

  // NEU: Serienmodus → eigene Funktion, Single-Flow bleibt unangetastet
  if (state.mode === 'cert' && state.seriesEnabled){
    await addSeriesToCart(goCheckout);
    return;
  }

  showLoadingOverlay();
  setSubmitting(true);

  fit1(); fit4(); fit6();
    const bundleId = editBundleId || ('PTB-' + Date.now());

    let canvasSnap = null;
    try{ canvasSnap = await captureCertificatePng(); }catch(e){ console.warn('captureCertificatePng failed in addToCart', e); }

// PATCH: wenn selbst Fallback scheitert, lieber abbrechen als ein kaputtes Zertifikat erzeugen
if (!canvasSnap){
  // JS-Error an Backend melden (best effort, ohne den User zusätzlich zu nerven)
  try{
    const errorPayload = {
      msg: "html2canvas / captureCertificatePng konnte kein Zertifikatsbild erzeugen (canvasSnap == null)",
      step: state.step,
      mode: state.mode,
      forest: state.forest,
      trees: state.trees,
      delivery: state.delivery,
      paperType: state.paperType,
      bundle_id: bundleId,
      ctx: {
        hasPhotoSender:    !!state.photo1State && !!state.photo1State.w,
        hasPhotoRecipient: !!state.photo4State && !!state.photo4State.w,
        hasPhotoMessage:   !!state.photo6State && !!state.photo6State.w,
        greetCardSelected: !!state.greetCardSelected
      },
      ua: (typeof navigator !== "undefined" && navigator.userAgent) ? navigator.userAgent : ""
    };

    fetch("https://partner.planet-tree.de/api2/wizard/js_error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(errorPayload)
    }).catch(function(err){
      console.warn("wizard js_error logging failed", err);
    });
  }catch(e){
    console.warn("wizard js_error payload build failed", e);
  }

  hideLoadingOverlay();
  setSubmitting(false);
  alert(
    'Auf deinem Gerät konnte das Zertifikat technisch nicht korrekt erzeugt werden.\n\n' +
    'Bitte versuche es mit einem anderen Browser oder Gerät – ' +
    'wir wollen dir kein fehlerhaftes Zertifikat ausstellen.'
  );
  return;
}

    let labelSnap = null;
    if(state.mode === 'label'){
      try{ updateLabelFinal(); labelSnap = await captureLabelPng(); }catch(e){ console.warn('captureLabelPng failed', e); }
    }

        // NEU: Grußkarte
    let greetCardSnap = null;
    if(state.greetCardSelected){
      try{
        greetCardSnap = await captureGreetingCardPng();
      }catch(e){
        console.warn('captureGreetingCardPng failed in addToCart', e);
      }
    }

    try{ placeA4Boxes(); updatePreview(); scaleA4(); }catch(e){ console.warn('preview refresh before snapshot failed', e); }

    const sender    = (txt1.value || '').trim();
    const recipient = (txt4.value || '').trim();
    const message   = (txt6.value || '').trim();
    const trees     = state.trees || 1;
    const isPlural  = (state.verb === 'HABEN');
    const verb      = state.verb || 'HAT';

    if(!state.forest){
      alert('Bitte wähle zuerst einen Pflanzort (Forst).');
      setStep(7);
      setSubmitting(false);
      hideLoadingOverlay();
      return;
    }
    const forest    = FORESTS[state.forest] || FORESTS.mv;


    if(editBundleId){
      try{ await removeExistingBundle(editBundleId); }catch(e){ console.warn('removeExistingBundle in addToCart failed', e); }
    }

    let previewUrl = '';
    let pdfUrl     = '';
    let labelPreviewUrl = '';
    let greetPreviewUrl = '';

    const snapshot = buildLayoutSnapshot();

    async function buildPhotoPayload(){
      const result = {};
      async function addPhoto(key, st, imgEl){
        if(!st) return;
        let dataUrl = null;
        if(st.file){ try{ dataUrl = await fileToDataURL(st.file); }catch(err){ console.warn('photo encode failed for', key, err); } }
        if(!dataUrl && imgEl && imgEl.src && imgEl.src.indexOf('data:') === 0){ dataUrl = imgEl.src; }
        if(!dataUrl && st.dataUrl){ dataUrl = st.dataUrl; }
        if(!dataUrl) return;
        result[key] = { data_url: dataUrl, mode:  st.mode  || 'contain', scale: st.scale || 1, offX:  st.offX  || 0, offY:  st.offY  || 0 };
      }
        await Promise.all([
          addPhoto('sender',       state.photo1State,      img1),
          addPhoto('recipient',    state.photo4State,      img4),
          addPhoto('message',      state.photo6State,      img6),
          addPhoto('greet_top',    state.greetPhoto1State, gcImg1),
          addPhoto('greet_middle', state.greetPhoto2State, gcImg2),
          addPhoto('greet_bottom', state.greetPhoto3State, gcImg3)
        ]);
        return result;
    }
    const photos = await buildPhotoPayload();

    try{
      const resp = await fetch('https://partner.planet-tree.de/api2/cert/render_preview', {
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({
          bundle_id: bundleId,
          mode: state.mode || 'cert',
          verb, trees, sender, recipient, message,
          deco_balloon: !!state.decoBalloon,
          deco_hat: !!state.decoHat,
          frame_color: state.frameColor || '#337451',
          forest_code:  state.forest || null,
          delivery:  state.delivery || 'digital',
          paper_type: state.paperType || 'white',
          gift_title: state.giftTitle || '',
          gift_img:   state.giftImg   || '',
          gift_base_price: (state.giftBasePrice != null ? state.giftBasePrice : null),
          cert_base_price: (state.certBasePrice != null ? state.certBasePrice : null),
          gift_variant_id:  state.giftVariantId || null,
          cert_variant_id:  state.certVariantId || null,
          giftwrap:   !!((state.mode==='gift'||state.mode==='label') && state.giftwrapAvailable && state.giftwrapSelected),
          gimmick_code: ((state.mode==='gift'||state.mode==='label') && state.gimmickSelected) ? state.gimmickCode : null,
          snapshot: snapshot || null,
          photos: photos,
          canvas_png: canvasSnap ? canvasSnap.dataUrl : null,

          label_png: labelSnap ? labelSnap.dataUrl : null,
          label_border_color: state.labelBorderColor || state.frameColor || '#337451',
          label_line1: state.labelLine1 || '',
          label_line2: state.labelLine2 || '',
          label_line3: state.labelLine3 || '',
          label_claim: buildClaim(),
          greet_card:      !!state.greetCardSelected,
          greet_card_png:  greetCardSnap ? greetCardSnap.dataUrl : null,
                    // NEU: Grußkartentexte speichern
          greet_card_text1: gcTxt1 ? gcTxt1.value : '',
          greet_card_text2: gcTxt2 ? gcTxt2.value : '',
          greet_card_text3: gcTxt3 ? gcTxt3.value : ''
        })
      });
      if (resp.ok){
        const data = await resp.json();
        if (data.preview_url) previewUrl = data.preview_url;
        if (data.pdf_url)     pdfUrl     = data.pdf_url;
        if (data.label_preview_url) labelPreviewUrl = data.label_preview_url;
        if (data.greet_preview_url)  greetPreviewUrl  = data.greet_preview_url; // NEU
      } else {
        console.warn('render_preview HTTP error', resp.status);
      }
    } catch(err){ console.warn('render_preview failed', err); }

    const propsBase = {};
    propsBase['DeinEuer Name für das Zertifikat:'] = sender;
    propsBase['Einzahl oder Mehrzahl:'] = isPlural ? 'haben gepflanzt für' : 'hat gepflanzt für';

    const keyTrees = isPlural ? 'Wie viele Bäume möchtet Ihr pflanzen?' : 'Wie viele Bäume möchtest Du pflanzen?';
    const valTrees = (trees === 1) ? '1 Baum (enthalten)' : (trees + ' Bäume');

    propsBase[keyTrees] = valTrees;
    propsBase['Name desder Beschenkten:']  = recipient;
    propsBase['Anlass/Datum/Message:']     = message;
    propsBase['Pflanzort (Forst):']        = forest.name;
    propsBase['Zertifikat erhalten als:']  = getDeliveryLabel();

    if(state.giftTitle){ propsBase['Zertifikat gehört zu Produkt:'] = state.giftTitle; }

        if(state.greetCardSelected){
      propsBase['Grußkarte hinzugefügt:'] = 'Ja';

      // NEU: Grußkarten-PNG aus dem Server-Preview im Line Item speichern
      if (greetPreviewUrl){
        propsBase['pt_greet_preview_url'] = greetPreviewUrl;
      }
    }

    propsBase['_pt_forest_code'] = forest.code;
    propsBase['_pt_bundle_id']   = bundleId;
    propsBase['_pt_role']        = 'base';
    propsBase['_pt_trees']       = String(trees);
    propsBase['_pt_frame_color'] = state.frameColor || FRAME_COLOR_DEFAULT;
    propsBase['_pt_delivery']    = state.delivery || 'digital';
    propsBase['_pt_paper_type']  = state.paperType || 'white';
    propsBase['_pt_mode']        = state.mode || 'cert';
    if(state.mode === 'gift' || state.mode === 'label'){
      propsBase['_pt_giftwrap']     = (state.giftwrapAvailable && state.giftwrapSelected) ? '1' : '0';
      propsBase['_pt_gimmick_code'] = (state.gimmickSelected ? (state.gimmickCode || '') : '');
      propsBase['_pt_gift_title']   = state.giftTitle || '';
      propsBase['_pt_gift_img']     = state.giftImg || '';
    }

    if (state.decoBalloon) propsBase['_pt_deco_balloon'] = '1';
    if (state.decoHat)     propsBase['_pt_deco_hat']     = '1';
    if (previewUrl)        propsBase['pt_cert_preview_url'] = previewUrl;
    if (pdfUrl)            propsBase['pt_cert_pdf_url']     = pdfUrl;

    if(state.mode === 'label'){
      propsBase['_pt_label_border_color'] = state.labelBorderColor || state.frameColor || FRAME_COLOR_DEFAULT;
      propsBase['_pt_label_line1'] = state.labelLine1 || '';
      propsBase['_pt_label_line2'] = state.labelLine2 || '';
      propsBase['_pt_label_line3'] = state.labelLine3 || '';
      if(labelPreviewUrl) propsBase['pt_label_preview_url'] = labelPreviewUrl;
    }

        if(state.extraHeartAvailable){
      propsBase['Herz-Stecker aus Holz:'] = state.extraHeartSelected ? 'Ja' : 'Nein';
    }
    if(state.extraJustAvailable){
      propsBase['"Just married"-Stecker:'] = state.extraJustSelected ? 'Ja' : 'Nein';
    }
    if(state.bookmarkAvailable){
      let val = 'Nein';
      if(state.bookmarkSelected){
        const map = { eule:'Eule', libelle:'Libelle', ginkgo:'Ginkgo' };
        val = 'Ja – ' + (map[state.bookmarkChoice] || 'Motiv');
      }
      propsBase['Metall-Lesezeichen:'] = val;
    }

    const formData = new FormData();
    let nextIndex = 0;

    // Basisartikel
    if((state.mode === 'gift' || state.mode==='label') && state.giftVariantId){
      formData.append(`items[${nextIndex}][id]`, state.giftVariantId);
      formData.append(`items[${nextIndex}][quantity]`, '1');
      Object.entries(propsBase).forEach(([k,v])=>{
        formData.append(`items[${nextIndex}][properties][${k}]`, v || '');
      });
      nextIndex++;
    } else if (state.mode === 'cert' && state.certVariantId){
      formData.append(`items[${nextIndex}][id]`, state.certVariantId);
      formData.append(`items[${nextIndex}][quantity]`, '1');
      Object.entries(propsBase).forEach(([k,v])=>{
        formData.append(`items[${nextIndex}][properties][${k}]`, v || '');
      });
      nextIndex++;
    } else {
      const baseVariantId = VARIANTS.certBase;
      formData.append(`items[${nextIndex}][id]`, baseVariantId);
      formData.append(`items[${nextIndex}][quantity]`, '1');
      Object.entries(propsBase).forEach(([k,v])=>{
        formData.append(`items[${nextIndex}][properties][${k}]`, v || '');
      });
      nextIndex++;
    }

        // Tree-Addon (Grundbaumpflanzung) für Gift/Label
// Tree-Addon (Grundbaumpflanzung) für Gift/Label
// Bei Always-Tree-Gift (41825519599803) ist der erste Baum im Produktpreis enthalten,
// daher KEIN zusätzliches treeAddonBase-Lineitem.
if((state.mode === 'gift' || state.mode === 'label') &&
   state.treeAddonSelected &&
   VARIANTS.treeAddonBase &&
   !(state.mode === 'gift' && isGiftAlwaysTree)){
  formData.append(`items[${nextIndex}][id]`, VARIANTS.treeAddonBase);
  formData.append(`items[${nextIndex}][quantity]`, '1');
  formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
  formData.append(`items[${nextIndex}][properties][_pt_role]`,      'tree_base');
  formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');
  nextIndex++;
}

    // Weitere Bäume
    const extraQty = (state.mode === 'cert' || state.treeAddonSelected)
      ? Math.max(0, trees - 1)
      : 0;

    if(extraQty > 0){
      formData.append(`items[${nextIndex}][id]`, VARIANTS.extraTree);
      formData.append(`items[${nextIndex}][quantity]`, String(extraQty));
      formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
      formData.append(`items[${nextIndex}][properties][_pt_role]`,      'extra');
      formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');
      nextIndex++;
    }

    // Druck / Papier (cert) bzw. Papier (gift/label)
    if(state.delivery === 'print' || state.mode==='gift' || state.mode==='label'){
      if(state.mode === 'cert'){
        const printVariantId = state.paperType === 'grass'
          ? VARIANTS.printGrass : VARIANTS.printWhite;
        formData.append(`items[${nextIndex}][id]`, printVariantId);
        formData.append(`items[${nextIndex}][quantity]`, '1');
        formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
        formData.append(`items[${nextIndex}][properties][_pt_role]`,      'print');
        formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');
        formData.append(`items[${nextIndex}][properties][_pt_paper_type]`, state.paperType || 'white');
        nextIndex++;
      }else{
        if(state.paperType === 'grass' && VARIANTS.giftPaperGrass){
          formData.append(`items[${nextIndex}][id]`, VARIANTS.giftPaperGrass);
          formData.append(`items[${nextIndex}][quantity]`, '1');
          formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
          formData.append(`items[${nextIndex}][properties][_pt_role]`,      'gift_paper');
          formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');
          formData.append(`items[${nextIndex}][properties][_pt_paper_type]`, 'grass');
          nextIndex++;
        }
      }
    }


    // Gift/Label: Extras
    if(state.mode === 'gift' || state.mode === 'label'){
      // Geschenkverpackung
      if(state.giftwrapAvailable && state.giftwrapSelected && VARIANTS.giftWrap){
        formData.append(`items[${nextIndex}][id]`, VARIANTS.giftWrap);
        formData.append(`items[${nextIndex}][quantity]`, '1');
        formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
        formData.append(`items[${nextIndex}][properties][_pt_role]`,      'gift_wrap');
        formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');
        nextIndex++;
      }

      // Gimmick (z. B. zweiter Ofenhandschuh)
      if(state.gimmickAvailable && state.gimmickSelected && state.gimmickConfig){
        const code = state.gimmickCode;
        const vId  = (VARIANTS.gimmicks && VARIANTS.gimmicks[code])
          ? VARIANTS.gimmicks[code]
          : state.gimmickConfig.id;

        formData.append(`items[${nextIndex}][id]`, vId);
        formData.append(`items[${nextIndex}][quantity]`, '1');
        formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
        formData.append(`items[${nextIndex}][properties][_pt_role]`,      'gimmick');
        formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');
        formData.append(`items[${nextIndex}][properties][_pt_gimmick_code]`, code || '');
        nextIndex++;
      }

      // NEU: Herz-Stecker
      if(state.extraHeartAvailable && state.extraHeartSelected && VARIANTS.extraHeart){
        formData.append(`items[${nextIndex}][id]`, VARIANTS.extraHeart);
        formData.append(`items[${nextIndex}][quantity]`, '1');
        formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
        formData.append(`items[${nextIndex}][properties][_pt_role]`,      'extra_heart');
        formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');
        nextIndex++;
      }

      // NEU: Just married-Stecker
      if(state.extraJustAvailable && state.extraJustSelected && VARIANTS.extraJustMarried){
        formData.append(`items[${nextIndex}][id]`, VARIANTS.extraJustMarried);
        formData.append(`items[${nextIndex}][quantity]`, '1');
        formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
        formData.append(`items[${nextIndex}][properties][_pt_role]`,      'extra_just_married');
        formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');
        nextIndex++;
      }

      // NEU: Lesezeichen (Design-abhängig)
      if(state.bookmarkAvailable && state.bookmarkSelected && state.bookmarkChoice){
        let vId = VARIANTS.bookmarkEule;
        let designTitle = 'Eule';

        if(state.bookmarkChoice === 'libelle'){
          vId = VARIANTS.bookmarkLibelle;
          designTitle = 'Libelle';
        } else if(state.bookmarkChoice === 'ginkgo'){
          vId = VARIANTS.bookmarkGinkgo;
          designTitle = 'Ginkgo';
        }

        formData.append(`items[${nextIndex}][id]`, vId);
        formData.append(`items[${nextIndex}][quantity]`, '1');
        formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
        formData.append(`items[${nextIndex}][properties][_pt_role]`,      'extra_bookmark');
        formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');
        formData.append(`items[${nextIndex}][properties][_pt_bookmark_design]`, designTitle);
        nextIndex++;
      }
    }

    // Grußkarte (alle Modi)
    // cert + digital → kostenlose Variante
    // sonst → kostenpflichtige Variante (Aufpreis, z. B. 3,50 €)
    if (state.greetCardSelected) {
      let greetVariantId = null;

      if (state.mode === 'cert' && state.delivery === 'digital') {
        // Kostenloses Karten-Variant für digitale Zertifikate
        greetVariantId = VARIANTS.greetingCardFree || VARIANTS.greetingCardPaid;
      } else {
        // Kostenpflichtige Karte für alle anderen Fälle (cert+print, gift, label)
        greetVariantId = VARIANTS.greetingCardPaid;
      }

      if (greetVariantId) {
        formData.append(`items[${nextIndex}][id]`, greetVariantId);
        formData.append(`items[${nextIndex}][quantity]`, '1');
        formData.append(`items[${nextIndex}][properties][_pt_bundle_id]`, bundleId);
        formData.append(`items[${nextIndex}][properties][_pt_role]`,      'greet_card');
        formData.append(`items[${nextIndex}][properties][_pt_hidden]`,    '1');

        // Typ markieren: kostenlos vs. bezahlt
        if (state.mode === 'cert' && state.delivery === 'digital') {
          formData.append(`items[${nextIndex}][properties][_pt_greet_type]`, 'digital_free');
        } else {
          formData.append(`items[${nextIndex}][properties][_pt_greet_type]`, 'paid');
        }

        nextIndex++;
      }
    }

    try{
      const res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Accept':'application/json' },
        body:formData
      });
      if(!res.ok){
        console.error('cart/add.js error', await res.text());
        alert('Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten.');
        setSubmitting(false);
        hideLoadingOverlay();
        return;
      }
      clearDraft();
      window.location.href = goCheckout ? '/checkout' : '/cart';
    }catch(err){
      console.error(err);
      alert('Leider konnte das Zertifikat nicht zum Warenkorb hinzugefügt werden. Bitte versuche es erneut.');
      setSubmitting(false);
      hideLoadingOverlay();
    }
}

async function customerUpdateCertificate(){
  if (!isCustomerEdit || !adminOrderId || !adminLineItemId){
    alert('Dieser Link zur Zertifikats-Änderung ist nicht gültig.');
    return;
  }

  showLoadingOverlay();
  setSubmitting(true);

  // Texte/Fotos in der Vorschau aktualisieren
  fit1(); fit4(); fit6();

  let canvasSnap = null;
  let labelSnap  = null;
  let greetSnap  = null;

  try {
    canvasSnap = await captureCertificatePng();
  } catch(e){
    console.warn('canvas', e);
  }
  if (state.mode === 'label'){
    try { labelSnap = await captureLabelPng(); } catch(e){ console.warn('label', e); }
  }
  if (state.greetCardSelected){
    try { greetSnap = await captureGreetingCardPng(); } catch(e){ console.warn('greet', e); }
  }

  // bundle_id aus URL nehmen (edit_bundle)
  const urlParams    = new URLSearchParams(window.location.search || '');
  const bundleFromUrl= urlParams.get('edit_bundle');

  const payload = {
    action:        'update',   // optionales Flag, Backend ignoriert es aktuell
    order_id:      adminOrderId,
    line_item_id:  adminLineItemId,
    bundle_id:     bundleFromUrl || null,
    canvas_png:    canvasSnap ? canvasSnap.dataUrl : null,
    label_png:     labelSnap   ? labelSnap.dataUrl  : null,
    greet_card_png:greetSnap  ? greetSnap.dataUrl  : null
  };

  try{
    const resp = await fetch('https://partner.planet-tree.de/api2/cert/customer_update', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload)
    });

    const js = await resp.json().catch(()=> ({}));

    if (!resp.ok || !js.ok){
      const reason = js && js.reason;
      if (reason === 'edit_already_used'){
        alert('Die einmalige Korrektur für dieses Zertifikat wurde bereits genutzt.');
        // Nach dem Hinweis zurück zur Zertifikatsansicht
        const returnTo = urlParams.get('return_to');
        if (returnTo){
          window.location.href = returnTo;
        } else if (urlParams.get('from_cert_view') === '1'){
          window.history.back();
        }
      } else if (reason === 'not_a_certificate'){
        alert('Für diese Bestellung konnte kein Zertifikat gefunden werden.');
      } else {
        alert('Beim Aktualisieren deines Zertifikats ist ein Fehler aufgetreten. Bitte melde dich bei uns, wenn das Problem bleibt.');
      }
    } else {
      // Erfolgreich aktualisiert
      alert('Deine Änderungen wurden gespeichert. Die Seite mit deinem Zertifikat wird jetzt neu geladen.');

      const returnTo = urlParams.get('return_to');
      if (returnTo){
        setTimeout(()=>{ window.location.href = returnTo; }, 800);
      } else if (urlParams.get('from_cert_view') === '1'){
        setTimeout(()=>{ window.history.back(); }, 800);
      } else {
        setTimeout(()=>{ closeWizard(); }, 800);
      }
    }
  } catch(e){
    console.error(e);
    alert('Leider konnte dein Zertifikat gerade nicht aktualisiert werden. Bitte versuche es später erneut.');
  } finally {
    setSubmitting(false);
    hideLoadingOverlay();
  }
}

async function socialUpdateCertificate(){
  if (!isSocialEdit){
    alert('Dieser Änderungs-Link ist nicht gültig.');
    return;
  }

  showLoadingOverlay();
  setSubmitting(true);

  fit1(); fit4(); fit6();

  let canvasSnap = null;
  let labelSnap  = null;
  let greetSnap  = null;

  try { canvasSnap = await captureCertificatePng(); } catch(e){ console.warn('canvas', e); }
  if (state.mode === 'label'){
    try { labelSnap = await captureLabelPng(); } catch(e){ console.warn('label', e); }
  }
  if (state.greetCardSelected){
    try { greetSnap = await captureGreetingCardPng(); } catch(e){ console.warn('greet', e); }
  }

  const urlParams = new URLSearchParams(window.location.search || '');
  const bundleFromUrl = urlParams.get('edit_bundle') || null;

  const payload = {
    code: socialCode,
    exp: socialExp,
    sig: socialSig,
    bundle_id: bundleFromUrl,
    canvas_png: canvasSnap ? canvasSnap.dataUrl : null,
    label_png: labelSnap ? labelSnap.dataUrl : null,
    greet_card_png: greetSnap ? greetSnap.dataUrl : null
  };

  try{
    const resp = await fetch('https://partner.planet-tree.de/api2/cert/social_update', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify(payload)
    });

    const js = await resp.json().catch(()=> ({}));

    if (!resp.ok || !js.ok){
      if (js && js.reason === 'edit_already_used'){
        alert('Die einmalige Korrektur für dieses Zertifikat wurde bereits genutzt.');
      } else {
        alert('Beim Speichern ist ein Fehler aufgetreten. Bitte später erneut versuchen.');
      }
      const returnTo = urlParams.get('return_to');
      if (returnTo) window.location.href = returnTo;
      return;
    }

    alert('Deine Änderungen wurden gespeichert. Die Seite mit deinem Zertifikat wird jetzt neu geladen.');
    const returnTo = urlParams.get('return_to');
    window.location.href = returnTo || (`/pages/dein-zertifikat?code=${encodeURIComponent(socialCode)}&exp=${encodeURIComponent(String(socialExp))}&sig=${encodeURIComponent(socialSig)}`);
  }catch(e){
    console.error(e);
    alert('Leider konnte dein Zertifikat gerade nicht aktualisiert werden. Bitte später erneut versuchen.');
  }finally{
    setSubmitting(false);
    hideLoadingOverlay();
  }
}


async function adminUpdateCertificate(){
  if (!isAdminEdit || !adminOrderId || !adminLineItemId){
    alert('Admin-God-Mode: fehlende Order-Informationen. Link prüfen.');
    return;
  }

  showLoadingOverlay();
  setSubmitting(true);

  // Sicherstellen, dass Texte/Fotos aktuell sind
  fit1(); fit4(); fit6();

  let canvasSnap = null;
  let labelSnap  = null;
  let greetSnap  = null;

  try {
    canvasSnap = await captureCertificatePng();
  } catch(e){
    console.warn('adminUpdateCertificate: canvas failed', e);
  }
  if (state.mode === 'label'){
    try { labelSnap = await captureLabelPng(); } catch(e){ console.warn('adminUpdateCertificate: label failed', e); }
  }
  if (state.greetCardSelected){
    try { greetSnap = await captureGreetingCardPng(); } catch(e){ console.warn('adminUpdateCertificate: greet failed', e); }
  }

  const urlParams    = new URLSearchParams(window.location.search || '');
  const bundleFromUrl= urlParams.get('edit_bundle');

  const payload = {
    order_id:      adminOrderId,
    line_item_id:  adminLineItemId,
    bundle_id:     bundleFromUrl || null,
    mode:          state.mode || 'cert',
    // komplette neuen Render-Ergebnisse:
    canvas_png:    canvasSnap ? canvasSnap.dataUrl : null,
    label_png:     labelSnap   ? labelSnap.dataUrl  : null,
    greet_card_png:greetSnap  ? greetSnap.dataUrl  : null
  };

  try{
    const resp = await fetch('https://partner.planet-tree.de/api2/cert/admin_update', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload)
    });

const js = await resp.json().catch(()=> ({}));

if (!resp.ok || !js.ok){
  const reason = js && js.reason ? ` (Reason: ${js.reason})` : '';
  console.error('admin_update failed', resp.status, js);
  alert('Admin-Update: Es gab ein Problem beim Aktualisieren.' + reason);
} else {
  alert('Zertifikat wurde neu erstellt und an die Bestellung angehängt.');

      const returnTo = urlParams.get('return_to');
      if (returnTo){
        setTimeout(()=>{ window.location.href = returnTo; }, 800);
      } else if (urlParams.get('from_cert_view') === '1'){
        setTimeout(()=>{ window.history.back(); }, 800);
      } else {
        setTimeout(()=>{ closeWizard(); }, 800);
      }
    }
  } catch(e){
    console.error(e);
    alert('Admin-Update: Es gab ein Problem beim Aktualisieren. Bitte später noch einmal versuchen.');
  } finally {
    setSubmitting(false);
    hideLoadingOverlay();
  }
}

async function removeExistingBundle(bundleId){
  if(!bundleId) return;
  try{
    const resp = await fetch('/cart.js',{headers:{'Accept':'application/json'}});
    if(!resp.ok) return;
    const cart = await resp.json();
    if(!cart || !cart.items) return;

    let lines = [];
    cart.items.forEach((it, idx)=>{
      const p = it.properties || {};
      if(p._pt_bundle_id === bundleId){ lines.push(idx+1); }
    });
    if(!lines.length) return;
    lines.sort((a,b)=>b-a);
    for(const line of lines){
      await fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({ line, quantity:0 })
      });
    }
  }catch(e){
    console.warn('removeExistingBundle failed', e);
  }
}

if(btnCart){
  btnCart.addEventListener('click', async (e)=>{
    e.preventDefault(); e.stopPropagation();

    // B2B: Monatszertifikat vor dem Add-To-Cart rendern (und im Step 11 anzeigen)
    if (isB2B && state.mode === 'cert'){
      await renderMonthlyFinalPreviewIfNeeded();
    }

    if(state.delivery === 'digital' && !state.digitalConfirmed){ openDigitalConfirm(false); }
    else{ addToCart(false); }
  });
}

if(btnCheckout){
  btnCheckout.addEventListener('click', async (e)=>{
    e.preventDefault(); e.stopPropagation();

    if (isB2B && state.mode === 'cert'){
      await renderMonthlyFinalPreviewIfNeeded();
    }

    if(state.delivery === 'digital' && !state.digitalConfirmed){ openDigitalConfirm(true); }
    else{ addToCart(true); }
  });
}


if(btnCartHeader){
  btnCartHeader.addEventListener('click',(e)=>{
    e.preventDefault();
    e.stopPropagation();
    if (isB2B) return;
    if(state.delivery === 'digital' && !state.digitalConfirmed){
      openDigitalConfirm(false);
    }else{
      addToCart(false);
    }
  });
}

  const btnCustomerUpdate = $('btnCustomerUpdate');
  if (btnCustomerUpdate){
    btnCustomerUpdate.addEventListener('click', (e)=>{
      e.preventDefault();
      e.stopPropagation();
      if (isSocialEdit) socialUpdateCertificate();
      else customerUpdateCertificate();
    });
  }

  const btnAdminUpdate = $('btnAdminUpdate');
if (btnAdminUpdate){
  btnAdminUpdate.addEventListener('click', (e)=>{
    e.preventDefault();
    e.stopPropagation();
    adminUpdateCertificate();
  });
}

  function buildLayoutSnapshot(){
    const inner = $('pvInnerFinal'); if(!inner){ return null; }
    const CANVAS_W = 2480; const CANVAS_H = 3508;
    const a4Rect = inner.getBoundingClientRect();
    const sx = CANVAS_W / (a4Rect.width  || 1);
    const sy = CANVAS_H / (a4Rect.height || 1);

    function rectInA4(el){
      const r = el.getBoundingClientRect();
      return { x: (r.left - a4Rect.left) * sx, y: (r.top  - a4Rect.top)  * sy, w:  r.width  * sx, h:  r.height * sy };
    }
    function boxSnapshot(pvTextEl, textarea, placeholder){
      if(!pvTextEl) return null;
const isComboSenderSnap =
  (pvTextEl && pvTextEl.id === 'pvTxt1' &&
   state && state.photo1State && state.photo1State.combine &&
   (state.photo1State.w > 0 && state.photo1State.h > 0));

const container = isComboSenderSnap
  ? pvTextEl                         // ✅ Combine: nimm den echten Text-Rect (inkl. translateY)
  : (pvTextEl.closest('.pv-box-inner') || pvTextEl);

const rect = rectInA4(container);
      const cs = getComputedStyle(pvTextEl);
      const txt = pvTextEl.textContent && pvTextEl.textContent.trim()
        ? pvTextEl.textContent
        : textForPreview(textarea, placeholder);
      return {
        text: txt, x: rect.x, y: rect.y, w: rect.w, h: rect.h, fontSize: parseFloat(cs.fontSize) || null, color: cs.color || null, textAlign: cs.textAlign || 'center'
      };
    }
    function decoSnapshot(imgEl, kind){
      if(!imgEl) return { visible:false };
      const style = getComputedStyle(imgEl);
      if(style.display === 'none' || style.visibility === 'hidden'){ return { visible:false }; }
      const rect = rectInA4(imgEl);

      let rot = 0;
      if(kind === 'hat'){
        const cssRot = style.getPropertyValue('--dec-hat-rot');
        if(cssRot){
          const m = cssRot.match(/([-0-9.]+)/);
          if(m) rot = parseFloat(m[1]) || 0;
        }
      }else{
        const tf = style.transform || '';
        const m = tf.match(/rotate\(([-0-9.]+)deg\)/);
        if(m) rot = parseFloat(m[1]) || 0;
      }
      return { visible:true, x: rect.x, y: rect.y, w: rect.w, h: rect.h, rotate: rot };
    }

    const snapshot = { page: { w: CANVAS_W, h: CANVAS_H } };
    snapshot.sender    = boxSnapshot(pvTxt1, txt1, '');
    snapshot.recipient = boxSnapshot(pvTxt4, txt4, '');
    snapshot.message   = boxSnapshot(pvTxt6, txt6, '');
    snapshot.tree    = decoSnapshot(treeFinal,    'tree');
    snapshot.balloon = decoSnapshot(balloonFinal, 'balloon');
    snapshot.hat     = decoSnapshot(hatFinal,     'hat');
    return snapshot;
  }

function applyWizardState(data){
  if(!data || typeof data !== 'object') return;

  // --- FIX: Mode aus Server-State übernehmen (edit_bundle / clone_bundle) ---
if (typeof data.mode === 'string'){
  const m = data.mode.toLowerCase();
  if (m === 'gift' || m === 'label' || m === 'cert'){
    state.mode = m;

    // Monatskoordinaten aus Draft übernehmen – aber nur als "loaded" markieren,
    // wenn wirklich DMS-Werte drin stehen
    if (data.monthly_coords){
      state.monthlyCoords = data.monthly_coords;

      const hasDms =
        (data.monthly_coords.mv && data.monthly_coords.mv.dms) ||
        (data.monthly_coords.by && data.monthly_coords.by.dms) ||
        (data.monthly_coords.rp && data.monthly_coords.rp.dms);

      state.monthlyCoordsLoaded = !!hasDms;
      state.monthlyCoordsCacheKey = '';
    }

if (typeof data.lang === 'string'){
  state.lang = normalizeLang(data.lang);
}
if (typeof data.monthly_lang === 'string'){
  state.monthlyLang = normalizeLang(data.monthly_lang);
}
if (Array.isArray(data.series_lang)){
  state.seriesLang = data.series_lang.map(normalizeLang);
}


if (typeof data.monthly_place_text === 'string'){
  state.monthlyPlaceText = data.monthly_place_text;
}
if (typeof data.event_claim_text === 'string'){
  state.eventClaimText = data.event_claim_text;
}

    if (typeof data.monthly_trees === 'number' && isFinite(data.monthly_trees) && data.monthly_trees > 0){
  state.monthlyTrees = data.monthly_trees;
}
if (typeof data.monthly_month === 'string' && /^\d{4}-\d{2}$/.test(data.monthly_month)){
  state.monthlyMonth = data.monthly_month;
}
if (Array.isArray(data.monthly_forests)){
  state.monthlyForests = data.monthly_forests;
}
if (data.monthly_forest_trees && typeof data.monthly_forest_trees === 'object'){
  state.monthlyForestTrees = {
    mv: Math.max(0, parseInt(data.monthly_forest_trees.mv, 10) || 0),
    by: Math.max(0, parseInt(data.monthly_forest_trees.by, 10) || 0),
    rp: Math.max(0, parseInt(data.monthly_forest_trees.rp, 10) || 0)
  };
}
if (data.monthly_project_forest_trees && typeof data.monthly_project_forest_trees === 'object'){
  state.monthlyProjectForestTrees = {
    mv: Math.max(0, parseInt(data.monthly_project_forest_trees.mv, 10) || 0),
    by: Math.max(0, parseInt(data.monthly_project_forest_trees.by, 10) || 0),
    rp: Math.max(0, parseInt(data.monthly_project_forest_trees.rp, 10) || 0)
  };
}
if (typeof data.monthly_qr_url === 'string'){
  state.monthlyQrUrl = data.monthly_qr_url;
}
if (typeof data.monthly_id === 'string' && /^[A-Z0-9]{10}$/.test(data.monthly_id)){
  state.monthlyId = data.monthly_id;
}
if (typeof data.subscription_active === 'boolean'){
  state.subscriptionActive = data.subscription_active;
}
if (typeof data.subscription_frequency === 'string'){
  state.subscriptionFrequency = normalizeSubscriptionFrequency(data.subscription_frequency);
}
if (typeof data.subscription_count_mode === 'string'){
  state.subscriptionCountMode = normalizeSubscriptionCountMode(data.subscription_count_mode);
}
if (Object.prototype.hasOwnProperty.call(data, 'subscription_fixed_trees')){
  state.subscriptionFixedTrees = Math.max(1, parseInt(data.subscription_fixed_trees, 10) || 1);
}
if (typeof data.subscription_forest_code === 'string'){
  state.subscriptionForestCode = normalizeSubscriptionForestCode(data.subscription_forest_code);
}
if (typeof data.subscription_start_date === 'string'){
  state.subscriptionStartDate = normalizeSubscriptionStartDate(data.subscription_start_date);
} else if (!state.subscriptionStartDate && typeof data.monthly_month === 'string' && /^\d{4}-\d{2}$/.test(data.monthly_month)){
  state.subscriptionStartDate = normalizeSubscriptionStartDate(data.monthly_month + '-01');
}
if (typeof data.subscription_id === 'string' && state && state.b2bPortal && !String(state.b2bPortal.subscriptionId || '').trim()){
  state.b2bPortal.subscriptionId = String(data.subscription_id || '').trim();
}


    // Root-Container CSS-Klassen aktualisieren
    if (rootEl){
      rootEl.classList.remove('mode-cert','mode-gift');
      rootEl.classList.add(
        state.mode === 'gift' || state.mode === 'label'
          ? 'mode-gift'
          : 'mode-cert'
      );
    }

      // Delivery-Default für Gift/Label sinnvoll setzen
      if (state.mode === 'gift' || state.mode === 'label'){
        if (!state.delivery){ state.delivery = 'print'; }
      }
    }
  }

  if (Object.prototype.hasOwnProperty.call(data, 'photo1_combine')){
  state.photo1State.combine = !!data.photo1_combine;

  const cb = $('photo1Combine');
  if (cb) cb.checked = state.photo1State.combine;

  // falls Foto schon geladen wurde/gleich geladen wird, Klassen korrekt setzen
  const b1 = $('box1');
  if (b1){
    const hasPhoto = !!(state.photo1State && state.photo1State.w > 0 && state.photo1State.h > 0);
    b1.classList.toggle('photo-combo', state.photo1State.combine && hasPhoto);
  }
}


  // Intro-Buttons (insbesondere "ohne Baumpflanzung") an neuen Mode anpassen
if (typeof refreshIntroNoTreeVisibility === 'function'){
  refreshIntroNoTreeVisibility();
}

    // Tree-Addon-Flag aus dem gespeicherten State übernehmen
    if(typeof data.treeAddonSelected === 'boolean'){
      state.treeAddonSelected = data.treeAddonSelected;
    } else if (state.mode === 'gift' || state.mode === 'label'){
      // Alte Bundles im Gift/Label-Modus hatten immer Baumpflanzung
      state.treeAddonSelected = true;
    }
    // Für bestimmte Gift-Varianten: Baum immer enthalten – auch bei alten Drafts
if ((state.mode === 'gift' || state.mode === 'label') && isGiftAlwaysTree){
  state.treeAddonSelected = true;
}


    applyModeUi();
    initGiftModeUI();

if(typeof data.gift_title === 'string'){ state.giftTitle = data.gift_title; }
if(typeof data.gift_img === 'string'){ state.giftImg = data.gift_img; }

/*
  WICHTIG:
  Alte PTP-States enthalten gift_base_price / cert_base_price aus der Vergangenheit.
  Diese sollen NICHT mehr verwendet werden, damit immer die aktuellen Preise gelten.
  Darum: gespeicherte Preise bewusst ignorieren.
*/
// if(typeof data.gift_base_price === 'number' && isFinite(data.gift_base_price) && data.gift_base_price > 0){
//   state.giftBasePrice = data.gift_base_price;
// }

// Egal was im PTP-State steht: Cert-Preis IMMER aus PRICES.certBase (JS / aktuelles Modell)

state.certBasePrice = null;

    if (typeof data.gift_variant_id === 'string' && data.gift_variant_id) { state.giftVariantId = data.gift_variant_id; }
    if (typeof data.cert_variant_id === 'string' && data.cert_variant_id) { state.certVariantId = data.cert_variant_id; }


    // --- WICHTIG: Beim Laden ALLE Fotos/Logos erst resetten,
// damit keine Bilder vom vorherigen Partner "hängen bleiben".
try{
  const clearSlot = (photoObj, stateObj)=>{
    if (photoObj && typeof photoObj.switchToText === 'function'){
      // entfernt img/src, entfernt .has-photo, blendet Upload-CTA wieder ein
      photoObj.switchToText();
    }
    if (stateObj){
      // damit beim nächsten Foto prevText korrekt neu gesetzt werden kann
      stateObj.prevText = undefined;
    }
  };

  clearSlot(photo1, state.photo1State);
  clearSlot(photo4, state.photo4State);
  clearSlot(photo6, state.photo6State);

  // Grußkarte (falls vorhanden)
  if (typeof greetPhoto1 !== 'undefined') clearSlot(greetPhoto1, state.greetPhoto1State);
  if (typeof greetPhoto2 !== 'undefined') clearSlot(greetPhoto2, state.greetPhoto2State);
  if (typeof greetPhoto3 !== 'undefined') clearSlot(greetPhoto3, state.greetPhoto3State);
}catch(e){
  console.warn('applyWizardState: photo reset failed', e);
}

    if(typeof data.sender === 'string' && txt1){ txt1.value = data.sender; fit1(); }
    if(typeof data.recipient === 'string' && txt4){ txt4.value = data.recipient; fit4(); }
    if(typeof data.message === 'string' && txt6){ txt6.value = data.message; fit6(); }

    if(typeof data.verb === 'string'){
      state.verb = data.verb.toUpperCase() === 'HABEN' ? 'HABEN' : 'HAT';
      if(segVerb){
        segVerb.querySelectorAll('button').forEach(b=>{
          b.classList.toggle('active', b.getAttribute('data-verb') === state.verb);
        });
      }
    }
    if(typeof data.trees === 'number' && !isNaN(data.trees) && data.trees > 0){
      state.trees = data.trees; if(qVal) qVal.value = state.trees;
    }

        // Serienmodus aus Draft/State wiederherstellen
    if (typeof data.series_enabled === 'boolean'){
      // Serienfunktion nur im cert-Mode sinnvoll
      state.seriesEnabled = !!data.series_enabled && state.mode === 'cert';
    }
    if (typeof data.series_blank_mode === 'boolean'){
      state.seriesBlankMode = !!data.series_blank_mode && state.seriesEnabled;
    }
    if (data.series_blank_count != null){
      state.seriesBlankCount = clampSeriesBlankCount(data.series_blank_count);
    }

    if (Array.isArray(data.series_rows)){
      state.seriesRows = data.series_rows.map(r => {
        const blankRecipient = !!(r && r.blank_recipient);
        return {
          line1: blankRecipient ? '' : ((r && r.line1) || ''),
          line2: blankRecipient ? '' : ((r && r.line2) || ''),
          blank_recipient: blankRecipient
        };
      });
      if (state.seriesBlankMode && state.seriesRows.length){
        state.seriesBlankCount = clampSeriesBlankCount(state.seriesBlankCount || state.seriesRows.length);
      }
    }

    if (Array.isArray(data.series_trees)){
      state.seriesTrees = data.series_trees.map(t =>
        (typeof t === 'number' && t > 0) ? t : 1
      );
    }

    if (typeof data.series_index === 'number' && isFinite(data.series_index)){
      state.seriesIndex = data.series_index;
    }

        if (Array.isArray(data.series_sender)){
      state.seriesSender = data.series_sender.map(s => String(s || ''));
    }

    // Fallback: Falls keine Senderliste existiert, aber Serienmodus aktiv ist,
    // pro Zertifikat mit dem aktuellen allgemeinen Schenker vorbelegen.
    if (state.seriesEnabled && hasSeriesRows()){
      const baseSender = txt1 ? (txt1.value || data.sender || '') : (data.sender || '');
      if (!Array.isArray(state.seriesSender) ||
          state.seriesSender.length !== state.seriesRows.length){
        state.seriesSender = state.seriesRows.map(() => baseSender);
      }
    }

    if (Array.isArray(data.series_occasion)){
      state.seriesOccasion = data.series_occasion.map(s => String(s || ''));
    }

    if (Array.isArray(data.series_verb)){
      state.seriesVerb = data.series_verb.map(v =>
        v === 'HABEN' ? 'HABEN' : 'HAT'
      );
    }

    if (Array.isArray(data.series_deco_balloon)){
      state.seriesDecoBalloon = data.series_deco_balloon.map(v => !!v);
    }
    if (Array.isArray(data.series_deco_hat)){
      state.seriesDecoHat = data.series_deco_hat.map(v => !!v);
    }

    if (Array.isArray(data.series_forest)){
     state.seriesForest = data.series_forest.map(code => {
       const c = (code || '').toLowerCase();
       return FORESTS[c] ? c : null;
     });
   }

   if (Array.isArray(data.series_frame_color)){
     state.seriesFrameColor = data.series_frame_color.map(c =>
       normalizeAndEnsureHex(c) || null
     );
   }

   if (Array.isArray(data.series_delivery)){
     state.seriesDelivery = data.series_delivery.map(d =>
      d === 'print' ? 'print' : 'digital'
     );
    }

   if (Array.isArray(data.series_paper_type)){
    state.seriesPaperType = data.series_paper_type.map(p =>
      p === 'grass' ? 'grass' : 'white'
    );
  }

    // Serien-UI & aktuelle Baumanzahl aus Serie ableiten
    applySeriesModeUI();
    if (state.seriesEnabled && hasSeriesRows()){
      clampSeriesIndex();
      syncTreesFromSeriesIndex();
      syncForestFromSeriesIndex();
    }

    applySeriesModeUI();
    if (state.seriesEnabled && hasSeriesRows()){
      clampSeriesIndex();
      syncDecorFromSeriesIndex();
    }

    if (state.seriesEnabled && hasSeriesRows()){
      clampSeriesIndex();
      syncFrameColorFromSeriesIndex();
    }

// NEU: ursprünglichen Grußkartenstatus merken
if (Object.prototype.hasOwnProperty.call(data, 'greet_card_selected')) {
  const sel = !!data.greet_card_selected;
  state.greetCardOriginallySelected = sel;
  state.greetCardSelected           = sel;
} else if (Object.prototype.hasOwnProperty.call(data, 'greet_card')) {
  const sel = !!data.greet_card;
  state.greetCardOriginallySelected = sel;
  state.greetCardSelected           = sel;
} else {
  state.greetCardOriginallySelected = false;
  // state.greetCardSelected bleibt was es ist (normaler Wizard/draft)
}

    if(typeof data.greet_card_text1 === 'string' && gcTxt1){
      gcTxt1.value = data.greet_card_text1;
      if(typeof fitGc1 === 'function') fitGc1();
    }
    if(typeof data.greet_card_text2 === 'string' && gcTxt2){
      gcTxt2.value = data.greet_card_text2;
      if(typeof fitGc2 === 'function') fitGc2();
    }
    if(typeof data.greet_card_text3 === 'string' && gcTxt3){
      gcTxt3.value = data.greet_card_text3;
      if(typeof fitGc3 === 'function') fitGc3();
    }

        // NEU: Grußkarten-Preview nach State-Load aktualisieren
    updateGreetPreviews();

    if(typeof data.deco_balloon === 'boolean'){ state.decoBalloon = data.deco_balloon; }
    if(typeof data.deco_hat === 'boolean'){ state.decoHat = data.deco_hat; }
    applyDecor();

// Forst immer deterministisch setzen ODER sauber leeren
if(data.forest_code && FORESTS[data.forest_code]){
  state.forest = data.forest_code;
  const inpF = document.querySelector('input[name="forest"][value="'+data.forest_code+'"]');
  if(inpF){ inpF.checked = true; }
}else{
  state.forest = null;
  // Radios abwählen
  try{
    if (forestOptionsEl){
      forestOptionsEl.querySelectorAll('input[name="forest"]').forEach(inp=>{ inp.checked = false; });
    }
  }catch(_){}
}
applyForestSelectionUI();
applyForestToPreview();
applyForestToLabel();

    if(typeof data.frame_color === 'string'){
      const norm = normalizeAndEnsureHex(data.frame_color);
      if(norm){ state.frameColor = norm; syncFrameColorInputs(); applyFrameColor(); }
    }

    if(typeof data.delivery === 'string'){
      state.delivery = (data.delivery === 'print') ? 'print' : 'digital';
    } else if(state.mode === 'gift' || state.mode === 'label'){
      state.delivery = 'print';
    }

    let rawPaper = null;
    if (typeof data.paperType === 'string') rawPaper = data.paperType;
    else if (typeof data.paper_type === 'string') rawPaper = data.paper_type;
    if (rawPaper) {
      const p = rawPaper.toLowerCase();
      if (p === 'grass' || p === 'graspapier' || p === 'grasspaper') { state.paperType = 'grass'; }
      else { state.paperType = 'white'; }
    }
    const inpD = document.querySelector('input[name="delivery"][value="'+state.delivery+'"]'); if(inpD) inpD.checked = true;
    const inpP = document.querySelector('input[name="paperType"][value="'+state.paperType+'"]'); if(inpP)   inpP.checked = true;
    applyDeliverySelectionUI(); togglePaperOptions();

if (Object.prototype.hasOwnProperty.call(data, 'giftwrap')) {
  state.giftwrapSelected = !!data.giftwrap;

  // WICHTIG: Verbot aus URL (?giftwrap=0) respektieren
  const disableGiftwrapByUrl = (giftwrapParam === '0');

  if (state.mode !== 'cert' && !disableGiftwrapByUrl) {
    // Gift-/Label-Mode ohne Verbot → Option ist grundsätzlich verfügbar
    state.giftwrapAvailable = true;
  } else {
    // Cert-Mode oder explizit disabled → nie anzeigen / nie ausgewählt
    state.giftwrapAvailable = false;
    state.giftwrapSelected  = false;
  }
}
    if(typeof data.gimmick_code === 'string' && data.gimmick_code){
      const code = data.gimmick_code;
      state.gimmickCode   = code;
      state.gimmickConfig = GIMMICKS[code] || null;
      state.gimmickAvailable = !!state.gimmickConfig;
      state.gimmickSelected  = !!state.gimmickConfig;
    }else{ state.gimmickSelected = false; }
    syncGiftExtrasFromState();

if (data.photos && typeof data.photos === 'object'){
  const photos = data.photos;

  const hydrate = (info, photoObj, stateObj) => {
    if(!info || !photoObj || !stateObj) return;

    const dataUrl = info.data_url || info.dataUrl || info.url;
    if(!dataUrl || typeof dataUrl !== 'string' || dataUrl.indexOf('data:image') !== 0){ return; }

    // prevText/rotation mitsichern (wichtig für "Foto entfernen" -> Text wiederherstellen)
    const prevText =
      (typeof info.prev_text === 'string') ? info.prev_text :
      (typeof info.prevText  === 'string') ? info.prevText :
      null;
    if (prevText != null){
      stateObj.prevText = prevText;
    }

    const saved = {
      scale: (typeof info.scale === 'number' ? info.scale : (stateObj.scale || 1)),
      offX:  (typeof info.offX  === 'number' ? info.offX  : (stateObj.offX  || 0)),
      offY:  (typeof info.offY  === 'number' ? info.offY  : (stateObj.offY  || 0)),
      mode:  info.mode || stateObj.mode || 'contain',
      rotation: (typeof info.rotation === 'number' ? info.rotation : (stateObj.rotation || 0))
    };

    if (typeof photoObj.hydrateFromDataUrl === 'function'){
      photoObj.hydrateFromDataUrl(dataUrl, saved);
    }
  };

  // Zertifikat-Fotos
  if (photos.sender)    hydrate(photos.sender,    photo1, state.photo1State);
  if (photos.recipient) hydrate(photos.recipient, photo4, state.photo4State);
  if (photos.message)   hydrate(photos.message,   photo6, state.photo6State);

  // Grußkarten-Fotos
  if (photos.greet_top)    hydrate(photos.greet_top,    greetPhoto1, state.greetPhoto1State);
  if (photos.greet_middle) hydrate(photos.greet_middle, greetPhoto2, state.greetPhoto2State);
  if (photos.greet_bottom) hydrate(photos.greet_bottom, greetPhoto3, state.greetPhoto3State);
}

restorePersonalizedMonthlySenderFromData(data);

if (isB2BEventPortalFlow() && state && state.b2bPortal && data.b2b_event_snapshot && typeof data.b2b_event_snapshot === 'object'){
  const snapInfo = data.b2b_event_snapshot;
  state.b2bPortal.eventSnapshot = {
    senderText: String(snapInfo.sender_text || snapInfo.senderText || txt1 && txt1.value || state.photo1State.prevText || '').replace(/\r/g,''),
    senderCombineText: String(snapInfo.sender_combine_text || snapInfo.senderCombineText || summaryCombineTextInput && summaryCombineTextInput.value || txt1 && txt1.value || '').replace(/\r/g,'').replace(/\n+/g,' '),
    photo1State: cloneSenderPhotoState(state.photo1State),
    forestTrees: {
      mv: Math.max(0, parseInt(snapInfo.forest_trees && snapInfo.forest_trees.mv, 10) || 0),
      by: Math.max(0, parseInt(snapInfo.forest_trees && snapInfo.forest_trees.by, 10) || 0),
      rp: Math.max(0, parseInt(snapInfo.forest_trees && snapInfo.forest_trees.rp, 10) || 0)
    },
    month: String(snapInfo.month || state.monthlyMonth || ''),
    placeText: String(snapInfo.place_text || snapInfo.placeText || state.monthlyPlaceText || ''),
    eventClaimText: String(snapInfo.event_claim_text || snapInfo.eventClaimText || state.eventClaimText || '').replace(/\r/g,''),
    canvasPng: ''
  };
}

    if(typeof data.label_border_color === 'string'){
      setLabelBorderColor(data.label_border_color);
    }
    if(typeof data.label_line1 === 'string'){
      state.labelLine1 = data.label_line1.slice(0, 50);
    }
    if(typeof data.label_line2 === 'string'){
      state.labelLine2 = data.label_line2.slice(0, 50);
    }
    if(typeof data.label_line3 === 'string'){
      state.labelLine3 = data.label_line3.slice(0, 50);
    }

        // NEU: Serien-Textareas (Step 3) aus dem geladenen State befüllen,
    // damit nach einem Reload die Liste nicht leer ist und ein erneutes
    // Aktivieren der Serienfunktion die vorhandenen Namen behält.
    if (hasSeriesRows()){
      if (seriesNamesTA){
        seriesNamesTA.value = state.seriesRows
          .map(seriesNameLineForTextarea)
          .join('\n');
      }
      if (seriesCompaniesTA){
        seriesCompaniesTA.value = state.seriesRows
          .map(seriesCompanyLineForTextarea)
          .join('\n');
      }
    }


    applyProductContextUI();
    updateClaim(); updatePrice(); updateQtyLabel(); updateCo2Label(); updateMetaBar();

    initLabelDefaultsFromSteps();

    if(state.step === 10 || state.step === 11){
      placeA4Boxes(); updatePreview(); scaleA4();
      updateLabelEdit(); updateLabelFinal(); fitLabelLines();
      scaleLabel(state.step===10 ? 'Edit' : 'Final');
    }

    ensureSeriesLangLen();
updateLangToggleUI();
updateClaim();
updatePreview();


  }

  let draftSaveTimer = null;
  function scheduleDraftSave(){
    if (!DRAFT_KEY || hasEditOrClone) return;
    if (draftSaveTimer) clearTimeout(draftSaveTimer);
    draftSaveTimer = setTimeout(() => {
      draftSaveTimer = null; saveDraft().catch(e => console.warn('wizard draft save failed', e));
    }, 300);
  }

  function buildWizardDraftPayload(){
    const payload = {
      mode: state.mode || (isLabelMode ? 'label' : (isGiftMode ? 'gift' : 'cert')),
      step: state.step || 0,
      verb: state.verb || 'HAT',
      trees: state.trees || 1,

      sender: (txt1 && txt1.value) ? txt1.value : '',
      recipient: (txt4 && txt4.value) ? txt4.value : '',
      message: (txt6 && txt6.value) ? txt6.value : '',

      deco_balloon: !!state.decoBalloon,
      deco_hat:     !!state.decoHat,


      forest_code: state.forest || null,
      frame_color: state.frameColor || FRAME_COLOR_DEFAULT,

      delivery:  state.delivery || (isGiftMode || isLabelMode ? 'print' : 'digital'),
      paper_type: state.paperType || 'white',

      gift_title:       state.giftTitle || '',
      gift_img:         state.giftImg   || '',

      gift_base_price:  null,
      cert_base_price:  null,

      gift_variant_id:  state.giftVariantId || null,
      cert_variant_id:  state.certVariantId || null,

      giftwrap:      !!((state.mode==='gift' || state.mode==='label') && state.giftwrapSelected),
      gimmick_code:  ((state.mode==='gift' || state.mode==='label') && state.gimmickSelected) ? (state.gimmickCode || '') : '',
      
      treeAddonSelected: !!state.treeAddonSelected,
      label_border_color: state.labelBorderColor || state.frameColor || FRAME_COLOR_DEFAULT,
      label_line1: (state.labelLine1 || '').slice(0, 50),
      label_line2: (state.labelLine2 || '').slice(0, 50),
      label_line3: (state.labelLine3 || '').slice(0, 50),

      greet_card_selected: !!state.greetCardSelected,
      greet_card_text1: gcTxt1 ? gcTxt1.value : '',
      greet_card_text2: gcTxt2 ? gcTxt2.value : '',
      greet_card_text3: gcTxt3 ? gcTxt3.value : '',

      monthly_coords: state.monthlyCoordsLoaded ? (state.monthlyCoords || null) : null,

    };

    // NEU: Draft nie in einen „Bäume ja, Tree-Addon nein“-Zustand laufen lassen
    if ((payload.mode === 'gift' || payload.mode === 'label') &&
        (payload.trees || 1) > 0 &&
        !payload.treeAddonSelected) {
      payload.treeAddonSelected = true;
    }

      // Serienfunktion: State mit speichern
  payload.series_enabled = !!state.seriesEnabled;
  payload.series_blank_mode = !!state.seriesBlankMode;
  payload.series_blank_count = clampSeriesBlankCount(state.seriesBlankCount || (Array.isArray(state.seriesRows) ? state.seriesRows.length : 10));
  payload.series_index   = state.seriesIndex || 0;
  payload.series_rows    = Array.isArray(state.seriesRows)   ? state.seriesRows   : [];
  payload.series_trees   = Array.isArray(state.seriesTrees)  ? state.seriesTrees  : [];
  payload.series_sender  = Array.isArray(state.seriesSender) ? state.seriesSender : [];
  payload.series_occasion = Array.isArray(state.seriesOccasion) ? state.seriesOccasion : [];
  payload.series_verb    = Array.isArray(state.seriesVerb)   ? state.seriesVerb   : [];
  payload.series_deco_balloon = Array.isArray(state.seriesDecoBalloon) ? state.seriesDecoBalloon : [];
  payload.series_deco_hat     = Array.isArray(state.seriesDecoHat)     ? state.seriesDecoHat     : [];
  payload.series_forest       = Array.isArray(state.seriesForest)      ? state.seriesForest      : [];
  payload.series_frame_color  = Array.isArray(state.seriesFrameColor) ? state.seriesFrameColor : [];
  payload.series_delivery     = Array.isArray(state.seriesDelivery)   ? state.seriesDelivery    : [];
  payload.series_paper_type   = Array.isArray(state.seriesPaperType)  ? state.seriesPaperType   : [];
payload.monthly_trees    = state.monthlyTrees || 1;
payload.monthly_month    = state.monthlyMonth || null;
payload.monthly_forests  = Array.isArray(state.monthlyForests) ? state.monthlyForests : [];
payload.monthly_forest_trees = getMonthlyForestTrees();
payload.monthly_project_forest_trees = getMonthlyProjectForestTrees();
payload.monthly_qr_url   = state.monthlyQrUrl || '';
payload.monthly_id       = state.monthlyId || null;
payload.monthly_place_text = state.monthlyPlaceText || '';
payload.event_claim_text = state.eventClaimText || '';
payload.subscription_active = !!state.subscriptionActive;
payload.subscription_id = String((state && state.b2bPortal && state.b2bPortal.subscriptionId) || portalSubscriptionId || '').trim();
payload.subscription_frequency = normalizeSubscriptionFrequency(state.subscriptionFrequency);
payload.subscription_count_mode = normalizeSubscriptionCountMode(state.subscriptionCountMode);
payload.subscription_fixed_trees = Math.max(1, parseInt(state.subscriptionFixedTrees, 10) || 1);
payload.subscription_forest_code = normalizeSubscriptionForestCode(state.subscriptionForestCode);
payload.subscription_start_date = normalizeSubscriptionStartDate(state.subscriptionStartDate || '');
payload.personalized_monthly_sender_text = String(personalizedMonthlyTxt1 && personalizedMonthlyTxt1.value || state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.prevText || '').replace(/\r/g,'');
payload.personalized_monthly_sender_combine = !!(state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.combine);
payload.personalized_monthly_sender_combine_text = String(personalizedMonthlyCombineTextInput && personalizedMonthlyCombineTextInput.value || personalizedMonthlyTxt1 && personalizedMonthlyTxt1.value || state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
payload.personalized_monthly_sender_customized = !!state.personalizedMonthlySenderCustomized;
payload.monthly_lang = normalizeLang(state.monthlyLang || state.lang);
payload.lang = normalizeLang(state.lang);
payload.series_lang = Array.isArray(state.seriesLang) ? state.seriesLang : [];
if (isB2BEventPortalFlow()){
  const eventDraftSnap = (state && state.b2bPortal && state.b2bPortal.eventSnapshot)
    ? state.b2bPortal.eventSnapshot
    : buildEventPortalSnapshot();
  payload.b2b_event_phase = (state && state.b2bPortal && state.b2bPortal.eventPhase === 'monthly') ? 'monthly' : 'event';
  payload.b2b_event_snapshot = {
    sender_text: String(eventDraftSnap && eventDraftSnap.senderText || '').replace(/\r/g,''),
    sender_combine_text: String(eventDraftSnap && eventDraftSnap.senderCombineText || '').replace(/\r/g,'').replace(/\n+/g,' '),
    forest_trees: {
      mv: Math.max(0, parseInt(eventDraftSnap && eventDraftSnap.forestTrees && eventDraftSnap.forestTrees.mv, 10) || 0),
      by: Math.max(0, parseInt(eventDraftSnap && eventDraftSnap.forestTrees && eventDraftSnap.forestTrees.by, 10) || 0),
      rp: Math.max(0, parseInt(eventDraftSnap && eventDraftSnap.forestTrees && eventDraftSnap.forestTrees.rp, 10) || 0)
    },
    month: String(eventDraftSnap && eventDraftSnap.month || ''),
    place_text: String(eventDraftSnap && eventDraftSnap.placeText || ''),
    event_claim_text: String(eventDraftSnap && eventDraftSnap.eventClaimText || '').replace(/\r/g,'')
  };
}


  payload.photo1_combine = !!(state.photo1State && state.photo1State.combine);



  return payload;
}

async function saveDraft(){
  if (!DRAFT_KEY || hasEditOrClone) return;

  // Bevor wir den Draft bauen: aktuellen Serien-Slot in den State schreiben
  if (state.seriesEnabled && hasSeriesRows()){
    saveSeriesSnapshotFromUI();
  }

  const baseData = buildWizardDraftPayload();
try{
  if ((!baseData.sender || !String(baseData.sender).trim()) && state.photo1State && typeof state.photo1State.prevText === 'string'){
    baseData.sender = state.photo1State.prevText;
  }
  if ((!baseData.recipient || !String(baseData.recipient).trim()) && state.photo4State && typeof state.photo4State.prevText === 'string'){
    baseData.recipient = state.photo4State.prevText;
  }
  if ((!baseData.message || !String(baseData.message).trim()) && state.photo6State && typeof state.photo6State.prevText === 'string'){
    baseData.message = state.photo6State.prevText;
  }
}catch(_){}

    try{
      const photos = await (async ()=>{
        const result = {};
        async function addPhoto(key, st, imgEl){
          if(!st) return;
          let dataUrl = null;
          if(st.file){ try{ dataUrl = await fileToDataURL(st.file); }catch(err){ } }
          if(!dataUrl && imgEl && imgEl.src && imgEl.src.indexOf('data:') === 0){ dataUrl = imgEl.src; }
          if(!dataUrl && st.dataUrl){ dataUrl = st.dataUrl; }
          if(!dataUrl) return;
          result[key] = {
            data_url: dataUrl,
            mode: st.mode || 'contain',
            scale: st.scale || 1,
            offX: st.offX || 0,
            offY: st.offY || 0,
            rotation: st.rotation || 0,
            prev_text: (typeof st.prevText === 'string') ? st.prevText : ''
          };
        }
        await Promise.all([
          addPhoto('sender',       state.photo1State,      img1),
          addPhoto('recipient',    state.photo4State,      img4),
          addPhoto('message',      state.photo6State,      img6),
          addPhoto('monthly_sender', state.personalizedMonthlyPhoto1State, personalizedMonthlyImg1),
          addPhoto('greet_top',    state.greetPhoto1State, gcImg1),
          addPhoto('greet_middle', state.greetPhoto2State, gcImg2),
          addPhoto('greet_bottom', state.greetPhoto3State, gcImg3)
        ]);
        return result;
      })();
      baseData.photos = photos;
    }catch(e){
      console.warn('buildPhotoPayload for draft failed', e);
    }

    const payload = { key:  DRAFT_KEY, mode: state.mode || (isLabelMode ? 'label' : (isGiftMode ? 'gift' : 'cert')), data: baseData };

    await fetch('https://partner.planet-tree.de/api2/wizard/draft/save', {
      method: 'POST', headers: { 'Content-Type':'application/json' }, body: JSON.stringify(payload)
    });

  }

  async function savePersistentSummarySenderDraft(){
    const key = getSummarySenderPersistentDraftKey();
    if (!key || hasEditOrClone || !isB2BSummaryOnlyPortalFlow()) return false;

    const baseData = buildWizardDraftPayload();
    try{
      if ((!baseData.sender || !String(baseData.sender).trim()) && state.photo1State && typeof state.photo1State.prevText === 'string'){
        baseData.sender = state.photo1State.prevText;
      }
    }catch(_){}

    try{
      const photos = await (async ()=>{
        const result = {};
        async function addPhoto(keyName, st, imgEl){
          if(!st) return;
          let dataUrl = null;
          if(st.file){ try{ dataUrl = await fileToDataURL(st.file); }catch(_){} }
          if(!dataUrl && imgEl && imgEl.src && imgEl.src.indexOf('data:') === 0){ dataUrl = imgEl.src; }
          if(!dataUrl && st.dataUrl){ dataUrl = st.dataUrl; }
          if(!dataUrl) return;
          result[keyName] = {
            data_url: dataUrl,
            mode: st.mode || 'contain',
            scale: st.scale || 1,
            offX: st.offX || 0,
            offY: st.offY || 0,
            rotation: st.rotation || 0,
            prev_text: (typeof st.prevText === 'string') ? st.prevText : ''
          };
        }
        await addPhoto('sender', state.photo1State, img1);
        return result;
      })();
      baseData.photos = Object.assign({}, baseData.photos || {}, photos || {});
    }catch(e){
      console.warn('persistent summary sender draft photo payload failed', e);
    }

    // Nur den oberen Sender-Stand konservieren, nie den unteren Datums-/Anlassblock.
    baseData.monthly_place_text = '';

    try{
      await fetch('https://partner.planet-tree.de/api2/wizard/draft/save', {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ key: key, mode: 'b2b-summary-sender', data: baseData })
      });
      return true;
    }catch(e){
      console.warn('persistent summary sender draft save failed', e);
      return false;
    }
  }

  function getPersonalizedSenderPersistentDraftKey(){
    const stablePortalRef = String(
      (state && state.b2bPortal && state.b2bPortal.customerRef) ||
      portalCustomerRef ||
      ''
    ).trim();
    return stablePortalRef ? ('WD-b2b-personalized-sender:' + stablePortalRef) : '';
  }

  async function savePersistentPersonalizedSenderDraft(){
    const key = getPersonalizedSenderPersistentDraftKey();
    if (!key || hasEditOrClone || !isB2BPersonalizedPortalFlow()) return false;

    const freshData = buildWizardDraftPayload();
    freshData.step = 1;
    freshData.sender = String((txt1 && txt1.value) || state.photo1State.prevText || '').trim();
    freshData.recipient = '';
    freshData.message = '';
    freshData.verb = 'HAT';
    freshData.trees = 1;
    freshData.forest_code = null;
    freshData.deco_balloon = false;
    freshData.deco_hat = false;
    freshData.greet_card_selected = false;
    freshData.greet_card_text1 = '';
    freshData.greet_card_text2 = '';
    freshData.greet_card_text3 = '';
    freshData.series_enabled = false;
    freshData.series_index = 0;
    freshData.series_rows = [];
    freshData.series_trees = [];
    freshData.series_sender = [];
    freshData.series_occasion = [];
    freshData.series_verb = [];
    freshData.series_deco_balloon = [];
    freshData.series_deco_hat = [];
    freshData.series_forest = [];
    freshData.series_frame_color = [];
    freshData.series_delivery = [];
    freshData.series_paper_type = [];
    freshData.series_lang = [];
    freshData.delivery = 'digital';
    freshData.paperType = 'white';
    freshData.paper_type = 'white';
    freshData.personalized_monthly_sender_text = String(personalizedMonthlyTxt1 && personalizedMonthlyTxt1.value || state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.prevText || '').replace(/\r/g,'');
    freshData.personalized_monthly_sender_combine = !!(state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.combine);
    freshData.personalized_monthly_sender_combine_text = String(personalizedMonthlyCombineTextInput && personalizedMonthlyCombineTextInput.value || personalizedMonthlyTxt1 && personalizedMonthlyTxt1.value || state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.prevText || '').replace(/\r/g,'').replace(/\n+/g,' ');
    freshData.personalized_monthly_sender_customized = !!state.personalizedMonthlySenderCustomized;

    try{
      const photos = {};
      async function addPhoto(keyName, st, imgEl){
        if(!st) return;
        let dataUrl = null;
        if(st.file){ try{ dataUrl = await fileToDataURL(st.file); }catch(_){} }
        if(!dataUrl && imgEl && imgEl.src && imgEl.src.indexOf('data:') === 0){ dataUrl = imgEl.src; }
        if(!dataUrl && st.dataUrl){ dataUrl = st.dataUrl; }
        if(!dataUrl) return;
        photos[keyName] = {
          data_url: dataUrl,
          mode: st.mode || 'contain',
          scale: st.scale || 1,
          offX: st.offX || 0,
          offY: st.offY || 0,
          rotation: st.rotation || 0,
          prev_text: keyName === 'sender' ? freshData.sender : ''
        };
      }
      await addPhoto('sender', state.photo1State, img1);
      await addPhoto('monthly_sender', state.personalizedMonthlyPhoto1State, personalizedMonthlyImg1);
      freshData.photos = photos;
    }catch(e){
      console.warn('persistent personalized sender draft photo payload failed', e);
    }

    try{
      await fetch('https://partner.planet-tree.de/api2/wizard/draft/save', {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ key: key, mode: 'b2b-personalized-sender', data: freshData })
      });
      return true;
    }catch(e){
      console.warn('persistent personalized sender draft save failed', e);
      return false;
    }
  }

  async function loadPersistentPersonalizedSenderDraft(){
    const key = getPersonalizedSenderPersistentDraftKey();
    if (!key || hasEditOrClone || !isB2BPersonalizedPortalFlow()) return null;
    try{
      const res = await fetch(
        'https://partner.planet-tree.de/api2/wizard/draft/load?key=' + encodeURIComponent(key),
        { headers:{ 'Accept':'application/json' } }
      );
      if(!res.ok) return null;
      const js = await res.json().catch(function(){ return {}; });
      if (!js || !js.data) return null;
      try{
        const draftSnap = buildPortalSenderSnapshotFromWizardPayload(js.data);
        if (draftSnap) applyPortalSenderSnapshot(draftSnap);
      }catch(_){}
      try{
        const localPortalSnap = loadPortalSenderSnapshot();
        if (localPortalSnap) applyPortalSenderSnapshot(localPortalSnap);
      }catch(_){}
      try{ syncPersonalizedStep1SenderUi(); }catch(_){}
      if (typeof updatePreview === 'function') updatePreview();
      return js.data;
    }catch(e){
      console.warn('persistent personalized sender draft load failed', e);
      return null;
    }
  }

  async function savePersonalizedFreshStartDraft(){
    if (!DRAFT_KEY || hasEditOrClone || !isB2BPersonalizedPortalFlow()) return false;

    const freshData = buildWizardDraftPayload();
    freshData.step = 1;
    freshData.sender = String((txt1 && txt1.value) || state.photo1State.prevText || '').trim();
    freshData.recipient = '';
    freshData.message = '';
    freshData.verb = 'HAT';
    freshData.trees = 1;
    freshData.forest_code = null;
    freshData.deco_balloon = false;
    freshData.deco_hat = false;
    freshData.greet_card_selected = false;
    freshData.greet_card_text1 = '';
    freshData.greet_card_text2 = '';
    freshData.greet_card_text3 = '';
    freshData.series_enabled = false;
    freshData.series_index = 0;
    freshData.series_rows = [];
    freshData.series_trees = [];
    freshData.series_sender = [];
    freshData.series_occasion = [];
    freshData.series_verb = [];
    freshData.series_deco_balloon = [];
    freshData.series_deco_hat = [];
    freshData.series_forest = [];
    freshData.series_frame_color = [];
    freshData.series_delivery = [];
    freshData.series_paper_type = [];
    freshData.series_lang = [];
    freshData.delivery = 'digital';
    freshData.paperType = 'white';
    freshData.paper_type = 'white';

    try{
      const photos = {};
      async function addPhoto(key, st, imgEl){
        if(!st) return;
        let dataUrl = null;
        if(st.file){ try{ dataUrl = await fileToDataURL(st.file); }catch(_){} }
        if(!dataUrl && imgEl && imgEl.src && imgEl.src.indexOf('data:') === 0){ dataUrl = imgEl.src; }
        if(!dataUrl && st.dataUrl){ dataUrl = st.dataUrl; }
        if(!dataUrl) return;
        photos[key] = {
          data_url: dataUrl,
          mode: st.mode || 'contain',
          scale: st.scale || 1,
          offX: st.offX || 0,
          offY: st.offY || 0,
          rotation: st.rotation || 0,
          prev_text: key === 'sender' ? freshData.sender : ''
        };
      }
      await addPhoto('sender', state.photo1State, img1);
      freshData.photos = photos;
    }catch(e){
      console.warn('personalized fresh-start draft photo payload failed', e);
    }

    try{
      await fetch('https://partner.planet-tree.de/api2/wizard/draft/save', {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ key: DRAFT_KEY, mode: 'cert', data: freshData })
      });
      return true;
    }catch(e){
      console.warn('personalized fresh-start draft save failed', e);
      return false;
    }
  }

  async function loadDraftIfAny(){
    if (!DRAFT_KEY || hasEditOrClone || shouldSkipDraftRestore()) return null;
    try{
      const res = await fetch(
        'https://partner.planet-tree.de/api2/wizard/draft/load?key=' + encodeURIComponent(DRAFT_KEY),
        { headers:{ 'Accept':'application/json' } }
      );
      if(!res.ok) return null;
      const js = await res.json(); if (!js || !js.data) return null;
      const data = js.data;
      applyWizardState(data);
      const draftStep = (typeof data.step === 'number') ? data.step : 1;
      const maxAllowed = totalSteps();
      const minAllowed = (isB2BSummaryOnlyPortalFlow() || isB2BEventPortalFlow()) ? 10 : 1;
      const clampedStep = Math.min(Math.max(minAllowed, draftStep), maxAllowed);

      if (isB2BEventPortalFlow() && state && state.b2bPortal){
        const savedPhase = String(data.b2b_event_phase || '').trim().toLowerCase();
        state.b2bPortal.eventPhase = (savedPhase === 'monthly' || clampedStep >= 11) ? 'monthly' : 'event';
        state.b2bPortal.eventSnapshot = Object.assign({}, buildEventPortalSnapshot(), state.b2bPortal.eventSnapshot || {});
        state.b2bPortal.eventSnapshot.photo1State = cloneSenderPhotoState(state.photo1State);
      }

      if (isB2BPortalFlow()){
        try{
          const portalSnap = loadPortalSenderSnapshot();
          if (portalSnap) applyPortalSenderSnapshot(portalSnap);
        }catch(_){}
      }

      setStep(clampedStep);
      if (isB2BPortalFlow()){
        try{ ensurePortalSenderPrefill(); }catch(_){}
      }
      return data;
    }catch(e){
      console.warn('wizard draft load failed', e);
      return null;
    }
  }

  async function loadPersistentSummarySenderDraft(){
    const key = getSummarySenderPersistentDraftKey();
    if (!key || hasEditOrClone || !isB2BSummaryOnlyPortalFlow()) return null;
    try{
      const res = await fetch(
        'https://partner.planet-tree.de/api2/wizard/draft/load?key=' + encodeURIComponent(key),
        { headers:{ 'Accept':'application/json' } }
      );
      if(!res.ok) return null;
      const js = await res.json();
      if (!js || !js.data) return null;
      const data = js.data || {};
      let senderTextRaw = String(data.sender || '').replace(/\r/g,'');
      let senderText = senderTextRaw.replace(/\n+/g, ' ');
      let combine = !!data.photo1_combine;
      let photos = (data && typeof data === 'object' && data.photos && typeof data.photos === 'object') ? data.photos : {};
      let senderPhoto = (photos && photos.sender && typeof photos.sender === 'object') ? photos.sender : {};
      let senderDataUrl = String(
        senderPhoto.data_url ||
        senderPhoto.dataUrl ||
        senderPhoto.url ||
        senderPhoto.src ||
        senderPhoto.preview_url ||
        ''
      ).trim();

      if ((!senderDataUrl || !senderText) && typeof loadB2BTemplateForAliases === 'function'){
        try{
          const tplJs = await loadB2BTemplateForAliases(getSummaryTemplateAliases());
          const tplData = tplJs && tplJs.data ? tplJs.data : null;
          if (tplData){
            const tplPhotos = (tplData && typeof tplData === 'object' && tplData.photos && typeof tplData.photos === 'object') ? tplData.photos : {};
            const tplSenderPhoto = (tplPhotos && tplPhotos.sender && typeof tplPhotos.sender === 'object') ? tplPhotos.sender : {};
            const tplSenderDataUrl = String(
              tplSenderPhoto.data_url ||
              tplSenderPhoto.dataUrl ||
              tplSenderPhoto.url ||
              tplSenderPhoto.src ||
              tplSenderPhoto.preview_url ||
              ''
            ).trim();
            const tplSenderTextRaw = String(tplData.sender || '').replace(/\r/g,'');
            if (!senderText && tplSenderTextRaw){
              senderTextRaw = tplSenderTextRaw;
              senderText = tplSenderTextRaw.replace(/\n+/g, ' ');
            }
            if (!senderDataUrl && tplSenderDataUrl){
              senderPhoto = tplSenderPhoto;
              senderDataUrl = tplSenderDataUrl;
            }
            if (!combine && tplData.photo1_combine){
              combine = !!tplData.photo1_combine;
            }
          }
        }catch(_){}
      }

      if (photo1Combine) photo1Combine.checked = combine;
      if (state && state.photo1State) state.photo1State.combine = combine;
      if (senderText){
        if (txt1) txt1.value = senderTextRaw;
        if (summaryCombineTextInput) summaryCombineTextInput.value = senderText;
        if (state && state.photo1State) state.photo1State.prevText = senderText;
      }
      if (senderDataUrl && photo1 && typeof photo1.hydrateFromDataUrl === 'function'){
        photo1.hydrateFromDataUrl(String(senderDataUrl), {
          scale: senderPhoto.scale || 1,
          offX: senderPhoto.offX || 0,
          offY: senderPhoto.offY || 0,
          rotation: senderPhoto.rotation || 0,
          mode: senderPhoto.mode || 'contain'
        });
      } else if (!senderDataUrl && photo1 && typeof photo1.switchToText === 'function'){
        photo1.switchToText();
      }
      resetSummaryOnlyPlaceTextFresh();
      syncSummaryOnlySenderEditor();
      if (typeof fit1 === 'function') fit1();
      updatePreview();
      try{
        const portalSnap = loadPortalSenderSnapshot();
        if (portalSnap) applyPortalSenderSnapshot(portalSnap);
      }catch(_){}
      return js.data;
    }catch(e){
      console.warn('persistent summary sender draft load failed', e);
      return null;
    }
  }

  function clearDraftMappingLocal(){
    if (!DRAFT_KEY) return;
    try{
      let modeStr = state.mode;
      let vId = (state.mode==='gift' || state.mode==='label')
        ? (giftVariantParam || '')
        : (certVariantParam || giftVariantParam || '');
      if (isB2BSummaryOnlyPortalFlow() && portalCustomerRef){
        modeStr = 'b2b-summary';
        vId = 'portal:' + portalCustomerRef + ':summary';
      } else if (isB2BEventPortalFlow() && portalCustomerRef){
        modeStr = 'b2b-event';
        vId = 'portal:' + portalCustomerRef + ':event';
      } else if (isB2BPersonalizedPortalFlow() && portalCustomerRef){
        modeStr = 'b2b-cert';
        vId = 'portal:' + portalCustomerRef + ':personalized';
      }
      if (!vId) return;
      const lsKey = `ptw:draft:${modeStr}:${vId}`;
      window.localStorage.removeItem(lsKey);
    }catch(e){ console.warn('draft id localStorage remove failed', e); }
  }
  async function clearDraft(){
    if (!DRAFT_KEY) return;
    try{
      await fetch('https://partner.planet-tree.de/api2/wizard/draft/clear', {
        method: 'POST', headers: { 'Content-Type':'application/json' }, body: JSON.stringify({ key: DRAFT_KEY })
      });
    }catch(e){ console.warn('wizard draft clear (server) failed', e); }
    clearDraftMappingLocal();
  }

  async function prefillFromBundle(bundleId){
    const bId = (bundleId || '').trim(); if(!bId) return;

    let ws = null;
    try{
      const r = await fetch(
        'https://partner.planet-tree.de/api2/wizard/state?bundle_id=' + encodeURIComponent(bId),
        { headers: { 'Accept': 'application/json' } }
      );
      if(r.ok){ const js = await r.json(); if(js && js.data){ ws = js.data; } }
    }catch(e){ console.warn('prefillFromBundle: fetch wizard_state failed', e); }

    if(ws){ applyWizardState(ws); applyProductContextUI(); }
    try{
      const okPhotos = await restorePhotosFromServer(bId);
      if(!okPhotos){ console.warn('prefillFromBundle: no photos restored for bundle', bId); }
    }catch(e){ console.warn('restorePhotosFromServer in prefillFromBundle failed', e); }

placeA4Boxes();
applyForestToPreview();
scaleA4();
updatePreview();
initLabelDefaultsFromSteps();

// NEU: Immer in die finale Vorschau springen – egal welcher Modus
const finalStep = totalSteps();
setStep(finalStep);
  }

  async function bootstrapB2BPortalIntoWizard(){
    if (!isB2BPortalFlow() || !portalCustomerRef) return false;

    try{
      applyB2BAccountTreePriceOverride({
        tree_price_net_cents: portalTreePriceNetCents,
        tree_price_net: portalTreePriceNet
      });
      const profile = await b2bProfileGet(portalCustomerRef);
      let meAccount = null;
      let partnerName = String(profile.partner_name || profile.partner || portalPartnerName || '').trim();
      if (portalToken){
        try{
          const meUrl = API_BASE + '/api2/b2b/portal/me?token=' + encodeURIComponent(portalToken);
          const meRes = await fetch(meUrl, { headers:{ 'Accept':'application/json' } });
          const meJs = await meRes.json().catch(()=> ({}));
          if (meRes.ok && meJs && meJs.ok === true && meJs.account){
            const meRef = String((meJs.account || {}).customer_ref || '').trim();
            if (!meRef || !portalCustomerRef || meRef === portalCustomerRef){
              meAccount = meJs.account || null;
              applyB2BAccountTreePriceOverride(meAccount);
              partnerName = String(
                meJs.account.partner_name ||
                meJs.account.partner_page_title ||
                meJs.account.invoice_company ||
                partnerName ||
                meJs.account.customer_ref ||
                ''
              ).trim();
            }
          }
        }catch(e){
          console.warn('b2b portal me fallback failed', e);
        }
      }
      const partnerInput = $('b2bPartnerKey');
      const partnerUrlInput = $('b2bPartnerUrl');

      if (state && state.b2bPortal){
        state.b2bPortal.partnerName = partnerName;
        state.b2bPortal.landingSlug = String((meAccount && meAccount.landing_slug) || profile.landing_slug || '').trim();
        state.b2bPortal.partnerUrl = String((meAccount && (meAccount.partner_page_url || meAccount.partner_url)) || profile.partner_url || '').trim();
        state.b2bPortal.partnerPageEnabled = ((meAccount && meAccount.partner_page_enabled) !== false) && (profile.partner_page_enabled !== false);
      }

      if (partnerInput && partnerName){
        partnerInput.value = partnerName;
        rememberPartnerKey(partnerName);
      }

      try{
        const js = await loadB2BTemplateForAliases([
          portalCustomerRef,
          profile.customer_ref || '',
          profile.landing_slug || '',
          partnerName
        ]);
        if (js && js.data){
          applyWizardState(js.data);
        }
      }catch(e){
        console.warn('b2b portal template load failed', e);
      }

      if (partnerInput && partnerName){
        partnerInput.value = partnerName;
      }

      var partnerSlug = String((meAccount && meAccount.landing_slug) || profile.landing_slug || '').trim();
      const partnerPageEnabled = ((meAccount && meAccount.partner_page_enabled) !== false) && (profile && profile.partner_page_enabled !== false);
      const preferredPartnerUrl = (partnerPageEnabled === false)
        ? 'https://planet-tree.de'
        : (partnerSlug ? ('https://partner.planet-tree.de/p/' + encodeURIComponent(partnerSlug)) : (((meAccount && (meAccount.partner_page_url || meAccount.partner_url)) || profile.partner_url || state.monthlyQrUrl || '')));
      const normalizedUrl = normalizePartnerUrl(preferredPartnerUrl || '');
      if (normalizedUrl.full){
        state.monthlyQrUrl = normalizedUrl.full;
      }
      if (partnerUrlInput){
        partnerUrlInput.value = String(state.monthlyQrUrl || '');
      }

      if (txt1 && !(txt1.value || '').trim() && partnerName){
        txt1.value = partnerName;
        if (state && state.photo1State){
          state.photo1State.prevText = partnerName;
        }
        if (typeof fit1 === 'function') fit1();
        if (typeof updatePreview === 'function') updatePreview();
      }

      if (isB2BSummaryOnlyPortalFlow()){
        state.seriesEnabled = false;
        state.seriesRows = [];
        state.seriesTrees = [];
        state.seriesForest = [];
        state.monthlyProjectForestTrees = { mv:0, by:0, rp:0 };
        state.monthlyTrees = 0;
        state.monthlyUserEdited = false;
        if (isB2BSubscriptionPortalFlow()){
          const appliedSubscriptionPlan = applySubscriptionSetupFromProfile(profile);
          if (!appliedSubscriptionPlan){
            syncSubscriptionMonthlyState();
          }
        } else if (isB2BQuickMonthlyPortalFlow()){
          const quickMonth = /^\d{4}-\d{2}$/.test(String(portalMonthlyKey || '').trim())
            ? String(portalMonthlyKey || '').trim()
            : (function(){
                const now = new Date();
                return String(now.getFullYear()) + '-' + String(now.getMonth() + 1).padStart(2, '0');
              })();
          state.monthlyMonth = quickMonth;
          if (state && state.b2bPortal){
            state.b2bPortal.monthlyMonth = quickMonth;
          }
        }
        if (isB2BSubscriptionPortalFlow()){
          syncSubscriptionMonthlyState();
        } else {
          resetSummaryOnlyPlaceTextFresh();
        }
        setStep(10);
        try{
          const localSummarySnap = loadSummarySenderLocalSnapshot();
          if (localSummarySnap) applySummarySenderLocalSnapshot(localSummarySnap);
        }catch(_){}
      } else if (isB2BEventPortalFlow()){
        state.seriesEnabled = false;
        state.seriesRows = [];
        state.seriesTrees = [];
        state.seriesForest = [];
        state.b2bPortal.eventPhase = 'event';
        setStep(10);
        try{
          const portalSnap = loadPortalSenderSnapshot();
          if (portalSnap) applyPortalSenderSnapshot(portalSnap);
        }catch(_){}
      } else {
        resetB2BPortalPersonalizedInputs();
        setStep(1);
        try{
          const logoSnap = loadPersonalizedLogoSnapshot();
          if (logoSnap) applyPersonalizedLogoSnapshot(logoSnap);
        }catch(_){}
        try{
          const portalSnap = loadPortalSenderSnapshot();
          if (portalSnap) applyPortalSenderSnapshot(portalSnap);
        }catch(_){}
      }

      applyForestToPreview();
      applyFrameColor();
      updateClaim();
      updatePrice();
      updatePreview();
      initMonthlyControls();
      if (isB2BSubscriptionPortalFlow()){
        try{ applySubscriptionSetupFromProfile(profile); }catch(_){}
        try{ initMonthlyControls(); }catch(_){}
      }

      if (isB2BSummaryOnlyPortalFlow()){
        try{
          const localSummarySnap = loadSummarySenderLocalSnapshot();
          if (localSummarySnap) applySummarySenderLocalSnapshot(localSummarySnap);
        }catch(_){}
        try{
          const portalSnap = loadPortalSenderSnapshot();
          if (portalSnap) applyPortalSenderSnapshot(portalSnap);
        }catch(_){}
        try{ await loadPersistentSummarySenderDraft(); }catch(_){}
        setTimeout(function(){
          try{
            const delayedSummarySnap = loadSummarySenderLocalSnapshot();
            if (delayedSummarySnap) applySummarySenderLocalSnapshot(delayedSummarySnap);
          }catch(_){}
          try{
            const delayedPortalSnap = loadPortalSenderSnapshot();
            if (delayedPortalSnap) applyPortalSenderSnapshot(delayedPortalSnap);
          }catch(_){}
        }, 220);
        setTimeout(async function(){
          try{ await loadPersistentSummarySenderDraft(); }catch(_){}
          try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
        }, 420);
      } else if (isB2BEventPortalFlow()){
        try{
          const portalSnap = loadPortalSenderSnapshot();
          if (portalSnap) applyPortalSenderSnapshot(portalSnap);
        }catch(_){}
        try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
        setTimeout(function(){
          try{
            const delayedPortalSnap = loadPortalSenderSnapshot();
            if (delayedPortalSnap) applyPortalSenderSnapshot(delayedPortalSnap);
          }catch(_){}
        }, 220);
        setTimeout(async function(){
          try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
        }, 420);
      } else if (isB2BPersonalizedPortalFlow()){
        try{ await loadPersistentPersonalizedSenderDraft(); }catch(_){}
        try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
        setTimeout(function(){
          try{
            const delayedLogoSnap = loadPersonalizedLogoSnapshot();
            if (delayedLogoSnap) applyPersonalizedLogoSnapshot(delayedLogoSnap);
          }catch(_){}
          try{
            const delayedPortalSnap = loadPortalSenderSnapshot();
            if (delayedPortalSnap) applyPortalSenderSnapshot(delayedPortalSnap);
          }catch(_){}
        }, 220);
        setTimeout(async function(){
          try{ await loadPersistentPersonalizedSenderDraft(); }catch(_){}
          try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
        }, 420);
      }

      if (partnerName){
        try{ await loadRecentB2BJobs(partnerName); }catch(_){}
      }

      try{ ensurePortalSenderPrefill(); }catch(_){}

      return true;
    }catch(e){
      console.warn('b2b portal bootstrap failed', e);
      return false;
    }
  }

  async function syncB2BPortalQrTarget(){
    if (!isB2BPortalFlow() || !portalCustomerRef) return;
    try{
      let targetUrl = '';
      let enabled = true;
      let slug = '';
      if (portalToken){
        try{
          const meUrl = API_BASE + '/api2/b2b/portal/me?token=' + encodeURIComponent(portalToken);
          const meRes = await fetch(meUrl, { headers:{ 'Accept':'application/json' } });
          const meJs = await meRes.json().catch(()=> ({}));
          if (meRes.ok && meJs && meJs.ok === true && meJs.account){
            enabled = meJs.account.partner_page_enabled !== false;
            slug = String(meJs.account.landing_slug || '').trim();
            targetUrl = String(meJs.account.partner_page_url || meJs.account.partner_url || '').trim();
          }
        }catch(_){}
      }
      if (!slug || !targetUrl){
        try{
          const profile = await b2bProfileGet(portalCustomerRef);
          enabled = enabled && (profile.partner_page_enabled !== false);
          slug = slug || String(profile.landing_slug || '').trim();
          targetUrl = targetUrl || String(profile.partner_url || '').trim();
        }catch(_){}
      }
      const preferred = (enabled === false)
        ? 'https://planet-tree.de'
        : (slug ? ('https://partner.planet-tree.de/p/' + encodeURIComponent(slug)) : (targetUrl || 'https://planet-tree.de'));
      const normalized = normalizePartnerUrl(preferred);
      if (normalized.full){
        state.monthlyQrUrl = normalized.full;
        const partnerUrlInput = $('b2bPartnerUrl');
        if (partnerUrlInput) partnerUrlInput.value = normalized.full;
        renderMonthlyQr();
        renderMonthlyUrl();
      }
    }catch(_){}
  }

  function ensureSummaryOnlySenderPrefill(){
    const partnerName =
      state && state.b2bPortal
        ? String(state.b2bPortal.partnerName || '').trim()
        : '';
    if (!partnerName) return;
    if (txt1 && !(txt1.value || '').trim()){
      txt1.value = partnerName;
      if (typeof fit1 === 'function') fit1();
    }
    if (state && state.photo1State && (typeof state.photo1State.prevText !== 'string' || !state.photo1State.prevText.trim())){
      state.photo1State.prevText = partnerName;
    }
  }

  function ensurePortalSenderPrefill(){
    if (!isB2BPortalFlow()) return false;
    const partnerName = String(getPartnerName() || portalPartnerName || '').trim();
    if (!partnerName) return false;

    const hasTopPhoto = !!(
      state &&
      state.photo1State &&
      (
        state.photo1State.file ||
        state.photo1State.dataUrl ||
        ((state.photo1State.w || 0) > 0 && (state.photo1State.h || 0) > 0)
      )
    );
    const currentTopText = String((txt1 && txt1.value) || (state && state.photo1State && state.photo1State.prevText) || '').replace(/\r/g,'').trim();
    if (!hasTopPhoto && !currentTopText){
      if (photo1Combine) photo1Combine.checked = false;
      if (state && state.photo1State){
        state.photo1State.combine = false;
        state.photo1State.prevText = partnerName;
      }
      if (photo1 && typeof photo1.switchToText === 'function'){
        photo1.switchToText();
      }
      if (txt1){
        txt1.value = partnerName;
        if (typeof fit1 === 'function') fit1();
      }
      if (personalizedSenderCombineTextInput && !String(personalizedSenderCombineTextInput.value || '').trim()){
        personalizedSenderCombineTextInput.value = partnerName;
      }
      if (summaryCombineTextInput && !String(summaryCombineTextInput.value || '').trim()){
        summaryCombineTextInput.value = partnerName;
      }
      try{ syncSummaryOnlySenderEditor(); }catch(_){}
      try{ syncPersonalizedStep1SenderUi(); }catch(_){}
      try{ updatePreview(); }catch(_){}
      return true;
    }
    return false;
  }

  function getRecurringEngagementProfile(profile){
    if (!profile || typeof profile !== 'object') return null;
    const list = Array.isArray(profile.recurring_engagements) ? profile.recurring_engagements.filter(function(item){
      return !!(item && typeof item === 'object');
    }) : [];
    if (portalSubscriptionId){
      for (const item of list){
        if (String(item.subscription_id || '').trim() === portalSubscriptionId){
          return item;
        }
      }
      return null;
    }
    if (isB2BSubscriptionPortalFlow()){
      return null;
    }
    const raw = profile.recurring_engagement || profile.recurring_subscription || null;
    return (raw && typeof raw === 'object') ? raw : null;
  }

  function applySubscriptionSetupFromProfile(profile){
    if (!isB2BSubscriptionPortalFlow()) return false;
    const plan = getRecurringEngagementProfile(profile) || {};
    const wizardState = (plan.wizard_state && typeof plan.wizard_state === 'object') ? plan.wizard_state : null;
    if (wizardState){
      applyWizardState(wizardState);
    }
    if (typeof plan.active === 'boolean'){
      state.subscriptionActive = !!plan.active;
    } else if (typeof state.subscriptionActive !== 'boolean'){
      state.subscriptionActive = true;
    }
    if (typeof plan.frequency === 'string'){
      state.subscriptionFrequency = normalizeSubscriptionFrequency(plan.frequency);
    }
    if (typeof plan.count_mode === 'string'){
      state.subscriptionCountMode = normalizeSubscriptionCountMode(plan.count_mode);
    } else if (portalSubscriptionCountMode){
      state.subscriptionCountMode = normalizeSubscriptionCountMode(portalSubscriptionCountMode);
    }
    const planFixedTrees = Math.max(
      1,
      parseInt(
        plan.fixed_trees
        ?? (wizardState && wizardState.subscription_fixed_trees)
        ?? (wizardState && wizardState.monthly_trees)
        ?? portalSubscriptionFixedTrees
        ?? state.subscriptionFixedTrees
        ?? 1,
        10
      ) || 1
    );
    state.subscriptionFixedTrees = planFixedTrees;
    state.monthlyTrees = planFixedTrees;
    if (typeof plan.forest_code === 'string'){
      state.subscriptionForestCode = normalizeSubscriptionForestCode(plan.forest_code);
    } else if (portalSubscriptionForestCode){
      state.subscriptionForestCode = normalizeSubscriptionForestCode(portalSubscriptionForestCode);
    }
    if (typeof plan.start_date === 'string'){
      state.subscriptionStartDate = normalizeSubscriptionStartDate(plan.start_date);
    } else if (portalSubscriptionStartDate){
      state.subscriptionStartDate = normalizeSubscriptionStartDate(portalSubscriptionStartDate);
    } else if (typeof plan.start_month === 'string' && /^\d{4}-\d{2}$/.test(plan.start_month)){
      state.subscriptionStartDate = normalizeSubscriptionStartDate(String(plan.start_month || '').trim() + '-01');
    }
    if (typeof plan.start_month === 'string' && /^\d{4}-\d{2}$/.test(plan.start_month)){
      state.monthlyMonth = String(plan.start_month || '').trim();
    }
    if (typeof plan.lang === 'string'){
      state.lang = normalizeLang(plan.lang);
    }
    syncSubscriptionMonthlyState();
    if (txt1 && !(txt1.value || '').trim()){
      ensureSummaryOnlySenderPrefill();
    }
    if (typeof fit1 === 'function') fit1();
    try{ syncSummaryOnlySenderEditor(); }catch(_){}
    try{ syncMonthlyLangToggleUI(); }catch(_){}
    try{ syncMonthlyVerbToggleUI(); }catch(_){}
    try{ initMonthlyControls(); }catch(_){}
    try{ updateClaim(); }catch(_){}
    try{ updatePreview(); }catch(_){}
    try{ syncB2BMonthlyCreateButtonLabel(); }catch(_){}
    setTimeout(function(){
      try{ initMonthlyControls(); }catch(_){}
      try{ syncB2BMonthlyCreateButtonLabel(); }catch(_){}
    }, 0);
    setTimeout(function(){
      try{ initMonthlyControls(); }catch(_){}
      try{ syncB2BMonthlyCreateButtonLabel(); }catch(_){}
    }, 180);
    return !!wizardState || !!plan.active;
  }

  function syncSummaryOnlySenderEditor(){
    const wrap = $('summarySenderEditorWrap');
    const host = $('summarySenderEditorHost');
    const home = $('senderEditorHome');
    const block = $('senderEditorBlock');
    const box = $('box1');
    const summaryMode = !!(
      (isB2BSummaryOnlyPortalFlow() && state.step === 10) ||
      isB2BEventCertificatePhase()
    );
    const hasPhoto = !!(state && state.photo1State && state.photo1State.w > 0 && state.photo1State.h > 0);
    const splitCombineMode = !!(summaryMode && photo1Combine && photo1Combine.checked);

    if (!wrap || !host || !home || !block) return;

    if (summaryMode){
      ensureSummaryOnlySenderPrefill();
      wrap.style.display = 'block';
      if (block.parentNode !== host){
        host.appendChild(block);
      }
      if (box){
        const stepInner = box.closest('.step-inner');
        if (stepInner){
          stepInner.classList.toggle('has-photo', hasPhoto);
        }
      }
      try{
        if (photo1 && typeof photo1.apply === 'function' && hasPhoto){
          photo1.apply();
        }
      }catch(_){}

      if (summaryCombineTextWrap && summaryCombineTextInput){
        summaryCombineTextWrap.style.display = splitCombineMode ? 'block' : 'none';
        summaryCombineTextInput.value = String(txt1 && txt1.value || '').replace(/\r/g,'').replace(/\n+/g,' ');
      }
      if (box){
        box.classList.remove('photo-combo');
      }
      if (txt1){
        if (splitCombineMode){
          txt1.style.display = 'none';
          txt1.style.setProperty('visibility', 'hidden', 'important');
        } else {
          txt1.style.removeProperty('visibility');
          if (!state.photo1State || !state.photo1State.w || !state.photo1State.h || !state.photo1State.combine){
            txt1.style.display = 'block';
          }
        }
      }
      if (ph1 && splitCombineMode){
        ph1.style.setProperty('inset', '0', 'important');
      }
    } else {
      wrap.style.display = 'none';
      if (block.parentNode !== home){
        home.appendChild(block);
      }
      if (box){
        const stepInner = box.closest('.step-inner');
        if (stepInner){
          stepInner.classList.toggle('has-photo', hasPhoto);
        }
      }
      if (summaryCombineTextWrap) summaryCombineTextWrap.style.display = 'none';
      if (txt1){
        txt1.style.removeProperty('visibility');
      }
      if (ph1){
        ph1.style.removeProperty('inset');
      }
    }
  }

    // Step 11: Etikett / Hinweis klicken -> zurück zu Schritt 10 (Label bearbeiten)
  const labelEditHint11 = $('labelEditHint11');
  if(labelEditHint11){
    labelEditHint11.style.cursor = 'pointer';
    labelEditHint11.addEventListener('click', ()=>{
      setStep(10);
    });
  }

  const labelStageFinal = $('labelStageFinal');
  if(labelStageFinal){
    labelStageFinal.style.cursor = 'pointer';
    labelStageFinal.addEventListener('click', ()=>{
      setStep(10);
    });
  }

  /* ===== Init ===== */
  updateClaim();
  updatePrice();
  updateQtyLabel();
  updateCo2Label();
  applyForestToPreview();
  applyFrameColor();
  applyDeliverySelectionUI();
  togglePaperOptions();
  updateNavForStep(state.step);
  updateFooterForStep(state.step);
  updatePreviewReturnUI();
  initGiftModeUI();
  applyProductContextUI();

  bindLabelInlineEditing();
  initLabelDefaultsFromSteps();
  applyForestToLabel();
  syncGreetCardUI();

  syncSummaryOnlySenderEditor();

  (async function initWizardLaunch(){
    try {
      if (params.has('edit_bundle')) {
        editBundleId = params.get('edit_bundle');
        openWizard();
        if (editBundleId) await prefillFromBundle(editBundleId);
        return;
      }

      if (params.has('clone_bundle')) {
        const cloneBundleId = params.get('clone_bundle');
        openWizard();
        if (cloneBundleId) await prefillFromBundle(cloneBundleId);
        return;
      }

      openWizard();

      if (isB2BPortalFlow()){
        await bootstrapB2BPortalIntoWizard();
        if (DRAFT_KEY){
          await loadDraftIfAny();
          if (isB2BQuickMonthlyPortalFlow()){
            initMonthlyControls();
          }
        }
        await syncB2BPortalQrTarget();
        if (isB2BSummaryOnlyPortalFlow()){
          try{
            const localSummarySnap = loadSummarySenderLocalSnapshot();
            if (localSummarySnap) applySummarySenderLocalSnapshot(localSummarySnap);
          }catch(_){}
          try{
            const portalSnap = loadPortalSenderSnapshot();
            if (portalSnap) applyPortalSenderSnapshot(portalSnap);
          }catch(_){}
          try{ await loadPersistentSummarySenderDraft(); }catch(_){}
          await syncB2BPortalQrTarget();
          setTimeout(function(){
            try{
              const delayedSummarySnap = loadSummarySenderLocalSnapshot();
              if (delayedSummarySnap) applySummarySenderLocalSnapshot(delayedSummarySnap);
            }catch(_){}
            try{
              const delayedPortalSnap = loadPortalSenderSnapshot();
              if (delayedPortalSnap) applyPortalSenderSnapshot(delayedPortalSnap);
            }catch(_){}
          }, 120);
          setTimeout(async function(){
            try{ await loadPersistentSummarySenderDraft(); }catch(_){}
            try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
            try{ await syncB2BPortalQrTarget(); }catch(_){}
          }, 420);
        } else if (isB2BEventPortalFlow()){
          try{
            const portalSnap = loadPortalSenderSnapshot();
            if (portalSnap) applyPortalSenderSnapshot(portalSnap);
          }catch(_){}
          try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
          setTimeout(function(){
            try{
              const delayedPortalSnap = loadPortalSenderSnapshot();
              if (delayedPortalSnap) applyPortalSenderSnapshot(delayedPortalSnap);
            }catch(_){}
          }, 120);
          setTimeout(async function(){
            try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
          }, 420);
        } else if (isB2BPersonalizedPortalFlow()){
          try{
            const localPersonalizedSnap = loadPersonalizedLogoSnapshot();
            if (localPersonalizedSnap) applyPersonalizedLogoSnapshot(localPersonalizedSnap);
          }catch(_){}
          try{ await loadPersistentPersonalizedSenderDraft(); }catch(_){}
          try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
          setTimeout(function(){
            try{
              const delayedPersonalizedSnap = loadPersonalizedLogoSnapshot();
              if (delayedPersonalizedSnap) applyPersonalizedLogoSnapshot(delayedPersonalizedSnap);
            }catch(_){}
            try{
              const delayedPortalSnap = loadPortalSenderSnapshot();
              if (delayedPortalSnap) applyPortalSenderSnapshot(delayedPortalSnap);
            }catch(_){}
          }, 120);
          setTimeout(async function(){
            try{ await loadPersistentPersonalizedSenderDraft(); }catch(_){}
            try{ await loadPersistentPortalSenderDraft({ force:true }); }catch(_){}
          }, 420);
        }
        return;
      }

      if (DRAFT_KEY){
        await loadDraftIfAny();
      }
    } catch (e) {
      console.warn('edit/clone_bundle/portal init failed', e);
      openWizard();
    }
  })();


function normalizePartnerUrl(raw){
  let s = String(raw || '').trim();
  if(!s) return { full:'', pretty:'' };

  // schon voll?
  if(/^https?:\/\//i.test(s)){
    const full = s;
    return { full, pretty: full.replace(/^https?:\/\//i,'') };
  }

  // partner.planet-tree.de/p/<slug>
  if(/^partner\.planet-tree\.de\/p\//i.test(s)){
    const full = 'https://' + s;
    return { full, pretty: full.replace(/^https?:\/\//i,'') };
  }

  // "/firmaxyz" -> planet-tree.de/firmaxyz
  if(s.startsWith('/')){
    const full = 'https://planet-tree.de' + s;
    return { full, pretty: full.replace(/^https?:\/\//i,'') };
  }

  // "planet-tree.de/firmaxyz" oder "www.planet-tree.de/..."
  if(/^(\w+\.)?planet-tree\.de\//i.test(s)){
    const full = 'https://' + s;
    return { full, pretty: full.replace(/^https?:\/\//i,'') };
  }

  // sonst: als Partnerseiten-Slug behandeln
  s = s.replace(/^\/+/,'');
  const full = 'https://partner.planet-tree.de/p/' + encodeURIComponent(s);
  return { full, pretty: full.replace(/^https?:\/\//i,'') };
}

function getB2BPrintedUrl(){
  const n = normalizePartnerUrl(state.monthlyQrUrl || '');
  return n.pretty || 'planet-tree.de';
}

function shortenSealUrl(s, maxLen){
  s = String(s || '').trim();
  maxLen = maxLen || 32;   // passt gut ins Siegel
  if (s.length <= maxLen) return s;
  return s.slice(0, maxLen - 1) + '…';
}

function renderMonthlyUrl(){
  const sealUrl = $('pvSealUrl');
  if (!sealUrl) return;

  if (!isMonthlyCertState()){
    sealUrl.textContent = '';
    return;
  }

  const txt = getB2BPrintedUrl(); // ohne https://
  sealUrl.textContent = shortenSealUrl(txt, 32);
}




/* =========================================================
   PT_B2B_AUTARK_PATCH_V1
   B2B: Autark „Zertifikate erstellen“ (ohne Shopify Checkout)
   ========================================================= */
(function setupB2BAutark(){
  if (!isB2B || isAdminEdit || isCustomerEdit) return;

  const b2bTemplateBlock   = $('b2bTemplateBlock');
  const b2bPartnerKey      = $('b2bPartnerKey');
  const btnB2BTemplateLoad  = $('btnB2BTemplateLoad');
  const btnB2BTemplateSave  = $('btnB2BTemplateSave');
  const b2bJobsBlock = $('b2bJobsBlock');
  const b2bJobsBody  = $('b2bJobsBody');
  const btnB2BReset = $('btnB2BReset');
  const b2bPartnerUrl = $('b2bPartnerUrl');
  const btnB2BCreateMonthly = $('btnB2BCreateMonthly');


  if (btnB2BReset){
    btnB2BReset.addEventListener('click', (e)=>{
      e.preventDefault();
      resetB2BWizard({ keepPartner:false });
      showTplResult('<div>Reset ✅ Du kannst jetzt clean neu starten.</div>');
    });
  }

  // ============================================
  // Partnerwechsel = Reset + Jobs laden (neuestes Projekt automatisch öffnen)
  // ============================================
  (function bindPartnerSwitchFlow(){
    if(!b2bPartnerKey) return;

    if (b2bPartnerKey.dataset && b2bPartnerKey.dataset.ptPartnerSwitchBound === '1') return;
    if (b2bPartnerKey.dataset) b2bPartnerKey.dataset.ptPartnerSwitchBound = '1';

    let lastCommitted = (b2bPartnerKey.value || '').trim();

    async function commit(){
      const name = (b2bPartnerKey.value || '').trim();

      // leer -> alles leeren
      if(!name){
        lastCommitted = '';
        resetB2BWizard({ keepPartner:true });
        return;
      }

      const changed = (name !== lastCommitted);
      lastCommitted = name;

      // bei Wechsel: sauber resetten (inkl. Draft/Outputs/Locks)
      if (changed){
        resetB2BWizard({ keepPartner:true });
      }else{
        // auch wenn gleich: Outputs/Locks sauber halten
        clearB2BOutputs();
        setB2BEditMode(false);
        setStep(0);
      }

      // Jobs laden + neuestes automatisch öffnen
      await loadRecentB2BJobs(name, { autoOpenLatest:true });

      showTplResult(
        '<div><strong>Partner aktiv ✅</strong><br>' +
        'Letzte Projekte geladen (neuestes geöffnet).</div>'
      );
    }

    // beim Tippen schon mal UI clean halten
    b2bPartnerKey.addEventListener('input', ()=>{
      clearB2BOutputs();
      setB2BEditMode(false);
    });

    // Commit auf blur/change/enter
    b2bPartnerKey.addEventListener('blur', commit);
    b2bPartnerKey.addEventListener('change', commit);
    b2bPartnerKey.addEventListener('keydown', (e)=>{
      if(e.key === 'Enter'){
        e.preventDefault();
        b2bPartnerKey.blur(); // triggert commit()
      }
    });
  })();

  // ============================
// Partner-Autocomplete (datalist)
// ============================
function ensurePartnerDatalist(){
  if(!b2bPartnerKey) return null;

  let dl = document.getElementById('b2bPartnerDatalist');
  if(!dl){
    dl = document.createElement('datalist');
    dl.id = 'b2bPartnerDatalist';
    document.body.appendChild(dl);
  }
  b2bPartnerKey.setAttribute('list', 'b2bPartnerDatalist');
  return dl;
}

let __partnerCache = null;
let __partnerCacheLoaded = false;

async function loadAllPartnersForAutocomplete(){
  if(__partnerCacheLoaded && Array.isArray(__partnerCache)) return __partnerCache;

  const dl = ensurePartnerDatalist();
  if(!dl) return [];

  try{
    const url = API_BASE + '/api2/b2b/partners/list?limit=2000';
    const res = await fetch(url, { headers:{ 'Accept':'application/json' }});
    const js  = await res.json().catch(()=> ({}));
    const items = (res.ok && js && js.ok === true && Array.isArray(js.items)) ? js.items : [];

    __partnerCache = items;
    __partnerCacheLoaded = true;

    // datalist füllen
    dl.innerHTML = items.map(name => `<option value="${String(name).replace(/"/g,'&quot;')}"></option>`).join('');
    return items;
  }catch(e){
    console.warn('partner autocomplete load failed', e);
    __partnerCache = [];
    __partnerCacheLoaded = true;
    return [];
  }
}

// beim Fokus (oder beim Öffnen) laden
if (b2bPartnerKey){
  b2bPartnerKey.addEventListener('focus', ()=>{
    loadAllPartnersForAutocomplete();
  });

  // optional: wenn User exakt einen Vorschlag auswählt, direkt committen
  b2bPartnerKey.addEventListener('change', ()=>{
    // change triggert bei datalist-Auswahl oft direkt -> dein bestehendes commit() hängt eh auf change/blur
    // hier nichts weiter nötig
  });
}


  const tplResultWrap = $('b2bTemplateResult');
  const tplResultBody = $('b2bTemplateResultBody');
  const btnB2BCreate      = $('btnB2BCreate');

  const resultWrap = $('b2bResult');
  const resultBody = $('b2bResultBody');

  if (b2bTemplateBlock) b2bTemplateBlock.style.display = 'block';


  function syncPartnerUrlFromUI(){
  if(!b2bPartnerUrl) return;
  const n = normalizePartnerUrl(b2bPartnerUrl.value);
  // full URL für QR
  if(n.full) state.monthlyQrUrl = n.full;
  // Preview updaten (Monat + personalisiert)
  updatePreview();
  renderMonthlyQr();
  renderMonthlyUrl();
invalidateMonthlyFinalCache();
  if (!hasEditOrClone && DRAFT_KEY){ scheduleDraftSave(); }
}

if (b2bPartnerUrl){
  // initial aus State befüllen
  b2bPartnerUrl.value = String(state.monthlyQrUrl || '');
  b2bPartnerUrl.addEventListener('input', syncPartnerUrlFromUI);
  b2bPartnerUrl.addEventListener('change', syncPartnerUrlFromUI);
  b2bPartnerUrl.addEventListener('blur',  syncPartnerUrlFromUI);
}


  function showB2BResult(html){
    if (!resultWrap || !resultBody) return;
    resultBody.innerHTML = html || '';
    resultWrap.style.display = 'block';
    try{ resultWrap.scrollIntoView({ behavior:'smooth', block:'start' }); }catch(_){}
  }
  function hideB2BResult(){
    if (resultWrap) resultWrap.style.display = 'none';
  }

  function escapeHtml(s){
    return String(s||'').replace(/[&<>"']/g, (c)=>({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'
    }[c]));
  }

  function monthlyPngFromPdf(monthlyPdfUrl){
  if(!monthlyPdfUrl) return '';
  // .../certs/b2b_<partner>_<YYYY-MM>.pdf  ->  .../certs/img/b2b_<partner>_<YYYY-MM>.png
  return String(monthlyPdfUrl)
    .replace('/certs/', '/certs/img/')
    .replace(/\.pdf(\?.*)?$/i, '.png');
}


  function showTplResult(html){
    if (!tplResultWrap || !tplResultBody) return;
    tplResultBody.innerHTML = html || '';
    tplResultWrap.style.display = 'block';
  }
  function hideTplResult(){
    if (tplResultWrap) tplResultWrap.style.display = 'none';
  }

    function clearB2BOutputs(){
    // 1) Ergebnisblock (Downloadlinks) hart zurücksetzen
    try{
      hideB2BResult();
      if (resultBody) resultBody.innerHTML = '';
    }catch(_){}

    // 2) Template-Result (Vorlage geladen/gespeichert) zurücksetzen
    try{
      hideTplResult();
      if (tplResultBody) tplResultBody.innerHTML = '';
    }catch(_){}

    // 3) Monats-Preview-Cache zurücksetzen (Step 11 / Monatsblock)
    try{
      const mb = $('monthlyFinalBlock');
      if (mb) mb.style.display = 'none';
      if (typeof invalidateMonthlyFinalCache === 'function'){
        invalidateMonthlyFinalCache();
      }
    }catch(_){}
  }

    function resetB2BWizard(opts){
    opts = opts || {};
    const keepPartner = (opts.keepPartner !== false); // default: true
    const partnerVal = keepPartner ? getPartnerName() : '';

    // UI/Outputs killen
    clearB2BOutputs();
    setB2BEditMode(false);

    // Draft sauber löschen (verhindert “Ghost Restore”)
    try{
      if (typeof clearDraft === 'function') clearDraft();
    }catch(_){}

    // Kern-State zurück
    state.seriesEnabled = false;
    state.seriesRows = [];
    state.seriesTrees = [];
    state.seriesSender = [];
    state.seriesOccasion = [];
    state.seriesVerb = [];
    state.seriesDecoBalloon = [];
    state.seriesDecoHat = [];
    state.seriesForest = [];
    state.seriesFrameColor = [];
    state.seriesDelivery = [];
    state.seriesPaperType = [];
    state.seriesIndex = 0;

    state.verb = 'HAT';
    state.trees = 1;

    state.decoBalloon = false;
    state.decoHat = false;

    state.forest = null;
    state.frameColor = FRAME_COLOR_DEFAULT;

    state.delivery = 'digital';
    state.paperType = 'white';

    // Grußkarte reset
    state.greetCardSelected = false;
    state.greetCardOriginallySelected = false;
    if (gcTxt1) gcTxt1.value = '';
    if (gcTxt2) gcTxt2.value = '';
    if (gcTxt3) gcTxt3.value = '';

    // Monatszertifikat reset (rudimentär)
  state.monthlyTrees = 0;
  state.monthlyMonth = null;
  state.monthlyForests = [];
  state.monthlyForestTrees = { mv:0, by:0, rp:0 };
  state.monthlyQrUrl = 'https://planet-tree.de';
  state.monthlyId = null;
    try{
      // Monthly-ID localStorage (falls gesetzt) löschen
      const k = monthlyStorageKey && (monthlyStorageKey() + ':id');
      if (k) localStorage.removeItem(k);
    }catch(_){}

    // Inputs reset
    if (txt1) { txt1.value = ''; if (typeof fit1 === 'function') fit1(); }
    if (txt4) { txt4.value = ''; if (typeof fit4 === 'function') fit4(); }
    if (txt6) { txt6.value = ''; if (typeof fit6 === 'function') fit6(); }
    if (qVal) qVal.value = '1';

    if (seriesNamesTA) seriesNamesTA.value = '';
    if (seriesCompaniesTA) seriesCompaniesTA.value = '';
    if (seriesRecipientText) seriesRecipientText.value = '';

    // Fotos hart weg
    try{ if (photo1 && photo1.switchToText) photo1.switchToText(); }catch(_){}
    try{ if (photo4 && photo4.switchToText) photo4.switchToText(); }catch(_){}
    try{ if (photo6 && photo6.switchToText) photo6.switchToText(); }catch(_){}
    try{ if (greetPhoto1 && greetPhoto1.switchToText) greetPhoto1.switchToText(); }catch(_){}
    try{ if (greetPhoto2 && greetPhoto2.switchToText) greetPhoto2.switchToText(); }catch(_){}
    try{ if (greetPhoto3 && greetPhoto3.switchToText) greetPhoto3.switchToText(); }catch(_){}

    // Deko-Checkboxes reset
    const ob = $('optBalloon'); if (ob) ob.checked = false;
    const oh = $('optHat');     if (oh) oh.checked = false;

    // Forst-Radios abwählen
    try{
      if (forestOptionsEl){
        forestOptionsEl.querySelectorAll('input[name="forest"]').forEach(inp=> inp.checked = false);
      }
    }catch(_){}

    // Verb-Buttons reset
    try{
      if (segVerb){
        segVerb.querySelectorAll('button').forEach(b=>{
          b.classList.toggle('active', b.getAttribute('data-verb') === 'HAT');
        });
      }
    }catch(_){}

    // UI sync
    applyDecor();
    applyForestSelectionUI();
    applyForestToPreview();
    applyFrameColor();
    togglePaperOptions();
    updateClaim();
    updatePrice();
    updateQtyLabel();
    updateCo2Label();
    updateMetaBar();
    updatePreview();
    syncGreetCardUI();

    // Partnerfeld optional wiederherstellen
    if (!keepPartner && b2bPartnerKey) b2bPartnerKey.value = '';
    if (keepPartner && b2bPartnerKey) b2bPartnerKey.value = partnerVal;
// ✅ Jobs/Projekte UI komplett leeren, wenn Partner nicht behalten wird
if (!keepPartner){
  if (b2bJobsBody)  b2bJobsBody.innerHTML = '';
  if (b2bJobsBlock) b2bJobsBlock.style.display = 'none';
}

    // In Step 0 bleiben
    setStep(0);
  }


  // === B2B Projekt-Edit-Mode (IDs behalten) =========================
let B2B_EDIT = { active:false, jobId:null, codes:[] };

function setB2BEditMode(on, jobId, codes){
  B2B_EDIT.active = !!on;
  B2B_EDIT.jobId  = on ? (jobId || null) : null;
  B2B_EDIT.codes  = on ? (Array.isArray(codes) ? codes : []) : [];

  // Button-Text anpassen
  if (btnB2BCreate){
    btnB2BCreate.textContent = B2B_EDIT.active
      ? 'Projekt aktualisieren (IDs bleiben gleich)'
      : 'Zertifikate erstellen';
  }




  // Sicherheits-Lock: in Edit-Mode Baumanzahl + Forst NICHT ändern (sonst Inkonsistenz)
  try{
    const lock = !!B2B_EDIT.active;
    const qMinus = $('qMinus');
    const qPlus  = $('qPlus');
    const qVal   = $('qVal');
    if(qMinus) qMinus.disabled = lock;
    if(qPlus)  qPlus.disabled  = lock;
    if(qVal){
      qVal.readOnly = lock;
      qVal.style.opacity = lock ? '0.7' : '';
    }
    if (forestOptionsEl){
      forestOptionsEl.querySelectorAll('input[name="forest"]').forEach(inp=>{
        inp.disabled = lock;
      });
    }
  }catch(_){}
}


  function slugifySimple(s){
    s = String(s||'').trim().toLowerCase();
    s = s.replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss');
    s = s.replace(/[^a-z0-9]+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
    return s || 'partner';
  }

  function getPartnerName(){
    if (isB2BPortalFlow() && state && state.b2bPortal){
      const portalName = String(state.b2bPortal.partnerName || '').trim();
      if (portalName) return portalName;
    }
    const direct = (b2bPartnerKey && b2bPartnerKey.value || '').trim();
    if (direct) return direct;
    return '';
  }

  function getPartnerKey(){
  const name = getPartnerName();
  if (name) return name;
  if (isB2BPortalFlow() && state && state.b2bPortal){
    const portalRef = String(state.b2bPortal.customerRef || '').trim();
    if (portalRef) return portalRef;
  }
  return '';
  // oder: return getPartnerName();
}



async function loadRecentB2BJobs(partnerName, opts){
  opts = opts || {};
  if(!b2bJobsBlock || !b2bJobsBody) return;

  const name = String(partnerName || '').trim();
  if(!name){
    b2bJobsBlock.style.display = 'none';
    b2bJobsBody.innerHTML = '';
    return;
  }

  // Keys ausprobieren: 1) customer_ref  2) Partnername
  const keys = [];
  if (isB2BPortalFlow() && state && state.b2bPortal && state.b2bPortal.customerRef){
    keys.push(String(state.b2bPortal.customerRef || '').trim());
  }
  const slug = slugifySimple(name);
  const legacyCustomerRef = 'B2B-' + slug;
  if (legacyCustomerRef && !keys.includes(legacyCustomerRef)) keys.push(legacyCustomerRef);
  if (!keys.includes(name)) keys.push(name);

  b2bJobsBlock.style.display = 'block';
  b2bJobsBody.innerHTML = '<div class="small">Lade letzte Projekte…</div>';

  let foundItems = null;

  for (const key of keys){
    try{
      const url = API_BASE + '/api2/b2b/jobs/list?partner=' + encodeURIComponent(key) + '&limit=50';
      const res = await fetch(url, { headers:{ 'Accept':'application/json' }});
      const js  = await res.json().catch(()=> ({}));

      const items = (res.ok && js && js.ok === true && Array.isArray(js.items)) ? js.items : [];

      if (items.length){
        foundItems = items;
        break;
      }
    }catch(e){
      console.warn('loadRecentB2BJobs failed for key', key, e);
    }
  }

  if(!foundItems || !foundItems.length){
    b2bJobsBody.innerHTML = '<div class="small">Noch keine Projekte für diesen Partner.</div>';
    return;
  }

  // --- Render wie bisher ---
  let html = '';
  foundItems.forEach(it=>{
    const jobId = String(it.id || '');
    const when  = escapeHtml(it.created_at_human || '');
    const cnt   = escapeHtml(String(it.cert_count || 0));
    const certCountNum = Math.max(0, parseInt(it.cert_count, 10) || 0);

const zip  = it.zip_url || '';
const comb = it.combined_url || '';
const mon  = it.monthly_url || '';
const monPng = it.monthly_png_url || (mon ? monthlyPngFromPdf(mon) : '');



    html += '<details class="b2b-job" data-job-id="'+escapeHtml(jobId)+'" data-monthly-png="'+escapeHtml(monPng)+'" style="margin:8px 0; padding:8px 10px; border:1px solid rgba(0,0,0,.10); border-radius:12px; background:#fff;">';
    html +=   '<summary style="cursor:pointer; font-weight:800;">' + when + ' · ' + cnt + ' Zertifikat(e)</summary>';

    html +=   '<div style="margin-top:8px;">';
if(zip && certCountNum > 0)  html += '📦 <a href="'+escapeHtml(zip)+'" target="_blank" rel="noopener">ZIP</a> · ';
if(comb && certCountNum > 0) html += '📄 <a href="'+escapeHtml(comb)+'" target="_blank" rel="noopener">Combined PDF</a> · ';
if(mon)  html += '🗓️ <a href="'+escapeHtml(mon)+'" target="_blank" rel="noopener">Monats-PDF</a>';
if(monPng) html += ' · 🖼️ <a href="'+escapeHtml(monPng)+'" target="_blank" rel="noopener">Monats-PNG</a>';
html +=   '</div>';

if(monPng){
  html += '<div data-job-preview-wrap="1" style="margin-top:10px; display:none;">' +
          '<div class="small">Monatsvorschau wird beim Aufklappen geladen…</div>' +
          '</div>';
}

html += '<div style="margin-top:10px; display:flex; flex-wrap:wrap; gap:8px;">' +
  '🛠️ <button type="button" class="tool" data-b2b-edit="'+escapeHtml(jobId)+'">' +
    'Projekt bearbeiten (IDs behalten)' +
  '</button>' +
  '✨ <button type="button" class="tool" data-b2b-clone="'+escapeHtml(jobId)+'">' +
    'Projekt als Vorlage verwenden' +
  '</button>' +
  '</div>';



    html +=   '<div class="small" data-job-body="1" style="margin-top:8px;">Einzel-PDFs werden beim Aufklappen geladen…</div>';
    html += '</details>';
  });


  b2bJobsBody.innerHTML = html;

  b2bJobsBody.querySelectorAll('[data-b2b-edit]').forEach(btn=>{
  btn.addEventListener('click', async (e)=>{
    e.preventDefault();
    const jobId = btn.getAttribute('data-b2b-edit') || '';
    if(!jobId) return;

    try{
      // Job-Details holen -> wir brauchen die Codes
      const url = API_BASE + '/api2/b2b/jobs/get?job_id=' + encodeURIComponent(jobId);
      const r   = await fetch(url, { headers:{ 'Accept':'application/json' }});
      const j   = await r.json().catch(()=> ({}));
      if(!r.ok || !j || j.ok !== true){
        alert('Konnte Projekt-Details nicht laden.');
        return;
      }

      const entries = Array.isArray(j.stamped_entries) ? j.stamped_entries : [];
      const codes = entries.map(it => String(it.code || '').trim()).filter(Boolean);

      if(!codes.length){
        alert('Dieses Projekt enthält keine Codes – Update nicht möglich.');
        return;
      }

      // Template laden (damit du exakt den Stand wieder hast)
      await loadProfileIntoUI();

      applyB2BJobAsTemplateFromEntries(entries); // ✅ Job-Stand (inkl. Sprachen) in UI übernehmen


      // Edit-Mode aktivieren
      setB2BEditMode(true, jobId, codes);

      // Komfort: direkt zur Deko springen (Nikolausmütze)
      setStep(6);

      showTplResult('<div><strong>Projekt-Edit aktiv ✅</strong><br>IDs bleiben identisch. Bitte nur Deko/Farbe ändern und dann „Projekt aktualisieren“.</div>');
    }catch(err){
      console.warn('start edit failed', err);
      alert('Projekt konnte nicht in den Edit-Modus versetzt werden.');
    }
  });
});

// ===========================
// NEU: Projekt als Vorlage verwenden (alles frei editierbar)
// ===========================

function _b2bRowFromRecipientText(txt){
  const raw = String(txt || '').replace(/\r/g,'');
  const lines = raw.split('\n');
  return { line1: lines[0] || '', line2: lines[1] || '' };
}

function applyB2BJobAsTemplateFromEntries(entries, opts){
  return applyB2BEntriesAsTemplate(entries, opts);
}

async function startB2BCloneFromJob(jobId){
  jobId = String(jobId || '').trim();
  if(!jobId) return;

  // WICHTIG: Template-Modus = Edit-Mode AUS (keine Locks, neue IDs)
  clearB2BOutputs();
  setB2BEditMode(false);

  showLoadingOverlay(); setSubmitting(true);
  try{
    // 1) Optional: aktuelle Partner-Vorlage laden (holt z.B. Logos/Fotos rein)
    // Falls das fehlschlägt, arbeiten wir trotzdem weiter.
    try{
      await loadProfileIntoUI();
    }catch(_){}

    // 2) Job-Details holen und daraus den Wizard füllen
    const url = API_BASE + '/api2/b2b/jobs/get?job_id=' + encodeURIComponent(jobId);
    const r   = await fetch(url, { headers:{ 'Accept':'application/json' }});
    const j   = await r.json().catch(()=> ({}));

    if(!r.ok || !j || j.ok !== true){
      alert('Konnte Projekt-Details nicht laden.');
      return;
    }

    // Wenn Backend irgendwann eine echte wizard_state mitliefert: direkt verwenden
    const maybeState =
      j.wizard_state || j.template_data || j.template || j.data || null;

    if (maybeState){
      let d = maybeState;
      if (typeof d === 'string'){
        try{ d = JSON.parse(d); }catch(_){}
      }
      if (d && typeof d === 'object'){
        applyWizardState(d);
      }
    }

    // Zusätzlich/alternativ: aus stamped_entries rekonstruieren (funktioniert sofort)
    const entries = Array.isArray(j.stamped_entries) ? j.stamped_entries : [];
    if (entries.length){
      applyB2BJobAsTemplateFromEntries(entries);
    }

    // Sicher: Edit-Mode bleibt AUS
    setB2BEditMode(false);

    // Nutzer landet wieder im Start (alles ist anpassbar)
    setStep(0);

    showTplResult(
      '<div><strong>Vorlagenmodus aktiv ✨</strong><br>' +
      'Projekt geladen – du kannst <strong>alles</strong> ändern (auch Forst/Baumanzahl).<br>' +
      'Beim Erstellen werden <strong>neue IDs</strong> vergeben.</div>'
    );

  }catch(err){
    console.warn('startB2BCloneFromJob failed', err);
    alert('Projekt konnte nicht als Vorlage geladen werden.');
  }finally{
    hideLoadingOverlay(); setSubmitting(false);
  }
}

// Buttons binden
b2bJobsBody.querySelectorAll('[data-b2b-clone]').forEach(btn=>{
  btn.addEventListener('click', async (e)=>{
    e.preventDefault();
    const jobId = btn.getAttribute('data-b2b-clone') || '';
    await startB2BCloneFromJob(jobId);
  });
});


  // Lazy-load Einzel-PDFs bleibt wie du es schon hast:
  b2bJobsBody.querySelectorAll('details.b2b-job').forEach(det=>{
    det.addEventListener('toggle', async ()=>{
      if(!det.open) return;
      const previewWrap = det.querySelector('[data-job-preview-wrap="1"]');
      const previewUrl = det.getAttribute('data-monthly-png') || '';
      if (previewWrap && previewUrl && previewWrap.dataset.loaded !== '1'){
        previewWrap.style.display = '';
        previewWrap.innerHTML =
          '<img src="'+escapeHtml(previewUrl)+'" alt="Monatszertifikat Vorschau" loading="lazy" decoding="async" fetchpriority="low" ' +
          'style="width:100%;max-width:520px;border-radius:12px;border:1px solid rgba(0,0,0,.12);box-shadow:0 10px 24px rgba(0,0,0,.18)">';
        previewWrap.dataset.loaded = '1';
      }
      if(det.dataset.loaded === '1') return;

      const jobId = det.getAttribute('data-job-id') || '';
      const body  = det.querySelector('[data-job-body="1"]');
      if(!jobId || !body) return;

      body.innerHTML = '<div class="small">Lade Einzel-PDFs…</div>';

      try{
        const url2 = API_BASE + '/api2/b2b/jobs/get?job_id=' + encodeURIComponent(jobId);
        const r2   = await fetch(url2, { headers:{ 'Accept':'application/json' }});
        const j2   = await r2.json().catch(()=> ({}));

        if(!r2.ok || !j2 || j2.ok !== true){
          body.innerHTML = '<div class="small">Konnte Details nicht laden.</div>';
          return;
        }

        const entries = Array.isArray(j2.stamped_entries) ? j2.stamped_entries : [];
        if(!entries.length){
          body.innerHTML = '<div class="small">Keine Einzel-PDFs gespeichert.</div>';
          det.dataset.loaded = '1';
          return;
        }

        let ul = '<ul style="margin:6px 0 0; padding-left:18px;">';
        entries.slice(0, 300).forEach(e=>{
          const rcp  = escapeHtml(e.recipient || 'Zertifikat');
          const code = escapeHtml(e.code || '');
          const link = (e.download_url || e.pdf_url || '');
          if(!link) return;
          ul += '<li><strong>'+rcp+'</strong> · ID '+code+' · <a href="'+escapeHtml(link)+'" target="_blank" rel="noopener">PDF</a></li>';
        });
        ul += '</ul>';

        body.innerHTML = ul;
        det.dataset.loaded = '1';
      }catch(e){
        console.warn('job details load failed', e);
        body.innerHTML = '<div class="small">Fehler beim Laden.</div>';
      }
    });
  });

  // >>> NEU: optional neuestes Projekt automatisch öffnen (inkl. Lazyload Einzel-PDFs)
  if (opts.autoOpenLatest){
    try{
      const first = b2bJobsBody.querySelector('details.b2b-job');
      if (first){
        first.open = true;
        first.dispatchEvent(new Event('toggle')); // triggert Lazyload
      }
    }catch(e){
      console.warn('autoOpenLatest failed', e);
    }
  }

  // >>> OPTIONAL: neuestes Projekt direkt in den Edit-Modus (IDs behalten)
  if (opts.autoEditLatest){
    try{
      const btn = b2bJobsBody.querySelector('button[data-b2b-edit]');
      if (btn) btn.click();
    }catch(e){
      console.warn('autoEditLatest failed', e);
    }
  }


}


  function getB2BInputs(){
    const isPortalFlow = !!(isB2BPortalFlow() && state && state.b2bPortal);
    const portalPartnerNameResolved = (
      isPortalFlow
    ) ? String(state.b2bPortal.partnerName || '').trim() : '';
    let partner = portalPartnerNameResolved || getPartnerName();
    const slug = slugifySimple(partner);
    const portalCustomerRefResolved = (
      isPortalFlow &&
      state.b2bPortal.customerRef
    ) ? String(state.b2bPortal.customerRef || '').trim() : '';
    const portalLandingSlugResolved = (
      isPortalFlow &&
      state.b2bPortal.landingSlug
    ) ? String(state.b2bPortal.landingSlug || '').trim() : '';
    const portalPartnerUrlResolved = (
      isPortalFlow &&
      state.b2bPortal.partnerUrl
    ) ? String(state.b2bPortal.partnerUrl || '').trim() : '';
    const customerRef = portalCustomerRefResolved || ('B2B-' + slug);
    const landingSlug = isPortalFlow ? portalLandingSlugResolved : slug;
return {
  partner: partner,
  customer_ref: customerRef,
  email_to: '',
  partner_name: partner,
  landing_slug: landingSlug,
  partner_city: 'Hanau',
  partner_url: isPortalFlow ? portalPartnerUrlResolved : ((state.monthlyQrUrl || '').trim())
};
  }

  function normalizePortalB2BProfile(profile){
    const out = (profile && typeof profile === 'object') ? Object.assign({}, profile) : {};
    if (!(isB2BPortalFlow() && state && state.b2bPortal)) return out;
    const portalName = String(state.b2bPortal.partnerName || '').trim();
    const portalRef = String(state.b2bPortal.customerRef || '').trim();
    const portalSlug = String(state.b2bPortal.landingSlug || '').trim();
    const portalUrl = String(state.b2bPortal.partnerUrl || '').trim();
    if (portalName){
      out.partner = portalName;
      out.partner_name = portalName;
    }
    if (portalRef) out.customer_ref = portalRef;
    if (portalSlug) out.landing_slug = portalSlug;
    if (portalUrl) out.partner_url = portalUrl;
    return out;
  }

  function rememberPartnerKey(name){
    try{ if(name) localStorage.setItem('ptw:b2b:partner', name); }catch(_){}
  }
  function recallPartnerKey(){
    try{ return localStorage.getItem('ptw:b2b:partner') || ''; }catch(_){ return ''; }
  }
  async function b2bProfileGet(customerRef){
    const url = API_BASE + '/api2/b2b/profile/get?customer_ref=' + encodeURIComponent(customerRef);
    const res = await fetch(url, { headers:{ 'Accept':'application/json' }});
    if(!res.ok) throw new Error('HTTP '+res.status);
    const js = await res.json();
    if(!js || js.ok !== true || !js.profile) throw new Error('profile_not_found');
    return js.profile;
  }

  async function b2bProfileSave(profile){
    const url = API_BASE + '/api2/b2b/profile/save';
    const res = await fetch(url, {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify(profile)
    });
    if(!res.ok) throw new Error('HTTP '+res.status);
    const js = await res.json();
    if(!js || js.ok !== true) throw new Error('save_failed');
    return true;
  }

  async function loadB2BTemplateForAliases(aliases){
    const list = [];
    (Array.isArray(aliases) ? aliases : [aliases]).forEach((value)=>{
      const s = String(value || '').trim();
      if (s && !list.includes(s)) list.push(s);
    });
    let firstHit = null;
    let bestHit = null;
    let bestScore = -1;
    for (const alias of list){
      try{
        const url = API_BASE + '/api2/b2b/template/load?partner=' + encodeURIComponent(alias);
        const res = await fetch(url, { headers:{ 'Accept':'application/json' } });
        const js = await res.json().catch(()=> ({}));
        if (res.ok && js && js.ok === true && js.data){
          const data = js.data || {};
          const photos = (data && typeof data === 'object' && data.photos && typeof data.photos === 'object') ? data.photos : {};
          const senderPhoto = (photos && photos.sender && typeof photos.sender === 'object') ? photos.sender : {};
          const senderText = String(data.sender || '').trim();
          const senderDataUrl = String(
            senderPhoto.data_url ||
            senderPhoto.dataUrl ||
            senderPhoto.url ||
            senderPhoto.src ||
            senderPhoto.preview_url ||
            ''
          ).trim();
          let score = 0;
          if (senderText) score += 10;
          if (senderDataUrl) score += 100;
          if (data.photo1_combine) score += 5;
          if (!firstHit) firstHit = js;
          if (score > bestScore){
            bestScore = score;
            bestHit = js;
          }
        }
      }catch(_){}
    }
    return bestHit || firstHit || null;
  }

  async function loadProfileIntoUI(){
    hideTplResult();

    // >>> NEU: beim Laden eines anderen Partners immer sauber aufräumen
    clearB2BOutputs();
    setB2BEditMode(false);   // falls vorher "IDs behalten" aktiv war

    const partner = getPartnerName();
    if(!partner){
      alert('Bitte einen Partner eintragen.');
      return;
    }

    showLoadingOverlay(); setSubmitting(true);
    try{
      const aliases = [];
      const baseProfile = getB2BInputs();
      [partner, baseProfile.customer_ref, baseProfile.landing_slug].forEach((v)=>{
        const s = String(v || '').trim();
        if (s && !aliases.includes(s)) aliases.push(s);
      });

      const js = await loadB2BTemplateForAliases(aliases);
      if(!js || !js.data) throw new Error('not_found');

      applyWizardState(js.data);

      // >>> FIX: in Step 0 bleiben
      setStep(0);

      await loadRecentB2BJobs(partner);

      rememberPartnerKey(partner);
      showTplResult('<div>Vorlage geladen ✅</div>');
    }catch(e){
      console.warn('b2b template load failed', e);
      alert('Vorlage konnte nicht geladen werden. Bitte Partner prüfen oder zuerst speichern.');
    }finally{
      hideLoadingOverlay(); setSubmitting(false);
    }
  }


  async function saveProfileFromUI(){
    hideTplResult();
    const partner = getPartnerName();
    if(!partner){
      alert('Bitte einen Partner eintragen.');
      return;
    }
    if (state.seriesEnabled && hasSeriesRows()){
      saveSeriesSnapshotFromUI();
    }
    showLoadingOverlay(); setSubmitting(true);
    try{
      const baseData = buildWizardDraftPayload();
      try{
        const photos = await (async ()=>{
          const result = {};
          async function addPhoto(key, st, imgEl){
            if(!st) return;
            let dataUrl = null;
            if(st.file){ try{ dataUrl = await fileToDataURL(st.file); }catch(err){} }
            if(!dataUrl && imgEl && imgEl.src && imgEl.src.indexOf('data:') === 0){ dataUrl = imgEl.src; }
            if(!dataUrl && st.dataUrl){ dataUrl = st.dataUrl; }
            if(!dataUrl) return;
            result[key] = { data_url:dataUrl, mode:st.mode||'contain', scale:st.scale||1, offX:st.offX||0, offY:st.offY||0, rotation:st.rotation||0 };
          }
          await Promise.all([
            addPhoto('sender',       state.photo1State,      img1),
            addPhoto('monthly_sender', state.personalizedMonthlyPhoto1State, personalizedMonthlyImg1),
            addPhoto('recipient',    state.photo4State,      img4),
            addPhoto('message',      state.photo6State,      img6),
            addPhoto('greet_top',    state.greetPhoto1State, gcImg1),
            addPhoto('greet_middle', state.greetPhoto2State, gcImg2),
            addPhoto('greet_bottom', state.greetPhoto3State, gcImg3),
          ]);
          return result;
        })();
        baseData.photos = photos;
      }catch(e){ console.warn('template save: photo payload failed', e); }

      const url = API_BASE + '/api2/b2b/template/save';
      const res = await fetch(url, { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ partner: partner, data: baseData }) });
      const js = await res.json().catch(()=> ({}));
      if(!res.ok || !js || js.ok !== true) throw new Error('save_failed');

      rememberPartnerKey(partner);
      await loadRecentB2BJobs(partner);
      showTplResult('<div>Vorlage gespeichert ✅</div>');
    }catch(e){
      console.warn('b2b template save failed', e);
      alert('Vorlage konnte nicht gespeichert werden (Server-Fehler).');
    }finally{
      hideLoadingOverlay(); setSubmitting(false);
    }
  }

  async function saveTemplateSnapshotSilently(partner){
  const p = String(partner || '').trim();
  if(!p) return false;

  try{
    // Serien-Slot sichern
    if (state.seriesEnabled && typeof hasSeriesRows === 'function' && hasSeriesRows()){
      if (typeof saveSeriesSnapshotFromUI === 'function') saveSeriesSnapshotFromUI();
    }

    // Payload wie beim normalen Speichern
    const baseData = buildWizardDraftPayload();

    // Fotos wie in saveProfileFromUI (kompakt kopiert)
    try{
      const photos = await (async ()=>{
        const result = {};
        async function addPhoto(key, st, imgEl){
          if(!st) return;
          let dataUrl = null;
          if(st.file){ try{ dataUrl = await fileToDataURL(st.file); }catch(_){} }
          if(!dataUrl && imgEl && imgEl.src && String(imgEl.src).startsWith('data:')) dataUrl = imgEl.src;
          if(!dataUrl && st.dataUrl) dataUrl = st.dataUrl;
          if(!dataUrl) return;
          result[key] = {
            data_url:dataUrl, mode:st.mode||'contain',
            scale:st.scale||1, offX:st.offX||0, offY:st.offY||0,
            rotation:st.rotation||0
          };
        }
        await Promise.all([
          addPhoto('sender',       state.photo1State, img1),
          addPhoto('monthly_sender', state.personalizedMonthlyPhoto1State, personalizedMonthlyImg1),
          addPhoto('recipient',    state.photo4State, img4),
          addPhoto('message',      state.photo6State, img6),
          addPhoto('greet_top',    state.greetPhoto1State, gcImg1),
          addPhoto('greet_middle', state.greetPhoto2State, gcImg2),
          addPhoto('greet_bottom', state.greetPhoto3State, gcImg3),
        ]);
        return result;
      })();
      baseData.photos = photos;
    }catch(_){}

    const res = await fetch(API_BASE + '/api2/b2b/template/save', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      keepalive: true,
      body: JSON.stringify({ partner: p, data: baseData })
    });

    return !!res.ok;
  }catch(e){
    console.warn('saveTemplateSnapshotSilently failed', e);
    return false;
  }
}

async function saveTemplateSnapshotSilentlyForAliases(partners){
  const rawList = Array.isArray(partners) ? partners : [partners];
  const list = [];
  rawList.forEach((value)=>{
    const v = String(value || '').trim();
    if (v && !list.includes(v)) list.push(v);
  });
  if (!list.length) return false;

  let ok = false;
  for (const partner of list){
    try{
      const saved = await saveTemplateSnapshotSilently(partner);
      if (saved) ok = true;
    }catch(_){}
  }
  return ok;
}


  async function buildPhotoPayloadForWizard(){
    const result = {};
    async function addPhoto(key, st, imgEl){
      if(!st) return;
      let dataUrl = null;
      if(st.file){
        try{ dataUrl = await fileToDataURL(st.file); }catch(_){}
      }
      if(!dataUrl && imgEl && imgEl.src && imgEl.src.indexOf('data:') === 0){
        dataUrl = imgEl.src;
      }
      if(!dataUrl && st.dataUrl){
        dataUrl = st.dataUrl;
      }
      if(!dataUrl) return;
      result[key] = {
        data_url: dataUrl,
        mode: st.mode || 'contain',
        scale: st.scale || 1,
        offX:  st.offX  || 0,
        offY:  st.offY  || 0,
        rotation: st.rotation || 0
      };
    }
    await Promise.all([
      addPhoto('sender',    state.photo1State, img1),
      addPhoto('recipient', state.photo4State, img4),
      addPhoto('message',   state.photo6State, img6)
    ]);
    return result;
  }

  function buildRenderPayloadForCert(bundleId, verb, trees, sender, recipient, message, forestCode, delivery, paperType, frameColor, decoBalloon, decoHat, photos, canvasDataUrl, lang){
    return {
      bundle_id: bundleId,
      mode: 'cert',
      lang: normalizeLang(lang || 'de'),
      verb, trees, sender, recipient, message,
      deco_balloon: !!decoBalloon,
      deco_hat: !!decoHat,
      frame_color: frameColor || FRAME_COLOR_DEFAULT,
      forest_code: forestCode || null,
      delivery: delivery || 'digital',
      paper_type: paperType || 'white',
      gift_title: '',
      gift_img: '',
      gift_base_price: null,
      cert_base_price: null,
      gift_variant_id: null,
      cert_variant_id: state.certVariantId || null,
      giftwrap: false,
      gimmick_code: null,
      snapshot: buildLayoutSnapshot(),
      photos: photos || {},
      canvas_png: canvasDataUrl || null,
      label_png: null,
      label_border_color: state.labelBorderColor || state.frameColor || FRAME_COLOR_DEFAULT,
      label_line1: '',
      label_line2: '',
      label_line3: '',
      label_claim: buildClaim(),
      greet_card: false,
      greet_card_png: null,
      greet_card_text1:'',
      greet_card_text2:'',
      greet_card_text3:''
    };
  }

  async function renderPreviewForCert(bundleId, verb, trees, sender, recipient, message, forestCode, delivery, paperType, frameColor, decoBalloon, decoHat, photos, canvasDataUrl, lang){
    const payload = buildRenderPayloadForCert(
      bundleId,
      verb,
      trees,
      sender,
      recipient,
      message,
      forestCode,
      delivery,
      paperType,
      frameColor,
      decoBalloon,
      decoHat,
      photos,
      canvasDataUrl,
      lang
    );

    const resp = await fetch(API_BASE + '/api2/cert/render_preview', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify(payload)
    });
    const js = await resp.json().catch(()=> ({}));
    if(!resp.ok || !js){
      throw new Error('render_preview_failed');
    }
    return {
      preview_url: js.preview_url || '',
      pdf_url: js.pdf_url || ''
    };
  }

  async function createB2BJob(){
    if (window.__PT_B2B_WIZARD_CREATE_IN_FLIGHT__) return false;
    window.__PT_B2B_WIZARD_CREATE_IN_FLIGHT__ = true;

    const createButtonWasDisabled = btnB2BCreate ? !!btnB2BCreate.disabled : false;
    const createButtonTitleBefore = btnB2BCreate ? btnB2BCreate.title : '';
    const createButtonHadBusyClass = !!(btnB2BCreate && btnB2BCreate.classList.contains('is-busy'));
    const createButtonAriaBusyBefore = btnB2BCreate ? btnB2BCreate.getAttribute('aria-busy') : null;
    if (btnB2BCreate){
      btnB2BCreate.disabled = true;
      btnB2BCreate.classList.add('is-busy');
      btnB2BCreate.setAttribute('aria-busy', 'true');
      btnB2BCreate.title = 'Die Zertifikate werden bereits erstellt.';
    }

    try{
      return await createB2BJobUnlocked();
    }finally{
      window.__PT_B2B_WIZARD_CREATE_IN_FLIGHT__ = false;
      if (btnB2BCreate){
        btnB2BCreate.classList.toggle('is-busy', createButtonHadBusyClass);
        if (createButtonAriaBusyBefore == null) btnB2BCreate.removeAttribute('aria-busy');
        else btnB2BCreate.setAttribute('aria-busy', createButtonAriaBusyBefore);
      }
      try{
        syncB2BFinalCreateAvailability();
      }catch(_){
        if (btnB2BCreate){
          btnB2BCreate.disabled = createButtonWasDisabled;
          btnB2BCreate.title = createButtonTitleBefore;
        }
      }
    }
  }

  async function createB2BJobUnlocked(){
    hideB2BResult();

      const isEdit = !!(B2B_EDIT && B2B_EDIT.active);
      const loadingTextBeforeCreate = loadingTextEl ? loadingTextEl.textContent : '';
      
  let profile = normalizePortalB2BProfile(getB2BInputs());
  if((!profile.partner_name || !String(profile.partner_name).trim()) && isB2BPortalFlow() && state && state.b2bPortal && state.b2bPortal.customerRef){
    try{
      const liveProfile = await b2bProfileGet(String(state.b2bPortal.customerRef || '').trim());
      const livePartner = String(liveProfile.partner_name || liveProfile.partner || '').trim();
      if (livePartner){
        if (b2bPartnerKey) b2bPartnerKey.value = livePartner;
        if (state && state.b2bPortal) state.b2bPortal.partnerName = livePartner;
        profile = getB2BInputs();
      }
    }catch(_){}
  }
    if(!profile.partner_name){
      alert('Bitte einen Partner eintragen (Step 0).');
      setStep(0);
      return;
    }
    const recentJobsPartner = profile.partner_name || profile.partner || getPartnerName();
    let createdOk = false;
    showLoadingOverlay(); setSubmitting(true);

    try{
      try{
        if (b2bJobsBody){
          b2bJobsBody.querySelectorAll('img').forEach(function(img){
            try{ img.removeAttribute('src'); }catch(_){}
            try{ img.remove(); }catch(_){}
          });
        }
        if (b2bJobsBlock){
          b2bJobsBlock.style.display = 'none';
        }
      }catch(_){}

      // Profil sicher speichern (b2b_series liest das Profil serverseitig)
      await b2bProfileSave(profile);
      rememberPartnerKey(profile.partner_name || profile.partner || '');

      if(state.mode !== 'cert'){
        alert('B2B läuft nur im Zertifikat-Modus.');
        return;
      }

      // Fotos einmalig (für render_preview)
      const photos = await buildPhotoPayloadForWizard();

      try{
        await ensureDecorImagesLoaded();
      }catch(e){
        console.warn('ensureDecorImagesLoaded before create failed', e);
      }
      await waitForFonts();

      // Monatszertifikat PNG (Canvas) – OHNE Stempel
      let monthlyCanvas = null;
      try{
        const snap = await captureMonthlyCertificatePng({ skipWarmup:true });
        if(snap && snap.dataUrl) monthlyCanvas = snap.dataUrl;
      }catch(e){
        console.warn('monthly capture failed', e);
      }

      const entries = [];
      const baseTime = Date.now();

      const inSeries = (state.seriesEnabled && hasSeriesRows());
      const count = inSeries ? state.seriesRows.length : 1;
      // Große Serien dürfen nicht als ein einziger Request mit sämtlichen
      // A4-Canvasbildern übertragen werden. Ab 20 Zertifikaten erzeugen wir
      // deshalb die unveränderten Basis-PDFs einzeln und übermitteln an den
      // Serien-Endpunkt anschließend nur noch URLs und kompakte Metadaten.
      const useStagedSeriesUpload = !isEdit && count >= 20;

            // Edit-Mode: Anzahl Zertifikate muss exakt zu den vorhandenen Codes passen
      if (isEdit){
        const codes = (B2B_EDIT && Array.isArray(B2B_EDIT.codes)) ? B2B_EDIT.codes : [];
        if (codes.length !== count){
          alert('Edit-Mode: Anzahl Zertifikate passt nicht zum Projekt (Codes=' + codes.length + ', aktuell=' + count + '). Bitte Serienanzahl nicht ändern.');
          return;
        }
      }


      const baseSender  = (txt1 && txt1.value || '').trim();
      const baseMessage = (txt6 && txt6.value || '').trim();
      const senderHasVisual =
        !!(state.photo1State && (
          state.photo1State.file ||
          (state.photo1State.dataUrl && String(state.photo1State.dataUrl).startsWith('data:image')) ||
          ((state.photo1State.w || 0) > 0 && (state.photo1State.h || 0) > 0)
        )) ||
        !!(img1 && img1.src && String(img1.src).startsWith('data:image')) ||
        !!(document.getElementById('ph1') && document.getElementById('ph1').style.display !== 'none');


      for(let i=0; i<count; i++){
        const bundleId = 'B2B-' + baseTime + '-' + (i+1);

        const senderForThis = (inSeries && Array.isArray(state.seriesSender) ? (state.seriesSender[i] || baseSender) : baseSender);
        const messageForThis= (inSeries && Array.isArray(state.seriesOccasion) ? (state.seriesOccasion[i] || baseMessage) : baseMessage);
        const verbForThis   = (inSeries && Array.isArray(state.seriesVerb) ? getSeriesVerb(i) : (state.verb || 'HAT'));

        const row = inSeries ? (state.seriesRows[i] || {}) : null;
        const blankRecipientForThis = inSeries && isSeriesBlankRecipientRow(row);
        const recipientForThis = inSeries
          ? seriesRecipientTextFromRow(row).trim()
          : (
              isB2BEventPortalFlow()
                ? ((txt4 && txt4.value || txt6 && txt6.value || '').trim())
                : (txt4 && txt4.value || '').trim()
            );

        const treesForThis  = inSeries ? getTreesForIndex(i) : (state.trees || 1);
        const forestForThis = inSeries ? (getForestForIndex(i) || state.forest) : state.forest;
        const frameForThis  = inSeries ? (getFrameColorForIndex(i) || state.frameColor) : state.frameColor;
        const decoBalloonThis = inSeries ? getDecoBalloonForIndex(i) : !!state.decoBalloon;
        const decoHatThis     = inSeries ? getDecoHatForIndex(i) : !!state.decoHat;
        const deliveryThis    = inSeries ? getDeliveryForIndex(i) : (state.delivery || 'digital');
        const paperThis       = inSeries ? getPaperTypeForIndex(i) : (state.paperType || 'white');

        const langForThis = inSeries
          ? normalizeLang((Array.isArray(state.seriesLang) ? state.seriesLang[i] : null) || state.lang)
          : normalizeLang(state.lang);

          // ✅ WICHTIG: pro Zertifikat die Sprache wirklich aktiv setzen (für Preview/Capture)
 if (inSeries){
   state.seriesIndex = i;   // getActiveLang() liest hieraus
 }
 state.lang = langForThis;  // Fallback / Single-Mode
 try{ updateLangToggleUI(); }catch(_){}

        // Absender darf leer sein, wenn Box 1 ein Foto/Logo hat
if(!senderForThis && !senderHasVisual){
  alert('Bitte trage einen Absender ein.');
  setStep(1);
  return;
}
        if(!recipientForThis && !blankRecipientForThis){ alert('Bitte trage mindestens eine/n Beschenkte/n ein.'); setStep(3); return; }
        if(!forestForThis){ alert('Bitte wähle einen Pflanzort (Forst).'); setStep(7); return; }

        // DOM auf Slot setzen (für capture)
        if (txt1){
          txt1.value = senderForThis;
          if(typeof fit1==='function') fit1();
        }
        if (txt4){
          txt4.value = recipientForThis;
          if(typeof fit4==='function') fit4();
        }
        if (txt6){
          txt6.value = messageForThis;
          if(typeof fit6==='function') fit6();
        }

        state.verb       = verbForThis;
        state.trees      = treesForThis;
        state.forest     = forestForThis;
        state.frameColor = (frameForThis || FRAME_COLOR_DEFAULT);
        state.delivery   = deliveryThis || 'digital';
        state.paperType  = paperThis || 'white';
        state.decoBalloon = !!decoBalloonThis;
        state.decoHat     = !!decoHatThis;

        if(qVal) qVal.value = String(state.trees || 1);

        applyDecor();
        applyForestToPreview();
        applyFrameColor();
        updateClaim();
        updatePreview();
        placeA4Boxes();

        const snap = await captureCertificatePng({ skipWarmup:true });
        if(!snap || !snap.dataUrl){
          throw new Error('capture_failed');
        }

        const codeForThis = isEdit ? (String((B2B_EDIT.codes && B2B_EDIT.codes[i]) || '').trim()) : null;
        const renderPayload = buildRenderPayloadForCert(
          bundleId,
          verbForThis,
          treesForThis,
          senderForThis,
          recipientForThis,
          messageForThis,
          forestForThis,
          deliveryThis,
          paperThis,
          frameForThis || FRAME_COLOR_DEFAULT,
          decoBalloonThis,
          decoHatThis,
          photos,
          snap.dataUrl,
          langForThis
        );
        let previewUrl = '';
        let pdfUrl = '';

        if (isEdit || useStagedSeriesUpload){
          if (useStagedSeriesUpload && loadingTextEl){
            loadingTextEl.textContent = 'Zertifikat ' + (i + 1) + ' von ' + count + ' wird sicher vorbereitet.';
          }
          let rp = null;
          let previewError = null;
          for (let attempt = 0; attempt < 2; attempt += 1){
            try{
              rp = await renderPreviewForCert(
                bundleId,
                verbForThis,
                treesForThis,
                senderForThis,
                recipientForThis,
                messageForThis,
                forestForThis,
                deliveryThis,
                paperThis,
                frameForThis || FRAME_COLOR_DEFAULT,
                decoBalloonThis,
                decoHatThis,
                photos,
                snap.dataUrl,
                langForThis
              );
              if (rp && rp.pdf_url) break;
              throw new Error('render_preview_missing_pdf');
            }catch(error){
              previewError = error;
              rp = null;
              if (attempt === 0){
                await new Promise(resolve => setTimeout(resolve, 450));
              }
            }
          }
          if (!rp || !rp.pdf_url){
            throw new Error(
              'Zertifikat ' + (i + 1) + ' von ' + count + ' konnte nicht vorbereitet werden: ' +
              String(previewError && previewError.message || 'Unbekannter Fehler')
            );
          }
          previewUrl = rp.preview_url || '';
          pdfUrl = rp.pdf_url || '';
        }

        const finalRenderPayload = useStagedSeriesUpload
          ? Object.assign({}, renderPayload, { canvas_png:null, photos:{} })
          : (isEdit ? null : renderPayload);

        entries.push({
          bundle_id: bundleId,
          sender: senderForThis,
          recipient: recipientForThis,
          message: messageForThis,
          verb: verbForThis,
          trees: treesForThis,
          forest_code: forestForThis,
          delivery: deliveryThis,
          paper_type: paperThis,
          frame_color: frameForThis || FRAME_COLOR_DEFAULT,
          lang: langForThis,
          preview_url: previewUrl,
          pdf_url: pdfUrl,
          render_payload: finalRenderPayload,
          code: codeForThis,
          blank_recipient: !!blankRecipientForThis
        });
      }

      const eventTitleFromCert =
        isB2BEventPortalFlow()
          ? String(txt6 && txt6.value || txt4 && txt4.value || '').replace(/\r/g,'').split('\n')[0].trim()
          : '';

      const payload = {
        customer_ref: profile.customer_ref,
        billing_mode: (state.b2bPortal && state.b2bPortal.billingMode) ? state.b2bPortal.billingMode : undefined,
        project_type: isB2BEventPortalFlow() ? 'event' : 'personalized',
        target_month: state.monthlyMonth || null,
        event_title: eventTitleFromCert || (state.monthlyPlaceText || '').replace(/\r/g,'').split('\n')[0].trim(),
        monthly_place_text: state.monthlyPlaceText || '',
        certs: entries.map(e => ({
          bundle_id: e.bundle_id,
          pdf_url: e.pdf_url,
          preview_url: e.preview_url,
          render_payload: e.render_payload || null,
          sender: e.sender,
          recipient: e.recipient,
          message: e.message,
          trees: e.trees,
          forest_code: e.forest_code,
          delivery: e.delivery,
          paper_type: e.paper_type,
          lang: e.lang || 'de',
          code: e.code || null,
          blank_recipient: !!e.blank_recipient
        })),
        photos: photos || {},

        monthly_canvas_png: monthlyCanvas,
        monthly_trees: getMonthlyProjectTreeCount(),
        monthly_month: state.monthlyMonth || null,
        monthly_forests: (typeof getMonthlySelectedForests === 'function') ? getMonthlySelectedForests() : null,
        monthly_forest_trees: getMonthlyProjectForestTrees()
      };

            if (isEdit){
        payload.job_id = B2B_EDIT.jobId || null;
      }

            const endpoint = isEdit
        ? (API_BASE + '/api2/cert/b2b_series_update')
        : (API_BASE + '/api2/cert/b2b_series');

      const resp = await fetch(endpoint, {

        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify(payload)
      });
      const js = await resp.json().catch(()=> ({}));

      if(!resp.ok || !js || js.ok !== true){
        console.error('b2b_series failed', resp.status, js);
        alert('B2B-Erstellung fehlgeschlagen. Bitte Logs prüfen.');
        return;
      }
      if (isEdit){
        setB2BEditMode(false);
      }
      createdOk = true;
// nach erfolgreichem Job: aktuellen Stand als "letzte Vorlage" sichern
try{
  await saveTemplateSnapshotSilentlyForAliases([
    profile.customer_ref,
    state && state.b2bPortal && state.b2bPortal.landingSlug,
    profile.partner_name || profile.partner || getPartnerName()
  ]);
}catch(_){}
if (isB2BPersonalizedPortalFlow()){
  try{
    await savePersistentPersonalizedSenderDraft();
  }catch(_){}
  try{
    await savePersistentPortalSenderDraft();
  }catch(_){}
  try{
    await savePersonalizedLogoSnapshot();
  }catch(_){}
  try{
    await savePersonalizedFreshStartDraft();
  }catch(_){}
} else {
  try{
    await savePortalSenderSnapshot();
  }catch(_){}
  try{
    await savePersistentPortalSenderDraft();
  }catch(_){}
  try{
    await clearDraft();
  }catch(_){}
}

      if(isB2BPortalFlow()){
        showB2BResult('<div class="small">Die Zertifikate wurden erstellt. Du wirst jetzt zurück ins B2B-Portal geleitet.</div>');
        setTimeout(function(){
          redirectBackToPortal({ b2b_created: '1' });
        }, 900);
      }else{
        // UI: Links anzeigen
        const zipUrl      = js.zip_url || '';
        const combinedUrl = js.combined_url || '';
        const monthlyUrl  = js.monthly_url || '';
        const stamped     = Array.isArray(js.stamped_entries) ? js.stamped_entries : [];

        let html = '';
        html += '<div class="small">Admin-Mail wurde ausgelöst. Hier sind die direkten Download-Links:</div>';
        if (zipUrl){
          html += '<div style="margin-top:10px;">📦 <a href="'+escapeHtml(zipUrl)+'" target="_blank" rel="noopener">ZIP (alle Zertifikate)</a></div>';
        }
        if (combinedUrl){
          html += '<div>📄 <a href="'+escapeHtml(combinedUrl)+'" target="_blank" rel="noopener">Combined PDF (alle Zertifikate)</a></div>';
        }
        if (monthlyUrl){
          const monthlyPng = monthlyPngFromPdf(monthlyUrl);
          html += '<div style="margin-top:10px;">🗓️ <a href="'+escapeHtml(monthlyUrl)+'" target="_blank" rel="noopener">Monats-Zertifikat (PDF)</a></div>';
          if (monthlyPng){
            html += '<div>🖼️ <a href="'+escapeHtml(monthlyPng)+'" target="_blank" rel="noopener">Monats-Zertifikat (PNG)</a></div>';
          }
          html += '<div class="small">Hinweis: Monatszertifikat wird nicht gestempelt.</div>';
        }

        if (stamped.length){
          html += '<div style="margin-top:12px;"><strong>Einzel-PDFs</strong></div>';
          html += '<ul style="margin:6px 0 0; padding-left:18px;">';
          stamped.slice(0, 200).forEach(it=>{
            const r = (it && it.recipient) ? it.recipient : 'Zertifikat';
            const u = (it && (it.download_url || it.pdf_url)) ? (it.download_url || it.pdf_url) : '';
            if (!u) return;
            html += '<li><a href="'+escapeHtml(u)+'" target="_blank" rel="noopener">'+escapeHtml(r)+'</a></li>';
          });
          html += '</ul>';
        }

        showB2BResult(html);
      }

      // 🔄 Nach erfolgreichem Job: "Letzte Projekte" neu laden
      try{
        await loadRecentB2BJobs(profile.partner_name || profile.partner || getPartnerName());
      }catch(e){
        console.warn('refresh jobs after create failed', e);
      }

    }catch(e){
      console.error('createB2BJob failed', e);
      alert('B2B-Erstellung fehlgeschlagen: ' + (e && e.message ? e.message : 'Unbekannter Fehler'));
    }finally{
      if (loadingTextEl) loadingTextEl.textContent = loadingTextBeforeCreate;
      if (!createdOk){
        try{
          await loadRecentB2BJobs(recentJobsPartner);
        }catch(_){}
      }
      hideLoadingOverlay(); setSubmitting(false);
    }
  }

async function saveB2BSubscriptionSetup(){
  if (!isB2BSubscriptionPortalFlow()) return false;
  if (window.__PT_B2B_SUBSCRIPTION_SAVE_LOCK){
    console.warn('saveB2BSubscriptionSetup: blocked by lock');
    return false;
  }
  window.__PT_B2B_SUBSCRIPTION_SAVE_LOCK = true;

  const btn = (typeof btnB2BCreateMonthly !== 'undefined') ? btnB2BCreateMonthly : document.getElementById('btnB2BCreateMonthly');
  const prevBtnText = btn ? btn.textContent : '';
  const isEditingSubscription = isEditingB2BSubscription();
  if (btn){
    btn.disabled = true;
    btn.classList.add('is-busy');
    btn.textContent = isEditingSubscription ? 'Baum-Abo wird aktualisiert…' : 'Baum-Abo wird gestartet…';
  }

  try{
    hideB2BResult();
    try{ await flushSummaryTemplateAutosave(); }catch(_){}

    const profile = normalizePortalB2BProfile(getB2BInputs());
    if ((!profile.partner_name || !String(profile.partner_name).trim()) && state && state.b2bPortal){
      const portalName = String(state.b2bPortal.partnerName || '').trim();
      const portalSlug = String(state.b2bPortal.landingSlug || '').trim();
      const portalUrl = String(state.b2bPortal.partnerUrl || '').trim();
      if (portalName){
        profile.partner_name = portalName;
        profile.partner = portalName;
      }
      if (!profile.landing_slug && portalSlug) profile.landing_slug = portalSlug;
      if (!profile.partner_url && portalUrl) profile.partner_url = portalUrl;
    }
    if (!profile.partner_name){
      alert('Bitte einen Partner eintragen.');
      setStep(10);
      return false;
    }

    state.subscriptionActive = !!state.subscriptionActive;
    state.subscriptionFrequency = normalizeSubscriptionFrequency(state.subscriptionFrequency);
    state.subscriptionCountMode = normalizeSubscriptionCountMode(state.subscriptionCountMode);
    state.subscriptionFixedTrees = Math.max(1, parseInt(state.subscriptionFixedTrees, 10) || 1);
    state.subscriptionForestCode = normalizeSubscriptionForestCode(state.subscriptionForestCode);
    syncSubscriptionMonthlyState();

    showLoadingOverlay();
    setSubmitting(true);

    await b2bProfileSave(profile);
    rememberPartnerKey(profile.partner_name || profile.partner || '');

    try{ await ensureMonthlyCoords(); }catch(_){}

    const snap = await captureMonthlyCertificatePng();
    const monthlyCanvas = snap && snap.dataUrl ? snap.dataUrl : '';
    if (!monthlyCanvas){
      alert('Die Abo-Vorlage konnte nicht erzeugt werden.');
      return false;
    }

    let senderPhotos = {};
    try{
      senderPhotos = await buildPhotoPayloadForWizard();
    }catch(_){}

    const wizardState = buildWizardDraftPayload();
    wizardState.photos = senderPhotos || {};

    const payload = {
      customer_ref: profile.customer_ref,
      subscription_id: String((state && state.b2bPortal && state.b2bPortal.subscriptionId) || portalSubscriptionId || '').trim(),
      active: !!state.subscriptionActive,
      frequency: state.subscriptionFrequency,
      count_mode: state.subscriptionCountMode,
      fixed_trees: Math.max(1, parseInt(state.subscriptionFixedTrees, 10) || 1),
      forest_code: normalizeSubscriptionForestCode(state.subscriptionForestCode),
      start_date: normalizeSubscriptionStartDate(state.subscriptionStartDate || ''),
      start_month: String(state.monthlyMonth || '').trim() || null,
      target_month: String(state.monthlyMonth || '').trim() || null,
      lang: getMonthlyCertLang(),
      verb: String(state.verb || 'HAT').trim().toUpperCase() || 'HAT',
      monthly_canvas_png: monthlyCanvas,
      wizard_state: wizardState,
      photos: senderPhotos || {},
      process_now: true
    };

    const resp = await fetch(API_BASE + '/api2/b2b/subscription/save', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify(payload)
    });
    const js = await resp.json().catch(()=> ({}));
    if(!resp.ok || !js || js.ok !== true){
      const msg = String((js && (js.reason || js.message || js.detail)) || 'Abo konnte nicht gespeichert werden.').trim();
      alert(msg);
      return false;
    }

    if (state && state.b2bPortal && js && js.subscription_id){
      state.b2bPortal.subscriptionId = String(js.subscription_id || '').trim();
    }
    try{ syncB2BMonthlyCreateButtonLabel(); }catch(_){}

    try{ await flushSummaryTemplateAutosave(); }catch(_){}
    try{ await savePersistentSummarySenderDraft(); }catch(_){}
    try{ await savePortalSenderSnapshot(); }catch(_){}
    try{ await savePersistentPortalSenderDraft(); }catch(_){}
    try{ await clearDraft(); }catch(_){}

    if (isB2BPortalFlow()){
      var deferredStartLabel = String((js && (js.deferred_start_date_label || (js.recurring_engagement && js.recurring_engagement.start_date_label))) || '').trim();
      var successText = '';
      if (js.process_skipped === 'future_start'){
        successText = deferredStartLabel
          ? ('Dein Baum-Abo wurde gespeichert. Der erste Bezahl-Link wird am ' + deferredStartLabel + ' verschickt.')
          : 'Dein Baum-Abo wurde gespeichert. Der erste Bezahl-Link wird zum Start deines Abos verschickt.';
      } else if (js.created_now){
        successText = 'Dein Baum-Abo ist aktiv. Der erste Bezahl-Link wird jetzt per E-Mail verschickt.';
      } else {
        successText = isEditingSubscription
          ? 'Dein Baum-Abo wurde aktualisiert.'
          : 'Dein Baum-Abo wurde gespeichert.';
      }
      showB2BResult(
        '<div class="small">' +
          successText +
        '</div>'
      );
      setTimeout(function(){
        redirectBackToPortal({
          b2b_subscription_saved: '1',
          b2b_created: js.created_now ? '1' : '',
          portal_tab: 'subscriptions'
        });
      }, js.created_now ? 1200 : 900);
    }
    return true;
  }catch(e){
    console.error('saveB2BSubscriptionSetup failed', e);
    alert('Baum-Abo konnte nicht gespeichert werden: ' + (e && e.message ? e.message : 'Unbekannter Fehler'));
    return false;
  }finally{
    try{ hideLoadingOverlay(); }catch(_){}
    try{ setSubmitting(false); }catch(_){}
    window.__PT_B2B_SUBSCRIPTION_SAVE_LOCK = false;
    if (btn){
      btn.disabled = false;
      btn.classList.remove('is-busy');
      btn.textContent = prevBtnText || (isEditingB2BSubscription() ? 'Baum-Abo aktualisieren' : 'Abo starten');
    }
  }
}

async function createB2BMonthlyOnlyJob(){
  if (isB2BEventPortalFlow() && state.mode === 'cert' && state.step === totalSteps()){
    return await createB2BEventWithSummaryJob();
  }
  if (isB2BSubscriptionPortalFlow()){
    return await saveB2BSubscriptionSetup();
  }
  // ===== FAILSAFE #1: Re-Entry Lock (global, überlebt auch doppelte Listener)
  if (window.__PT_B2B_MONTHLY_ONLY_LOCK) {
    console.warn('createB2BMonthlyOnlyJob: blocked by lock');
    return;
  }
  window.__PT_B2B_MONTHLY_ONLY_LOCK = true;

  // ===== FAILSAFE #2: Button währenddessen deaktivieren (UI)
  const btn = (typeof btnB2BCreateMonthly !== 'undefined') ? btnB2BCreateMonthly : document.getElementById('btnB2BCreateMonthly');
  const prevBtnText = btn ? btn.textContent : '';
  if (btn){
    btn.disabled = true;
    btn.classList.add('is-busy');
    btn.textContent = 'Erstelle Monatszertifikat…';
  }

  // ===== OPTIONAL FAILSAFE #3: Signature-Guard (verhindert doppeltes Abschicken derselben Daten)
  // Wenn du das nicht willst: den ganzen Block rauslöschen.
  const sig = (function(){
    try{
      const forests = (typeof getMonthlySelectedForests === 'function')
        ? getMonthlySelectedForests()
        : (Array.isArray(state.monthlyForests) ? state.monthlyForests : []);
      return [
        String((b2bPartnerKey && b2bPartnerKey.value) || '').trim(),
        String(state.monthlyTrees || ''),
        String(state.monthlyMonth || ''),
        forests.join(','),
        String(state.monthlyQrUrl || '').trim(),
        String(state.frameColor || '')
      ].join('|');
    }catch(_){
      return '';
    }
  })();

  if (sig && window.__PT_B2B_MONTHLY_ONLY_LAST_SIG === sig){
    console.warn('createB2BMonthlyOnlyJob: same payload signature, skipping');
    // Lock wieder freigeben und UI resetten
    window.__PT_B2B_MONTHLY_ONLY_LOCK = false;
    if (btn){
      btn.disabled = false;
      btn.classList.remove('is-busy');
      btn.textContent = prevBtnText || 'Monatszertifikat erstellen';
    }
    return;
  }
  window.__PT_B2B_MONTHLY_ONLY_LAST_SIG = sig;

  try{
    // ====== AB HIER: dein normaler Code (nur leicht gestrafft)
    hideB2BResult();
    try{
      await flushSummaryTemplateAutosave();
    }catch(_){}

    if (getMonthlyProjectTreeCount() <= 0){
      alert('Bitte trage mindestens einen Baum ein.');
      setStep(10);
      return;
    }

    const profile = normalizePortalB2BProfile(getB2BInputs());
    if((!profile.partner_name || !String(profile.partner_name).trim()) && isB2BPortalFlow() && state && state.b2bPortal){
      const portalName = String(state.b2bPortal.partnerName || '').trim();
      const portalSlug = String(state.b2bPortal.landingSlug || '').trim();
      const portalUrl  = String(state.b2bPortal.partnerUrl || '').trim();
      if (portalName) {
        profile.partner_name = portalName;
        profile.partner = portalName;
      }
      if (!profile.landing_slug && portalSlug) profile.landing_slug = portalSlug;
      if (!profile.partner_url && portalUrl) profile.partner_url = portalUrl;
      if ((!profile.partner_name || !String(profile.partner_name).trim()) && state.b2bPortal.customerRef){
        try{
          const liveProfile = await b2bProfileGet(state.b2bPortal.customerRef);
          const liveName = String(liveProfile && liveProfile.partner_name || '').trim();
          const liveSlug = String(liveProfile && liveProfile.landing_slug || '').trim();
          const liveUrl  = String(liveProfile && liveProfile.partner_url || '').trim();
          if (liveName){
            profile.partner_name = liveName;
            profile.partner = liveName;
            state.b2bPortal.partnerName = liveName;
            if (b2bPartnerKey) b2bPartnerKey.value = liveName;
          }
          if (!profile.landing_slug && liveSlug){
            profile.landing_slug = liveSlug;
            state.b2bPortal.landingSlug = liveSlug;
          }
          if (!profile.partner_url && liveUrl){
            profile.partner_url = liveUrl;
            state.b2bPortal.partnerUrl = liveUrl;
          }
        }catch(_){}
      }
    }
    if(!profile.partner_name){
      alert('Bitte einen Partner eintragen (Step 0).');
      setStep(10);
      return;
    }

    showLoadingOverlay(); 
    setSubmitting(true);

    // Profil speichern (wie beim normalen B2B-Flow)
    await b2bProfileSave(profile);
    rememberPartnerKey(profile.partner_name || profile.partner || '');

    // Koordinaten sicherstellen
    try{ await ensureMonthlyCoords(); }catch(_){}

    // Monats-PNG capturen (ohne Stempel)
    let monthlyCanvas = null;
    const snap = await captureMonthlyCertificatePng();
    if (snap && snap.dataUrl) monthlyCanvas = snap.dataUrl;

    if(!monthlyCanvas){
      alert('Monatszertifikat konnte nicht erzeugt werden (Canvas leer).');
      return;
    }

    let senderPhotos = {};
    try{
      senderPhotos = await buildPhotoPayloadForWizard();
    }catch(_){}

    const payload = {
      customer_ref: profile.customer_ref,
      billing_mode: (state.b2bPortal && state.b2bPortal.billingMode) ? state.b2bPortal.billingMode : undefined,
      project_type: (state.b2bPortal && state.b2bPortal.mode === 'event') ? 'event' : 'monthly_simple',
      target_month: state.monthlyMonth || null,
      event_title: (state.monthlyPlaceText || '').replace(/\r/g,'').split('\n')[0].trim(),
      monthly_place_text: state.monthlyPlaceText || '',
      monthly_canvas_png: monthlyCanvas,
      monthly_trees: getMonthlyProjectTreeCount(),
      monthly_month: state.monthlyMonth || null,
      monthly_forests: (typeof getMonthlySelectedForests === 'function') ? getMonthlySelectedForests() : null,
      monthly_forest_trees: getMonthlyProjectForestTrees(),
      partner_url: (state.monthlyQrUrl || '').trim(),
      photos: senderPhotos || {}
    };

    const monthlyEndpoint = isB2BQuickMonthlyPortalFlow()
      ? '/api2/cert/b2b_monthly_refresh'
      : '/api2/cert/b2b_monthly_only';

    // 1) Erst sauberer Endpoint (wenn vorhanden)
    let resp = await fetch(API_BASE + monthlyEndpoint, {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify(payload)
    });

    // 2) Fallback: b2b_series mit leeren certs
    if(!resp.ok && !isB2BQuickMonthlyPortalFlow()){
      resp = await fetch(API_BASE + '/api2/cert/b2b_series', {
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({
          customer_ref: payload.customer_ref,
          certs: [],
          monthly_canvas_png: payload.monthly_canvas_png,
          monthly_trees: payload.monthly_trees,
          monthly_month: payload.monthly_month,
          monthly_forests: payload.monthly_forests,
          monthly_forest_trees: payload.monthly_forest_trees
        })
      });
    }

    const js = await resp.json().catch(()=> ({}));

    if(!resp.ok || !js || js.ok !== true){
      console.error('monthly-only failed', resp.status, js);
      alert('Monatszertifikat-Erstellung fehlgeschlagen. Bitte Logs prüfen.');
      return;
    }

    try{
      await flushSummaryTemplateAutosave();
    }catch(_){}
    try{
      await savePersistentSummarySenderDraft();
    }catch(_){}
    try{
      await savePortalSenderSnapshot();
    }catch(_){}
    try{
      await savePersistentPortalSenderDraft();
    }catch(_){}
    try{
      await clearDraft();
    }catch(_){}

    if(isB2BPortalFlow()){
      const monthlyUrl = js.monthly_url || js.url || '';
      if (isB2BQuickMonthlyPortalFlow() && monthlyUrl){
        const monthKey = String(state.monthlyMonth || '').trim();
        const partnerLabel = String(profile.partner_name || profile.partner || 'B2B').trim().replace(/[^\p{L}\p{N}\-_]+/gu, '_').replace(/^_+|_+$/g, '') || 'B2B';
        const downloadName = partnerLabel + '_Monatszertifikat_' + (monthKey || 'aktuell') + '.pdf';
        try{ await triggerPortalPdfDownload(monthlyUrl, downloadName); }catch(_){}
        showB2BResult(
          '<div class="small">Das Monatszertifikat wurde aktualisiert. Der PDF-Download wurde gestartet. Du wirst jetzt zurück ins B2B-Portal geleitet.</div>' +
          '<div style="margin-top:12px;"><a href="' + escapeHtml(monthlyUrl) + '" target="_blank" rel="noopener" class="btn btn-primary">PDF herunterladen</a></div>'
        );
      } else {
        showB2BResult('<div class="small">' + (isB2BQuickMonthlyPortalFlow() ? 'Das Monatszertifikat wurde aktualisiert.' : 'Das Sammel-Zertifikat wurde erstellt.') + ' Du wirst jetzt zurück ins B2B-Portal geleitet.</div>');
      }
      setTimeout(function(){
        redirectBackToPortal({ b2b_created: '1' });
      }, isB2BQuickMonthlyPortalFlow() ? 1600 : 900);
    }else{
      const monthlyUrl = js.monthly_url || js.url || '';
      let html = '';
      html += '<div class="small">Admin-Mail wurde ausgelöst. Hier ist der Download-Link:</div>';
      if(monthlyUrl){
        const monthlyPng = monthlyPngFromPdf(monthlyUrl);
        html += '<div style="margin-top:10px;">🗓️ <a href="'+escapeHtml(monthlyUrl)+'" target="_blank" rel="noopener">Monats-Zertifikat (PDF)</a></div>';
        if(monthlyPng){
          html += '<div>🖼️ <a href="'+escapeHtml(monthlyPng)+'" target="_blank" rel="noopener">Monats-Zertifikat (PNG)</a></div>';
        }
        html += '<div class="small">Hinweis: Monatszertifikat wird nicht gestempelt.</div>';
      }else{
        html += '<div class="small">Kein monthly_url im Response gefunden.</div>';
      }
      showB2BResult(html);
    }

    try{
      await loadRecentB2BJobs(profile.partner_name || profile.partner || getPartnerName());
    }catch(_){}

  } catch(e){
    console.error('createB2BMonthlyOnlyJob failed', e);
    alert('Monatszertifikat-Erstellung fehlgeschlagen: ' + (e && e.message ? e.message : 'Unbekannter Fehler'));
  } finally {
    // ===== Immer aufräumen =====
    try{ hideLoadingOverlay(); }catch(_){}
    try{ setSubmitting(false); }catch(_){}

    // Lock wieder freigeben
    window.__PT_B2B_MONTHLY_ONLY_LOCK = false;

    // Button wieder freigeben
    if (btn){
      btn.disabled = false;
      btn.classList.remove('is-busy');
      btn.textContent = prevBtnText || 'Monatszertifikat erstellen';
    }
  }
}

async function createB2BEventWithSummaryJob(){
  const btn = (typeof btnB2BCreateMonthly !== 'undefined') ? btnB2BCreateMonthly : document.getElementById('btnB2BCreateMonthly');
  const prevBtnText = btn ? btn.textContent : '';

  try{
    hideB2BResult();
    const profile = normalizePortalB2BProfile(getB2BInputs());
    if(!profile.partner_name){
      alert('Bitte einen Partner eintragen (Step 0).');
      setStep(0);
      return;
    }

    const snap = state && state.b2bPortal ? state.b2bPortal.eventSnapshot : null;
    if (!snap || !snap.canvasPng){
      alert('Das Event-Zertifikat konnte nicht vorbereitet werden. Bitte den Event-Schritt erneut aufrufen.');
      if (state && state.b2bPortal){
        state.b2bPortal.eventPhase = 'event';
      }
      setStep(10);
      return;
    }

    if (btn){
      btn.disabled = true;
      btn.classList.add('is-busy');
      btn.textContent = 'Erstelle Event-Zertifikat…';
    }

    showLoadingOverlay();
    setSubmitting(true);

    await b2bProfileSave(profile);
    rememberPartnerKey(profile.partner_name || profile.partner || '');

    let monthlyCanvas = null;
    const monthlySnap = await captureMonthlyCertificatePng();
    if (monthlySnap && monthlySnap.dataUrl) monthlyCanvas = monthlySnap.dataUrl;
    if (!monthlyCanvas){
      alert('Sammel-Zertifikat konnte nicht erzeugt werden (Canvas leer).');
      return;
    }

    const eventForestMap = {
      mv: Math.max(0, parseInt(snap.forestTrees && snap.forestTrees.mv, 10) || 0),
      by: Math.max(0, parseInt(snap.forestTrees && snap.forestTrees.by, 10) || 0),
      rp: Math.max(0, parseInt(snap.forestTrees && snap.forestTrees.rp, 10) || 0)
    };
    const eventTrees = Math.max(1, (eventForestMap.mv || 0) + (eventForestMap.by || 0) + (eventForestMap.rp || 0));
    const eventForestCode = ['mv','by','rp'].find((code)=> eventForestMap[code] > 0) || 'mv';
    const eventTitle = String(snap.placeText || '').replace(/\r/g,'').split('\n')[0].trim() || 'Event-Zertifikat';

    let senderPhotoDataUrl = '';
    try{
      if (state.personalizedMonthlyPhoto1State && state.personalizedMonthlyPhoto1State.dataUrl){
        senderPhotoDataUrl = String(state.personalizedMonthlyPhoto1State.dataUrl || '');
      } else if (personalizedMonthlyImg1 && personalizedMonthlyImg1.src && String(personalizedMonthlyImg1.src).indexOf('data:image') === 0){
        senderPhotoDataUrl = String(personalizedMonthlyImg1.src || '');
      } else if (snap.photo1State && snap.photo1State.dataUrl){
        senderPhotoDataUrl = String(snap.photo1State.dataUrl || '');
      }
    }catch(_){}

    const payload = {
      customer_ref: profile.customer_ref,
      billing_mode: (state.b2bPortal && state.b2bPortal.billingMode) ? state.b2bPortal.billingMode : undefined,
      target_month: state.monthlyMonth || snap.month || null,
      event_title: eventTitle,
      event_canvas_png: snap.canvasPng,
      event_sender: String(snap.senderText || '').replace(/\r/g,''),
      event_recipient: eventTitle,
      event_message: String(snap.placeText || '').replace(/\r/g,''),
      event_trees: eventTrees,
      event_forest_code: eventForestCode,
      event_delivery: 'digital',
      event_paper_type: 'white',
      event_frame_color: state.frameColor || FRAME_COLOR_DEFAULT,
      monthly_canvas_png: monthlyCanvas,
      monthly_trees: getMonthlyProjectTreeCount(),
      monthly_month: state.monthlyMonth || snap.month || null,
      monthly_forests: (typeof getMonthlySelectedForests === 'function') ? getMonthlySelectedForests() : null,
      monthly_forest_trees: getMonthlyProjectForestTrees(),
      monthly_place_text: state.monthlyPlaceText || '',
      partner_url: (state.monthlyQrUrl || '').trim(),
      photos: senderPhotoDataUrl ? { sender: { data_url: senderPhotoDataUrl } } : {}
    };

    const resp = await fetch(API_BASE + '/api2/cert/b2b_event_with_summary', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify(payload)
    });
    const js = await resp.json().catch(()=> ({}));
    if(!resp.ok || !js || js.ok !== true){
      console.error('b2b_event_with_summary failed', resp.status, js);
      alert('Event-Zertifikat-Erstellung fehlgeschlagen. Bitte Logs prüfen.');
      return;
    }

try{
  await saveTemplateSnapshotSilentlyForAliases([
    profile.customer_ref,
    state && state.b2bPortal && state.b2bPortal.landingSlug,
    profile.partner_name || profile.partner || getPartnerName()
  ]);
}catch(_){}
try{
  await savePersistentPortalSenderDraft();
}catch(_){}
try{
  await savePersonalizedLogoSnapshot();
}catch(_){}
try{
  await clearDraft();
}catch(_){}

    if(isB2BPortalFlow()){
      showB2BResult('<div class="small">Das Event-Zertifikat und das Sammel-Zertifikat wurden erstellt. Du wirst jetzt zurück ins B2B-Portal geleitet.</div>');
      setTimeout(function(){
        redirectBackToPortal({ b2b_created: '1' });
      }, 900);
    }else{
      const eventUrl = (Array.isArray(js.stamped_entries) && js.stamped_entries[0] && (js.stamped_entries[0].download_url || js.stamped_entries[0].pdf_url)) || '';
      const monthlyUrl = js.monthly_url || '';
      let html = '<div class="small">Die Zertifikate wurden erstellt. Hier sind die direkten Download-Links:</div>';
      if (eventUrl){
        html += '<div style="margin-top:10px;">🎉 <a href="'+escapeHtml(eventUrl)+'" target="_blank" rel="noopener">Event-Zertifikat</a></div>';
      }
      if (monthlyUrl){
        html += '<div>🗓️ <a href="'+escapeHtml(monthlyUrl)+'" target="_blank" rel="noopener">Sammel-Zertifikat</a></div>';
      }
      showB2BResult(html);
    }

    try{
      await loadRecentB2BJobs(profile.partner_name || profile.partner || getPartnerName());
    }catch(_){}
  }catch(e){
    console.error('createB2BEventWithSummaryJob failed', e);
    alert('Event-Zertifikat-Erstellung fehlgeschlagen: ' + (e && e.message ? e.message : 'Unbekannter Fehler'));
  }finally{
    try{ hideLoadingOverlay(); }catch(_){}
    try{ setSubmitting(false); }catch(_){}
    if (btn){
      btn.disabled = false;
      btn.classList.remove('is-busy');
      btn.textContent = prevBtnText || 'Event-Zertifikat erstellen';
    }
  }
}



if (btnB2BTemplateLoad){
  btnB2BTemplateLoad.addEventListener('click', (e)=>{
    e.preventDefault();
    loadProfileIntoUI();
  });
}

if (btnB2BTemplateSave){
  btnB2BTemplateSave.addEventListener('click', (e)=>{
    e.preventDefault();
    saveProfileFromUI();
  });
}

if (btnB2BCreate){
  btnB2BCreate.addEventListener('click', async (e)=>{
    e.preventDefault(); e.stopPropagation();
    await createB2BJob();
  });
}

if (btnB2BCreateMonthly){
  if (btnB2BCreateMonthly.dataset && btnB2BCreateMonthly.dataset.ptBoundMonthly !== '1'){
    btnB2BCreateMonthly.dataset.ptBoundMonthly = '1';

    btnB2BCreateMonthly.addEventListener('click', async (e)=>{
      e.preventDefault(); e.stopPropagation();
      await createB2BMonthlyOnlyJob();
    });
  }
}

function syncB2BMonthlyCreateButtonLabel(){
  if (!btnB2BCreateMonthly) return;
  btnB2BCreateMonthly.textContent = isB2BSubscriptionPortalFlow()
    ? (isEditingB2BSubscription() ? 'Baum-Abo aktualisieren' : 'Abo starten')
    : isB2BEventFinalOverviewPhase()
    ? 'Event- und Sammel-Zertifikat erstellen'
    : 'Sammel-Zertifikat erstellen';
}

syncB2BMonthlyCreateButtonLabel();


if (!isB2BPortalFlow() && b2bPartnerKey && !b2bPartnerKey.value){
  const r = recallPartnerKey();
  if (r) b2bPartnerKey.value = r;
}

if (isB2BPortalFlow() && state && state.b2bPortal && state.b2bPortal.customerRef){
  loadRecentB2BJobs(String(state.b2bPortal.partnerName || state.b2bPortal.customerRef || '').trim(), { autoOpenLatest:true });
}else if (b2bPartnerKey && b2bPartnerKey.value){
  loadRecentB2BJobs(b2bPartnerKey.value, { autoOpenLatest:true });
}




  // Footer-Logik: in B2B finalen Step „Zertifikate erstellen“ statt Warenkorb/Checkout
updateFooterForStep = function(step){
  try{ __oldUpdateFooterForStep(step); }catch(_){}
  const tot = totalSteps();
  const inFinal = (step === tot);
  const isSummaryOnlyFinal = !!(isB2BSummaryOnlyPortalFlow() && inFinal);
  const isPersonalizedFinal = !!(isB2BPersonalizedPortalFlow() && inFinal);
  const isNonPersonalizedFinal = !!(inFinal && !isB2BPersonalizedPortalFlow());

  if (btnCart) btnCart.style.display = 'none';
  if (btnCheckout) btnCheckout.style.display = 'none';
  if (btnCartHeader) btnCartHeader.style.display = 'none';

  if (btnB2BCreate){
    btnB2BCreate.style.display = isPersonalizedFinal ? 'inline-flex' : 'none';
  }
  if (btnB2BCreateMonthly){
    syncB2BMonthlyCreateButtonLabel();
    btnB2BCreateMonthly.style.display = isNonPersonalizedFinal ? 'inline-flex' : 'none';
  }
  try{ syncB2BFinalCreateAvailability(); }catch(_){}
};

  try{ updateFooterForStep(state.step || 0); }catch(_){}
})();

})();
